import * as t from "maptalks";

import { Coordinate as e, Util as n, Point as i, Polygon as r, Extent as s, Map as o, renderer as a } from "maptalks";

import { mat4 as c, vec3 as h, vec4 as l, mat3 as f, vec2 as u, quat as d, glMatrix as m, mat2 as v, mat2d as g, quat2 as p } from "gl-matrix";

import { buildTangents as x, packTangentFrame as _, buildNormals as b } from "@maptalks/tbn-packer";

import y from "@maptalks/regl";

import { GLContext as w } from "@maptalks/fusiongl";

export { GLContext } from "@maptalks/fusiongl";

const S = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    throw new Error("unable to locate global object");
};

function A() {
    return S().maptalks_gltf_loader;
}

function M(t) {
    return !T(t) && ("string" == typeof t || null !== t.constructor && t.constructor === String);
}

function T(t) {
    return null == t;
}

function C(t) {
    return !T(t);
}

function O(t) {
    return !T(t) && ("function" == typeof t || null !== t.constructor && t.constructor === Function);
}

function E(t, ...e) {
    return Object.assign(t, ...e), t;
}

function I(t, ...e) {
    for (let n = 0; n < e.length; n++) {
        const i = e[n];
        for (const e in i) void 0 !== i[e] && null !== i[e] && (t[e] = i[e]);
    }
    return t;
}

function P(t) {
    return "number" == typeof t && !isNaN(t);
}

function H(t, e, n) {
    return t * (1 - n) + e * n;
}

function R(t) {
    return Array.isArray(t) || t instanceof Uint8Array || t instanceof Int8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Uint32Array || t instanceof Int32Array || t instanceof Uint8ClampedArray || t instanceof Float32Array || t instanceof Float64Array;
}

function k(t) {
    return Array.isArray(t) && Array || t instanceof Uint8Array && Uint8Array || t instanceof Int8Array && Int8Array || t instanceof Uint16Array && Uint16Array || t instanceof Int16Array && Int16Array || t instanceof Uint32Array && Uint32Array || t instanceof Int32Array && Int32Array || t instanceof Uint8ClampedArray && Uint8ClampedArray || t instanceof Float32Array && Float32Array || t instanceof Float64Array && Float64Array;
}

function N(t) {
    return (t = Math.abs(t)) < 128 ? Int8Array : t < 32768 ? Int16Array : Float32Array;
}

function D(t, e, n) {
    return Math.min(n, Math.max(e, t));
}

function L(t) {
    return !globalThis.MAPTALKS_DISABLE_VAO && (!t.wgpu && (t && t.hasExtension && t.hasExtension("oes_vertex_array_object")));
}

function F(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}

function U(t) {
    if (t.data) {
        if (t.data.BYTES_PER_ELEMENT) return t.data.length * t.data.BYTES_PER_ELEMENT;
        if (t.data.length) return 4 * t.data.length;
    } else {
        if (t.BYTES_PER_ELEMENT) return t.length * t.BYTES_PER_ELEMENT;
        if (t.length) return 4 * t.length;
        if (t.buffer && t.buffer.destroy) {
            const e = t.buffer._buffer;
            return e ? e.byteLength : t.buffer.size;
        }
    }
    return 0;
}

function z(t) {
    return t.width * t.height * B(t.format) * G(t.type) * ("textureCube" === t._reglType ? 6 : 1);
}

function G(t) {
    return "uint8" === t ? 1 : "uint16" === t || "float16" === t || "half float" === t ? 2 : "uint32" === t || "float" === t || "float32" === t ? 4 : 0;
}

function B(t) {
    return "depth" === t || "alpha" === t || "luminance" === t ? 1 : "luminance alpha" === t || "depth stencil" === t ? 2 : "srgba" === t || "rgb5 a1" === t || "rgba" === t.substring(0, 4) ? 4 : "srgb" === t || "rgb" === t.substring(0, 3) ? 3 : 1;
}

function V(t) {
    if (!t.componentType) return !1;
    const e = A().GLTFLoader.getTypedArrayCtor(t.componentType);
    return t.byteStride > 0 && t.byteStride !== t.itemSize * e.BYTES_PER_ELEMENT;
}

function j(t) {
    return t && (t.stride > 0 || V(t));
}

function W(t) {
    const e = t.getExtension && t, n = !e && t, i = "WEBGL_compressed_texture_", r = "texture-compression-", s = {
        "etc": e ? !!e.getExtension(i + "etc") : !!n.features.has(r + "etc2"),
        "etc1": e ? !!e.getExtension(i + "etc1") : !!n.features.has(r + "etc2"),
        "s3tc": e ? !!e.getExtension(i + "s3tc") : !!n.features.has(r + "bc"),
        "pvrtc": !!e && !!e.getExtension(i + "pvrtc"),
        "astc": e ? !!e.getExtension(i + "astc") : !!n.features.has(r + "astc"),
        "bc7": e ? !!e.getExtension("EXT_texture_compression_bptc") : !!n.features.has(r + "bc")
    };
    return s[i + "etc"] = s.etc, s[i + "etc1"] = s.etc1, s[i + "s3tc"] = s.s3tc, s[i + "pvrtc"] = s.pvrtc, 
    s[i + "astc"] = s.astc, s[i + "bc7"] = s.bc7, s;
}

function q(t) {
    let e = 0;
    const n = t && t.length || 0;
    if (!n) return e;
    let i;
    for (let r = 0; r < n; r++) i = t.charCodeAt(r), e = (e << 5) - e + i, e |= 0;
    return e;
}

function X(t) {
    return !(t & t - 1) && 0 !== t;
}

function K(t) {
    return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}

function $(t, e, n) {
    if (R(t)) return X(e) && X(n) ? t : function(t, e, n) {
        let i = e, r = n;
        X(e) || (i = K(e)), X(n) || (r = K(n));
        const s = new ImageData(new Uint8ClampedArray(t), e, n), o = document.createElement("canvas");
        o.width = e, o.height = n, o.getContext("2d").putImageData(s, 0, 0);
        const a = document.createElement("canvas");
        a.width = i, a.height = r, a.getContext("2d").drawImage(o, 0, 0, e, n, 0, 0, r, r), 
        console.warn(`Texture's size is not power of two, resize from (${e}, ${n}) to (${i}, ${r})`);
        let c = document.getElementById("_debug_resize_canvas");
        return c || (c = document.createElement("canvas"), c.id = "_debug_resize_canvas", 
        document.body.appendChild(c)), c.width = i, c.height = r, c.getContext("2d").drawImage(a, 0, 0), 
        a;
    }(t, e, n);
    if (X(t.width) && X(t.height)) return t;
    e = t.width, n = t.height, X(e) || (e = K(e)), X(n) || (n = K(n));
    const i = document.createElement("canvas");
    i.width = e, i.height = n, i.getContext("2d").drawImage(t, 0, 0, e, n);
    const r = t.src, s = r.lastIndexOf("/") + 1, o = r.substring(s);
    return console.warn(`Texture(${o})'s size is not power of two, resize from (${t.width}, ${t.height}) to (${e}, ${n})`), 
    i;
}

function J(t) {
    return !!t.wgpu || (!t._gl || t._gl instanceof WebGL2RenderingContext);
}

var Y = Object.freeze({
    __proto__: null,
    clamp: D,
    defined: C,
    extend: E,
    extendWithoutNil: I,
    getArrayCtor: k,
    getBufferSize: U,
    getPosArrayType: N,
    getSupportedFormats: W,
    getTexMemorySize: z,
    getTextureByteWidth: G,
    getTextureChannels: B,
    hasOwn: F,
    hashCode: q,
    interpolate: H,
    isArray: R,
    isFunction: O,
    isInStride: V,
    isInterleaved: j,
    isNil: T,
    isNumber: P,
    isPowerOfTwo: X,
    isString: M,
    isSupportVAO: L,
    isTextureDestroyed: function(t) {
        return t.device ? !t.texture : !t._texture || !t._texture.texture;
    },
    lerp: function(t, e, n, i) {
        for (let r = 0; r < t.length; r++) t[r] = e[r] + i * (n[r] - e[r]);
        return t;
    },
    log2: function(t) {
        return Math.log2(t);
    },
    normalize: function(t, e) {
        let n = 0;
        for (let t = 0, i = e.length; t < i; t++) n += e[t];
        for (let i = 0, r = e.length; i < r; i++) t[i] = e[i] / n;
        return t;
    },
    resizeToPowerOfTwo: $,
    set: function(t, e) {
        for (let n = 0; n < t.length; n++) t[n] = e[n];
        return t;
    },
    supportNPOT: J
});

function Z(t) {
    return class extends t {
        on(t, e) {
            return this.o || (this.o = {
                type: [ e ]
            }), this.o[t] = this.o[t] || [], this.o[t].push(e), this;
        }
        once(t, e) {
            return this.on(t, this.h(t, e));
        }
        off(t, e) {
            return this.o && this.o[t] ? (this.o[t].splice(this.o[t].indexOf(e), 1), this) : this;
        }
        fire(t, e = {}) {
            if (!this.o || !this.o[t]) return this;
            e.target || (e.target = this);
            const n = this.o[t].slice(0);
            for (const t of n) t(e);
            return this;
        }
        h(t, e) {
            const n = this;
            let i = !1;
            return function r(s) {
                i || (i = !0, e(s), n.off(t, r));
            };
        }
    };
}

const Q = "__reshader_disposed", tt = "not implemented";

var et = Object.freeze({
    __proto__: null,
    ERROR_NOT_IMPLEMENTED: tt,
    KEY_DISPOSED: Q,
    WEBGL_EXTENSIONS: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives" ],
    WEBGL_OPTIONAL_EXTENSIONS: [ "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_texture_filter_anisotropic" ]
});

const nt = "_reshader_refCount";

let it = class {};

class rt extends(Z(it)){
    constructor(t, e) {
        if (super(), O(t)) {
            this._texture = t, t = this.config = {};
            for (const e in this._texture) F(this._texture, e) && (O(this._texture[e]) || (t[e] = this._texture[e]));
        } else if (this.config = t || {}, this.resLoader = e, (t.url || t.promise) && !t.data) {
            this.u = !0;
            const n = this;
            let i;
            if (t.promise) i = t.promise; else {
                let n;
                n = t.arrayBuffer ? e.getArrayBuffer : e.get, i = n.call(e, t.url);
            }
            t.data = e.getDefaultTexture(t.url), this.promise = i, i.then((t => (delete this.promise, 
            n.u = !1, n.config ? (n.onLoad(t), Array.isArray(t) || (t = [ t ]), n.fire("complete", {
                target: this,
                resources: t
            }), t) : t))).catch((t => {
                console.error("error when loading texture image.", t), n.fire("error", {
                    target: this,
                    error: t
                });
            }));
        }
    }
    onLoad(t) {}
    isReady() {
        return !this.u;
    }
    set(t, e) {
        return this.config[t] = e, this.dirty = !0, this;
    }
    get(t) {
        return this.config[t];
    }
    createREGLTexture(t) {
        return null;
    }
    getREGLTexture(t) {
        return this._texture || (this._texture = this.createREGLTexture(t), this.config.persistent || (this.config.data && (this.config.data instanceof ImageBitmap || (this.config.data = [])), 
        this.config.image && (this.config.image.array = []), this.config.mipmap && delete this.config.mipmap)), 
        this.dirty && this.m(), this._texture;
    }
    getMemorySize() {
        if (!this.config) return 0;
        const {width: t, height: e, type: n, format: i} = this.config;
        return t * e * G(n || "uint8") * B(i || "rgba");
    }
    m() {
        throw new Error(tt);
    }
    dispose() {
        this.config && this.config.url && (URL.revokeObjectURL(this.config.url), this.resLoader.disposeRes(this.config.url)), 
        this.config && this.config.data instanceof ImageBitmap && (this.config.data.close(), 
        this.config.data = []), this._texture && !this._texture[Q] && (this._texture[nt] && this._texture[nt]--, 
        this._texture[nt] || (this._texture.destroy(), this._texture[Q] = !0, delete this._texture)), 
        delete this.resLoader, delete this.p;
        const t = this.config && this.config.url;
        delete this.config, t && this.fire("disposed", {
            target: this,
            url: t
        });
    }
}

const st = c.identity([]), ot = c.identity([]);

class at {
    constructor(t, e) {
        this.min = t || [ 1 / 0, 1 / 0, 1 / 0 ], this.max = e || [ -1 / 0, -1 / 0, -1 / 0 ], 
        this.updateVertex();
    }
    static copy(t, e) {
        h.copy(t.min, e.min), h.copy(t.max, e.max);
        for (let n = 0; n < e.vertex.length; n++) h.copy(t.vertex[n], e.vertex[n]);
        return t;
    }
    combine(t) {
        if (!t) return this;
        let e, n;
        return Array.isArray(t) ? (e = t[0], n = t[1]) : (e = t.min, n = t.max), e[0] < this.min[0] && (this.min[0] = e[0], 
        this.S = !0), e[1] < this.min[1] && (this.min[1] = e[1], this.S = !0), e[2] < this.min[2] && (this.min[2] = e[2], 
        this.S = !0), n[0] > this.max[0] && (this.max[0] = n[0], this.S = !0), n[1] > this.max[1] && (this.max[1] = n[1], 
        this.S = !0), n[2] > this.max[2] && (this.max[2] = n[2], this.S = !0), this;
    }
    dirty() {
        return this.S = !0, this;
    }
    getCenter() {
        return this.center || (this.center = [ 0, 0, 0 ], this.S = !0), this.S && (h.add(this.center, this.min, this.max), 
        h.scale(this.center, this.center, .5)), this.S = !1, this.center;
    }
    containPoint(t) {
        const e = this.min, n = this.max;
        return e[0] <= t[0] && e[1] <= t[1] && e[2] <= t[2] && n[0] >= t[0] && n[1] >= t[1] && n[2] >= t[2];
    }
    isFinite() {
        const t = this.min, e = this.max;
        return isFinite(t[0]) && isFinite(t[1]) && isFinite(t[2]) && isFinite(e[0]) && isFinite(e[1]) && isFinite(e[2]);
    }
    updateVertex() {
        if (!this.vertex) {
            this.vertex = [];
            for (let t = 0; t < 8; t++) this.vertex.push([ 0, 0, 0 ]);
        }
        return this.vertex[0][0] = this.min[0], this.vertex[0][1] = this.min[1], this.vertex[0][2] = this.min[2], 
        this.vertex[1][0] = this.min[0], this.vertex[1][1] = this.min[1], this.vertex[1][2] = this.max[2], 
        this.vertex[2][0] = this.min[0], this.vertex[2][1] = this.max[1], this.vertex[2][2] = this.max[2], 
        this.vertex[3][0] = this.min[0], this.vertex[3][1] = this.max[1], this.vertex[3][2] = this.min[2], 
        this.vertex[4][0] = this.max[0], this.vertex[4][1] = this.min[1], this.vertex[4][2] = this.min[2], 
        this.vertex[5][0] = this.max[0], this.vertex[5][1] = this.min[1], this.vertex[5][2] = this.max[2], 
        this.vertex[6][0] = this.max[0], this.vertex[6][1] = this.max[1], this.vertex[6][2] = this.max[2], 
        this.vertex[7][0] = this.max[0], this.vertex[7][1] = this.max[1], this.vertex[7][2] = this.min[2], 
        this.vertex;
    }
    copy(t) {
        return t ? at.copy(t, this) : new at(this.min.slice(), this.max.slice());
    }
    equals(t) {
        if (!h.equals(this.min, t.min) || !h.equals(this.max, t.max)) return !1;
        const e = t.vertex;
        for (let t = 0; t < this.vertex.length; t++) if (!h.equals(e[t], this.vertex[t])) return !1;
        return !0;
    }
    transform(t, e) {
        if (t = t || ot, (e = e || ot)[1] || e[2] || e[4] || e[6] || e[8] || e[9]) {
            const n = this.vertex, i = c.multiply(st, e, t);
            for (let t = 0; t < n.length; t++) h.transformMat4(this.vertex[t], this.vertex[t], i);
            const r = this.vertex.map((t => t[0])), s = this.vertex.map((t => t[1])), o = this.vertex.map((t => t[2])), a = Math.min(...r), l = Math.max(...r), f = Math.min(...s), u = Math.max(...s), d = Math.min(...o), m = Math.max(...o);
            h.set(this.min, a, f, d), h.set(this.max, l, u, m);
        } else {
            const n = c.multiply(st, e, t);
            h.transformMat4(this.min, this.min, n), h.transformMat4(this.max, this.max, n);
        }
        return this;
    }
}

function ct(t, e, n = 2) {
    const i = e && e.length, r = i ? e[0] * n : t.length;
    let s = ht(t, 0, r, n, !0);
    const o = [];
    if (!s || s.next === s.prev) return o;
    let a, c, h;
    if (i && (s = function(t, e, n, i) {
        const r = [];
        for (let n = 0, s = e.length; n < s; n++) {
            const o = ht(t, e[n] * i, n < s - 1 ? e[n + 1] * i : t.length, i, !1);
            o === o.next && (o.steiner = !0), r.push(bt(o));
        }
        r.sort(gt);
        for (let t = 0; t < r.length; t++) n = pt(r[t], n);
        return n;
    }(t, e, s, n)), t.length > 80 * n) {
        a = 1 / 0, c = 1 / 0;
        let e = -1 / 0, i = -1 / 0;
        for (let s = n; s < r; s += n) {
            const n = t[s], r = t[s + 1];
            n < a && (a = n), r < c && (c = r), n > e && (e = n), r > i && (i = r);
        }
        h = Math.max(e - a, i - c), h = 0 !== h ? 32767 / h : 0;
    }
    return ft(s, o, n, a, c, h, 0), o;
}

function ht(t, e, n, i, r) {
    let s;
    if (r === function(t, e, n, i) {
        let r = 0;
        for (let s = e, o = n - i; s < n; s += i) r += (t[o] - t[s]) * (t[s + 1] + t[o + 1]), 
        o = s;
        return r;
    }(t, e, n, i) > 0) for (let r = e; r < n; r += i) s = Pt(r / i | 0, t[r], t[r + 1], s); else for (let r = n - i; r >= e; r -= i) s = Pt(r / i | 0, t[r], t[r + 1], s);
    return s && Mt(s, s.next) && (Ht(s), s = s.next), s;
}

function lt(t, e) {
    if (!t) return t;
    e || (e = t);
    let n, i = t;
    do {
        if (n = !1, i.steiner || !Mt(i, i.next) && 0 !== At(i.prev, i, i.next)) i = i.next; else {
            if (Ht(i), i = e = i.prev, i === i.next) break;
            n = !0;
        }
    } while (n || i !== e);
    return e;
}

function ft(t, e, n, i, r, s, o) {
    if (!t) return;
    !o && s && function(t, e, n, i) {
        let r = t;
        do {
            0 === r.z && (r.z = _t(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, 
            r = r.next;
        } while (r !== t);
        r.prevZ.nextZ = null, r.prevZ = null, function(t) {
            let e, n = 1;
            do {
                let i, r = t;
                t = null;
                let s = null;
                for (e = 0; r; ) {
                    e++;
                    let o = r, a = 0;
                    for (let t = 0; t < n && (a++, o = o.nextZ, o); t++) ;
                    let c = n;
                    for (;a > 0 || c > 0 && o; ) 0 !== a && (0 === c || !o || r.z <= o.z) ? (i = r, 
                    r = r.nextZ, a--) : (i = o, o = o.nextZ, c--), s ? s.nextZ = i : t = i, i.prevZ = s, 
                    s = i;
                    r = o;
                }
                s.nextZ = null, n *= 2;
            } while (e > 1);
        }(r);
    }(t, i, r, s);
    let a = t;
    for (;t.prev !== t.next; ) {
        const c = t.prev, h = t.next;
        if (s ? dt(t, i, r, s) : ut(t)) e.push(c.i, t.i, h.i), Ht(t), t = h.next, a = h.next; else if ((t = h) === a) {
            o ? 1 === o ? ft(t = mt(lt(t), e), e, n, i, r, s, 2) : 2 === o && vt(t, e, n, i, r, s) : ft(lt(t), e, n, i, r, s, 1);
            break;
        }
    }
}

function ut(t) {
    const e = t.prev, n = t, i = t.next;
    if (At(e, n, i) >= 0) return !1;
    const r = e.x, s = n.x, o = i.x, a = e.y, c = n.y, h = i.y, l = Math.min(r, s, o), f = Math.min(a, c, h), u = Math.max(r, s, o), d = Math.max(a, c, h);
    let m = i.next;
    for (;m !== e; ) {
        if (m.x >= l && m.x <= u && m.y >= f && m.y <= d && wt(r, a, s, c, o, h, m.x, m.y) && At(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}

function dt(t, e, n, i) {
    const r = t.prev, s = t, o = t.next;
    if (At(r, s, o) >= 0) return !1;
    const a = r.x, c = s.x, h = o.x, l = r.y, f = s.y, u = o.y, d = Math.min(a, c, h), m = Math.min(l, f, u), v = Math.max(a, c, h), g = Math.max(l, f, u), p = _t(d, m, e, n, i), x = _t(v, g, e, n, i);
    let _ = t.prevZ, b = t.nextZ;
    for (;_ && _.z >= p && b && b.z <= x; ) {
        if (_.x >= d && _.x <= v && _.y >= m && _.y <= g && _ !== r && _ !== o && wt(a, l, c, f, h, u, _.x, _.y) && At(_.prev, _, _.next) >= 0) return !1;
        if (_ = _.prevZ, b.x >= d && b.x <= v && b.y >= m && b.y <= g && b !== r && b !== o && wt(a, l, c, f, h, u, b.x, b.y) && At(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    for (;_ && _.z >= p; ) {
        if (_.x >= d && _.x <= v && _.y >= m && _.y <= g && _ !== r && _ !== o && wt(a, l, c, f, h, u, _.x, _.y) && At(_.prev, _, _.next) >= 0) return !1;
        _ = _.prevZ;
    }
    for (;b && b.z <= x; ) {
        if (b.x >= d && b.x <= v && b.y >= m && b.y <= g && b !== r && b !== o && wt(a, l, c, f, h, u, b.x, b.y) && At(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    return !0;
}

function mt(t, e) {
    let n = t;
    do {
        const i = n.prev, r = n.next.next;
        !Mt(i, r) && Tt(i, n, n.next, r) && Et(i, r) && Et(r, i) && (e.push(i.i, n.i, r.i), 
        Ht(n), Ht(n.next), n = t = r), n = n.next;
    } while (n !== t);
    return lt(n);
}

function vt(t, e, n, i, r, s) {
    let o = t;
    do {
        let t = o.next.next;
        for (;t !== o.prev; ) {
            if (o.i !== t.i && St(o, t)) {
                let a = It(o, t);
                return o = lt(o, o.next), a = lt(a, a.next), ft(o, e, n, i, r, s, 0), void ft(a, e, n, i, r, s, 0);
            }
            t = t.next;
        }
        o = o.next;
    } while (o !== t);
}

function gt(t, e) {
    let n = t.x - e.x;
    if (0 === n && (n = t.y - e.y, 0 === n)) {
        n = (t.next.y - t.y) / (t.next.x - t.x) - (e.next.y - e.y) / (e.next.x - e.x);
    }
    return n;
}

function pt(t, e) {
    const n = function(t, e) {
        let n = e;
        const i = t.x, r = t.y;
        let s, o = -1 / 0;
        if (Mt(t, n)) return n;
        do {
            if (Mt(t, n.next)) return n.next;
            if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                const t = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                if (t <= i && t > o && (o = t, s = n.x < n.next.x ? n : n.next, t === i)) return s;
            }
            n = n.next;
        } while (n !== e);
        if (!s) return null;
        const a = s, c = s.x, h = s.y;
        let l = 1 / 0;
        n = s;
        do {
            if (i >= n.x && n.x >= c && i !== n.x && yt(r < h ? i : o, r, c, h, r < h ? o : i, r, n.x, n.y)) {
                const e = Math.abs(r - n.y) / (i - n.x);
                Et(n, t) && (e < l || e === l && (n.x > s.x || n.x === s.x && xt(s, n))) && (s = n, 
                l = e);
            }
            n = n.next;
        } while (n !== a);
        return s;
    }(t, e);
    if (!n) return e;
    const i = It(n, t);
    return lt(i, i.next), lt(n, n.next);
}

function xt(t, e) {
    return At(t.prev, t, e.prev) < 0 && At(e.next, t, t.next) < 0;
}

function _t(t, e, n, i, r) {
    return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - i) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}

function bt(t) {
    let e = t, n = t;
    do {
        (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
    } while (e !== t);
    return n;
}

function yt(t, e, n, i, r, s, o, a) {
    return (r - o) * (e - a) >= (t - o) * (s - a) && (t - o) * (i - a) >= (n - o) * (e - a) && (n - o) * (s - a) >= (r - o) * (i - a);
}

function wt(t, e, n, i, r, s, o, a) {
    return !(t === o && e === a) && yt(t, e, n, i, r, s, o, a);
}

function St(t, e) {
    return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
        let n = t;
        do {
            if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && Tt(n, n.next, t, e)) return !0;
            n = n.next;
        } while (n !== t);
        return !1;
    }(t, e) && (Et(t, e) && Et(e, t) && function(t, e) {
        let n = t, i = !1;
        const r = (t.x + e.x) / 2, s = (t.y + e.y) / 2;
        do {
            n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), 
            n = n.next;
        } while (n !== t);
        return i;
    }(t, e) && (At(t.prev, t, e.prev) || At(t, e.prev, e)) || Mt(t, e) && At(t.prev, t, t.next) > 0 && At(e.prev, e, e.next) > 0);
}

function At(t, e, n) {
    return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}

function Mt(t, e) {
    return t.x === e.x && t.y === e.y;
}

function Tt(t, e, n, i) {
    const r = Ot(At(t, e, n)), s = Ot(At(t, e, i)), o = Ot(At(n, i, t)), a = Ot(At(n, i, e));
    return r !== s && o !== a || (!(0 !== r || !Ct(t, n, e)) || (!(0 !== s || !Ct(t, i, e)) || (!(0 !== o || !Ct(n, t, i)) || !(0 !== a || !Ct(n, e, i)))));
}

function Ct(t, e, n) {
    return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}

function Ot(t) {
    return t > 0 ? 1 : t < 0 ? -1 : 0;
}

function Et(t, e) {
    return At(t.prev, t, t.next) < 0 ? At(t, e, t.next) >= 0 && At(t, t.prev, e) >= 0 : At(t, e, t.prev) < 0 || At(t, t.next, e) < 0;
}

function It(t, e) {
    const n = Rt(t.i, t.x, t.y), i = Rt(e.i, e.x, e.y), r = t.next, s = e.prev;
    return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, 
    i.prev = s, i;
}

function Pt(t, e, n, i) {
    const r = Rt(t, e, n);
    return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, 
    r.next = r), r;
}

function Ht(t) {
    t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), 
    t.nextZ && (t.nextZ.prevZ = t.prevZ);
}

function Rt(t, e, n) {
    return {
        i: t,
        x: e,
        y: n,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}

function kt(t) {
    const e = [], n = [], i = t[0][0].length;
    let r = 0, s = 0;
    for (const o of t) {
        for (const t of o) for (let n = 0; n < i; n++) e.push(t[n]);
        s && (r += s, n.push(r)), s = o.length;
    }
    return {
        vertices: e,
        holes: n,
        dimensions: i
    };
}

function Nt(t) {
    let e;
    return Array.isArray(t) || t instanceof Float32Array ? e = "float32" : t instanceof Uint32Array ? e = "uint32" : t instanceof Int32Array ? e = "sint32" : t instanceof Uint16Array ? e = "uint16" : t instanceof Int16Array ? e = "sint16" : t instanceof Uint8Array ? e = "uint8" : t instanceof Int8Array && (e = "sint8"), 
    e;
}

const Dt = {
    5120: {
        name: "sint8",
        bytes: 1
    },
    5122: {
        name: "sint16",
        bytes: 2
    },
    5124: {
        name: "sint32",
        bytes: 4
    },
    5121: {
        name: "uint8",
        bytes: 1
    },
    5123: {
        name: "uint16",
        bytes: 2
    },
    5125: {
        name: "uint32",
        bytes: 4
    },
    5126: {
        name: "float32",
        bytes: 4
    }
};

function Lt(t, e) {
    const n = Dt[t].name;
    return e > 1 ? n + "x" + e : n;
}

const Ft = {
    mat2x3f: {
        pad: [ 3, 1 ]
    },
    mat2x3h: {
        pad: [ 3, 1 ]
    },
    mat3x3f: {
        pad: [ 3, 1 ]
    },
    mat3x3h: {
        pad: [ 3, 1 ]
    },
    mat4x3f: {
        pad: [ 3, 1 ]
    },
    mat4x3h: {
        pad: [ 3, 1 ]
    },
    mat3x4f: {
        pad: [ 3, 1 ]
    },
    mat3x4h: {
        pad: [ 3, 1 ]
    }
};

function Ut(t, e) {
    return 0 === e ? t : Math.ceil(t / e) * e;
}

const zt = [], Gt = {
    5120: "int8",
    5122: "int16",
    5124: "int32",
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float"
}, Bt = {
    5120: 1,
    5122: 2,
    5124: 4,
    5121: 1,
    5123: 2,
    5125: 4,
    5126: 4
}, Vt = {
    "positionSize": 3,
    "primitive": "triangles",
    "positionAttribute": "aPosition",
    "normalAttribute": "aNormal",
    "uv0Attribute": "aTexCoord",
    "uv1Attribute": "aTexCoord1",
    "color0Attribute": "aColor0",
    "tangentAttribute": "aTangent",
    "pickingIdAttribute": "aPickingId",
    "textureCoordMatrixAttribute": "aTextureCoordMatrix"
};

let jt = 1;

const Wt = "_reshader_refCount";

class qt {
    static createElementBuffer(t, e) {
        if (t.wgpu) {
            if (Array.isArray(e)) {
                e = new (Qt(e))(e);
            }
            return Zt(t, e, GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST, "index buffer");
        }
        return t.elements(e);
    }
    static createBuffer(t, e, n) {
        return t.wgpu ? Zt(t, e, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST, n) : t.buffer(e);
    }
    static padGPUBufferAlignment(t, e) {
        const n = t.byteLength / e;
        if (n % 4 == 0) return t;
        const i = t.constructor, r = t.length / e, s = te(r, n / r), o = new i(s * e);
        for (let n = 0; n < e; n++) for (let e = 0; e < r; e++) o[n * s + e] = t[n * r + e];
        return o;
    }
    constructor(t, e, n, i) {
        this.A = 0, this.data = t, this.elements = e, this.desc = E({}, Vt, i), this.semantic = function(t) {
            const e = {};
            for (const n in Vt) n.endsWith("Attribute") && (e[t[n]] = Vt[n]);
            return e;
        }(this.desc);
        const r = this.M();
        this.data[this.desc.positionAttribute] = r, n || (this.elements ? n = Xt(this.elements) : r && r.length ? n = r.length / this.desc.positionSize : r && r.interleavedArray ? n = r.interleavedArray.length / this.desc.positionSize : r && r.array && (n = r.array.length / this.desc.positionSize)), 
        this.count = n, this.elements || (this.elements = n), this.T = !P(this.elements), 
        this.properties = {}, this.C = {}, this.O = {}, this.getVertexCount(), this.I(!0), 
        this.updateBoundingBox();
    }
    set version(t) {
        throw new Error("Geometry.version is read only.");
    }
    get version() {
        return this.A;
    }
    M() {
        return this.data[this.desc.positionAttribute];
    }
    I(t) {
        if (!this.data) return;
        const e = this.C || {};
        for (const n in this.data) {
            const i = this.data[n];
            if (i) if (i.buffer && i.buffer.destroy) {
                const e = i.buffer;
                e[Wt] || (e[Wt] = 0), t && e[Wt]++;
            } else if (i && i.array) if (V(i)) {
                let t = i.array.buffer.__id;
                t || (t = i.array.buffer.__id = jt++), this.data[n] = {
                    buffer: t,
                    offset: i.byteOffset,
                    stride: i.byteStride,
                    type: Gt[i.componentType],
                    size: i.itemSize,
                    count: i.count,
                    componentType: i.componentType
                }, e[t] || (e[t] = {
                    data: i.array.buffer
                });
            } else this.data[n] = i.array;
        }
        this.C = e;
        const n = this.elements;
        n && n.array && (this.elements = n.array);
    }
    getBuffer(t) {
        return this.data[t] && this.data[t].buffer;
    }
    getAttrData(t) {
        const e = t.key, n = !this.P || !this.P[e];
        if (this.P || (this.P = {}), n) {
            const t = this.P[e] = {}, n = this.data, {positionAttribute: i, normalAttribute: r, uv0Attribute: s, uv1Attribute: o, tangentAttribute: a, color0Attribute: c, pickingIdAttribute: h, textureCoordMatrixAttribute: l} = this.desc;
            E(t, this.data), t.aPosition = n[i], n[r] && (t.aNormal = n[r]), n[s] && (t.aTexCoord = n[s]), 
            n[o] && (t.aTexCoord1 = n[o]), n[a] && (t.aTangent = n[a]), n[c] && (t.aColor0 = n[c]), 
            n[h] && (t.aPickingId = n[h]), n[l] && (t.aTextureCoordMatrix = n[l]);
        }
        return this.P[e];
    }
    getREGLData(t, e, n) {
        if (this.getAttrData(e), L(t) && !n) {
            const n = !this.P || !this.P[e.key], i = e && e.key || "default";
            if (!this.O[i] || n || this.O[i].dirty) {
                const n = this.P[e.key], r = this.H, s = [];
                for (let t = 0; t < e.length; t++) {
                    const i = e[t].name, o = n[i] && n[i].buffer;
                    if (o && o.destroy) void 0 !== n[i].stride ? s.push(n[i]) : s.push(o); else {
                        const t = n[i];
                        if (!t) {
                            this.desc.fillEmptyDataInMissingAttribute ? s.push(new Uint8Array(4 * r)) : s.push(zt);
                            continue;
                        }
                        const e = (t.data && R(t.data) ? t.data.length : t.length) / r;
                        t.data ? (t.dimension = e, s.push(t)) : s.push({
                            data: t,
                            dimension: e
                        });
                    }
                }
                const o = {
                    attributes: s,
                    primitive: this.getPrimitive()
                };
                if (this.elements && !P(this.elements)) if (this.elements.destroy) o.elements = this.elements; else {
                    o.elements = {
                        primitive: this.getPrimitive(),
                        data: this.elements
                    };
                    const t = this.getElementsType(this.elements);
                    t && (o.elements.type = t);
                }
                this.O[i] ? this.O[i].vao(o) : this.O[i] = {
                    vao: t.vao(o)
                };
            }
            return delete this.O[i].dirty, this.O[i];
        }
        return this.P[e.key];
    }
    R(t) {
        if (t === this.k) return !1;
        if (t.length !== this.k.length) return !0;
        for (let e = 0; e < t.length; e++) if (t[e] !== this.k[e]) return !0;
        return !1;
    }
    generateBuffers(t) {
        const e = !!t.wgpu, n = this.C;
        for (const e in n) n[e].buffer || (n[e].buffer = qt.createBuffer(t, n[e].data, e)), 
        delete n[e].data;
        const i = this.desc.positionAttribute, r = this.desc.altitudeAttribute, s = this.data, o = this.H, a = {};
        for (const c in s) if (s[c]) {
            if (Array.isArray(s[c]) ? s[c] = new Float32Array(s[c]) : e && R(s[c]) && (s[c] = qt.padGPUBufferAlignment(s[c], o)), 
            void 0 === s[c].buffer || s[c].buffer instanceof ArrayBuffer) {
                const e = (s[c].data ? s[c].data : s[c]).length / o, n = s[c].data ? s[c] : {
                    data: s[c]
                };
                n.dimension = e;
                const h = qt.createBuffer(t, n, c);
                h[Wt] = 1, a[c] = {
                    buffer: h
                }, c !== i && c !== r || (a[c].array = s[c]);
            } else s[c].buffer.destroy ? a[c] = s[c] : n[s[c].buffer] && (a[c] = E({}, s[c]), 
            a[c].buffer = n[s[c].buffer].buffer);
            (this.desc.static || c !== i) && delete s[c].array;
        }
        if (this.data = a, delete this.P, this.elements && !P(this.elements)) {
            if (this.getPrimitive(), this.elements, this.getElementsType(this.elements), !this.desc.static && !this.elements.destroy) {
                const t = this.elements;
                let e;
                e = Array.isArray(this.elements) ? Qt(this.elements) : this.elements.constructor, 
                this.indices = new e(t.length);
                for (let e = 0; e < t.length; e++) this.indices[e] = t[e];
            }
            this.elements = this.elements.destroy ? this.elements : qt.createElementBuffer(t, this.elements);
            const e = this.elements;
            e[Wt] || (e[Wt] = 0), e[Wt]++;
        }
    }
    getVertexCount() {
        const {positionAttribute: t, positionSize: e, color0Attribute: n} = this.desc;
        let i = this.data[t];
        i.data && (i = i.data), i.array && (i = i.array), R(i) ? this.H = Math.ceil(i.length / e) : i && void 0 !== i.count && (this.H = i.count);
        const r = n;
        if (this.data[r]) {
            const t = this.data[r].data || this.data[r].array || this.data[r];
            Array.isArray(t) ? this.N = t.length / this.H : this.data[r].buffer && this.data[r].buffer.destroy ? this.N = this.data[r].buffer._buffer.dimension : t && t.itemSize && (this.N = t.itemSize);
        }
        return this.H;
    }
    getColor0Size() {
        return this.N || 0;
    }
    deleteData(t) {
        const e = this.data[t];
        return e ? (this.D(), e.buffer && e.buffer.destroy && e.buffer.destroy(), delete this.data[t], 
        delete this.P, this.L(!1), this) : this;
    }
    updateData(t, e) {
        const n = this.data[t];
        if (!n) return this;
        let i;
        return this.D(), this.data[t] = e, n.buffer && n.buffer.destroy && (i = n), t === this.desc.positionAttribute && this.updateBoundingBox(), 
        this.getVertexCount(), i && (i.buffer.mapState ? i.buffer = this.F(i.buffer, e) : i.buffer(e), 
        this.data[t] = i), this.I(!1), this.desc.positionAttribute === t && (this.U = !0), 
        delete this.P, this;
    }
    F(t, e) {
        Array.isArray(e) && (e = new Float32Array(e));
        const n = t.device;
        if (e.buffer.byteLength > t.size) {
            const i = Zt(n, e, t.usage, t.label);
            return delete t.device, t.destroy(), i;
        }
        return n.wgpu.queue.writeBuffer(t, 0, e.buffer, 0, e.buffer.byteLength), t;
    }
    updateSubData(t, e, n) {
        const i = this.data[t];
        if (!i) return this;
        let r;
        if (this.D(), i.buffer && i.buffer.destroy && (r = i), t === this.desc.positionAttribute && this.G(e), 
        r) {
            const t = Bt[r.buffer._buffer.dtype];
            if (e.BYTES_PER_ELEMENT !== t) {
                const n = function(t, e) {
                    if (t instanceof Uint8Array || t instanceof Uint16Array || t instanceof Uint32Array || t instanceof Uint8ClampedArray) return 1 === e ? Uint8Array : 2 === e ? Uint16Array : Uint32Array;
                    if (t instanceof Int8Array || t instanceof Int16Array || t instanceof Int32Array) return 1 === e ? Int8Array : 2 === e ? Int16Array : Int32Array;
                    if (t instanceof Float32Array || t instanceof Float64Array) return 4 === e ? Float32Array : Float64Array;
                    return null;
                }(e, t);
                e = new n(e);
            }
            r.buffer.subdata(e, n * t);
        } else {
            const i = this.data[t].data ? this.data[t].data : this.data[t];
            for (let t = 0; t < e.length; t++) i[n + t] = e[t];
        }
        return this.I(!1), this.desc.positionAttribute === t && (this.U = !0), delete this.P, 
        this;
    }
    getPrimitive() {
        return this.desc.primitive;
    }
    getElements() {
        return this.elements;
    }
    setElements(t, e) {
        if (!t) throw new Error("elements data is invalid");
        this.D();
        const n = this.elements;
        if (this.count = void 0 === e ? Xt(t) : e, t && t.destroy) this.elements = t; else if (n.destroy) if (n.mapState) {
            if (Array.isArray(t)) {
                t = new (Qt(t))(t);
            }
            this.elements = this.F(n, t);
        } else this.elements = n(t); else this.elements = t;
        return this.L(!0), this.T = !P(t), this;
    }
    isIndexedElements() {
        return this.T;
    }
    deleteElements() {
        return this.elements && 0 !== this.elements.length ? (this.D(), this.elements && this.elements.destroy && !this.elements[Q] && (this.elements.destroy(), 
        this.elements[Q] = 1), this.elements = [], this.L(!0), this) : this;
    }
    L(t) {
        if (this.O) {
            for (const e in this.O) t ? this.O[e].vao.destroy() : this.O[e].dirty = !0;
            t && (this.O = {});
        }
    }
    setDrawCount(t) {
        return this.D(), this.count1 = t, this;
    }
    getDrawCount() {
        return this.count1 >= 0 ? this.count1 : this.count;
    }
    setDrawOffset(t) {
        return this.D(), this.offset = t, this;
    }
    getDrawOffset() {
        return this.offset || 0;
    }
    dispose() {
        if (this.B(), this.V((t => {
            if (!t[Q]) {
                let e = t[Wt];
                e && e--, e <= 0 ? (t[Q] = !0, t.destroy()) : t[Wt] = e;
            }
        })), this.properties) {
            const t = this.properties.oldElementsBeforeHighlight;
            t && !t[Q] && t.destroy && (t.destroy(), t[Q] = !0), delete this.properties.oldElementsBeforeHighlight, 
            delete this.properties.hasInvisible;
        }
        this.data = {}, this.C = {}, delete this.P, this.count = 0, this.elements = [], 
        delete this.j, this.W = !0;
    }
    B() {
        for (const t in this.O) this.O[t].vao.destroy();
        this.O = {};
    }
    isDisposed() {
        return !!this.W;
    }
    updateBoundingBox() {
        let t = this.boundingBox;
        t || (t = this.boundingBox = new at);
        const e = this.desc.positionAttribute;
        let n, i, r = this.data[e];
        if (R(r) || (r.data ? r = r.data : j(r) ? r = this.q(this.desc.positionAttribute) : r.array && (n = r.min, 
        i = r.max, r = r.array)), r && r.length) {
            const e = t.min, s = t.max;
            if (n && i) h.set(e, ...n), h.set(s, ...i); else {
                h.set(e, r[0], r[1], r[2]), h.set(s, r[0], r[1], r[2]);
                for (let t = 3; t < r.length; ) {
                    const n = r[t++], i = r[t++], o = r[t++];
                    n < e[0] && (e[0] = n), i < e[1] && (e[1] = i), o < e[2] && (e[2] = o), n > s[0] && (s[0] = n), 
                    i > s[1] && (s[1] = i), o > s[2] && (s[2] = o);
                }
            }
            t.updateVertex(), t.dirty();
        }
    }
    G(t) {
        const e = this.boundingBox, n = e.min, i = e.max, r = this.desc.positionSize;
        for (let e = 0; e < t.length; ) {
            const s = t[e++], o = t[e++];
            let a = 0;
            3 === r && (a = t[e++]), s < n[0] && (n[0] = s), o < n[1] && (n[1] = o), a < n[2] && (n[2] = a), 
            s > i[0] && (i[0] = s), o > i[1] && (i[1] = o), a > i[2] && (i[2] = a);
        }
        e.updateVertex(), e.dirty();
    }
    q(t) {
        const e = A(), n = this.data[t] && this.data[t].array ? this.data[t].array : this.data[t], i = n.buffer;
        if (j(n)) {
            const r = this.C[i] ? this.C[i].data : n.array, {count: s, size: o, stride: a, offset: c, componentType: h} = n, l = e.GLTFLoader.getTypedArrayCtor(h);
            if ((0 === a || a === o * l.BYTES_PER_ELEMENT) && c % l.BYTES_PER_ELEMENT == 0) return new l(r, c, s * o);
            if (t === this.desc.positionAttribute) return !this.j || this.j && this.j.length < o * s ? (this.j = new l(o * s), 
            e.GLTFLoader.readInterleavedArray(this.j, r, s, o, a, c, h)) : this.U ? (this.U = !1, 
            e.GLTFLoader.readInterleavedArray(this.j, r, s, o, a, c, h)) : this.j;
            {
                const t = new l(o * s);
                return e.GLTFLoader.readInterleavedArray(t, r, s, o, a, c, h);
            }
        }
        return n;
    }
    createTangent(t = "aTangent") {
        this.D();
        const {normalAttribute: e, positionAttribute: n, uv0Attribute: i} = this.desc, r = this.q(e), s = this.q(n), o = x(s, r, this.data[i], this.elements), a = this.data[t] = new Float32Array(o.length), c = [ 0, 0, 0, 0 ], f = [ 0, 0, 0 ], u = [ 0, 0, 0, 0 ];
        for (let t = 0; t < o.length; t += 4) {
            const e = t / 4 * 3;
            h.set(f, r[e], r[e + 1], r[e + 2]), l.set(c, o[t], o[t + 1], o[t + 2], o[t + 3]), 
            _(u, f, c), l.copy(a.subarray(t, t + 4), u);
        }
        delete this.P;
    }
    createNormal(t = "aNormal") {
        this.D();
        const e = this.q(this.desc.positionAttribute);
        this.data[t] = b(e.array || e, this.elements), delete this.P;
    }
    createBarycentric(t = "aBarycentric") {
        if ("triangles" !== this.desc.primitive) throw new Error("Primitive must be triangles to create bary centric data");
        this.D();
        const e = new Uint8Array(3 * this.H);
        for (let t = 0, n = this.elements.length; t < n; ) for (let n = 0; n < 3; n++) {
            e[3 * this.elements[t++] + n] = 1;
        }
        this.data[t] = e, delete this.P;
    }
    buildUniqueVertex() {
        this.D();
        const t = this.data, e = this.elements;
        if (!R(e)) throw new Error("elements must be array to build unique vertex.");
        const n = Object.keys(t), i = {};
        let r = t[this.desc.positionAttribute];
        if (r = r.length ? r : r.array, !R(r)) throw new Error(this.desc.positionAttribute + " must be array to build unique vertex.");
        const s = this.H, o = e.length;
        for (let e = 0; e < n.length; e++) {
            const r = n[e], a = R(t[r]) ? t[r] : t[r].array, c = a.length / s;
            if (!R(a)) throw new Error(r + " must be array to build unique vertex.");
            i[r] = a;
            const h = k(a);
            t[r] = new h(o * c);
        }
        let a = 0;
        for (let r = 0; r < o; r++) {
            const o = e[r];
            for (let e = 0; e < n.length; e++) {
                const r = n[e], c = t[r], h = i[r].length / s;
                for (let t = 0; t < h; t++) c[a * h + t] = i[r][o * h + t];
            }
            e[r] = a++;
        }
        r = this.data[this.desc.positionAttribute], this.H = Math.ceil(r.length / this.desc.positionSize), 
        delete this.P;
    }
    getMemorySize() {
        let t = 0;
        for (const e in this.data) F(this.data, e) && (t += U(this.data[e]));
        if (this.elements) {
            const e = this.elements;
            e.destroy ? e._elements ? t += e._elements.buffer.byteLength : t += e.size : e.BYTES_PER_ELEMENT ? t += e.length * e.BYTES_PER_ELEMENT : e.length && (t += 4 * e.length);
        }
        return t;
    }
    V(t) {
        this.elements && this.elements.destroy && t(this.elements);
        for (const e in this.data) F(this.data, e) && this.data[e] && this.data[e].buffer && this.data[e].buffer.destroy && t(this.data[e].buffer);
        for (const e in this.C) F(this.C, e) && this.C[e] && this.C[e].buffer && this.C[e].buffer.destroy && t(this.C[e].buffer);
    }
    getElementsType(t) {
        return t instanceof Uint8Array ? "uint8" : t instanceof Uint16Array ? "uint16" : t instanceof Uint32Array ? "uint32" : void 0;
    }
    D() {
        this.A++;
    }
    getCommandKey(t) {
        if (t && t.wgpu) {
            const t = [];
            for (const e in this.data) {
                const n = this.data[e];
                n.byteStride ? t.push(`${e}(${n.byteOffset}/${n.byteStride}})`) : t.push(e);
            }
            return t.sort().join("-");
        }
        return "";
    }
    getBufferDescriptor(t) {
        const e = [];
        for (const n in t) {
            const i = t[n];
            e[i.location] = i;
        }
        const n = this.data, i = [], r = {};
        for (let s = 0; s < e.length; s++) {
            if (!e[s]) continue;
            const o = e[s].geoAttrName, a = n[o];
            if (!a) continue;
            const c = t[this.semantic[o] || o];
            if (!c) continue;
            const h = a.accessorName, l = a.byteStride;
            if (l && h) {
                const t = Lt(a.componentType, a.itemSize);
                let e = r[h];
                e ? e.attributes.push({
                    shaderLocation: c.location,
                    format: t,
                    offset: a.byteOffset
                }) : (e = {
                    arrayStride: l,
                    attributes: [ {
                        shaderLocation: c.location,
                        format: t,
                        offset: a.byteOffset
                    } ]
                }, r[h] = e, i[s] = e);
            } else {
                const t = Kt(a, c);
                i[s] = t;
            }
        }
        return i;
    }
}

function Xt(t) {
    if (P(t)) return t;
    if (void 0 !== t.count) return t.count;
    if (t.destroy) return t._elements ? t._elements.vertCount : t.itemCount;
    if (void 0 !== t.length) return t.length;
    if (t.data) return t.data.length;
    throw new Error("invalid elements length");
}

function Kt(t, e) {
    const n = t.data || t.array || t;
    let i = e.itemSize;
    if (t.buffer && !R(t)) {
        const n = t.buffer.bytesPerElement;
        i = te(i, n);
        const r = Jt(t, i);
        return {
            arrayStride: i * n,
            attributes: [ {
                shaderLocation: e.location,
                format: r,
                offset: 0
            } ]
        };
    }
    if (R(n)) {
        let s, o;
        return t.componentType ? (s = Lt(t.componentType, t.itemSize), r = t.componentType, 
        o = Dt[r].bytes) : (s = Jt(n, i), o = $t(n)), i = te(i, o), {
            arrayStride: i * o,
            attributes: [ {
                shaderLocation: e.location,
                format: s,
                offset: 0
            } ]
        };
    }
    var r;
}

function $t(t) {
    const e = Yt(t);
    if (e.destroy) return e.bytesPerElement;
    if (e.BYTES_PER_ELEMENT) return e.BYTES_PER_ELEMENT;
    if (Array.isArray(e)) return 4;
    {
        const t = e;
        return A().GLTFLoader.getTypedArrayCtor(t.componentType).BYTES_PER_ELEMENT;
    }
}

function Jt(t, e) {
    const n = Yt(t);
    let i;
    return i = n.destroy ? n.itemType : Nt(n), e > 1 ? i + "x" + e : i;
}

function Yt(t) {
    return t.data || t.buffer.destroy && t.buffer || t;
}

function Zt(t, e, n, i) {
    e = e.data || e, Array.isArray(e[0]) && (e = kt(e)), Array.isArray(e) && (e = new Float32Array(e));
    const r = e.constructor, s = Ut(e.byteLength, 4), o = t.wgpu.createBuffer({
        label: i,
        size: s,
        usage: n,
        mappedAtCreation: !0
    });
    return o.device = t, new r(o.getMappedRange()).set(e), o.unmap(), o.itemCount = e.length, 
    o.itemType = Nt(e), o.bytesPerElement = $t(e), o;
}

function Qt(t) {
    let e = -1 / 0;
    for (let n = 0; n < t.length; n++) t[n] > e && (e = t[n]);
    return function(t) {
        return t < 65536 ? Uint16Array : Uint32Array;
    }(e);
}

function te(t, e) {
    const n = t * e;
    return n % 4 == 0 ? t : t + (4 - n % 4) / e;
}

const ee = [ "points", "lines", "line strip", "line loop", "triangles", "triangle strip", "triangle fan" ];

function ne(t) {
    return ee[t];
}

const ie = {
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float",
    36193: "half float"
};

function re(t) {
    return ie[t];
}

function se(t) {
    return t instanceof Uint8Array ? "uint8" : t instanceof Int8Array ? "int8" : t instanceof Uint16Array ? "uint16" : t instanceof Int16Array ? "int16" : "float";
}

const oe = {
    6406: "alpha",
    6407: "rgb",
    6408: "rgba",
    6409: "luminance",
    6410: "luminance alpha",
    33776: "rgb s3tc dxt1",
    33777: "rgba s3tc dxt1",
    33778: "rgba s3tc dxt3",
    33779: "rgba s3tc dxt5",
    35840: "rgb pvrtc 4bppv1",
    35841: "rgb pvrtc 2bppv1",
    35842: "rgba pvrtc 4bppv1",
    35843: "rgba pvrtc 2bppv1",
    35986: "rgb atc",
    35987: "rgba atc explicit alpha",
    34798: "rgba atc interpolated alpha",
    36196: "rgb etc1",
    37492: "rgb etc2"
};

function ae(t) {
    return oe[t];
}

const ce = {
    9729: "linear",
    9728: "nearest"
};

function he(t) {
    return ce[t];
}

const le = {
    9729: "linear",
    9728: "nearest",
    9984: "nearest mipmap nearest",
    9985: "linear mipmap nearest",
    9986: "nearest mipmap linear",
    9987: "linear mipmap linear"
};

function fe(t) {
    return le[t];
}

const ue = {
    10497: "repeat",
    33071: "clamp",
    33648: "mirror"
};

function de(t) {
    return ue[t];
}

const me = "__reshader_webgl_buffer", ve = "__reshader_webgl_tex";

function ge(t, e, n) {
    let i;
    if (R(e) ? e.buffer && void 0 !== e.byteOffset && (i = e) : e.array && e.array.buffer && void 0 !== e.array.byteOffset && (i = e.array), 
    !i) return null;
    const r = i.buffer, s = i.byteOffset;
    r[me] || (r[me] = {});
    let o = r[me][s];
    if (!o) {
        const e = {};
        n && E(e, n), e.data = i, e.type || (e.type = se(i)), o = t.buffer(e), r[me][s] = o;
    }
    return o;
}

function pe(t, e) {
    const n = e.data;
    if (!n || !n.buffer) return t.texture(e);
    const i = n.buffer, r = n.byteOffset;
    i[ve] || (i[ve] = {});
    let s = i[ve][r];
    return s || (s = t.texture(e), i[ve][r] = s), s;
}

var xe = Object.freeze({
    __proto__: null,
    getArrayType: se,
    getMaterialFormat: ae,
    getMaterialType: re,
    getPrimitive: ne,
    getTextureMagFilter: he,
    getTextureMinFilter: fe,
    getTextureWrap: de,
    getUniqueREGLBuffer: ge,
    getUniqueTexture: pe
});

const _e = [ 0, 0, 0 ], be = [ 0, 0, 0 ], ye = [ 0, 0, 0 ], we = [], Se = [], Ae = [], Me = [ "a", "b", "c" ];

class Te extends qt {
    constructor(t, e, n, i) {
        super(t, e, n, {
            primitive: ne(1),
            positionAttribute: i.positionAttribute
        });
    }
    M() {
        const t = this.data[this.desc.positionAttribute];
        if (!t.length) return [];
        const e = Math.pow(10, 4), n = Math.cos(Math.PI / 180 * .8), i = this.elements, r = t.length ? t : t.array, s = i.length ? i ? i.length : r.length / 3 : i, o = [ 0, 0, 0 ], a = new Array(3), c = {}, h = [], l = new Ce;
        for (let t = 0; t < s; t += 3) {
            i.length ? (o[0] = i[t], o[1] = i[t + 1], o[2] = i[t + 2]) : (o[0] = t, o[1] = t + 1, 
            o[2] = t + 2), l.a = Oe(we, r, o[0]), l.b = Oe(Se, r, o[1]), l.c = Oe(Ae, r, o[2]);
            const s = l.getNormal(), f = l.a, u = l.b, d = l.c;
            if (a[0] = `${Math.round(f[0] * e)},${Math.round(f[1] * e)},${Math.round(f[2] * e)}`, 
            a[1] = `${Math.round(u[0] * e)},${Math.round(u[1] * e)},${Math.round(u[2] * e)}`, 
            a[2] = `${Math.round(d[0] * e)},${Math.round(d[1] * e)},${Math.round(d[2] * e)}`, 
            a[0] !== a[1] && a[1] !== a[2] && a[2] !== a[0]) for (let t = 0; t < 3; t++) this.X(t, o, l, c, a, n, s, h);
        }
        for (const t in c) if (c[t]) {
            const {index0: e, index1: n} = c[t];
            h.push(r[3 * e], r[3 * e + 1], r[3 * e + 2]), h.push(r[3 * n], r[3 * n + 1], r[3 * n + 2]);
        }
        return this.elements = this.K(h), h;
    }
    X(t, e, n, i, r, s, o, a) {
        const c = (t + 1) % 3, l = r[t], f = r[c], u = n[Me[t]], d = n[Me[c]], m = `${l}_${f}`, v = `${f}_${l}`;
        if (v in i && i[v]) {
            h.dot(o, i[v].normal) <= s && (a.push(u[0], u[1], u[2]), a.push(d[0], d[1], d[2])), 
            i[v] = null;
        } else m in i || (i[m] = {
            index0: e[t],
            index1: e[c],
            normal: h.copy([ 0, 0, 0 ], o)
        });
    }
    K(t) {
        const e = [], n = t.length / 3;
        for (let t = 0; t < n; t++) e.push(t);
        return e;
    }
}

class Ce {
    constructor(t = [ 0, 0, 0 ], e = [ 0, 0, 0 ], n = [ 0, 0, 0 ]) {
        this.a = t, this.b = e, this.c = n;
    }
    getNormal() {
        const t = h.sub(_e, this.a, this.b), e = h.sub(be, this.a, this.c);
        h.cross(ye, t, e);
        const n = h.length(ye);
        return h.set(ye, ye[0] / n, ye[1] / n, ye[2] / n);
    }
}

function Oe(t, e, n) {
    return h.set(t, e[3 * n], e[3 * n + 1], e[3 * n + 2]);
}

class Ee {}

class Ie extends(Z(Ee)){
    constructor(t = {}, e) {
        super(), this.A = 0, this.$ = 0, this.uniforms = I({}, e || {}, t);
        for (const e in t) {
            const n = Object.getOwnPropertyDescriptor(t, e).get;
            n && Object.defineProperty(this.uniforms, e, {
                get: n
            });
        }
        this.unlit = !1, this.J = {}, this.refCount = 0, this.Y = (...t) => this.Z.call(this, ...t), 
        this.tt(), this.et();
    }
    set version(t) {
        throw new Error("Material.version is read only.");
    }
    get version() {
        return this.A;
    }
    get propVersion() {
        return this.$;
    }
    set doubleSided(t) {
        this.uniforms.doubleSided = t;
    }
    get doubleSided() {
        return !!this.uniforms.doubleSided;
    }
    getUniforms(t) {
        if (this.J && !this.isDirty()) return this.J;
        const e = this.uniforms, n = {};
        for (const i in e) if (this.isTexture(i)) Object.defineProperty(n, i, {
            enumerable: !0,
            configurable: !0,
            get: function() {
                return e[i].getREGLTexture(t);
            }
        }); else {
            Object.getOwnPropertyDescriptor(e, i).get ? Object.defineProperty(n, i, {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return e[i];
                }
            }) : n[i] = e[i];
        }
        return this.J = n, this.nt = this.version, n;
    }
    getMemorySize() {
        const t = this.uniforms;
        let e = 0;
        for (const n in t) this.isTexture(n) ? e += t[n].getMemorySize() : this.uniforms[n] && this.uniforms[n].destroy && (e += z(this.uniforms[n]));
        return e;
    }
    isReady() {
        return this.it <= 0;
    }
    hasUniform(t) {
        return Object.prototype.hasOwnProperty.call(this.uniforms, t);
    }
    setUniform(t, e) {
        return this.set(t, e);
    }
    getUniform(t) {
        return this.get(t);
    }
    set(t, e, n = !0) {
        if (this.get(t) === e) return this;
        const i = T(this.uniforms[t]) && !T(e) || !T(this.uniforms[t]) && T(e);
        if (this.uniforms[t] && this.isTexture(t) && n && this.uniforms[t].dispose(), T(e)) T(this.uniforms[t]) || delete this.uniforms[t]; else if (this.uniforms[t] = e, 
        this.J) {
            const n = Object.getOwnPropertyDescriptor(this.J, t);
            n && !n.get && (this.$++, this.J[t] = e);
        }
        return this.isTexture(t) && this.et(), i && (this.tt(), this.D()), this;
    }
    setFunctionUniform(t, e) {
        return this.tt(), this.D(), Object.defineProperty(this.uniforms, t, {
            enumerable: !0,
            get: e
        }), this;
    }
    hasFunctionUniform(t) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, t);
    }
    get(t) {
        return this.uniforms[t];
    }
    isDirty() {
        return this.nt !== this.version;
    }
    appendDefines(t, e) {
        const n = this.uniforms;
        return n ? (n.jointTexture && (t.HAS_SKIN = 1), n.morphWeights1 && (t.HAS_MORPH = 1), 
        (n.khr_offset || n.khr_rotation || n.khr_scale) && (t.HAS_KHR_TEXTURE_TRANSFORM = 1), 
        t) : t;
    }
    hasSkinAnimation() {
        return !!(this.uniforms && this.uniforms.jointTexture && this.uniforms.skinAnimation);
    }
    isTexture(t) {
        return this.uniforms[t] instanceof rt;
    }
    dispose() {
        for (const t in this.uniforms) {
            const e = this.uniforms[t];
            e && (e.dispose ? e.dispose() : e.destroy && !e[Q] && (e.destroy(), e[Q] = !0));
        }
        delete this.uniforms, delete this.J, delete this.Y, this.W = !0;
    }
    isDisposed() {
        return !!this.W;
    }
    et() {
        this.it = 0;
        for (const t in this.uniforms) if (this.isTexture(t)) {
            const e = this.uniforms[t];
            e.isReady() || (this.it++, e.on("complete", this.Y));
        }
    }
    Z() {
        this.it--, this.D(), this.it <= 0 && (this.W || this.fire("complete"));
    }
    getUniformKeys() {
        return this.rt;
    }
    tt() {
        const t = [];
        for (const e in this.uniforms) F(this.uniforms, e) && !T(this.uniforms[e]) && t.push(e);
        this.rt = t.join();
    }
    D() {
        this.A++;
    }
}

const Pe = {
    "time": 0,
    "seeThrough": !0,
    "thickness": .03,
    "fill": [ 1, .5137254902, .98, 1 ],
    "stroke": [ .7019607843, .9333333333, .2274509804, 1 ],
    "dashEnabled": !1,
    "dashAnimate": !1,
    "dashRepeats": 1,
    "dashLength": .8,
    "dashOverlap": !0,
    "insideAltColor": !1,
    "squeeze": !1,
    "squeezeMin": .5,
    "squeezeMax": 1,
    "dualStroke": !1,
    "secondThickness": .05,
    "opacity": 1,
    "noiseEnable": !1
};

const He = {
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "materialShininess": 32,
    "environmentExposure": 1,
    "specularStrength": 32,
    "opacity": 1,
    "extrusionOpacity": 0,
    "extrusionOpacityRange": [ 0, 1.8 ],
    "baseColorTexture": null,
    "normalTexture": null,
    "emissiveTexture": null,
    "occlusionTexture": null,
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "alphaTest": 0
};

class Re extends Ie {
    constructor(t) {
        super(t, He);
    }
    static convertFrom(t) {
        const e = {};
        for (const n in He) e[n] = t.get(n);
        return new Re(e);
    }
    appendDefines(t, e) {
        super.appendDefines(t, e);
        const n = this.uniforms;
        this.unlit && (t.SHADING_MODEL_UNLIT = 1), n.extrusionOpacity && (t.HAS_EXTRUSION_OPACITY = 1), 
        e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1);
        return e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, t.COLOR0_SIZE = e.getColor0Size()), 
        e.data.aVertexColorType && (t.HAS_VERTEX_COLOR = 1), e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
        e.data[e.desc.uv0Attribute] ? (n.baseColorTexture && (t.HAS_BASECOLOR_MAP = 1), 
        n.occlusionTexture && e.data[e.desc.uv1Attribute] && (t.HAS_AO_MAP = 1), n.emissiveTexture && (t.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (t.HAS_NORMAL_MAP = 1), (t.HAS_BASECOLOR_MAP || t.HAS_AO_MAP || t.HAS_EMISSIVE_MAP || t.HAS_NORMAL_MAP) && (t.HAS_MAP = 1), 
        t) : t;
    }
}

const ke = {
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "opacity": 1,
    "envMapExposure": 128,
    "emissiveFactor": [ .1, .1, .1 ],
    "specularFactor": [ 0, 0, 0 ],
    "envRotationSin": 0,
    "envRotationCos": 1,
    "reflectivity": .01,
    "themingColor": [ 0, 0, 0, 0 ],
    "exposureBias": .6
};

const Ne = {
    "diffuseFactor": [ 1, 1, 1, 1 ],
    "specularFactor": [ 1, 1, 1 ],
    "glossinessFactor": 1,
    "diffuseTexture": null,
    "specularGlossinessTexture": null,
    "normalTexture": null,
    "emissiveTexture": null,
    "occlusionTexture": null
};

function De(t) {
    return class extends t {
        constructor(...t) {
            let e = t[0];
            e = E({}, Ne, e || {}), super(e, t);
        }
        appendDefines(t, e) {
            if (super.appendDefines(t, e), t.SHADING_MODEL_SPECULAR_GLOSSINESS = 1, !e.data[e.desc.uv0Attribute]) return t;
            const n = this.uniforms;
            return n.diffuseTexture && (t.HAS_DIFFUSE_MAP = 1), n.specularGlossinessTexture && (t.HAS_SPECULARGLOSSINESS_MAP = 1), 
            (t.HAS_SPECULARGLOSSINESS_MAP || t.HAS_DIFFUSE_MAP) && (t.HAS_MAP = 1), t;
        }
    };
}

class Le extends(De(Re)){}

class Fe {
    constructor() {
        this.constants = new Map, this.aliases = new Map, this.structs = new Map;
    }
}

class Ue {
    constructor() {}
    get isAstNode() {
        return !0;
    }
    get astNodeType() {
        return "";
    }
    evaluate(t) {
        throw new Error("Cannot evaluate node");
    }
    evaluateString(t) {
        return this.evaluate(t).toString();
    }
    search(t) {}
    searchBlock(t, e) {
        if (t) {
            e(ze.instance);
            for (const n of t) n instanceof Array ? this.searchBlock(n, e) : n.search(e);
            e(Ge.instance);
        }
    }
}

class ze extends Ue {}

ze.instance = new ze;

class Ge extends Ue {}

Ge.instance = new Ge;

class Be extends Ue {
    constructor() {
        super();
    }
}

let Ve = class extends Be {
    constructor(t, e, n, i, r, s) {
        super(), this.calls = new Set, this.name = t, this.args = e, this.returnType = n, 
        this.body = i, this.startLine = r, this.endLine = s;
    }
    get astNodeType() {
        return "function";
    }
    search(t) {
        this.searchBlock(this.body, t);
    }
};

class je extends Be {
    constructor(t) {
        super(), this.expression = t;
    }
    get astNodeType() {
        return "staticAssert";
    }
    search(t) {
        this.expression.search(t);
    }
}

class We extends Be {
    constructor(t, e) {
        super(), this.condition = t, this.body = e;
    }
    get astNodeType() {
        return "while";
    }
    search(t) {
        this.condition.search(t), this.searchBlock(this.body, t);
    }
}

class qe extends Be {
    constructor(t) {
        super(), this.body = t;
    }
    get astNodeType() {
        return "continuing";
    }
    search(t) {
        this.searchBlock(this.body, t);
    }
}

class Xe extends Be {
    constructor(t, e, n, i) {
        super(), this.init = t, this.condition = e, this.increment = n, this.body = i;
    }
    get astNodeType() {
        return "for";
    }
    search(t) {
        var e, n, i;
        null === (e = this.init) || void 0 === e || e.search(t), null === (n = this.condition) || void 0 === n || n.search(t), 
        null === (i = this.increment) || void 0 === i || i.search(t), this.searchBlock(this.body, t);
    }
}

class Ke extends Be {
    constructor(t, e, n, i, r) {
        super(), this.name = t, this.type = e, this.storage = n, this.access = i, this.value = r;
    }
    get astNodeType() {
        return "var";
    }
    search(t) {
        var e;
        t(this), null === (e = this.value) || void 0 === e || e.search(t);
    }
}

class $e extends Be {
    constructor(t, e, n) {
        super(), this.name = t, this.type = e, this.value = n;
    }
    get astNodeType() {
        return "override";
    }
    search(t) {
        var e;
        null === (e = this.value) || void 0 === e || e.search(t);
    }
}

class Je extends Be {
    constructor(t, e, n, i, r) {
        super(), this.name = t, this.type = e, this.storage = n, this.access = i, this.value = r;
    }
    get astNodeType() {
        return "let";
    }
    search(t) {
        var e;
        t(this), null === (e = this.value) || void 0 === e || e.search(t);
    }
}

class Ye extends Be {
    constructor(t, e, n, i, r) {
        super(), this.name = t, this.type = e, this.storage = n, this.access = i, this.value = r;
    }
    get astNodeType() {
        return "const";
    }
    evaluate(t) {
        return this.value.evaluate(t);
    }
    search(t) {
        var e;
        t(this), null === (e = this.value) || void 0 === e || e.search(t);
    }
}

var Ze, Qe, tn, en, nn;

!function(t) {
    t.increment = "++", t.decrement = "--";
}(Ze || (Ze = {})), function(t) {
    t.parse = function(e) {
        const n = e;
        if ("parse" == n) throw new Error("Invalid value for IncrementOperator");
        return t[n];
    };
}(Ze || (Ze = {}));

class rn extends Be {
    constructor(t, e) {
        super(), this.operator = t, this.variable = e;
    }
    get astNodeType() {
        return "increment";
    }
    search(t) {
        this.variable.search(t);
    }
}

!function(t) {
    t.assign = "=", t.addAssign = "+=", t.subtractAssin = "-=", t.multiplyAssign = "*=", 
    t.divideAssign = "/=", t.moduloAssign = "%=", t.andAssign = "&=", t.orAssign = "|=", 
    t.xorAssign = "^=", t.shiftLeftAssign = "<<=", t.shiftRightAssign = ">>=";
}(Qe || (Qe = {})), function(t) {
    t.parse = function(t) {
        const e = t;
        if ("parse" == e) throw new Error("Invalid value for AssignOperator");
        return e;
    };
}(Qe || (Qe = {}));

class sn extends Be {
    constructor(t, e, n) {
        super(), this.operator = t, this.variable = e, this.value = n;
    }
    get astNodeType() {
        return "assign";
    }
    search(t) {
        this.variable.search(t), this.value.search(t);
    }
}

class on extends Be {
    constructor(t, e) {
        super(), this.name = t, this.args = e;
    }
    get astNodeType() {
        return "call";
    }
    search(t) {
        for (const e of this.args) e.search(t);
        t(this);
    }
}

class an extends Be {
    constructor(t, e) {
        super(), this.body = t, this.continuing = e;
    }
    get astNodeType() {
        return "loop";
    }
}

class cn extends Be {
    constructor(t, e) {
        super(), this.condition = t, this.body = e;
    }
    get astNodeType() {
        return "body";
    }
}

class hn extends Be {
    constructor(t, e, n, i) {
        super(), this.condition = t, this.body = e, this.elseif = n, this.else = i;
    }
    get astNodeType() {
        return "if";
    }
    search(t) {
        this.condition.search(t), this.searchBlock(this.body, t), this.searchBlock(this.elseif, t), 
        this.searchBlock(this.else, t);
    }
}

class ln extends Be {
    constructor(t) {
        super(), this.value = t;
    }
    get astNodeType() {
        return "return";
    }
    search(t) {
        var e;
        null === (e = this.value) || void 0 === e || e.search(t);
    }
}

class fn extends Be {
    constructor(t) {
        super(), this.name = t;
    }
    get astNodeType() {
        return "enable";
    }
}

class un extends Be {
    constructor(t) {
        super(), this.extensions = t;
    }
    get astNodeType() {
        return "requires";
    }
}

class dn extends Be {
    constructor(t, e) {
        super(), this.severity = t, this.rule = e;
    }
    get astNodeType() {
        return "diagnostic";
    }
}

class mn extends Be {
    constructor(t, e) {
        super(), this.name = t, this.type = e;
    }
    get astNodeType() {
        return "alias";
    }
}

class vn extends Be {
    constructor() {
        super();
    }
    get astNodeType() {
        return "discard";
    }
}

class gn extends Be {
    constructor() {
        super();
    }
    get astNodeType() {
        return "break";
    }
}

class pn extends Be {
    constructor() {
        super();
    }
    get astNodeType() {
        return "continue";
    }
}

class xn extends Be {
    constructor(t) {
        super(), this.name = t;
    }
    get astNodeType() {
        return "type";
    }
    get isStruct() {
        return !1;
    }
    get isArray() {
        return !1;
    }
}

class _n extends xn {
    constructor(t, e, n, i) {
        super(t), this.members = e, this.startLine = n, this.endLine = i;
    }
    get astNodeType() {
        return "struct";
    }
    get isStruct() {
        return !0;
    }
    getMemberIndex(t) {
        for (let e = 0; e < this.members.length; e++) if (this.members[e].name == t) return e;
        return -1;
    }
}

class bn extends xn {
    constructor(t, e, n) {
        super(t), this.format = e, this.access = n;
    }
    get astNodeType() {
        return "template";
    }
}

class yn extends xn {
    constructor(t, e, n, i) {
        super(t), this.storage = e, this.type = n, this.access = i;
    }
    get astNodeType() {
        return "pointer";
    }
}

class wn extends xn {
    constructor(t, e, n, i) {
        super(t), this.attributes = e, this.format = n, this.count = i;
    }
    get astNodeType() {
        return "array";
    }
    get isArray() {
        return !0;
    }
}

class Sn extends xn {
    constructor(t, e, n) {
        super(t), this.format = e, this.access = n;
    }
    get astNodeType() {
        return "sampler";
    }
}

class An extends Ue {
    constructor() {
        super();
    }
}

class Mn extends An {
    constructor(t) {
        super(), this.value = t;
    }
    get astNodeType() {
        return "stringExpr";
    }
    toString() {
        return this.value;
    }
    evaluateString() {
        return this.value;
    }
}

class Tn extends An {
    constructor(t, e) {
        super(), this.type = t, this.args = e;
    }
    get astNodeType() {
        return "createExpr";
    }
    search(t) {
        if (t(this), this.args) for (const e of this.args) e.search(t);
    }
    evaluate(t) {
        return this.args[0].evaluate(t);
    }
}

class Cn extends An {
    constructor(t, e) {
        super(), this.name = t, this.args = e;
    }
    get astNodeType() {
        return "callExpr";
    }
    evaluate(t) {
        switch (this.name) {
          case "abs":
            return Math.abs(this.args[0].evaluate(t));

          case "acos":
            return Math.acos(this.args[0].evaluate(t));

          case "acosh":
            return Math.acosh(this.args[0].evaluate(t));

          case "asin":
            return Math.asin(this.args[0].evaluate(t));

          case "asinh":
            return Math.asinh(this.args[0].evaluate(t));

          case "atan":
            return Math.atan(this.args[0].evaluate(t));

          case "atan2":
            return Math.atan2(this.args[0].evaluate(t), this.args[1].evaluate(t));

          case "atanh":
            return Math.atanh(this.args[0].evaluate(t));

          case "ceil":
            return Math.ceil(this.args[0].evaluate(t));

          case "clamp":
            return Math.min(Math.max(this.args[0].evaluate(t), this.args[1].evaluate(t)), this.args[2].evaluate(t));

          case "cos":
            return Math.cos(this.args[0].evaluate(t));

          case "degrees":
            return 180 * this.args[0].evaluate(t) / Math.PI;

          case "distance":
            return Math.sqrt(Math.pow(this.args[0].evaluate(t) - this.args[1].evaluate(t), 2));

          case "dot":
          case "exp":
            return Math.exp(this.args[0].evaluate(t));

          case "exp2":
            return Math.pow(2, this.args[0].evaluate(t));

          case "floor":
            return Math.floor(this.args[0].evaluate(t));

          case "fma":
            return this.args[0].evaluate(t) * this.args[1].evaluate(t) + this.args[2].evaluate(t);

          case "fract":
          case "modf":
            return this.args[0].evaluate(t) - Math.floor(this.args[0].evaluate(t));

          case "inverseSqrt":
            return 1 / Math.sqrt(this.args[0].evaluate(t));

          case "log":
            return Math.log(this.args[0].evaluate(t));

          case "log2":
            return Math.log2(this.args[0].evaluate(t));

          case "max":
            return Math.max(this.args[0].evaluate(t), this.args[1].evaluate(t));

          case "min":
            return Math.min(this.args[0].evaluate(t), this.args[1].evaluate(t));

          case "mix":
            return this.args[0].evaluate(t) * (1 - this.args[2].evaluate(t)) + this.args[1].evaluate(t) * this.args[2].evaluate(t);

          case "pow":
            return Math.pow(this.args[0].evaluate(t), this.args[1].evaluate(t));

          case "radians":
            return this.args[0].evaluate(t) * Math.PI / 180;

          case "round":
            return Math.round(this.args[0].evaluate(t));

          case "sign":
            return Math.sign(this.args[0].evaluate(t));

          case "sin":
            return Math.sin(this.args[0].evaluate(t));

          case "sinh":
            return Math.sinh(this.args[0].evaluate(t));

          case "saturate":
            return Math.min(Math.max(this.args[0].evaluate(t), 0), 1);

          case "smoothstep":
            return this.args[0].evaluate(t) * this.args[0].evaluate(t) * (3 - 2 * this.args[0].evaluate(t));

          case "sqrt":
            return Math.sqrt(this.args[0].evaluate(t));

          case "step":
            return this.args[0].evaluate(t) < this.args[1].evaluate(t) ? 0 : 1;

          case "tan":
            return Math.tan(this.args[0].evaluate(t));

          case "tanh":
            return Math.tanh(this.args[0].evaluate(t));

          case "trunc":
            return Math.trunc(this.args[0].evaluate(t));

          default:
            throw new Error("Non const function: " + this.name);
        }
    }
    search(t) {
        for (const e of this.args) e.search(t);
        t(this);
    }
}

class On extends An {
    constructor(t) {
        super(), this.name = t;
    }
    get astNodeType() {
        return "varExpr";
    }
    search(t) {
        t(this), this.postfix && this.postfix.search(t);
    }
    evaluate(t) {
        const e = t.constants.get(this.name);
        if (!e) throw new Error("Cannot evaluate node");
        return e.evaluate(t);
    }
}

class En extends An {
    constructor(t, e) {
        super(), this.name = t, this.initializer = e;
    }
    get astNodeType() {
        return "constExpr";
    }
    evaluate(t) {
        var e, n;
        if (this.initializer instanceof Tn) {
            const i = null === (e = this.postfix) || void 0 === e ? void 0 : e.evaluateString(t), r = null === (n = this.initializer.type) || void 0 === n ? void 0 : n.name, s = t.structs.get(r), o = null == s ? void 0 : s.getMemberIndex(i);
            if (void 0 !== o && -1 != o) {
                return this.initializer.args[o].evaluate(t);
            }
            return this.initializer.evaluate(t);
        }
        return this.initializer.evaluate(t);
    }
    search(t) {
        this.initializer.search(t);
    }
}

class In extends An {
    constructor(t) {
        super(), this.value = t;
    }
    get astNodeType() {
        return "literalExpr";
    }
    evaluate() {
        return this.value;
    }
}

class Pn extends An {
    constructor(t, e) {
        super(), this.type = t, this.value = e;
    }
    get astNodeType() {
        return "bitcastExpr";
    }
    search(t) {
        this.value.search(t);
    }
}

class Hn extends An {
    constructor(t) {
        super(), this.contents = t;
    }
    get astNodeType() {
        return "groupExpr";
    }
    evaluate(t) {
        return this.contents[0].evaluate(t);
    }
    search(t) {
        this.searchBlock(this.contents, t);
    }
}

class Rn extends An {
    constructor(t) {
        super(), this.index = t;
    }
    search(t) {
        this.index.search(t);
    }
}

class kn extends An {
    constructor() {
        super();
    }
}

class Nn extends kn {
    constructor(t, e) {
        super(), this.operator = t, this.right = e;
    }
    get astNodeType() {
        return "unaryOp";
    }
    evaluate(t) {
        switch (this.operator) {
          case "+":
            return this.right.evaluate(t);

          case "-":
            return -this.right.evaluate(t);

          case "!":
            return this.right.evaluate(t) ? 0 : 1;

          case "~":
            return ~this.right.evaluate(t);

          default:
            throw new Error("Unknown unary operator: " + this.operator);
        }
    }
    search(t) {
        this.right.search(t);
    }
}

class Dn extends kn {
    constructor(t, e, n) {
        super(), this.operator = t, this.left = e, this.right = n;
    }
    get astNodeType() {
        return "binaryOp";
    }
    evaluate(t) {
        switch (this.operator) {
          case "+":
            return this.left.evaluate(t) + this.right.evaluate(t);

          case "-":
            return this.left.evaluate(t) - this.right.evaluate(t);

          case "*":
            return this.left.evaluate(t) * this.right.evaluate(t);

          case "/":
            return this.left.evaluate(t) / this.right.evaluate(t);

          case "%":
            return this.left.evaluate(t) % this.right.evaluate(t);

          case "==":
            return this.left.evaluate(t) == this.right.evaluate(t) ? 1 : 0;

          case "!=":
            return this.left.evaluate(t) != this.right.evaluate(t) ? 1 : 0;

          case "<":
            return this.left.evaluate(t) < this.right.evaluate(t) ? 1 : 0;

          case ">":
            return this.left.evaluate(t) > this.right.evaluate(t) ? 1 : 0;

          case "<=":
            return this.left.evaluate(t) <= this.right.evaluate(t) ? 1 : 0;

          case ">=":
            return this.left.evaluate(t) >= this.right.evaluate(t) ? 1 : 0;

          case "&&":
            return this.left.evaluate(t) && this.right.evaluate(t) ? 1 : 0;

          case "||":
            return this.left.evaluate(t) || this.right.evaluate(t) ? 1 : 0;

          default:
            throw new Error(`Unknown operator ${this.operator}`);
        }
    }
    search(t) {
        this.left.search(t), this.right.search(t);
    }
}

class Ln extends Ue {
    constructor() {
        super();
    }
}

class Fn extends Ln {
    constructor(t, e) {
        super(), this.selector = t, this.body = e;
    }
    get astNodeType() {
        return "case";
    }
    search(t) {
        this.searchBlock(this.body, t);
    }
}

class Un extends Ln {
    constructor(t) {
        super(), this.body = t;
    }
    get astNodeType() {
        return "default";
    }
    search(t) {
        this.searchBlock(this.body, t);
    }
}

class zn extends Ue {
    constructor(t, e, n) {
        super(), this.name = t, this.type = e, this.attributes = n;
    }
    get astNodeType() {
        return "argument";
    }
}

class Gn extends Ue {
    constructor(t, e) {
        super(), this.condition = t, this.body = e;
    }
    get astNodeType() {
        return "elseif";
    }
    search(t) {
        this.condition.search(t), this.searchBlock(this.body, t);
    }
}

class Bn extends Ue {
    constructor(t, e, n) {
        super(), this.name = t, this.type = e, this.attributes = n;
    }
    get astNodeType() {
        return "member";
    }
}

class Vn extends Ue {
    constructor(t, e) {
        super(), this.name = t, this.value = e;
    }
    get astNodeType() {
        return "attribute";
    }
}

!function(t) {
    t[t.token = 0] = "token", t[t.keyword = 1] = "keyword", t[t.reserved = 2] = "reserved";
}(en || (en = {}));

class jn {
    constructor(t, e, n) {
        this.name = t, this.type = e, this.rule = n;
    }
    toString() {
        return this.name;
    }
}

class Wn {}

tn = Wn, Wn.none = new jn("", en.reserved, ""), Wn.eof = new jn("EOF", en.token, ""), 
Wn.reserved = {
    asm: new jn("asm", en.reserved, "asm"),
    bf16: new jn("bf16", en.reserved, "bf16"),
    do: new jn("do", en.reserved, "do"),
    enum: new jn("enum", en.reserved, "enum"),
    f16: new jn("f16", en.reserved, "f16"),
    f64: new jn("f64", en.reserved, "f64"),
    handle: new jn("handle", en.reserved, "handle"),
    i8: new jn("i8", en.reserved, "i8"),
    i16: new jn("i16", en.reserved, "i16"),
    i64: new jn("i64", en.reserved, "i64"),
    mat: new jn("mat", en.reserved, "mat"),
    premerge: new jn("premerge", en.reserved, "premerge"),
    regardless: new jn("regardless", en.reserved, "regardless"),
    typedef: new jn("typedef", en.reserved, "typedef"),
    u8: new jn("u8", en.reserved, "u8"),
    u16: new jn("u16", en.reserved, "u16"),
    u64: new jn("u64", en.reserved, "u64"),
    unless: new jn("unless", en.reserved, "unless"),
    using: new jn("using", en.reserved, "using"),
    vec: new jn("vec", en.reserved, "vec"),
    void: new jn("void", en.reserved, "void")
}, Wn.keywords = {
    array: new jn("array", en.keyword, "array"),
    atomic: new jn("atomic", en.keyword, "atomic"),
    bool: new jn("bool", en.keyword, "bool"),
    f32: new jn("f32", en.keyword, "f32"),
    i32: new jn("i32", en.keyword, "i32"),
    mat2x2: new jn("mat2x2", en.keyword, "mat2x2"),
    mat2x3: new jn("mat2x3", en.keyword, "mat2x3"),
    mat2x4: new jn("mat2x4", en.keyword, "mat2x4"),
    mat3x2: new jn("mat3x2", en.keyword, "mat3x2"),
    mat3x3: new jn("mat3x3", en.keyword, "mat3x3"),
    mat3x4: new jn("mat3x4", en.keyword, "mat3x4"),
    mat4x2: new jn("mat4x2", en.keyword, "mat4x2"),
    mat4x3: new jn("mat4x3", en.keyword, "mat4x3"),
    mat4x4: new jn("mat4x4", en.keyword, "mat4x4"),
    ptr: new jn("ptr", en.keyword, "ptr"),
    sampler: new jn("sampler", en.keyword, "sampler"),
    sampler_comparison: new jn("sampler_comparison", en.keyword, "sampler_comparison"),
    struct: new jn("struct", en.keyword, "struct"),
    texture_1d: new jn("texture_1d", en.keyword, "texture_1d"),
    texture_2d: new jn("texture_2d", en.keyword, "texture_2d"),
    texture_2d_array: new jn("texture_2d_array", en.keyword, "texture_2d_array"),
    texture_3d: new jn("texture_3d", en.keyword, "texture_3d"),
    texture_cube: new jn("texture_cube", en.keyword, "texture_cube"),
    texture_cube_array: new jn("texture_cube_array", en.keyword, "texture_cube_array"),
    texture_multisampled_2d: new jn("texture_multisampled_2d", en.keyword, "texture_multisampled_2d"),
    texture_storage_1d: new jn("texture_storage_1d", en.keyword, "texture_storage_1d"),
    texture_storage_2d: new jn("texture_storage_2d", en.keyword, "texture_storage_2d"),
    texture_storage_2d_array: new jn("texture_storage_2d_array", en.keyword, "texture_storage_2d_array"),
    texture_storage_3d: new jn("texture_storage_3d", en.keyword, "texture_storage_3d"),
    texture_depth_2d: new jn("texture_depth_2d", en.keyword, "texture_depth_2d"),
    texture_depth_2d_array: new jn("texture_depth_2d_array", en.keyword, "texture_depth_2d_array"),
    texture_depth_cube: new jn("texture_depth_cube", en.keyword, "texture_depth_cube"),
    texture_depth_cube_array: new jn("texture_depth_cube_array", en.keyword, "texture_depth_cube_array"),
    texture_depth_multisampled_2d: new jn("texture_depth_multisampled_2d", en.keyword, "texture_depth_multisampled_2d"),
    texture_external: new jn("texture_external", en.keyword, "texture_external"),
    u32: new jn("u32", en.keyword, "u32"),
    vec2: new jn("vec2", en.keyword, "vec2"),
    vec3: new jn("vec3", en.keyword, "vec3"),
    vec4: new jn("vec4", en.keyword, "vec4"),
    bitcast: new jn("bitcast", en.keyword, "bitcast"),
    block: new jn("block", en.keyword, "block"),
    break: new jn("break", en.keyword, "break"),
    case: new jn("case", en.keyword, "case"),
    continue: new jn("continue", en.keyword, "continue"),
    continuing: new jn("continuing", en.keyword, "continuing"),
    default: new jn("default", en.keyword, "default"),
    diagnostic: new jn("diagnostic", en.keyword, "diagnostic"),
    discard: new jn("discard", en.keyword, "discard"),
    else: new jn("else", en.keyword, "else"),
    enable: new jn("enable", en.keyword, "enable"),
    fallthrough: new jn("fallthrough", en.keyword, "fallthrough"),
    false: new jn("false", en.keyword, "false"),
    fn: new jn("fn", en.keyword, "fn"),
    for: new jn("for", en.keyword, "for"),
    function: new jn("function", en.keyword, "function"),
    if: new jn("if", en.keyword, "if"),
    let: new jn("let", en.keyword, "let"),
    const: new jn("const", en.keyword, "const"),
    loop: new jn("loop", en.keyword, "loop"),
    while: new jn("while", en.keyword, "while"),
    private: new jn("private", en.keyword, "private"),
    read: new jn("read", en.keyword, "read"),
    read_write: new jn("read_write", en.keyword, "read_write"),
    return: new jn("return", en.keyword, "return"),
    requires: new jn("requires", en.keyword, "requires"),
    storage: new jn("storage", en.keyword, "storage"),
    switch: new jn("switch", en.keyword, "switch"),
    true: new jn("true", en.keyword, "true"),
    alias: new jn("alias", en.keyword, "alias"),
    type: new jn("type", en.keyword, "type"),
    uniform: new jn("uniform", en.keyword, "uniform"),
    var: new jn("var", en.keyword, "var"),
    override: new jn("override", en.keyword, "override"),
    workgroup: new jn("workgroup", en.keyword, "workgroup"),
    write: new jn("write", en.keyword, "write"),
    r8unorm: new jn("r8unorm", en.keyword, "r8unorm"),
    r8snorm: new jn("r8snorm", en.keyword, "r8snorm"),
    r8uint: new jn("r8uint", en.keyword, "r8uint"),
    r8sint: new jn("r8sint", en.keyword, "r8sint"),
    r16uint: new jn("r16uint", en.keyword, "r16uint"),
    r16sint: new jn("r16sint", en.keyword, "r16sint"),
    r16float: new jn("r16float", en.keyword, "r16float"),
    rg8unorm: new jn("rg8unorm", en.keyword, "rg8unorm"),
    rg8snorm: new jn("rg8snorm", en.keyword, "rg8snorm"),
    rg8uint: new jn("rg8uint", en.keyword, "rg8uint"),
    rg8sint: new jn("rg8sint", en.keyword, "rg8sint"),
    r32uint: new jn("r32uint", en.keyword, "r32uint"),
    r32sint: new jn("r32sint", en.keyword, "r32sint"),
    r32float: new jn("r32float", en.keyword, "r32float"),
    rg16uint: new jn("rg16uint", en.keyword, "rg16uint"),
    rg16sint: new jn("rg16sint", en.keyword, "rg16sint"),
    rg16float: new jn("rg16float", en.keyword, "rg16float"),
    rgba8unorm: new jn("rgba8unorm", en.keyword, "rgba8unorm"),
    rgba8unorm_srgb: new jn("rgba8unorm_srgb", en.keyword, "rgba8unorm_srgb"),
    rgba8snorm: new jn("rgba8snorm", en.keyword, "rgba8snorm"),
    rgba8uint: new jn("rgba8uint", en.keyword, "rgba8uint"),
    rgba8sint: new jn("rgba8sint", en.keyword, "rgba8sint"),
    bgra8unorm: new jn("bgra8unorm", en.keyword, "bgra8unorm"),
    bgra8unorm_srgb: new jn("bgra8unorm_srgb", en.keyword, "bgra8unorm_srgb"),
    rgb10a2unorm: new jn("rgb10a2unorm", en.keyword, "rgb10a2unorm"),
    rg11b10float: new jn("rg11b10float", en.keyword, "rg11b10float"),
    rg32uint: new jn("rg32uint", en.keyword, "rg32uint"),
    rg32sint: new jn("rg32sint", en.keyword, "rg32sint"),
    rg32float: new jn("rg32float", en.keyword, "rg32float"),
    rgba16uint: new jn("rgba16uint", en.keyword, "rgba16uint"),
    rgba16sint: new jn("rgba16sint", en.keyword, "rgba16sint"),
    rgba16float: new jn("rgba16float", en.keyword, "rgba16float"),
    rgba32uint: new jn("rgba32uint", en.keyword, "rgba32uint"),
    rgba32sint: new jn("rgba32sint", en.keyword, "rgba32sint"),
    rgba32float: new jn("rgba32float", en.keyword, "rgba32float"),
    static_assert: new jn("static_assert", en.keyword, "static_assert")
}, Wn.tokens = {
    decimal_float_literal: new jn("decimal_float_literal", en.token, /((-?[0-9]*\.[0-9]+|-?[0-9]+\.[0-9]*)((e|E)(\+|-)?[0-9]+)?f?)|(-?[0-9]+(e|E)(\+|-)?[0-9]+f?)|([0-9]+f)/),
    hex_float_literal: new jn("hex_float_literal", en.token, /-?0x((([0-9a-fA-F]*\.[0-9a-fA-F]+|[0-9a-fA-F]+\.[0-9a-fA-F]*)((p|P)(\+|-)?[0-9]+f?)?)|([0-9a-fA-F]+(p|P)(\+|-)?[0-9]+f?))/),
    int_literal: new jn("int_literal", en.token, /-?0x[0-9a-fA-F]+|0i?|-?[1-9][0-9]*i?/),
    uint_literal: new jn("uint_literal", en.token, /0x[0-9a-fA-F]+u|0u|[1-9][0-9]*u/),
    ident: new jn("ident", en.token, /[_a-zA-Z][0-9a-zA-Z_]*/),
    and: new jn("and", en.token, "&"),
    and_and: new jn("and_and", en.token, "&&"),
    arrow: new jn("arrow ", en.token, "->"),
    attr: new jn("attr", en.token, "@"),
    forward_slash: new jn("forward_slash", en.token, "/"),
    bang: new jn("bang", en.token, "!"),
    bracket_left: new jn("bracket_left", en.token, "["),
    bracket_right: new jn("bracket_right", en.token, "]"),
    brace_left: new jn("brace_left", en.token, "{"),
    brace_right: new jn("brace_right", en.token, "}"),
    colon: new jn("colon", en.token, ":"),
    comma: new jn("comma", en.token, ","),
    equal: new jn("equal", en.token, "="),
    equal_equal: new jn("equal_equal", en.token, "=="),
    not_equal: new jn("not_equal", en.token, "!="),
    greater_than: new jn("greater_than", en.token, ">"),
    greater_than_equal: new jn("greater_than_equal", en.token, ">="),
    shift_right: new jn("shift_right", en.token, ">>"),
    less_than: new jn("less_than", en.token, "<"),
    less_than_equal: new jn("less_than_equal", en.token, "<="),
    shift_left: new jn("shift_left", en.token, "<<"),
    modulo: new jn("modulo", en.token, "%"),
    minus: new jn("minus", en.token, "-"),
    minus_minus: new jn("minus_minus", en.token, "--"),
    period: new jn("period", en.token, "."),
    plus: new jn("plus", en.token, "+"),
    plus_plus: new jn("plus_plus", en.token, "++"),
    or: new jn("or", en.token, "|"),
    or_or: new jn("or_or", en.token, "||"),
    paren_left: new jn("paren_left", en.token, "("),
    paren_right: new jn("paren_right", en.token, ")"),
    semicolon: new jn("semicolon", en.token, ";"),
    star: new jn("star", en.token, "*"),
    tilde: new jn("tilde", en.token, "~"),
    underscore: new jn("underscore", en.token, "_"),
    xor: new jn("xor", en.token, "^"),
    plus_equal: new jn("plus_equal", en.token, "+="),
    minus_equal: new jn("minus_equal", en.token, "-="),
    times_equal: new jn("times_equal", en.token, "*="),
    division_equal: new jn("division_equal", en.token, "/="),
    modulo_equal: new jn("modulo_equal", en.token, "%="),
    and_equal: new jn("and_equal", en.token, "&="),
    or_equal: new jn("or_equal", en.token, "|="),
    xor_equal: new jn("xor_equal", en.token, "^="),
    shift_right_equal: new jn("shift_right_equal", en.token, ">>="),
    shift_left_equal: new jn("shift_left_equal", en.token, "<<=")
}, Wn.simpleTokens = {
    "@": tn.tokens.attr,
    "{": tn.tokens.brace_left,
    "}": tn.tokens.brace_right,
    ":": tn.tokens.colon,
    ",": tn.tokens.comma,
    "(": tn.tokens.paren_left,
    ")": tn.tokens.paren_right,
    ";": tn.tokens.semicolon
}, Wn.literalTokens = {
    "&": tn.tokens.and,
    "&&": tn.tokens.and_and,
    "->": tn.tokens.arrow,
    "/": tn.tokens.forward_slash,
    "!": tn.tokens.bang,
    "[": tn.tokens.bracket_left,
    "]": tn.tokens.bracket_right,
    "=": tn.tokens.equal,
    "==": tn.tokens.equal_equal,
    "!=": tn.tokens.not_equal,
    ">": tn.tokens.greater_than,
    ">=": tn.tokens.greater_than_equal,
    ">>": tn.tokens.shift_right,
    "<": tn.tokens.less_than,
    "<=": tn.tokens.less_than_equal,
    "<<": tn.tokens.shift_left,
    "%": tn.tokens.modulo,
    "-": tn.tokens.minus,
    "--": tn.tokens.minus_minus,
    ".": tn.tokens.period,
    "+": tn.tokens.plus,
    "++": tn.tokens.plus_plus,
    "|": tn.tokens.or,
    "||": tn.tokens.or_or,
    "*": tn.tokens.star,
    "~": tn.tokens.tilde,
    "_": tn.tokens.underscore,
    "^": tn.tokens.xor,
    "+=": tn.tokens.plus_equal,
    "-=": tn.tokens.minus_equal,
    "*=": tn.tokens.times_equal,
    "/=": tn.tokens.division_equal,
    "%=": tn.tokens.modulo_equal,
    "&=": tn.tokens.and_equal,
    "|=": tn.tokens.or_equal,
    "^=": tn.tokens.xor_equal,
    ">>=": tn.tokens.shift_right_equal,
    "<<=": tn.tokens.shift_left_equal
}, Wn.regexTokens = {
    decimal_float_literal: tn.tokens.decimal_float_literal,
    hex_float_literal: tn.tokens.hex_float_literal,
    int_literal: tn.tokens.int_literal,
    uint_literal: tn.tokens.uint_literal,
    ident: tn.tokens.ident
}, Wn.storage_class = [ tn.keywords.function, tn.keywords.private, tn.keywords.workgroup, tn.keywords.uniform, tn.keywords.storage ], 
Wn.access_mode = [ tn.keywords.read, tn.keywords.write, tn.keywords.read_write ], 
Wn.sampler_type = [ tn.keywords.sampler, tn.keywords.sampler_comparison ], Wn.sampled_texture_type = [ tn.keywords.texture_1d, tn.keywords.texture_2d, tn.keywords.texture_2d_array, tn.keywords.texture_3d, tn.keywords.texture_cube, tn.keywords.texture_cube_array ], 
Wn.multisampled_texture_type = [ tn.keywords.texture_multisampled_2d ], Wn.storage_texture_type = [ tn.keywords.texture_storage_1d, tn.keywords.texture_storage_2d, tn.keywords.texture_storage_2d_array, tn.keywords.texture_storage_3d ], 
Wn.depth_texture_type = [ tn.keywords.texture_depth_2d, tn.keywords.texture_depth_2d_array, tn.keywords.texture_depth_cube, tn.keywords.texture_depth_cube_array, tn.keywords.texture_depth_multisampled_2d ], 
Wn.texture_external_type = [ tn.keywords.texture_external ], Wn.any_texture_type = [ ...tn.sampled_texture_type, ...tn.multisampled_texture_type, ...tn.storage_texture_type, ...tn.depth_texture_type, ...tn.texture_external_type ], 
Wn.texel_format = [ tn.keywords.r8unorm, tn.keywords.r8snorm, tn.keywords.r8uint, tn.keywords.r8sint, tn.keywords.r16uint, tn.keywords.r16sint, tn.keywords.r16float, tn.keywords.rg8unorm, tn.keywords.rg8snorm, tn.keywords.rg8uint, tn.keywords.rg8sint, tn.keywords.r32uint, tn.keywords.r32sint, tn.keywords.r32float, tn.keywords.rg16uint, tn.keywords.rg16sint, tn.keywords.rg16float, tn.keywords.rgba8unorm, tn.keywords.rgba8unorm_srgb, tn.keywords.rgba8snorm, tn.keywords.rgba8uint, tn.keywords.rgba8sint, tn.keywords.bgra8unorm, tn.keywords.bgra8unorm_srgb, tn.keywords.rgb10a2unorm, tn.keywords.rg11b10float, tn.keywords.rg32uint, tn.keywords.rg32sint, tn.keywords.rg32float, tn.keywords.rgba16uint, tn.keywords.rgba16sint, tn.keywords.rgba16float, tn.keywords.rgba32uint, tn.keywords.rgba32sint, tn.keywords.rgba32float ], 
Wn.const_literal = [ tn.tokens.int_literal, tn.tokens.uint_literal, tn.tokens.decimal_float_literal, tn.tokens.hex_float_literal, tn.keywords.true, tn.keywords.false ], 
Wn.literal_or_ident = [ tn.tokens.ident, tn.tokens.int_literal, tn.tokens.uint_literal, tn.tokens.decimal_float_literal, tn.tokens.hex_float_literal ], 
Wn.element_count_expression = [ tn.tokens.int_literal, tn.tokens.uint_literal, tn.tokens.ident ], 
Wn.template_types = [ tn.keywords.vec2, tn.keywords.vec3, tn.keywords.vec4, tn.keywords.mat2x2, tn.keywords.mat2x3, tn.keywords.mat2x4, tn.keywords.mat3x2, tn.keywords.mat3x3, tn.keywords.mat3x4, tn.keywords.mat4x2, tn.keywords.mat4x3, tn.keywords.mat4x4, tn.keywords.atomic, tn.keywords.bitcast, ...tn.any_texture_type ], 
Wn.attribute_name = [ tn.tokens.ident, tn.keywords.block, tn.keywords.diagnostic ], 
Wn.assignment_operators = [ tn.tokens.equal, tn.tokens.plus_equal, tn.tokens.minus_equal, tn.tokens.times_equal, tn.tokens.division_equal, tn.tokens.modulo_equal, tn.tokens.and_equal, tn.tokens.or_equal, tn.tokens.xor_equal, tn.tokens.shift_right_equal, tn.tokens.shift_left_equal ], 
Wn.increment_operators = [ tn.tokens.plus_plus, tn.tokens.minus_minus ];

class qn {
    constructor(t, e, n) {
        this.type = t, this.lexeme = e, this.line = n;
    }
    toString() {
        return this.lexeme;
    }
    isTemplateType() {
        return -1 != Wn.template_types.indexOf(this.type);
    }
    isArrayType() {
        return this.type == Wn.keywords.array;
    }
    isArrayOrTemplateType() {
        return this.isArrayType() || this.isTemplateType();
    }
}

class Xn {
    constructor(t) {
        this.st = [], this.ot = 0, this.ct = 0, this.ht = 1, this.lt = null != t ? t : "";
    }
    scanTokens() {
        for (;!this.ft(); ) if (this.ot = this.ct, !this.scanToken()) throw `Invalid syntax at line ${this.ht}`;
        return this.st.push(new qn(Wn.eof, "", this.ht)), this.st;
    }
    scanToken() {
        let t = this.ut();
        if ("\n" == t) return this.ht++, !0;
        if (this.dt(t)) return !0;
        if ("/" == t) {
            if ("/" == this.vt()) {
                for (;"\n" != t; ) {
                    if (this.ft()) return !0;
                    t = this.ut();
                }
                return this.ht++, !0;
            }
            if ("*" == this.vt()) {
                this.ut();
                let e = 1;
                for (;e > 0; ) {
                    if (this.ft()) return !0;
                    if (t = this.ut(), "\n" == t) this.ht++; else if ("*" == t) {
                        if ("/" == this.vt() && (this.ut(), e--, 0 == e)) return !0;
                    } else "/" == t && "*" == this.vt() && (this.ut(), e++);
                }
                return !0;
            }
        }
        const e = Wn.simpleTokens[t];
        if (e) return this.gt(e), !0;
        let n = Wn.none;
        const i = this.xt(t), r = "_" === t;
        if (this._t(t)) {
            let e = this.vt();
            for (;this._t(e); ) t += this.ut(), e = this.vt();
        }
        if (i) {
            const e = Wn.keywords[t];
            if (e) return this.gt(e), !0;
        }
        if (i || r) return this.gt(Wn.tokens.ident), !0;
        for (;;) {
            let e = this.bt(t);
            const i = this.vt();
            if ("-" == t && this.st.length > 0) {
                if ("=" == i) return this.ct++, t += i, this.gt(Wn.tokens.minus_equal), !0;
                if ("-" == i) return this.ct++, t += i, this.gt(Wn.tokens.minus_minus), !0;
                const n = this.st.length - 1;
                if ((-1 != Wn.literal_or_ident.indexOf(this.st[n].type) || this.st[n].type == Wn.tokens.paren_right) && ">" != i) return this.gt(e), 
                !0;
            }
            if (">" == t && (">" == i || "=" == i)) {
                let t = !1, n = this.st.length - 1;
                for (let e = 0; e < 5 && n >= 0 && -1 === Wn.assignment_operators.indexOf(this.st[n].type); ++e, 
                --n) if (this.st[n].type === Wn.tokens.less_than) {
                    n > 0 && this.st[n - 1].isArrayOrTemplateType() && (t = !0);
                    break;
                }
                if (t) return this.gt(e), !0;
            }
            if (e === Wn.none) {
                let i = t, r = 0;
                const s = 2;
                for (let t = 0; t < s; ++t) if (i += this.vt(t), e = this.bt(i), e !== Wn.none) {
                    r = t;
                    break;
                }
                if (e === Wn.none) return n !== Wn.none && (this.ct--, this.gt(n), !0);
                t = i, this.ct += r + 1;
            }
            if (n = e, this.ft()) break;
            t += this.ut();
        }
        return n !== Wn.none && (this.gt(n), !0);
    }
    bt(t) {
        for (const e in Wn.regexTokens) {
            const n = Wn.regexTokens[e];
            if (this.yt(t, n.rule)) return n;
        }
        const e = Wn.literalTokens[t];
        return e || Wn.none;
    }
    yt(t, e) {
        const n = e.exec(t);
        return n && 0 == n.index && n[0] == t;
    }
    ft() {
        return this.ct >= this.lt.length;
    }
    xt(t) {
        return t >= "a" && t <= "z" || t >= "A" && t <= "Z";
    }
    _t(t) {
        return t >= "a" && t <= "z" || t >= "A" && t <= "Z" || "_" == t || t >= "0" && t <= "9";
    }
    dt(t) {
        return " " == t || "\t" == t || "\r" == t;
    }
    ut(t = 0) {
        let e = this.lt[this.ct];
        return t = t || 0, t++, this.ct += t, e;
    }
    vt(t = 0) {
        return t = t || 0, this.ct + t >= this.lt.length ? "\0" : this.lt[this.ct + t];
    }
    gt(t) {
        const e = this.lt.substring(this.ot, this.ct);
        this.st.push(new qn(t, e, this.ht));
    }
}

class Kn {
    constructor() {
        this.st = [], this.ct = 0, this.wt = 0, this.St = new Fe, this.At = [];
    }
    parse(t) {
        this.Mt(t), this.At.length = 0;
        const e = [];
        for (;!this.ft(); ) {
            const t = this.Tt();
            if (!t) break;
            e.push(t);
        }
        if (this.At.length > 0) {
            for (const t of this.At) {
                const e = t.arrayType, n = t.countNode;
                if (n instanceof On) {
                    const t = n.name, i = this.St.constants.get(t);
                    if (i) try {
                        const t = i.evaluate(this.St);
                        e.count = t;
                    } catch (t) {}
                }
            }
            this.At.length = 0;
        }
        return e;
    }
    Mt(t) {
        if (t) if ("string" == typeof t) {
            const e = new Xn(t);
            this.st = e.scanTokens();
        } else this.st = t; else this.st = [];
        this.ct = 0;
    }
    Ct(t, e) {
        return {
            token: t,
            message: e,
            toString: function() {
                return `${e}`;
            }
        };
    }
    ft() {
        return this.ct >= this.st.length || this.Ot().type == Wn.eof;
    }
    yt(t) {
        if (t instanceof jn) return !!this.Et(t) && (this.ut(), !0);
        for (let e = 0, n = t.length; e < n; ++e) {
            const n = t[e];
            if (this.Et(n)) return this.ut(), !0;
        }
        return !1;
    }
    It(t, e) {
        if (this.Et(t)) return this.ut();
        throw this.Ct(this.Ot(), e);
    }
    Et(t) {
        if (this.ft()) return !1;
        const e = this.Ot();
        if (t instanceof Array) {
            const n = e.type;
            return -1 != t.indexOf(n);
        }
        return e.type == t;
    }
    ut() {
        var t, e;
        return this.wt = null !== (e = null === (t = this.Ot()) || void 0 === t ? void 0 : t.line) && void 0 !== e ? e : -1, 
        this.ft() || this.ct++, this.Pt();
    }
    Ot() {
        return this.st[this.ct];
    }
    Pt() {
        return this.st[this.ct - 1];
    }
    Tt() {
        for (;this.yt(Wn.tokens.semicolon) && !this.ft(); ) ;
        if (this.yt(Wn.keywords.alias)) {
            const t = this.Ht();
            return this.It(Wn.tokens.semicolon, "Expected ';'"), t;
        }
        if (this.yt(Wn.keywords.diagnostic)) {
            const t = this.Rt();
            return this.It(Wn.tokens.semicolon, "Expected ';'"), t;
        }
        if (this.yt(Wn.keywords.requires)) {
            const t = this.kt();
            return this.It(Wn.tokens.semicolon, "Expected ';'"), t;
        }
        if (this.yt(Wn.keywords.enable)) {
            const t = this.Nt();
            return this.It(Wn.tokens.semicolon, "Expected ';'"), t;
        }
        const t = this.Dt();
        if (this.Et(Wn.keywords.var)) {
            const e = this.Lt();
            return null != e && (e.attributes = t), this.It(Wn.tokens.semicolon, "Expected ';'."), 
            e;
        }
        if (this.Et(Wn.keywords.override)) {
            const e = this.Ft();
            return null != e && (e.attributes = t), this.It(Wn.tokens.semicolon, "Expected ';'."), 
            e;
        }
        if (this.Et(Wn.keywords.let)) {
            const e = this.Ut();
            return null != e && (e.attributes = t), this.It(Wn.tokens.semicolon, "Expected ';'."), 
            e;
        }
        if (this.Et(Wn.keywords.const)) {
            const e = this.zt();
            return null != e && (e.attributes = t), this.It(Wn.tokens.semicolon, "Expected ';'."), 
            e;
        }
        if (this.Et(Wn.keywords.struct)) {
            const e = this.Gt();
            return null != e && (e.attributes = t), e;
        }
        if (this.Et(Wn.keywords.fn)) {
            const e = this.Bt();
            return null != e && (e.attributes = t), e;
        }
        return null;
    }
    Bt() {
        if (!this.yt(Wn.keywords.fn)) return null;
        const t = this.wt, e = this.It(Wn.tokens.ident, "Expected function name.").toString();
        this.It(Wn.tokens.paren_left, "Expected '(' for function arguments.");
        const n = [];
        if (!this.Et(Wn.tokens.paren_right)) do {
            if (this.Et(Wn.tokens.paren_right)) break;
            const t = this.Dt(), e = this.It(Wn.tokens.ident, "Expected argument name.").toString();
            this.It(Wn.tokens.colon, "Expected ':' for argument type.");
            const i = this.Dt(), r = this.Vt();
            null != r && (r.attributes = i, n.push(new zn(e, r, t)));
        } while (this.yt(Wn.tokens.comma));
        this.It(Wn.tokens.paren_right, "Expected ')' after function arguments.");
        let i = null;
        if (this.yt(Wn.tokens.arrow)) {
            const t = this.Dt();
            i = this.Vt(), null != i && (i.attributes = t);
        }
        const r = this.jt(), s = this.wt;
        return new Ve(e, n, i, r, t, s);
    }
    jt() {
        const t = [];
        for (this.It(Wn.tokens.brace_left, "Expected '{' for block."); !this.Et(Wn.tokens.brace_right); ) {
            const e = this.Wt();
            null !== e && t.push(e);
        }
        return this.It(Wn.tokens.brace_right, "Expected '}' for block."), t;
    }
    Wt() {
        for (;this.yt(Wn.tokens.semicolon) && !this.ft(); ) ;
        if (this.Et(Wn.tokens.attr) && this.Dt(), this.Et(Wn.keywords.if)) return this.qt();
        if (this.Et(Wn.keywords.switch)) return this.Xt();
        if (this.Et(Wn.keywords.loop)) return this.Kt();
        if (this.Et(Wn.keywords.for)) return this.$t();
        if (this.Et(Wn.keywords.while)) return this.Jt();
        if (this.Et(Wn.keywords.continuing)) return this.Yt();
        if (this.Et(Wn.keywords.static_assert)) return this.Zt();
        if (this.Et(Wn.tokens.brace_left)) return this.jt();
        let t = null;
        return t = this.Et(Wn.keywords.return) ? this.Qt() : this.Et([ Wn.keywords.var, Wn.keywords.let, Wn.keywords.const ]) ? this.te() : this.yt(Wn.keywords.discard) ? new vn : this.yt(Wn.keywords.break) ? new gn : this.yt(Wn.keywords.continue) ? new pn : this.ee() || this.ne() || this.ie(), 
        null != t && this.It(Wn.tokens.semicolon, "Expected ';' after statement."), t;
    }
    Zt() {
        if (!this.yt(Wn.keywords.static_assert)) return null;
        const t = this.re();
        return new je(t);
    }
    Jt() {
        if (!this.yt(Wn.keywords.while)) return null;
        const t = this.re();
        this.Et(Wn.tokens.attr) && this.Dt();
        const e = this.jt();
        return new We(t, e);
    }
    Yt() {
        if (!this.yt(Wn.keywords.continuing)) return null;
        const t = this.jt();
        return new qe(t);
    }
    $t() {
        if (!this.yt(Wn.keywords.for)) return null;
        this.It(Wn.tokens.paren_left, "Expected '('.");
        const t = this.Et(Wn.tokens.semicolon) ? null : this.se();
        this.It(Wn.tokens.semicolon, "Expected ';'.");
        const e = this.Et(Wn.tokens.semicolon) ? null : this.oe();
        this.It(Wn.tokens.semicolon, "Expected ';'.");
        const n = this.Et(Wn.tokens.paren_right) ? null : this.ae();
        this.It(Wn.tokens.paren_right, "Expected ')'."), this.Et(Wn.tokens.attr) && this.Dt();
        const i = this.jt();
        return new Xe(t, e, n, i);
    }
    se() {
        return this.te() || this.ne() || this.ie();
    }
    ae() {
        return this.ne() || this.ee() || this.ie();
    }
    te() {
        if (this.Et(Wn.keywords.var)) {
            const t = this.ce();
            if (null === t) throw this.Ct(this.Ot(), "Variable declaration expected.");
            let e = null;
            return this.yt(Wn.tokens.equal) && (e = this.oe()), new Ke(t.name, t.type, t.storage, t.access, e);
        }
        if (this.yt(Wn.keywords.let)) {
            const t = this.It(Wn.tokens.ident, "Expected name for let.").toString();
            let e = null;
            if (this.yt(Wn.tokens.colon)) {
                const t = this.Dt();
                e = this.Vt(), null != e && (e.attributes = t);
            }
            this.It(Wn.tokens.equal, "Expected '=' for let.");
            const n = this.oe();
            return new Je(t, e, null, null, n);
        }
        if (this.yt(Wn.keywords.const)) {
            const t = this.It(Wn.tokens.ident, "Expected name for const.").toString();
            let e = null;
            if (this.yt(Wn.tokens.colon)) {
                const t = this.Dt();
                e = this.Vt(), null != e && (e.attributes = t);
            }
            this.It(Wn.tokens.equal, "Expected '=' for const.");
            const n = this.oe();
            return new Ye(t, e, null, null, n);
        }
        return null;
    }
    ee() {
        const t = this.ct, e = this.he();
        if (null == e) return null;
        if (!this.Et(Wn.increment_operators)) return this.ct = t, null;
        const n = this.It(Wn.increment_operators, "Expected increment operator");
        return new rn(n.type === Wn.tokens.plus_plus ? Ze.increment : Ze.decrement, e);
    }
    ie() {
        let t = null;
        if (this.Et(Wn.tokens.brace_right)) return null;
        let e = this.yt(Wn.tokens.underscore);
        if (e || (t = this.he()), !e && null == t) return null;
        const n = this.It(Wn.assignment_operators, "Expected assignment operator."), i = this.oe();
        return new sn(Qe.parse(n.lexeme), t, i);
    }
    ne() {
        if (!this.Et(Wn.tokens.ident)) return null;
        const t = this.ct, e = this.It(Wn.tokens.ident, "Expected function name."), n = this.le();
        return null === n ? (this.ct = t, null) : new on(e.lexeme, n);
    }
    Kt() {
        if (!this.yt(Wn.keywords.loop)) return null;
        this.Et(Wn.tokens.attr) && this.Dt(), this.It(Wn.tokens.brace_left, "Expected '{' for loop.");
        const t = [];
        let e = this.Wt();
        for (;null !== e; ) {
            if (Array.isArray(e)) for (let n of e) t.push(n); else t.push(e);
            e = this.Wt();
        }
        let n = null;
        return this.yt(Wn.keywords.continuing) && (n = this.jt()), this.It(Wn.tokens.brace_right, "Expected '}' for loop."), 
        new an(t, n);
    }
    Xt() {
        if (!this.yt(Wn.keywords.switch)) return null;
        const t = this.re();
        this.Et(Wn.tokens.attr) && this.Dt(), this.It(Wn.tokens.brace_left, "Expected '{' for switch.");
        const e = this.fe();
        if (null == e || 0 == e.length) throw this.Ct(this.Pt(), "Expected 'case' or 'default'.");
        return this.It(Wn.tokens.brace_right, "Expected '}' for switch."), new cn(t, e);
    }
    fe() {
        const t = [];
        if (this.yt(Wn.keywords.case)) {
            const e = this.ue();
            this.yt(Wn.tokens.colon), this.Et(Wn.tokens.attr) && this.Dt(), this.It(Wn.tokens.brace_left, "Exected '{' for switch case.");
            const n = this.de();
            this.It(Wn.tokens.brace_right, "Exected '}' for switch case."), t.push(new Fn(e, n));
        }
        if (this.yt(Wn.keywords.default)) {
            this.yt(Wn.tokens.colon), this.Et(Wn.tokens.attr) && this.Dt(), this.It(Wn.tokens.brace_left, "Exected '{' for switch default.");
            const e = this.de();
            this.It(Wn.tokens.brace_right, "Exected '}' for switch default."), t.push(new Un(e));
        }
        if (this.Et([ Wn.keywords.default, Wn.keywords.case ])) {
            const e = this.fe();
            t.push(e[0]);
        }
        return t;
    }
    ue() {
        const t = [ this.me() ];
        for (;this.yt(Wn.tokens.comma); ) t.push(this.me());
        return t;
    }
    de() {
        if (this.yt(Wn.keywords.fallthrough)) return this.It(Wn.tokens.semicolon, "Expected ';'"), 
        [];
        let t = this.Wt();
        if (null == t) return [];
        t instanceof Array || (t = [ t ]);
        const e = this.de();
        return 0 == e.length ? t : [ ...t, e[0] ];
    }
    qt() {
        if (!this.yt(Wn.keywords.if)) return null;
        const t = this.re();
        this.Et(Wn.tokens.attr) && this.Dt();
        const e = this.jt();
        let n = [];
        this.ve() && (this.Et(Wn.tokens.attr) && this.Dt(), n = this.ge(n));
        let i = null;
        return this.yt(Wn.keywords.else) && (this.Et(Wn.tokens.attr) && this.Dt(), i = this.jt()), 
        new hn(t, e, n, i);
    }
    ve() {
        return this.st[this.ct].type === Wn.keywords.else && this.st[this.ct + 1].type === Wn.keywords.if && (this.ut(), 
        this.ut(), !0);
    }
    ge(t = []) {
        const e = this.re(), n = this.jt();
        return t.push(new Gn(e, n)), this.ve() && (this.Et(Wn.tokens.attr) && this.Dt(), 
        this.ge(t)), t;
    }
    Qt() {
        if (!this.yt(Wn.keywords.return)) return null;
        const t = this.oe();
        return new ln(t);
    }
    oe() {
        let t = this.pe();
        for (;this.yt(Wn.tokens.or_or); ) t = new Dn(this.Pt().toString(), t, this.pe());
        return t;
    }
    pe() {
        let t = this.xe();
        for (;this.yt(Wn.tokens.and_and); ) t = new Dn(this.Pt().toString(), t, this.xe());
        return t;
    }
    xe() {
        let t = this._e();
        for (;this.yt(Wn.tokens.or); ) t = new Dn(this.Pt().toString(), t, this._e());
        return t;
    }
    _e() {
        let t = this.be();
        for (;this.yt(Wn.tokens.xor); ) t = new Dn(this.Pt().toString(), t, this.be());
        return t;
    }
    be() {
        let t = this.ye();
        for (;this.yt(Wn.tokens.and); ) t = new Dn(this.Pt().toString(), t, this.ye());
        return t;
    }
    ye() {
        const t = this.we();
        return this.yt([ Wn.tokens.equal_equal, Wn.tokens.not_equal ]) ? new Dn(this.Pt().toString(), t, this.we()) : t;
    }
    we() {
        let t = this.me();
        for (;this.yt([ Wn.tokens.less_than, Wn.tokens.greater_than, Wn.tokens.less_than_equal, Wn.tokens.greater_than_equal ]); ) t = new Dn(this.Pt().toString(), t, this.me());
        return t;
    }
    me() {
        let t = this.Se();
        for (;this.yt([ Wn.tokens.shift_left, Wn.tokens.shift_right ]); ) t = new Dn(this.Pt().toString(), t, this.Se());
        return t;
    }
    Se() {
        let t = this.Ae();
        for (;this.yt([ Wn.tokens.plus, Wn.tokens.minus ]); ) t = new Dn(this.Pt().toString(), t, this.Ae());
        return t;
    }
    Ae() {
        let t = this.he();
        for (;this.yt([ Wn.tokens.star, Wn.tokens.forward_slash, Wn.tokens.modulo ]); ) t = new Dn(this.Pt().toString(), t, this.he());
        return t;
    }
    he() {
        return this.yt([ Wn.tokens.minus, Wn.tokens.bang, Wn.tokens.tilde, Wn.tokens.star, Wn.tokens.and ]) ? new Nn(this.Pt().toString(), this.he()) : this.Me();
    }
    Me() {
        const t = this.Te(), e = this.Ce();
        return e && (t.postfix = e), t;
    }
    Ce() {
        if (this.yt(Wn.tokens.bracket_left)) {
            const t = this.oe();
            this.It(Wn.tokens.bracket_right, "Expected ']'.");
            const e = new Rn(t), n = this.Ce();
            return n && (e.postfix = n), e;
        }
        if (this.yt(Wn.tokens.period)) {
            const t = this.It(Wn.tokens.ident, "Expected member name."), e = this.Ce(), n = new Mn(t.lexeme);
            return e && (n.postfix = e), n;
        }
        return null;
    }
    Oe(t) {
        if (this.St.aliases.has(t)) {
            return this.St.aliases.get(t).type;
        }
        if (this.St.structs.has(t)) {
            return this.St.structs.get(t);
        }
        return null;
    }
    Te() {
        if (this.yt(Wn.tokens.ident)) {
            const t = this.Pt().toString();
            if (this.Et(Wn.tokens.paren_left)) {
                const e = this.le(), n = this.Oe(t);
                return null != n ? new Tn(n, e) : new Cn(t, e);
            }
            if (this.St.constants.has(t)) {
                const e = this.St.constants.get(t);
                return new En(t, e.value);
            }
            return new On(t);
        }
        if (this.yt(Wn.const_literal)) return new In(parseFloat(this.Pt().toString()));
        if (this.Et(Wn.tokens.paren_left)) return this.Ee();
        if (this.yt(Wn.keywords.bitcast)) {
            this.It(Wn.tokens.less_than, "Expected '<'.");
            const t = this.Vt();
            this.It(Wn.tokens.greater_than, "Expected '>'.");
            const e = this.Ee();
            return new Pn(t, e);
        }
        const t = this.Vt(), e = this.le();
        return new Tn(t, e);
    }
    le() {
        if (!this.yt(Wn.tokens.paren_left)) return null;
        const t = [];
        do {
            if (this.Et(Wn.tokens.paren_right)) break;
            const e = this.oe();
            t.push(e);
        } while (this.yt(Wn.tokens.comma));
        return this.It(Wn.tokens.paren_right, "Expected ')' for agument list"), t;
    }
    re() {
        this.yt(Wn.tokens.paren_left);
        const t = this.oe();
        return this.yt(Wn.tokens.paren_right), new Hn([ t ]);
    }
    Ee() {
        this.It(Wn.tokens.paren_left, "Expected '('.");
        const t = this.oe();
        return this.It(Wn.tokens.paren_right, "Expected ')'."), new Hn([ t ]);
    }
    Gt() {
        if (!this.yt(Wn.keywords.struct)) return null;
        const t = this.wt, e = this.It(Wn.tokens.ident, "Expected name for struct.").toString();
        this.It(Wn.tokens.brace_left, "Expected '{' for struct body.");
        const n = [];
        for (;!this.Et(Wn.tokens.brace_right); ) {
            const t = this.Dt(), e = this.It(Wn.tokens.ident, "Expected variable name.").toString();
            this.It(Wn.tokens.colon, "Expected ':' for struct member type.");
            const i = this.Dt(), r = this.Vt();
            null != r && (r.attributes = i), this.Et(Wn.tokens.brace_right) ? this.yt(Wn.tokens.comma) : this.It(Wn.tokens.comma, "Expected ',' for struct member."), 
            n.push(new Bn(e, r, t));
        }
        this.It(Wn.tokens.brace_right, "Expected '}' after struct body.");
        const i = this.wt, r = new _n(e, n, t, i);
        return this.St.structs.set(e, r), r;
    }
    Lt() {
        const t = this.ce();
        return t && this.yt(Wn.tokens.equal) && (t.value = this.Ie()), t;
    }
    Ft() {
        const t = this.Pe();
        return t && this.yt(Wn.tokens.equal) && (t.value = this.Ie()), t;
    }
    zt() {
        if (!this.yt(Wn.keywords.const)) return null;
        const t = this.It(Wn.tokens.ident, "Expected variable name");
        let e = null;
        if (this.yt(Wn.tokens.colon)) {
            const t = this.Dt();
            e = this.Vt(), null != e && (e.attributes = t);
        }
        let n = null;
        if (this.yt(Wn.tokens.equal)) {
            const t = this.oe();
            if (t instanceof Tn) n = t; else if (t instanceof En && t.initializer instanceof Tn) n = t.initializer; else try {
                const e = t.evaluate(this.St);
                n = new In(e);
            } catch (e) {
                n = t;
            }
        }
        const i = new Ye(t.toString(), e, "", "", n);
        return this.St.constants.set(i.name, i), i;
    }
    Ut() {
        if (!this.yt(Wn.keywords.let)) return null;
        const t = this.It(Wn.tokens.ident, "Expected variable name");
        let e = null;
        if (this.yt(Wn.tokens.colon)) {
            const t = this.Dt();
            e = this.Vt(), null != e && (e.attributes = t);
        }
        let n = null;
        return this.yt(Wn.tokens.equal) && (n = this.Ie()), new Je(t.toString(), e, "", "", n);
    }
    Ie() {
        return this.oe();
    }
    ce() {
        if (!this.yt(Wn.keywords.var)) return null;
        let t = "", e = "";
        this.yt(Wn.tokens.less_than) && (t = this.It(Wn.storage_class, "Expected storage_class.").toString(), 
        this.yt(Wn.tokens.comma) && (e = this.It(Wn.access_mode, "Expected access_mode.").toString()), 
        this.It(Wn.tokens.greater_than, "Expected '>'."));
        const n = this.It(Wn.tokens.ident, "Expected variable name");
        let i = null;
        if (this.yt(Wn.tokens.colon)) {
            const t = this.Dt();
            i = this.Vt(), null != i && (i.attributes = t);
        }
        return new Ke(n.toString(), i, t, e, null);
    }
    Pe() {
        if (!this.yt(Wn.keywords.override)) return null;
        const t = this.It(Wn.tokens.ident, "Expected variable name");
        let e = null;
        if (this.yt(Wn.tokens.colon)) {
            const t = this.Dt();
            e = this.Vt(), null != e && (e.attributes = t);
        }
        return new $e(t.toString(), e, null);
    }
    Rt() {
        this.It(Wn.tokens.paren_left, "Expected '('");
        const t = this.It(Wn.tokens.ident, "Expected severity control name.");
        this.It(Wn.tokens.comma, "Expected ','");
        const e = this.It(Wn.tokens.ident, "Expected diagnostic rule name.");
        return this.It(Wn.tokens.paren_right, "Expected ')'"), new dn(t.toString(), e.toString());
    }
    Nt() {
        const t = this.It(Wn.tokens.ident, "identity expected.");
        return new fn(t.toString());
    }
    kt() {
        const t = [ this.It(Wn.tokens.ident, "identity expected.").toString() ];
        for (;this.yt(Wn.tokens.comma); ) {
            const e = this.It(Wn.tokens.ident, "identity expected.");
            t.push(e.toString());
        }
        return new un(t);
    }
    Ht() {
        const t = this.It(Wn.tokens.ident, "identity expected.");
        this.It(Wn.tokens.equal, "Expected '=' for type alias.");
        let e = this.Vt();
        if (null === e) throw this.Ct(this.Ot(), "Expected Type for Alias.");
        this.St.aliases.has(e.name) && (e = this.St.aliases.get(e.name).type);
        const n = new mn(t.toString(), e);
        return this.St.aliases.set(n.name, n), n;
    }
    Vt() {
        if (this.Et([ Wn.tokens.ident, ...Wn.texel_format, Wn.keywords.bool, Wn.keywords.f32, Wn.keywords.i32, Wn.keywords.u32 ])) {
            const t = this.ut(), e = t.toString();
            return this.St.structs.has(e) ? this.St.structs.get(e) : this.St.aliases.has(e) ? this.St.aliases.get(e).type : new xn(t.toString());
        }
        let t = this.He();
        if (t) return t;
        if (this.Et(Wn.template_types)) {
            let t = this.ut().toString(), e = null, n = null;
            return this.yt(Wn.tokens.less_than) && (e = this.Vt(), n = null, this.yt(Wn.tokens.comma) && (n = this.It(Wn.access_mode, "Expected access_mode for pointer").toString()), 
            this.It(Wn.tokens.greater_than, "Expected '>' for type.")), new bn(t, e, n);
        }
        if (this.yt(Wn.keywords.ptr)) {
            let t = this.Pt().toString();
            this.It(Wn.tokens.less_than, "Expected '<' for pointer.");
            const e = this.It(Wn.storage_class, "Expected storage_class for pointer");
            this.It(Wn.tokens.comma, "Expected ',' for pointer.");
            const n = this.Vt();
            let i = null;
            return this.yt(Wn.tokens.comma) && (i = this.It(Wn.access_mode, "Expected access_mode for pointer").toString()), 
            this.It(Wn.tokens.greater_than, "Expected '>' for pointer."), new yn(t, e.toString(), n, i);
        }
        const e = this.Dt();
        if (this.yt(Wn.keywords.array)) {
            let t = null, n = -1;
            const i = this.Pt();
            let r = null;
            if (this.yt(Wn.tokens.less_than)) {
                t = this.Vt(), this.St.aliases.has(t.name) && (t = this.St.aliases.get(t.name).type);
                let e = "";
                if (this.yt(Wn.tokens.comma)) {
                    r = this.me();
                    try {
                        e = r.evaluate(this.St).toString(), r = null;
                    } catch (t) {
                        e = "1";
                    }
                }
                this.It(Wn.tokens.greater_than, "Expected '>' for array."), n = e ? parseInt(e) : 0;
            }
            const s = new wn(i.toString(), e, t, n);
            return r && this.At.push({
                arrayType: s,
                countNode: r
            }), s;
        }
        return null;
    }
    He() {
        if (this.yt(Wn.sampler_type)) return new Sn(this.Pt().toString(), null, null);
        if (this.yt(Wn.depth_texture_type)) return new Sn(this.Pt().toString(), null, null);
        if (this.yt(Wn.sampled_texture_type) || this.yt(Wn.multisampled_texture_type)) {
            const t = this.Pt();
            this.It(Wn.tokens.less_than, "Expected '<' for sampler type.");
            const e = this.Vt();
            return this.It(Wn.tokens.greater_than, "Expected '>' for sampler type."), new Sn(t.toString(), e, null);
        }
        if (this.yt(Wn.storage_texture_type)) {
            const t = this.Pt();
            this.It(Wn.tokens.less_than, "Expected '<' for sampler type.");
            const e = this.It(Wn.texel_format, "Invalid texel format.").toString();
            this.It(Wn.tokens.comma, "Expected ',' after texel format.");
            const n = this.It(Wn.access_mode, "Expected access mode for storage texture type.").toString();
            return this.It(Wn.tokens.greater_than, "Expected '>' for sampler type."), new Sn(t.toString(), e, n);
        }
        return null;
    }
    Dt() {
        let t = [];
        for (;this.yt(Wn.tokens.attr); ) {
            const e = this.It(Wn.attribute_name, "Expected attribute name"), n = new Vn(e.toString(), null);
            if (this.yt(Wn.tokens.paren_left)) {
                if (n.value = this.It(Wn.literal_or_ident, "Expected attribute value").toString(), 
                this.Et(Wn.tokens.comma)) {
                    this.ut();
                    do {
                        const t = this.It(Wn.literal_or_ident, "Expected attribute value").toString();
                        n.value instanceof Array || (n.value = [ n.value ]), n.value.push(t);
                    } while (this.yt(Wn.tokens.comma));
                }
                this.It(Wn.tokens.paren_right, "Expected ')'");
            }
            t.push(n);
        }
        return 0 == t.length ? null : t;
    }
}

class $n {
    constructor(t, e) {
        this.name = t, this.attributes = e, this.size = 0;
    }
    get isArray() {
        return !1;
    }
    get isStruct() {
        return !1;
    }
    get isTemplate() {
        return !1;
    }
}

class Jn {
    constructor(t, e, n) {
        this.name = t, this.type = e, this.attributes = n, this.offset = 0, this.size = 0;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}

class Yn extends $n {
    constructor(t, e) {
        super(t, e), this.members = [], this.align = 0, this.startLine = -1, this.endLine = -1, 
        this.inUse = !1;
    }
    get isStruct() {
        return !0;
    }
}

class Zn extends $n {
    constructor(t, e) {
        super(t, e), this.count = 0, this.stride = 0;
    }
    get isArray() {
        return !0;
    }
}

class Qn extends $n {
    constructor(t, e, n, i) {
        super(t, n), this.format = e, this.access = i;
    }
    get isTemplate() {
        return !0;
    }
}

!function(t) {
    t[t.Uniform = 0] = "Uniform", t[t.Storage = 1] = "Storage", t[t.Texture = 2] = "Texture", 
    t[t.Sampler = 3] = "Sampler", t[t.StorageTexture = 4] = "StorageTexture";
}(nn || (nn = {}));

class ti {
    constructor(t, e, n, i, r, s, o) {
        this.name = t, this.type = e, this.group = n, this.binding = i, this.attributes = r, 
        this.resourceType = s, this.access = o;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get size() {
        return this.type.size;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}

class ei {
    constructor(t, e) {
        this.name = t, this.type = e;
    }
}

class ni {
    constructor(t, e) {
        this.align = t, this.size = e;
    }
}

class ii {
    constructor(t, e, n, i) {
        this.name = t, this.type = e, this.locationType = n, this.location = i, this.interpolation = null;
    }
}

class ri {
    constructor(t, e, n, i) {
        this.name = t, this.type = e, this.locationType = n, this.location = i;
    }
}

class si {
    constructor(t, e, n, i) {
        this.name = t, this.type = e, this.attributes = n, this.id = i;
    }
}

class oi {
    constructor(t, e) {
        this.name = t, this.type = e;
    }
}

class ai {
    constructor(t, e = null) {
        this.stage = null, this.inputs = [], this.outputs = [], this.arguments = [], this.returnType = null, 
        this.resources = [], this.overrides = [], this.startLine = -1, this.endLine = -1, 
        this.inUse = !1, this.calls = new Set, this.name = t, this.stage = e;
    }
}

class ci {
    constructor() {
        this.vertex = [], this.fragment = [], this.compute = [];
    }
}

class hi {
    constructor(t) {
        this.resources = null, this.inUse = !1, this.info = null, this.node = t;
    }
}

class li {
    constructor(t) {
        this.uniforms = [], this.storage = [], this.textures = [], this.samplers = [], this.aliases = [], 
        this.overrides = [], this.structs = [], this.entry = new ci, this.functions = [], 
        this.Re = new Map, this.ke = new Map, t && this.update(t);
    }
    Ne(t) {
        return "texture_storage_1d" == t.name || "texture_storage_2d" == t.name || "texture_storage_2d_array" == t.name || "texture_storage_3d" == t.name;
    }
    update(t) {
        const e = (new Kn).parse(t);
        for (const t of e) t instanceof Ve && this.ke.set(t.name, new hi(t));
        for (const t of e) if (t instanceof _n) {
            const e = this.De(t, null);
            e instanceof Yn && this.structs.push(e);
        }
        for (const t of e) if (t instanceof mn) this.aliases.push(this.Le(t)); else if (t instanceof $e) {
            const e = t, n = this.Fe(e.attributes, "id", 0), i = null != e.type ? this.De(e.type, e.attributes) : null;
            this.overrides.push(new si(e.name, i, e.attributes, n));
        } else if (this.Ue(t)) {
            const e = t, n = this.Fe(e.attributes, "group", 0), i = this.Fe(e.attributes, "binding", 0), r = this.De(e.type, e.attributes), s = new ti(e.name, r, n, i, e.attributes, nn.Uniform, e.access);
            this.uniforms.push(s);
        } else if (this.ze(t)) {
            const e = t, n = this.Fe(e.attributes, "group", 0), i = this.Fe(e.attributes, "binding", 0), r = this.De(e.type, e.attributes), s = this.Ne(r), o = new ti(e.name, r, n, i, e.attributes, s ? nn.StorageTexture : nn.Storage, e.access);
            this.storage.push(o);
        } else if (this.Ge(t)) {
            const e = t, n = this.Fe(e.attributes, "group", 0), i = this.Fe(e.attributes, "binding", 0), r = this.De(e.type, e.attributes), s = this.Ne(r), o = new ti(e.name, r, n, i, e.attributes, s ? nn.StorageTexture : nn.Texture, e.access);
            s ? this.storage.push(o) : this.textures.push(o);
        } else if (this.Be(t)) {
            const e = t, n = this.Fe(e.attributes, "group", 0), i = this.Fe(e.attributes, "binding", 0), r = this.De(e.type, e.attributes), s = new ti(e.name, r, n, i, e.attributes, nn.Sampler, e.access);
            this.samplers.push(s);
        } else if (t instanceof Ve) {
            const e = this.Ve(t, "vertex"), n = this.Ve(t, "fragment"), i = this.Ve(t, "compute"), r = e || n || i, s = new ai(t.name, null == r ? void 0 : r.name);
            s.startLine = t.startLine, s.endLine = t.endLine, this.functions.push(s), this.ke.get(t.name).info = s, 
            r ? (this.ke.get(t.name).inUse = !0, s.inUse = !0, s.resources = this.je(t, !!r), 
            s.inputs = this.We(t.args), s.outputs = this.qe(t.returnType), this.entry[r.name].push(s)) : (s.arguments = t.args.map((t => new oi(t.name, this.De(t.type, t.attributes)))), 
            s.returnType = t.returnType ? this.De(t.returnType, t.attributes) : null);
        } else ;
        for (const t of this.ke.values()) t.info && (t.info.inUse = t.inUse, this.Xe(t.node, t.info.calls));
        for (const t of this.ke.values()) t.node.search((e => {
            var n;
            if ("varExpr" === e.astNodeType) {
                const i = e;
                for (const e of this.overrides) i.name == e.name && (null === (n = t.info) || void 0 === n || n.overrides.push(e));
            }
        }));
        for (const t of this.uniforms) this.Ke(t.type);
        for (const t of this.storage) this.Ke(t.type);
    }
    Ke(t) {
        if (t) if (t.isStruct) {
            if (t.inUse = !0, t.members) for (const e of t.members) this.Ke(e.type);
        } else if (t.isArray) this.Ke(t.format); else if (t.isTemplate) t.format && this.Ke(t.format); else {
            const e = this.$e(t.name);
            e && this.Ke(e);
        }
    }
    Xe(t, e) {
        var n;
        for (const i of t.calls) {
            const t = null === (n = this.ke.get(i.name)) || void 0 === n ? void 0 : n.info;
            t && e.add(t);
        }
    }
    findResource(t, e) {
        for (const n of this.uniforms) if (n.group == t && n.binding == e) return n;
        for (const n of this.storage) if (n.group == t && n.binding == e) return n;
        for (const n of this.textures) if (n.group == t && n.binding == e) return n;
        for (const n of this.samplers) if (n.group == t && n.binding == e) return n;
        return null;
    }
    Je(t) {
        for (const e of this.uniforms) if (e.name == t) return e;
        for (const e of this.storage) if (e.name == t) return e;
        for (const e of this.textures) if (e.name == t) return e;
        for (const e of this.samplers) if (e.name == t) return e;
        return null;
    }
    Ye(t) {
        const e = this.De(t, null);
        this.Ke(e);
    }
    je(t, e) {
        const n = [], i = this, r = [];
        return t.search((s => {
            if (s instanceof ze) r.push({}); else if (s instanceof Ge) r.pop(); else if (s instanceof Ke) {
                const t = s;
                e && null !== t.type && this.Ye(t.type), r.length > 0 && (r[r.length - 1][t.name] = t);
            } else if (s instanceof Tn) {
                const t = s;
                e && null !== t.type && this.Ye(t.type);
            } else if (s instanceof Je) {
                const t = s;
                e && null !== t.type && this.Ye(t.type), r.length > 0 && (r[r.length - 1][t.name] = t);
            } else if (s instanceof On) {
                const t = s;
                if (r.length > 0) {
                    if (r[r.length - 1][t.name]) return;
                }
                const e = i.Je(t.name);
                e && n.push(e);
            } else if (s instanceof Cn) {
                const r = s, o = i.ke.get(r.name);
                o && (e && (o.inUse = !0), t.calls.add(o.node), null === o.resources && (o.resources = i.je(o.node, e)), 
                n.push(...o.resources));
            } else if (s instanceof on) {
                const r = s, o = i.ke.get(r.name);
                o && (e && (o.inUse = !0), t.calls.add(o.node), null === o.resources && (o.resources = i.je(o.node, e)), 
                n.push(...o.resources));
            }
        })), [ ...new Map(n.map((t => [ t.name, t ]))).values() ];
    }
    getBindGroups() {
        const t = [];
        function e(e, n) {
            e >= t.length && (t.length = e + 1), void 0 === t[e] && (t[e] = []), n >= t[e].length && (t[e].length = n + 1);
        }
        for (const n of this.uniforms) {
            e(n.group, n.binding);
            t[n.group][n.binding] = n;
        }
        for (const n of this.storage) {
            e(n.group, n.binding);
            t[n.group][n.binding] = n;
        }
        for (const n of this.textures) {
            e(n.group, n.binding);
            t[n.group][n.binding] = n;
        }
        for (const n of this.samplers) {
            e(n.group, n.binding);
            t[n.group][n.binding] = n;
        }
        return t;
    }
    qe(t, e = void 0) {
        if (void 0 === e && (e = []), t instanceof _n) this.Ze(t, e); else {
            const n = this.Qe(t);
            null !== n && e.push(n);
        }
        return e;
    }
    Ze(t, e) {
        for (const n of t.members) if (n.type instanceof _n) this.Ze(n.type, e); else {
            const t = this.Ve(n, "location") || this.Ve(n, "builtin");
            if (null !== t) {
                const i = this.De(n.type, n.type.attributes), r = this.tn(t.value), s = new ri(n.name, i, t.name, r);
                e.push(s);
            }
        }
    }
    Qe(t) {
        const e = this.Ve(t, "location") || this.Ve(t, "builtin");
        if (null !== e) {
            const n = this.De(t, t.attributes), i = this.tn(e.value);
            return new ri("", n, e.name, i);
        }
        return null;
    }
    We(t, e = void 0) {
        void 0 === e && (e = []);
        for (const n of t) if (n.type instanceof _n) this.en(n.type, e); else {
            const t = this.nn(n);
            null !== t && e.push(t);
        }
        return e;
    }
    en(t, e) {
        for (const n of t.members) if (n.type instanceof _n) this.en(n.type, e); else {
            const t = this.nn(n);
            null !== t && e.push(t);
        }
    }
    nn(t) {
        const e = this.Ve(t, "location") || this.Ve(t, "builtin");
        if (null !== e) {
            const n = this.Ve(t, "interpolation"), i = this.De(t.type, t.attributes), r = this.tn(e.value), s = new ii(t.name, i, e.name, r);
            return null !== n && (s.interpolation = this.rn(n.value)), s;
        }
        return null;
    }
    rn(t) {
        return t instanceof Array && (t = t[0]), t;
    }
    tn(t) {
        t instanceof Array && (t = t[0]);
        const e = parseInt(t);
        return isNaN(e) ? t : e;
    }
    $e(t) {
        for (const e of this.aliases) if (e.name == t) return e.type;
        return null;
    }
    Le(t) {
        return new ei(t.name, this.De(t.type, null));
    }
    De(t, e) {
        if (this.Re.has(t)) return this.Re.get(t);
        if (t instanceof wn) {
            const n = t, i = n.format ? this.De(n.format, n.attributes) : null, r = new Zn(n.name, e);
            return r.format = i, r.count = n.count, this.Re.set(t, r), this.sn(r), r;
        }
        if (t instanceof _n) {
            const n = t, i = new Yn(n.name, e);
            i.startLine = n.startLine, i.endLine = n.endLine;
            for (const t of n.members) {
                const e = this.De(t.type, t.attributes);
                i.members.push(new Jn(t.name, e, t.attributes));
            }
            return this.Re.set(t, i), this.sn(i), i;
        }
        if (t instanceof Sn) {
            const n = t, i = n.format instanceof xn, r = n.format ? i ? this.De(n.format, null) : new $n(n.format, null) : null, s = new Qn(n.name, r, e, n.access);
            return this.Re.set(t, s), this.sn(s), s;
        }
        if (t instanceof bn) {
            const n = t, i = n.format ? this.De(n.format, null) : null, r = new Qn(n.name, i, e, n.access);
            return this.Re.set(t, r), this.sn(r), r;
        }
        const n = new $n(t.name, e);
        return this.Re.set(t, n), this.sn(n), n;
    }
    sn(t) {
        var e, n;
        const i = this.an(t);
        if (t.size = null !== (e = null == i ? void 0 : i.size) && void 0 !== e ? e : 0, 
        t instanceof Zn && t.format) {
            const e = this.an(t.format);
            t.stride = null !== (n = null == e ? void 0 : e.size) && void 0 !== n ? n : 0, this.sn(t.format);
        }
        t instanceof Yn && this.cn(t);
    }
    cn(t) {
        var e;
        let n = 0, i = 0, r = 0, s = 0;
        for (let o = 0, a = t.members.length; o < a; ++o) {
            const a = t.members[o], c = this.an(a);
            if (!c) continue;
            null !== (e = this.$e(a.type.name)) && void 0 !== e || a.type;
            const h = c.align, l = c.size;
            n = this.hn(h, n + i), i = l, r = n, s = Math.max(s, h), a.offset = n, a.size = l, 
            this.sn(a.type);
        }
        t.size = this.hn(s, r + i), t.align = s;
    }
    an(t) {
        var e, n;
        if (null == t) return null;
        const i = this.Fe(t.attributes, "size", 0), r = this.Fe(t.attributes, "align", 0);
        if (t instanceof Jn && (t = t.type), t instanceof $n) {
            const e = this.$e(t.name);
            null !== e && (t = e);
        }
        {
            const n = li.ln[t.name];
            if (void 0 !== n) {
                const s = "f16" === (null === (e = t.format) || void 0 === e ? void 0 : e.name) ? 2 : 1;
                return new ni(Math.max(r, n.align / s), Math.max(i, n.size / s));
            }
        }
        {
            const e = li.ln[t.name.substring(0, t.name.length - 1)];
            if (e) {
                const n = "h" === t.name[t.name.length - 1] ? 2 : 1;
                return new ni(Math.max(r, e.align / n), Math.max(i, e.size / n));
            }
        }
        if (t instanceof Zn) {
            let e = t, s = 8, o = 8;
            const a = this.an(e.format);
            null !== a && (o = a.size, s = a.align);
            return o = e.count * this.Fe(null !== (n = null == t ? void 0 : t.attributes) && void 0 !== n ? n : null, "stride", this.hn(s, o)), 
            i && (o = i), new ni(Math.max(r, s), Math.max(i, o));
        }
        if (t instanceof Yn) {
            let e = 0, n = 0, s = 0, o = 0, a = 0;
            for (const n of t.members) {
                const t = this.an(n.type);
                null !== t && (e = Math.max(t.align, e), s = this.hn(t.align, s + o), o = t.size, 
                a = s);
            }
            return n = this.hn(e, a + o), new ni(Math.max(r, e), Math.max(i, n));
        }
        return null;
    }
    Ue(t) {
        return t instanceof Ke && "uniform" == t.storage;
    }
    ze(t) {
        return t instanceof Ke && "storage" == t.storage;
    }
    Ge(t) {
        return t instanceof Ke && null !== t.type && -1 != li.un.indexOf(t.type.name);
    }
    Be(t) {
        return t instanceof Ke && null !== t.type && -1 != li.dn.indexOf(t.type.name);
    }
    Ve(t, e) {
        const n = t;
        if (!n || !n.attributes) return null;
        const i = n.attributes;
        for (let t of i) if (t.name == e) return t;
        return null;
    }
    Fe(t, e, n) {
        if (null === t) return n;
        for (let i of t) if (i.name == e) {
            let t = null !== i && null !== i.value ? i.value : n;
            return t instanceof Array && (t = t[0]), "number" == typeof t ? t : "string" == typeof t ? parseInt(t) : n;
        }
        return n;
    }
    hn(t, e) {
        return Math.ceil(e / t) * t;
    }
}

li.ln = {
    f16: {
        align: 2,
        size: 2
    },
    i32: {
        align: 4,
        size: 4
    },
    u32: {
        align: 4,
        size: 4
    },
    f32: {
        align: 4,
        size: 4
    },
    atomic: {
        align: 4,
        size: 4
    },
    vec2: {
        align: 8,
        size: 8
    },
    vec3: {
        align: 16,
        size: 12
    },
    vec4: {
        align: 16,
        size: 16
    },
    mat2x2: {
        align: 8,
        size: 16
    },
    mat3x2: {
        align: 8,
        size: 24
    },
    mat4x2: {
        align: 8,
        size: 32
    },
    mat2x3: {
        align: 16,
        size: 32
    },
    mat3x3: {
        align: 16,
        size: 48
    },
    mat4x3: {
        align: 16,
        size: 64
    },
    mat2x4: {
        align: 16,
        size: 32
    },
    mat3x4: {
        align: 16,
        size: 48
    },
    mat4x4: {
        align: 16,
        size: 64
    }
}, li.un = Wn.any_texture_type.map((t => t.name)), li.dn = Wn.sampler_type.map((t => t.name));

class fi {
    constructor(t, e) {
        this.version = 0, this.bindgroupMapping = t, this.pool = e, this.allocation = {};
    }
    writeBuffer(t, e) {
        const n = this.bindgroupMapping, i = n.totalSize, r = this.allocation.gpuBuffer, s = this.pool.bufferAlignment;
        this.pool.alloc(this.allocation, i), r !== this.allocation.gpuBuffer && this.version++;
        let o = this.allocation.offset;
        const a = this.allocation.storage;
        for (let i = 0; i < n.length; i++) {
            const r = n[i], c = r.binding, h = r.members;
            if (h) {
                e.addItem(c, o);
                for (let e = 0; e < h.length; e++) {
                    const n = h[e], i = t[n.name];
                    void 0 === i && console.warn(`Uniform value ${n.name} is not provided`);
                    const r = o + n.offset, s = n.size;
                    this.mn(n.type, a, r, s, i);
                }
                o += Ut(r.size, s);
            } else if (r.resourceType === nn.Uniform) {
                e.addItem(c, o);
                const n = t[r.name], i = O(r.size) ? r.size() : r.size;
                this.mn(r.type, a, o, i, n), o += Ut(i, s);
            }
        }
    }
    mn(t, e, n, i, r) {
        const s = new Float32Array(e, n, i / 4);
        if (R(r)) {
            const e = function(t) {
                return Ft[t.name];
            }(t);
            if (!e) return void s.set(r);
            for (let t = 0; t < r.length; t++) {
                s[4 * Math.floor(t / 3) + t % 3] = r[t];
            }
        } else s[0] = r;
    }
    dispose() {
        delete this.pool, delete this.allocation;
    }
}

const ui = new Array(16);

let di = 0;

class mi {
    constructor(t, e, n = {}) {
        this.A = 0, this.vn = t, this.gn = e, this.transparent = !!n.transparent, this.bloom = !!n.bloom, 
        this.ssr = !!n.ssr, this.pn = T(n.castShadow) || n.castShadow, this.needUpdateShadow = !1, 
        this.picking = !!n.picking, this.disableVAO = !!n.disableVAO, this.uniforms = {}, 
        this.xn = c.identity(new Array(16)), this._n = c.identity(new Array(16)), this.properties = {}, 
        this.bn = !0, this.yn = !0, Object.defineProperty(this, "uuid", {
            value: di++
        }), di > Number.MAX_VALUE - 10 && (di = 0);
    }
    set material(t) {
        this.gn !== t && this.setMaterial(t);
    }
    get material() {
        return this.gn;
    }
    set version(t) {
        throw new Error("Mesh.version is read only.");
    }
    get version() {
        return this.A;
    }
    get geometry() {
        return this.vn;
    }
    set geometry(t) {
        this.vn !== t && (this.D(), this.yn = !0), this.vn = t;
    }
    set localTransform(t) {
        this.wn || (this.wn = new Array(16)), Array.isArray(t) && !c.exactEquals(this.wn, t) && (this.D(), 
        this.wn = c.copy(this.wn, t)), this.xn = t;
    }
    get localTransform() {
        return O(this.xn) ? this.xn() : this.xn;
    }
    set positionMatrix(t) {
        this.Sn || (this.Sn = new Array(16)), Array.isArray(t) && !c.exactEquals(this.Sn, t) && (this.D(), 
        this.Sn = c.copy(this.Sn, t)), this._n = t;
    }
    get positionMatrix() {
        return O(this._n) ? this._n() : this._n;
    }
    get config() {
        return this.An || (this.An = {}), this.An.transparent = this.transparent, this.An.castShadow = this.castShadow, 
        this.An.bloom = this.bloom, this.An.ssr = this.ssr, this.An.picking = this.picking, 
        this.An;
    }
    get defines() {
        return this.Mn();
    }
    set defines(t) {
        this.setDefines(t);
    }
    get castShadow() {
        return this.pn && (!this.material || !this.material.unlit);
    }
    set castShadow(t) {
        this.pn = t;
    }
    setMaterial(t) {
        return this.gn = t, this.bn = !0, delete this.Tn, this.dirtyDefines = !0, this;
    }
    setParent(t) {
        return this.parent = t, this;
    }
    setLocalTransform(t) {
        return this.localTransform = t, this;
    }
    setPositionMatrix(t) {
        this.positionMatrix = t;
    }
    setUniform(t, e) {
        return this.uniforms[t] === e || (this.Cn(t), this.uniforms[t] = e), this;
    }
    setFunctionUniform(t, e) {
        return this.Cn(t), Object.defineProperty(this.uniforms, t, {
            enumerable: !0,
            get: e
        }), this;
    }
    hasFunctionUniform(t) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, t);
    }
    Cn(t) {
        void 0 === this.uniforms[t] ? this.bn = !0 : (this.On = this.On || [], this.On.push(t));
    }
    hasUniform(t) {
        return void 0 !== this.uniforms[t];
    }
    getUniform(t) {
        return this.uniforms[t];
    }
    getDefines() {
        const t = {};
        return E(t, this.Mn()), this.gn && this.vn && this.gn.appendDefines(t, this.vn), 
        t;
    }
    Mn() {
        this.En || (this.En = {});
        const t = this.vn, e = t.data[t.desc.positionAttribute], n = t.data[t.desc.uv0Attribute], i = t.data[t.desc.normalAttribute];
        return e && e.quantization && (this.En.HAS_DRACO_POSITION = 1), n && n.quantization && (this.En.HAS_DRACO_TEXCOORD = 1), 
        i && i.quantization && (this.En.HAS_DRACO_NORMAL = 1), this.En;
    }
    setDefines(t) {
        const e = this.In;
        return this.En = t, this.dirtyDefines = !!e != !!t || !function(t, e) {
            if (!t && !e) return !0;
            const n = Object.getOwnPropertyNames(t), i = Object.getOwnPropertyNames(e);
            if (n.length !== i.length) return !1;
            for (let i = 0; i < n.length; i++) if (t[n[i]] !== e[n[i]]) return !1;
            return !0;
        }(e, t), this;
    }
    hasSkinAnimation() {
        return this.gn && this.gn.hasSkinAnimation();
    }
    Pn() {
        return this.In = E({}, this.En), this.dirtyDefines = !1, this.Hn(this.getDefines());
    }
    getCommandKey(t) {
        if (!this.Rn || this.dirtyDefines || this.gn && this.kn !== this.gn.getUniformKeys()) {
            let e = this.geometry.getCommandKey(t) + "_" + this.Pn();
            e += "_" + (P(this.getElements()) ? "count" : "elements"), e += "_" + +!!this.disableVAO, 
            this.gn && (e += "_" + +!!this.gn.doubleSided), this.Rn = e, this.gn && (this.kn = this.gn.getUniformKeys());
        }
        return this.Rn;
    }
    getRenderProps(t) {
        const e = this.getUniforms(t);
        return e.meshProperties = this.properties, e.geometryProperties = this.vn.properties, 
        e.meshConfig = this.config, e.count = this.vn.getDrawCount(), e.offset = this.vn.getDrawOffset(), 
        e.primitive = this.vn.getPrimitive(), e;
    }
    Nn(t, e) {
        return this.vn.getREGLData(t, e, this.disableVAO);
    }
    appendGeoAttributes(t, e, n) {
        E(t, this.Nn(e, n)), L(e) && !this.disableVAO || (t.elements = this.vn.getElements());
    }
    getUniforms(t) {
        if (this.bn || this.yn || this.gn && this.Tn !== this.gn.version) {
            this.Dn = new Set, this.Ln = {}, this.Fn();
            const e = this.uniforms;
            for (const t in this.uniforms) if (F(this.uniforms, t)) {
                Object.getOwnPropertyDescriptor(e, t).get ? (this.Dn.add(t), Object.defineProperty(this.Ln, t, {
                    enumerable: !0,
                    configurable: !0,
                    get: function() {
                        return e[t];
                    }
                })) : this.Ln[t] = e[t];
            }
            if (this.gn) {
                const e = this.gn.getUniforms(t);
                for (const t in e) if (F(e, t) && !F(this.Ln, t)) {
                    Object.getOwnPropertyDescriptor(e, t).get ? (this.Dn.add(t), Object.defineProperty(this.Ln, t, {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return e[t];
                        }
                    })) : void 0 === this.Ln[t] && (this.Ln[t] = e[t]);
                }
            }
            this.bn = !1, this.yn = !1, this.Tn = this.gn && this.gn.version, this.Un = this.gn && this.gn.propVersion, 
            this.On = null;
        } else if (this.On || this.gn && this.gn.propVersion !== this.Un) {
            if (this.On) for (const t of this.On) this.Ln[t] = this.uniforms[t];
            if (this.gn && this.gn.propVersion !== this.Un) {
                const e = this.gn.getUniforms(t);
                for (const t in e) if (F(e, t) && !this.Dn.has(t)) {
                    Object.getOwnPropertyDescriptor(e, t).get || this.Ln[t] === e[t] || (this.Ln[t] = e[t]);
                }
                this.Un = this.gn.propVersion;
            }
            this.On = null;
        }
        return this.Ln.modelMatrix = this.localTransform, this.Ln.positionMatrix = this.positionMatrix, 
        this.Ln;
    }
    Fn() {
        const t = this.vn, e = t.data[t.desc.positionAttribute], n = t.data[t.desc.uv0Attribute], i = t.data[t.desc.normalAttribute];
        if (e && e.quantization) {
            const t = e.quantization, n = t.range / (1 << t.quantizationBits);
            this.Ln.minValues_pos = t.minValues, this.Ln.gltf_u_dec_position_normConstant = n;
        }
        if (n && n.quantization) {
            const t = n.quantization;
            this.Ln.minValues_tex = t.minValues;
            const e = t.range / (1 << t.quantizationBits);
            this.Ln.gltf_u_dec_texcoord_0_normConstant = e;
        }
        if (i && i.quantization) {
            const t = (1 << i.quantization.quantizationBits) - 1;
            this.Ln.gltf_u_dec_normal_rangeConstant = t;
        }
    }
    getMaterial() {
        return this.gn;
    }
    getElements() {
        return this.vn.getElements();
    }
    dispose() {
        if (delete this.vn, delete this.gn, delete this.zn, delete this.Gn, this.uniforms = null, 
        this.Bn) {
            for (const t in this.Bn) this.Bn[t].dispose();
            delete this.Bn;
        }
        return this;
    }
    isValid() {
        return this.vn && !this.vn.isDisposed() && (!this.gn || !this.gn.isDisposed());
    }
    getBoundingBox() {
        return this.vn ? (this.Vn || this.updateBoundingBox(), c.multiply(ui, this.localTransform, this.positionMatrix), 
        c.exactEquals(ui, this.jn) && this.vn.boundingBox.equals(this.Wn) || this.updateBoundingBox(), 
        this.qn) : null;
    }
    updateBoundingBox() {
        const t = this.vn.boundingBox;
        this.Vn || (this.Vn = new at), this.qn || (this.qn = [ [ 0, 0, 0 ], [ 0, 0, 0 ] ]), 
        this.Wn || (this.Wn = new at), at.copy(this.Vn, t), this.Vn.updateVertex(), "InstancedMesh" === this.constructor.name ? (this.Vn.transform(this.localTransform, this.positionMatrix), 
        this.jn = c.multiply(this.jn || new Array(16), this.positionMatrix, this.localTransform)) : (this.Vn.transform(this.positionMatrix, this.localTransform), 
        this.jn = c.multiply(this.jn || new Array(16), this.localTransform, this.positionMatrix)), 
        at.copy(this.Wn, t), h.copy(this.qn[0], this.Vn.min), h.copy(this.qn[1], this.Vn.max);
    }
    Hn(t) {
        const e = [];
        for (const n in t) e.push(n, t[n]);
        return e.join(",");
    }
    D() {
        this.A++;
    }
    getMemorySize() {
        return (this.geometry && this.geometry.getMemorySize() || 0) + (this.material && this.material.getMemorySize() || 0);
    }
    getWorldTransform() {
        const t = this.parent;
        return t ? c.multiply(new Array(16), t.getWorldTransform(), this.localTransform) : this.localTransform;
    }
    writeDynamicBuffer(t, e, n, i, r) {
        this.Bn || (this.Bn = {});
        let s = this.Bn[t];
        return s || (s = this.Bn[t] = new fi(n, i)), s.writeBuffer(e, r), s;
    }
    getBindGroup(t) {
        return this.zn || (this.zn = {}), this.zn[t];
    }
    setBindGroup(t, e) {
        return this.zn[t] = e, this;
    }
    getShaderFnValues(t) {
        return this.Gn ? this.Gn[t] : null;
    }
    setShaderFnValues(t, e) {
        return this.Gn || (this.Gn = {}), this.Gn[t] = e, this;
    }
}

class vi extends mi {
    constructor(t, e, n, i, r = {}) {
        super(n, i, r), this.Xn = e, this.instancedData = t || {}, this.Kn(), this.O = {};
    }
    get instanceCount() {
        return this.Xn;
    }
    set instanceCount(t) {
        this.D(), this.Xn = t;
    }
    getMemorySize() {
        return super.getMemorySize() + this.$n();
    }
    $n() {
        let t = 0;
        for (const e in this.instancedData) F(this.instancedData, e) && (t += U(this.instancedData[e]));
        return t;
    }
    Kn() {
        for (const t in this.instancedData) if (this.geometry.data[t]) throw new Error(`Duplicate attribute ${t} defined in geometry and instanced data`);
    }
    appendGeoAttributes(t, e, n) {
        const i = this.geometry.getAttrData(n);
        if (L(e)) {
            const r = n.key;
            if (!this.O[r] || this.O[r].dirty) {
                const t = n.map((t => t.name)), s = [];
                for (let e = 0; e < t.length; e++) {
                    const n = i[t[e]], r = n && n.buffer || this.instancedData[t[e]];
                    s.push(r);
                }
                const o = {
                    attributes: s,
                    primitive: this.geometry.getPrimitive()
                };
                this.O[r] ? this.O[r].vao(o) : this.O[r] = {
                    vao: e.vao(o)
                }, delete this.O[r].dirty;
            }
            E(t, this.O[r]);
        } else E(t, i);
    }
    getDefines() {
        const t = super.getDefines();
        return t.HAS_INSTANCE = 1, t;
    }
    getCommandKey(t) {
        return "i_" + super.getCommandKey(t);
    }
    updateInstancedData(t, e) {
        const n = this.instancedData[t];
        if (this.D(), this.instancedData[t] = e, n && n.buffer && n.buffer.destroy && n.buffer.destroy(), 
        this.O) for (const t in this.O) this.O[t].dirty = !0;
        return this;
    }
    getInstancedBuffer(t) {
        return this.instancedData[t] && this.instancedData[t].buffer;
    }
    generateInstancedBuffers(t) {
        const e = !!t && t.wgpu, n = this.instancedData, i = this.instanceCount, r = {};
        for (const s in n) {
            if (!n[s]) continue;
            Array.isArray(n[s]) ? n[s] = new Float32Array(n[s]) : e && R(n[s]) && (n[s] = qt.padGPUBufferAlignment(n[s], i));
            const o = n[s];
            if (void 0 !== o.buffer && o.buffer.destroy) r[s] = o, r[s].divisor && (r[s].divisor = 1); else if (n[s].destroy) r[s] = {
                buffer: n[s],
                divisor: 1
            }; else {
                const e = {
                    data: n[s],
                    dimension: n[s].length / this.Xn
                };
                r[s] = {
                    buffer: qt.createBuffer(t, e, s),
                    divisor: 1
                };
            }
        }
        return this.instancedData = r, this;
    }
    getRenderProps(t) {
        const e = super.getRenderProps(t);
        return L(t) || E(e, this.instancedData), e.elements = this.geometry.getElements(), 
        e.instances = this.Xn, e;
    }
    disposeInstancedData() {
        const t = this.instancedData;
        if (t) for (const e in t) {
            if (!t[e]) continue;
            const n = t[e].destroy ? t[e] : t[e].buffer;
            n.destroy && !n[Q] && (n[Q] = 1, n.destroy());
        }
        this.instancedData = {};
        for (const t in this.O) this.O[t].vao.destroy();
        this.O = {};
    }
    getBufferDescriptor(t) {
        const e = [];
        for (const n in t) {
            const i = t[n];
            e[i.location] = i;
        }
        const n = this.instancedData, i = [];
        for (let r = 0; r < e.length; r++) {
            if (!e[r]) continue;
            const s = e[r].geoAttrName, o = n[s];
            if (!o) continue;
            const a = Kt(o, t[s]);
            a.stepMode = "instance", i[r] = a;
        }
        return i;
    }
}

const gi = {};

class pi {
    constructor(t) {
        this.device = t;
    }
    render(t, e, n, i) {
        t.setUniforms(e || gi), t.setFramebuffer(i);
        let r = 0;
        if (n) {
            const {opaques: e, transparents: i} = n.getSortedMeshes();
            r += t.draw(this.device, e), r += t.draw(this.device, i);
        } else r += t.draw(this.device);
        return r;
    }
    clear(t) {
        this.device.clear(t);
    }
}

const xi = {
    getArrayBuffer: (t, e) => xi.get(t, {
        responseType: "arraybuffer"
    }, e),
    get: function(t, e, n) {
        const i = xi.Jn(n);
        if (i.open("GET", t, !0), e) {
            for (const t in e.headers) i.setRequestHeader(t, e.headers[t]);
            i.withCredentials = "include" === e.credentials, e.responseType && (i.responseType = e.responseType);
        }
        return i.send(null), i;
    },
    Yn: function(t, e) {
        return function() {
            if (4 === t.readyState) if (200 === t.status) if ("arraybuffer" === t.responseType) {
                0 === t.response.byteLength ? e(new Error("http status 200 returned without content.")) : e(null, {
                    data: t.response,
                    cacheControl: t.getResponseHeader("Cache-Control"),
                    expires: t.getResponseHeader("Expires"),
                    contentType: t.getResponseHeader("Content-Type")
                });
            } else e(null, t.responseText); else e(new Error(t.statusText + "," + t.status));
        };
    },
    Jn: function(t) {
        let e;
        try {
            e = new XMLHttpRequest;
        } catch (t) {
            try {
                e = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (t) {
                try {
                    e = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (t) {}
            }
        }
        return e.onreadystatechange = xi.Yn(e, t), e;
    }
};

class _i {
    constructor(t, e) {
        this.defaultTexture = t, this.defaultCubeTexture = new Array(6), this.urlModifier = e, 
        this.resources = {};
    }
    setURLModifier(t) {
        this.urlModifier = t;
    }
    get(t) {
        return Array.isArray(t) ? this.Zn(t) : this.Qn(t);
    }
    getArrayBuffer(t) {
        if (Array.isArray(t)) {
            const e = t.map((t => this.getArrayBuffer(t)));
            return Promise.all(e);
        }
        return new Promise(((e, n) => {
            let i = t;
            this.urlModifier && (i = this.urlModifier(t)), xi.getArrayBuffer(i, ((i, r) => {
                i ? n(i) : e({
                    url: t,
                    data: r
                });
            }));
        }));
    }
    disposeRes(t) {
        return Array.isArray(t) ? t.forEach((t => this.ti(t))) : this.ti(t), this;
    }
    isLoading() {
        return this.ei && this.ei > 0;
    }
    getDefaultTexture(t) {
        return Array.isArray(t) ? this.ni(t.length) : this.defaultTexture;
    }
    ti(t) {
        const e = this.resources;
        e[t] && (e[t].count--, e[t].count <= 0 && delete e[t]);
    }
    Qn(t) {
        const e = this.resources;
        if (e[t]) return Promise.resolve({
            url: t,
            data: e[t].image
        });
        return new Promise(((n, i) => {
            const r = new Image;
            r.crossOrigin = "anonymous", r.onload = function() {
                e[t] = {
                    image: r,
                    count: 1
                }, n({
                    url: t,
                    data: r
                });
            }, r.onerror = function(t) {
                i(t);
            }, r.onabort = function() {
                i(`image(${t}) loading aborted.`);
            }, this.urlModifier ? r.src = this.urlModifier(t) : r.src = t;
        }));
    }
    Zn(t) {
        const e = t.map((t => this.Qn(t)));
        return Promise.all(e);
    }
    ni(t) {
        const e = new Array(t);
        for (let t = 0; t < 6; t++) e.push(this.defaultTexture);
        return e;
    }
}

class bi extends(Z(_i)){}

const yi = [ 0, 0, 0 ], wi = [ 0, 0, 0 ];

let Si, Ai = 0;

function Mi(t, e) {
    return h.transformMat4(yi, t.geometry.boundingBox.getCenter(), t.localTransform), 
    h.transformMat4(wi, e.geometry.boundingBox.getCenter(), e.localTransform), h.dist(wi, Si) - h.dist(yi, Si);
}

class Ti {
    constructor(t) {
        this.ii = Ai++, this.sortedMeshes = {}, this.setMeshes(t), this.dirty();
    }
    setMeshes(t) {
        if (this.clear(), !t || Array.isArray(t) && !t.length || t === this.meshes) return this;
        t = Array.isArray(t) ? t : [ t ], this.meshes = [];
        for (let e = 0; e < t.length; e++) {
            const n = t[e];
            n && (n.ri = n.ri || {}, n.ri[this.ii] = 1, this.meshes.push(n));
        }
        return this.dirty(), this;
    }
    addMesh(t) {
        if (!t || Array.isArray(t) && !t.length) return this;
        if (Array.isArray(t)) t.forEach((t => {
            const e = t.ri = t.ri || {};
            e[this.ii] || (e[this.ii] = 1, this.meshes.push(t), this.dirty());
        })); else {
            const e = t.ri = t.ri || {};
            e[this.ii] || (e[this.ii] = 1, this.meshes.push(t), this.dirty());
        }
        return this;
    }
    removeMesh(t) {
        if (!t || Array.isArray(t) && !t.length) return this;
        if (Array.isArray(t)) {
            let e = !1;
            for (let n = 0; n < t.length; n++) {
                const i = t[n].ri;
                i && i[this.ii] && (e = !0, this.dirty(), delete i[this.ii]);
            }
            e && (this.meshes = this.meshes.filter((e => t.indexOf(e) < 0)));
        } else {
            const e = t.ri;
            if (!e || !e[this.ii]) return this;
            const n = this.meshes.indexOf(t);
            n >= 0 && this.meshes.splice(n, 1), delete e[this.ii], this.dirty();
        }
        return this;
    }
    getMeshes() {
        return this.meshes || [];
    }
    clear() {
        if (this.meshes) for (let t = 0; t < this.meshes.length; t++) delete this.meshes[t].ri[this.ii];
        return this.meshes = [], this.sortedMeshes.opaques = [], this.sortedMeshes.transparents = [], 
        this;
    }
    dirty() {
        return this.S = !0, this;
    }
    sortMeshes(t) {
        const e = this.meshes;
        this.sortFunction && e.sort(this.sortFunction);
        let n = this.sortedMeshes.transparents;
        if (this.S) {
            const t = this.sortedMeshes.opaques = [];
            n = this.sortedMeshes.transparents = [];
            for (let i = 0, r = e.length; i < r; i++) e[i].transparent ? n.push(e[i]) : t.push(e[i]);
        }
        t && n.length > 1 && (Si = t, n.sort(Mi)), this.S = !1;
    }
    getSortedMeshes() {
        return this.S && this.sortMeshes(), this.sortedMeshes || {};
    }
}

const Ci = String.fromCharCode, Oi = 8, Ei = 32767;

function Ii(t, e, n, i) {
    if (t[3] > 0) {
        const r = Math.pow(2, t[3] - 128 - 8 + i);
        e[n + 0] = t[0] * r, e[n + 1] = t[1] * r, e[n + 2] = t[2] * r;
    } else e[n + 0] = 0, e[n + 1] = 0, e[n + 2] = 0;
    return e[n + 3] = 1, e;
}

function Pi(t, e, n, i) {
    let r = 0, s = 0, o = i;
    for (;o > 0; ) if (t[s][0] = e[n++], t[s][1] = e[n++], t[s][2] = e[n++], t[s][3] = e[n++], 
    1 === t[s][0] && 1 === t[s][1] && 1 === t[s][2]) {
        for (let e = t[s][3] << r >>> 0; e > 0; e--) a = t[s - 1], (c = t[s])[0] = a[0], 
        c[1] = a[1], c[2] = a[2], c[3] = a[3], s++, o--;
        r += 8;
    } else s++, o--, r = 0;
    var a, c;
    return n;
}

function Hi(t, e, n, i) {
    if (i < Oi | i > Ei) return Pi(t, e, n, i);
    let r = e[n++];
    if (2 !== r) return Pi(t, e, n - 1, i);
    if (t[0][1] = e[n++], t[0][2] = e[n++], r = e[n++], (t[0][2] << 8 >>> 0 | r) >>> 0 !== i) return null;
    for (let r = 0; r < 4; r++) for (let s = 0; s < i; ) {
        let i = e[n++];
        if (i > 128) {
            i = (127 & i) >>> 0;
            const o = e[n++];
            for (;i--; ) t[s++][r] = o;
        } else for (;i--; ) t[s++][r] = e[n++];
    }
    return n;
}

function Ri(t, e = 0) {
    const n = new Uint8Array(t), i = n.length;
    if ("#?" !== function(t, e, n) {
        let i = "";
        for (let r = e; r < n; r++) i += Ci(t[r]);
        return i;
    }(n, 0, 2)) return null;
    for (var r = 2; r < i && ("\n" !== Ci(n[r]) || "\n" !== Ci(n[r + 1])); r++) ;
    if (r >= i) return null;
    r += 2;
    let s = "";
    for (;r < i; r++) {
        const t = Ci(n[r]);
        if ("\n" === t) break;
        s += t;
    }
    const o = s.split(" "), a = parseInt(o[1]), c = parseInt(o[3]);
    if (!c || !a) return null;
    let h = r + 1;
    const l = [];
    for (let t = 0; t < c; t++) {
        l[t] = [];
        for (let e = 0; e < 4; e++) l[t][e] = 0;
    }
    const f = new Float32Array(c * a * 4);
    let u = 0;
    for (let t = 0; t < a; t++) {
        if (h = Hi(l, n, h, c), !h) return null;
        for (let t = 0; t < c; t++) Ii(l[t], f, u, e), u += 4;
    }
    return {
        width: c,
        height: a,
        pixels: f
    };
}

const ki = Ni();

function Ni() {
    const t = new ArrayBuffer(4), e = new Float32Array(t), n = new Uint32Array(t), i = new Uint32Array(512), r = new Uint32Array(512);
    for (let t = 0; t < 256; ++t) {
        const e = t - 127;
        e < -27 ? (i[t] = 0, i[256 | t] = 32768, r[t] = 24, r[256 | t] = 24) : e < -14 ? (i[t] = 1024 >> -e - 14, 
        i[256 | t] = 1024 >> -e - 14 | 32768, r[t] = -e - 1, r[256 | t] = -e - 1) : e <= 15 ? (i[t] = e + 15 << 10, 
        i[256 | t] = e + 15 << 10 | 32768, r[t] = 13, r[256 | t] = 13) : e < 128 ? (i[t] = 31744, 
        i[256 | t] = 64512, r[t] = 24, r[256 | t] = 24) : (i[t] = 31744, i[256 | t] = 64512, 
        r[t] = 13, r[256 | t] = 13);
    }
    const s = new Uint32Array(2048), o = new Uint32Array(64), a = new Uint32Array(64);
    for (let t = 1; t < 1024; ++t) {
        let e = t << 13, n = 0;
        for (;!(8388608 & e); ) e <<= 1, n -= 8388608;
        e &= -8388609, n += 947912704, s[t] = e | n;
    }
    for (let t = 1024; t < 2048; ++t) s[t] = 939524096 + (t - 1024 << 13);
    for (let t = 1; t < 31; ++t) o[t] = t << 23;
    o[31] = 1199570944, o[32] = 2147483648;
    for (let t = 33; t < 63; ++t) o[t] = 2147483648 + (t - 32 << 23);
    o[63] = 3347054592;
    for (let t = 1; t < 64; ++t) 32 !== t && (a[t] = 1024);
    return {
        floatView: e,
        uint32View: n,
        baseTable: i,
        shiftTable: r,
        mantissaTable: s,
        exponentTable: o,
        offsetTable: a
    };
}

const Di = {
    toHalfFloat: function(t) {
        Math.abs(t) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), 
        t = D(t, -65504, 65504), ki.floatView[0] = t;
        const e = ki.uint32View[0], n = e >> 23 & 511;
        return ki.baseTable[n] + ((8388607 & e) >> ki.shiftTable[n]);
    },
    fromHalfFloat: function(t) {
        const e = t >> 10;
        return ki.uint32View[0] = ki.mantissaTable[ki.offsetTable[e] + (1023 & t)] + ki.exponentTable[e], 
        ki.floatView[0];
    }
}, Li = 9728, Fi = 9729, Ui = 9987;

var zi = Object.freeze({
    __proto__: null,
    GL_LINEAR: Fi,
    GL_LINEAR_MIPMAP_LINEAR: Ui,
    GL_NEAREST: Li,
    MAG_FILTER: 10240,
    MIN_FILTER: 10241
});

class Gi extends rt {
    constructor() {
        super(...arguments), this.A = 0;
    }
    get version() {
        return this.A;
    }
    set version(t) {
        throw new Error("Texture2D.version is read only.");
    }
    onLoad({data: t}) {
        const e = this.config;
        if (e) {
            if (e.hdr) {
                if (!(t = Ri(t.data, 0))) throw new Error("Invalid hdr data" + (e.url ? ":" + e.url : ""));
                {
                    const n = new Uint16Array(t.pixels.length);
                    for (let e = 0; e < t.pixels.length; e++) n[e] = Math.min(Di.toHalfFloat(t.pixels[e]), 65504);
                    e.data = n, e.type = "float16", e.colorSpace = "browser", e.min = "linear", e.mag = "linear";
                }
            } else e.data = t;
            e.width = e.width || t.width, e.height = e.height || t.height, this.p && this.si(this.p), 
            this.m();
        }
    }
    setConfig(t) {
        const e = t.data;
        t.image = e, t.width = t.width || e.width, t.height = t.height || e.height, this.config = t, 
        this.dirty = !!this._texture;
    }
    m() {
        this._texture && !this._texture[Q] && (this.A++, O(this._texture) ? this._texture(this.config) : this._texture.update(this.config)), 
        this.dirty = !1;
    }
    setMinFilter(t) {
        this.config.min = fe(t), this._texture && this._texture.updateFilter && this._texture.updateFilter(), 
        this._texture && this._texture.texParameteri && this._texture.texParameteri(10241, t);
    }
    setMagFilter(t) {
        this.config.mag = he(t), this._texture && this._texture.updateFilter && this._texture.updateFilter(), 
        this._texture && this._texture.texParameteri && this._texture.texParameteri(10240, t);
    }
    createREGLTexture(t) {
        if (this.p = t, this.si(t), R(this.config.data) || R(this.config.mipmap)) {
            const e = pe(t, this.config);
            return e[nt] || (e[nt] = 0), e[nt]++, e;
        }
        return t.texture(this.config);
    }
    si(t) {
        const e = this.config;
        e.data && this.oi(t) && (e.data instanceof Image ? (e.data = $(e.data), e.width = e.data.width, 
        e.height = e.data.height) : e.hdr || !R(e.data) || X(e.width) && X(e.height) || (e.data = $(e.data, e.width, e.height), 
        e.width = e.data.width, e.height = e.data.height));
    }
    oi(t) {
        if (J(t)) return !1;
        const e = this.config;
        return e.wrap && "clamp" !== e.wrap || e.wrapS && "clamp" !== e.wrapS || e.wrapT && "clamp" !== e.wrapT || e.min && "nearest" !== e.min && "linear" !== e.min;
    }
}

class Bi extends qt {
    constructor(t) {
        super({
            aPosition: new (N(t = t || 0))([ -1, -1, t, 1, -1, t, -1, 1, t, 1, 1, t ]),
            aNormal: new Int8Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1 ])
        }, new Uint16Array([ 0, 1, 3, 3, 2, 0 ]));
    }
}

const Vi = {
    vsm_shadow_vert: "\nuniform mat4 shadow_lightProjViewModelMatrix;\nvarying vec4 shadow_vLightSpacePos;\nvoid shadow_computeShadowPars(vec4 position) {\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\n}",
    vsm_shadow_frag: "\nuniform sampler2D shadow_shadowMap;\nuniform float shadow_opacity;\nuniform vec3 shadow_color;\n#if defined(USE_ESM)\n    uniform float esm_shadow_threshold;\n#endif\nvarying vec4 shadow_vLightSpacePos;\n#ifdef PACK_FLOAT\n    #include <common_pack_float>\n#endif\n#if defined(USE_ESM)\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\n    float compare = projCoords.z;\n    float c = 120.0;\n    #ifdef PACK_FLOAT\n        float depth = common_decodeDepth(shadowTexel);\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\n            return 1.0;\n        }\n    #else\n        float depth = shadowTexel.r;\n    #endif\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, esm_shadow_threshold, 1.0);\n}\n#endif\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\n    vec2 uv = projCoords.xy;\n    vec4 shadowTexel = texture2D(shadowMap, uv);\n    #if defined(USE_ESM)\n        float esm_coeff = esm(projCoords, shadowTexel);\n        float coeff = esm_coeff * esm_coeff;\n    #endif\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\n}\nfloat shadow_computeShadow() {\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\nvec3 shadow_blend(vec3 color, float coeff) {\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\n    return color;\n}",
    fbo_picking_vert: "\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 1\n    attribute float aPickingId;\n#elif HAS_PICKING_ID == 2\n    uniform float uPickingId;\n#endif\n    varying float vPickingId;\n    varying float vFbo_picking_viewZ;\n    varying float vFbo_picking_visible;\n#endif\n    varying float vFbo_picking_fragDepth;\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n        vPickingId = aPickingId;\n    #elif HAS_PICKING_ID == 2\n        vPickingId = uPickingId;\n    #endif\n        vFbo_picking_viewZ = viewPosZ;\n        vFbo_picking_visible = visible ? 1.0 : 0.0;\n    #endif\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\n}",
    common_pack_float: "const float COMMON_FLOAT_MAX =  1.70141184e38;\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\nvec4 common_unpackFloat(highp float v) {\n    highp float av = abs(v);\n    if(av < COMMON_FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > COMMON_FLOAT_MAX) {\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if(v < -COMMON_FLOAT_MAX) {\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n    highp vec4 c = vec4(0,0,0,0);\n    highp float e = floor(log2(av));\n    highp float m = av * pow(2.0, -e) - 1.0;\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n    highp float ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n    c[0] += 128.0 * step(0.0, -v);\n    return c / 255.0;\n}\nvec4 common_encodeDepth(const in float depth) {\n    float alpha = 1.0;\n    vec4 pack = vec4(0.0);\n    pack.a = alpha;\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\n    pack.rgb = vec3(code * depth);\n    pack.gb = fract(pack.gb);\n    pack.rg -= pack.gb * (1.0 / 256.0);\n    pack.b -= mod(pack.b, 4.0 / 255.0);\n    return pack;\n}\nfloat common_decodeDepth(const in vec4 pack) {\n    return pack.r + pack.g / 255.0;\n}\nvec4 encodeFloat32(float f) {\n    float e =5.0;\n    float F = abs(f);\n    float Sign = step(0.0,-f);\n    float Exponent = floor(log2(F));\n    float Mantissa = (exp2(- Exponent) * F);\n    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n    vec4 rgba;\n    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n    rgba[1] = 128.0 * mod(Exponent,2.0) + mod(floor(Mantissa*128.0),128.0);\n    rgba[2] = floor(mod(floor(Mantissa*exp2(23.0 -8.0)),exp2(8.0)));\n    rgba[3] = floor(exp2(23.0)*mod(Mantissa,exp2(-15.0)));\n    return rgba / 255.0;\n}\nfloat decodeFloat32(vec4 rgba) {\n    rgba *= 255.0;\n    float Sign = 1.0 - step(128.0,rgba[0])*2.0;\n    float Exponent = 2.0 * mod(rgba[0],128.0) + step(128.0,rgba[1]) - 127.0;\n    float Mantissa = mod(rgba[1],128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + float(0x800000);\n    float Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n    return Result;\n}",
    invert_matrix: "mat4 invert_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return inverse(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n        det = 1.0 / det;\n        mat4 m = mat4(\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\n        );\n        return m;\n    #endif\n}\nmat4 transpose_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return transpose(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a12 = vector2.z, a13 = vector2.w;\n        float a23 = vector3.w;\n        mat4 m = mat4(\n            vector1.x,\n            vector2.x,\n            vector3.x,\n            vector4.x,\n            a01,\n            vector2.y,\n            vector3.y,\n            vector4.y,\n            a02,\n            a12,\n            vector3.z,\n            vector4.z,\n            a03,\n            a13,\n            a23,\n            vector4.w\n        );\n        return m;\n    #endif\n}",
    get_output: "#include <invert_matrix>\n#include <draco_decode_vert>\n#ifdef HAS_INSTANCE\n    #include <instance_vert>\n    #ifdef HAS_INSTANCE_COLOR\n        varying vec4 vInstanceColor;\n    #endif\n#endif\n#ifdef HAS_SKIN\n    uniform int skinAnimation;\n    #include <skin_vert>\n#endif\n#include <mask_vert>\n#ifdef HAS_MORPH\n    attribute vec3 POSITION0;\n    attribute vec3 POSITION1;\n    attribute vec3 POSITION2;\n    attribute vec3 POSITION3;\n    attribute vec3 POSITION4;\n    attribute vec3 POSITION5;\n    attribute vec3 POSITION6;\n    attribute vec3 POSITION7;\n    #ifdef HAS_MORPHNORMALS\n        attribute vec3 NORMAL0;\n        attribute vec3 NORMAL1;\n        attribute vec3 NORMAL2;\n        attribute vec3 NORMAL3;\n    #endif\n    uniform vec4 morphWeights1;\n    uniform vec4 morphWeights2;\n#endif\n#ifdef HAS_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\n#endif\nmat4 getPositionMatrix() {\n    mat4 worldMatrix;\n    #ifdef HAS_INSTANCE\n        #ifdef HAS_INSTANCE_COLOR\n            vInstanceColor = instance_getInstanceColor();\n        #endif\n        mat4 attributeMatrix = instance_getAttributeMatrix();\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n            } else {\n                worldMatrix = attributeMatrix * positionMatrix;\n            }\n        #else\n            worldMatrix = attributeMatrix * positionMatrix;\n        #endif\n    #else\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\n            } else {\n                worldMatrix = positionMatrix;\n            }\n        #else\n            worldMatrix = positionMatrix;\n        #endif\n    #endif\n    return worldMatrix;\n}\n#ifdef HAS_MIN_ALTITUDE\n    uniform float minAltitude;\n#endif\n#ifdef HAS_TERRAIN_FLAT_MASK\n    uniform sampler2D flatMask;\n#endif\nvec4 getPosition(vec3 aPosition) {\n    vec3 position = decode_getPosition(aPosition);\n    #ifdef HAS_MORPH\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\n        , 1.0);\n    #else\n        vec4 POSITION = vec4(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        POSITION.z += aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_TERRAIN_FLAT_MASK\n        vec2 uv = aTexCoord;\n        uv.y = 1.0 - uv.y;\n        vec4 encodedHeight = texture2D(flatMask, uv);\n        if (length(encodedHeight) < 2.0) {\n            float maskHeight = decodeFloat32(encodedHeight);\n            POSITION.z = min(POSITION.z, maskHeight);\n        }\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        POSITION.z += minAltitude * 100.0;\n    #endif\n    return POSITION;\n}\nvec3 appendMorphNormal(vec3 NORMAL) {\n    #ifdef HAS_MORPHNORMALS\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\n    #else\n        vec3 normal = NORMAL;\n    #endif\n    return normal;\n}",
    instance_vert: "attribute vec4 instance_vectorA;\nattribute vec4 instance_vectorB;\nattribute vec4 instance_vectorC;\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\nuniform float terrainAltitudeScale;\n#endif\nmat4 instance_getAttributeMatrix() {\n    mat4 mat =  mat4(\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\n    );\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n        mat4 terrainMat = mat4(\n            1., 0., 0., 0.,\n            0., 1., 0., 0.,\n            0., 0., 1., 0.,\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\n        );\n        mat = terrainMat * mat;\n    #endif\n    return mat;\n}\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    attribute vec4 highlight_color;\n#endif\n#ifdef HAS_INSTANCE_COLOR\n   \n    attribute vec4 instance_color;\n    vec4 instance_getInstanceColor() {\n        vec4 color = instance_color;\n        #ifdef HAS_INSTANCE_HIGHLIGHT\n            color = instance_color * highlight_color;\n        #endif\n        return color;\n    }\n#endif",
    skin_vert: "attribute vec4 WEIGHTS_0;\nattribute vec4 JOINTS_0;\nuniform sampler2D jointTexture;\nuniform vec2 jointTextureSize;\nuniform float numJoints;\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\nmat4 skin_getBoneMatrix(float jointNdx) {\n    float v = (jointNdx + 0.5) / numJoints;\n    return mat4(\n        texture2D(jointTexture, vec2(ROW0_U, v)),\n        texture2D(jointTexture, vec2(ROW1_U, v)),\n        texture2D(jointTexture, vec2(ROW2_U, v)),\n        texture2D(jointTexture, vec2(ROW3_U, v)));\n}\nmat4 skin_getSkinMatrix() {\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n        return skinMatrix;\n}",
    heatmap_render_vert: "#ifdef HAS_HEATMAP\nvarying vec2 heatmap_vTexCoord;\nvoid heatmap_compute(mat4 matrix, vec3 position) {\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\n}\n#endif",
    heatmap_render_frag: "#ifdef HAS_HEATMAP\nuniform sampler2D heatmap_inputTexture;\nuniform sampler2D heatmap_colorRamp;\nuniform float heatmap_heatmapOpacity;\nvarying vec2 heatmap_vTexCoord;\nvec4 heatmap_getColor(vec4 color) {\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\n}\n#endif",
    line_extrusion_vert: "#ifdef IS_LINE_EXTRUSION\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n    attribute vec2 aExtrude;\n    #ifdef HAS_LINE_WIDTH\n        attribute float aLineWidth;\n    #else\n        uniform float lineWidth;\n    #endif\n    #ifdef HAS_LINE_HEIGHT\n        attribute float aLineHeight;\n    #else\n        uniform float lineHeight;\n    #endif\n    uniform float linePixelScale;\n    vec3 getLineExtrudePosition(vec3 position) {\n        #ifdef HAS_LINE_WIDTH\n            float lineWidth = aLineWidth / 2.0;\n        #endif\n        #ifdef HAS_LINE_HEIGHT\n            float lineHeight = aLineHeight / 10.0;\n        #endif\n        float halfwidth = lineWidth / 2.0;\n        float outset = halfwidth;\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\n        position.z *= lineHeight / ALTITUDE_SCALE;\n        return position + vec3(dist, 0.0) * linePixelScale;\n    }\n#endif",
    gl2_vert: "#if __VERSION__ == 300\n    #define texture2D texture\n    #define varying out\n    #define attribute in\n#endif",
    gl2_frag: "#if __VERSION__ == 300\n    #define varying in\n    #define gl_FragDepthEXT gl_FragDepth\n    #define texture2D texture\n    #define textureCube texture\n    #define texture2DProj textureProj\n    #define texture2DLodEXT textureLod\n    #define texture2DProjLodEXT textureProjLod\n    #define textureCubeLodEXT textureLod\n    #define texture2DGradEXT textureGrad\n    #define texture2DProjGradEXT textureProjGrad\n    #define textureCubeGradEXT textureGrad\n    out vec4 glFragColor;\n#else\n    vec4 glFragColor;\n#endif",
    hsv_frag: "\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst mediump float HSV_E = 1.0e-10;\nvec3 hsv_rgb2hsv(vec3 c) {\n    vec4 K = HSV_K0;\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n    float d = q.x - min(q.w, q.y);\n    float e = HSV_E;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\nvec3 hsv_hsv2rgb(vec3 c) {\n    vec4 K = HSV_K1;\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return vec4(hsv_hsv2rgb(hsv), c.a);\n}\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return hsv_hsv2rgb(hsv);\n}\nmat4 contrastMatrix(float contrast)\n{\n    float t = (1.0 - contrast) / 2.0;\n    return mat4(\n        contrast, 0., 0., 0.,\n        0., contrast, 0., 0.,\n        0., 0., contrast, 0.,\n        t, t, t, 1\n    );\n}",
    snow_frag: "#ifdef HAS_SNOW\n    float lerp(float a, float b, float w) {\n        return a + w * (b - a);\n    }\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\n        float snowIntense = normalColor.b;\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\n        if (height < 1.0) {\n            float r = lerp(0.5, fixedC.x, snowIntense);\n            float g = lerp(0.5, fixedC.y, snowIntense);\n            float b = lerp(0.5, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        } else {\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        }\n    }\n#endif",
    draco_decode_vert: "#if defined(HAS_TANGENT)\n    attribute vec4 aTangent;\n#elif defined(HAS_NORMAL)\n    #ifdef HAS_DRACO_NORMAL\n        attribute vec2 aNormal;\n        uniform float gltf_u_dec_normal_rangeConstant;\n    #else\n        attribute vec3 aNormal;\n    #endif\n#endif\n#ifdef HAS_DRACO_POSITION\n    uniform float gltf_u_dec_position_normConstant;\n    uniform vec3 minValues_pos;\n    vec3 decodeDracoPosition(vec3 aPosition) {\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\n    }\n#endif\n#ifdef HAS_DRACO_TEXCOORD\n    uniform vec2 minValues_tex;\n    uniform float gltf_u_dec_texcoord_0_normConstant;\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\n    }\n#endif\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\n    uniform mat3 decodeMatrix;\n#endif\n#ifdef HAS_DRACO_NORMAL\n    float czm_signNotZero(float value) {\n        return value >= 0.0 ? 1.0 : -1.0;\n    }\n    vec2 czm_signNotZero(vec2 value) {\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n    vec3 decodeDracoNormal(vec2 encoded, float range)\n    {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n    vec3 decode_getNormal(vec2 aNormal) {\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\n    }\n#endif\n#ifdef HAS_COMPRESSED_INT16\n    #ifdef HAS_COMPRESSED_INT16_POSITION\n      uniform vec2 compressedPositionRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\n      uniform vec2 compressedTexcoordRange_0;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\n      uniform vec2 compressedTexcoordRange_1;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n      uniform vec2 compressedNormalRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_RATIO\n      uniform float compressed_ratio;\n    #endif\n    float int16ToFloat32(float value, vec2 range) {\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n#endif\nvec3 decode_getPosition(vec3 aPosition) {\n    vec3 position = aPosition;\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\n        #else\n          position = vec3(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n}\nvec2 decode_getTexcoord(vec2 aTexCoord) {\n    vec2 texcoord = aTexCoord;\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\n        texcoord = vec2(x, y);\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\n    #else\n        return texcoord;\n    #endif\n}\nvec3 decode_getNormal(vec3 aNormal) {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\n    #endif\n    return aNormal;\n}",
    highlight_vert: "#if defined(HAS_HIGHLIGHT_COLOR)\n    attribute vec4 aHighlightColor;\n    varying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    attribute float aHighlightOpacity;\n    varying float vHighlightOpacity;\n#endif\nvoid highlight_setVarying() {\n    #if defined(HAS_HIGHLIGHT_COLOR)\n        vHighlightColor = aHighlightColor / 255.0;\n    #endif\n    #if defined(HAS_HIGHLIGHT_OPACITY)\n        vHighlightOpacity = aHighlightOpacity / 255.0;\n    #endif\n}",
    highlight_frag: "#if defined(HAS_HIGHLIGHT_COLOR)\n\tvarying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    varying float vHighlightOpacity;\n#endif\nvec4 highlight_blendColor(vec4 color) {\n\tvec4 outColor;\n\t#if defined(HAS_HIGHLIGHT_COLOR)\n\t\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\n\t\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\n        \tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\n        #endif\n        outColor = color;\n\t#else\n\t\toutColor = color;\n\t#endif\n\t#if defined(HAS_HIGHLIGHT_OPACITY)\n\t\toutColor *= vHighlightOpacity;\n\t#endif\n\treturn outColor;\n}",
    mask_vert: "#ifdef HAS_MASK_EXTENT\n    uniform vec4 mask_extent;\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_maskMode;\n    uniform float mask_hasFlatOut;\n    uniform mat4 viewMatrix;\n    uniform float mask_heightRatio;\n    uniform float mask_heightOffset;\n    varying vec4 vWorldPosition;\n    varying vec2 vUVInExtent;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    const float CLIPINSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float ELEVATE_MODE = 0.7;\n    float random (vec2 st) {\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\n    }\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n          return flatHeight + height;\n      } else {\n        return flatHeight;\n      }\n    }\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\n      float deltaY = realPos.y - tempPos.y;\n      float deltaZ = realPos.z - tempPos.z;\n      pos.x = pos.x + deltaX;\n      pos.y = pos.y + deltaY;\n      pos.z = pos.z + deltaZ;\n      return pos;\n    }\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\n        vWorldPosition = modelMatrix * position;\n        float w = mask_extent.z - mask_extent.x;\n        float h = mask_extent.y - mask_extent.w;\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\n        float maskMode = maskOptionColor.r;\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\n        vUVInExtent = uvInExtent;\n        vHeightRatio = mask_heightRatio;\n        vHeightOffset = mask_heightOffset;\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n            return modelViewMatrix * position;;\n        } else if (mask_hasFlatOut == 1.0) {\n            return getNoErrorPosition(position, wPosition);\n        }\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n            return getNoErrorPosition(position, wPosition);\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n            return getNoErrorPosition(position, wPosition);\n        } else {\n            return modelViewMatrix * position;\n        }\n    }\n#endif",
    mask_frag: "#ifdef HAS_MASK_EXTENT\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_hasClipOut;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    varying vec2 vUVInExtent;\n    varying vec4 vWorldPosition;\n    const float CLIPINSIDE_MODE = 0.1;\n    const float CLIPOUTSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float COLOR_MODE = 0.5;\n    const float VIDEO_MODE = 0.6;\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    vec4 setMask(vec4 glFragColor) {\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\n        float maskMode = modeColor.r;\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                return glFragColor;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                return glFragColor;\n            } else {\n              discard;\n            }\n        } else if (mask_hasClipOut == 1.0) {\n            discard;\n        }\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                discard;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                discard;\n            } else {\n              return glFragColor;\n            }\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            }\n        }\n        return glFragColor;\n    }\n#endif",
    compute_texcoord_frag: "#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    uniform vec2 khr_offset;\n    uniform float khr_rotation;\n    uniform vec2 khr_scale;\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\n        rotation = -rotation;\n        mat3 transform = mat3(\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\nvarying highp vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\n    varying vec4 vUvRegion;\n#endif\nvec2 computeTexCoord(vec2 texCoord) {\n    #ifdef HAS_I3S_UVREGION\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\n        return uvAtlas;\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\n    #else\n        return texCoord;\n    #endif\n}",
    terrain_normal_frag: "#ifdef HAS_TERRAIN_NORMAL\n    uniform sampler2D terrainHeightTexture;\n    uniform vec2 terrainHeightMapResolution;\n    uniform vec2 terrainResolution;\n    uniform vec4 terrainUnpackFactors;\n    float getHeight(vec2 uv) {\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\n        color.a = -1.0;\n        return dot(color, terrainUnpackFactors) / 4.0;\n    }\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\n        uv.y = 1.0 - uv.y;\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\n        float b = getHeight(uv + vec2(0, -epsilon.y));\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\n        float e = getHeight(uv + vec2(epsilon.x, 0));\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\n        float g = getHeight(uv + vec2(0, epsilon.y));\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\n        vec2 dxy = vec2(\n            (c + e + e + h) - (a + d + d + f),\n            (f + g + g + h) - (a + b + b + c)\n        );\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\n    }\n#endif",
    vertex_color_vert: "#ifdef HAS_VERTEX_COLOR\nattribute float aVertexColorType;\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\nvarying vec4 vertexColor_color;\nvoid vertexColor_update() {\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\n}\n#endif\n//用于识别顶点颜色类型: topPolygonFill 还是 bottomPolygonFill",
    vertex_color_frag: "#ifdef HAS_VERTEX_COLOR\nvarying vec4 vertexColor_color;\nvec4 vertexColor_get() {\n\treturn vertexColor_color;\n}\n#endif",
    excavate_vert: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform vec4 excavateExtent;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  float getWorldHeight(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    return wPosition.z;\n  }\n  vec2 getCoordinateTexcoord(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\n    return vec2(x, y);\n  }\n#endif",
    excavate_frag: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform sampler2D heightmap;\n  uniform float excavateHeight;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  const vec2 range = vec2(-100.0, 1000.0);\n  float decodeHeight(const in vec4 pack) {\n      return pack.r + pack.g / 255.0;\n  }\n  vec4 excavateColor(vec4 fragColor) {\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\n      if(realHeight < range.x || realHeight > range.y) {\n          realHeight = 0.0;\n      }\n      if(vExcavateHeight > realHeight) {\n          discard;\n      }\n      return fragColor;\n  }\n#endif",
    srgb_frag: "vec3 linearTosRGB(const in vec3 color) {\n    return vec3(\n        color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055,\n        color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055,\n        color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055\n    );\n}\nvec3 sRGBToLinear(const in vec3 color) {\n    return vec3(\n        color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4),\n        color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4),\n        color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4)\n    );\n}",
    mesh_picking_vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <fbo_picking_vert>\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n    fbo_picking_setData(gl_Position.w, true);\n}"
};

var ji = {
    register(t, e) {
        if (Vi[t]) throw new Error(`Key of ${t} is already registered in ShaderLib.`);
        Vi[t] = e;
    },
    compile: t => qi(t),
    get: t => Vi[t]
};

const Wi = /^[ \t]*#include +<([\w\d.]+)>/gm;

function qi(t) {
    return t.replace(Wi, Xi);
}

function Xi(t, e) {
    const n = Vi[e];
    if (!n) throw new Error("Can not resolve #include <" + e + ">");
    return qi(n);
}

const Ki = "\n// 矩阵求逆函数\nfn invert_matrix(matrix: mat4x4f) -> mat4x4f {\n    let vector1 = matrix[0];\n    let vector2 = matrix[1];\n    let vector3 = matrix[2];\n    let vector4 = matrix[3];\n\n    let a00 = vector1.x;\n    let a01 = vector1.y;\n    let a02 = vector1.z;\n    let a03 = vector1.w;\n\n    let a10 = vector2.x;\n    let a11 = vector2.y;\n    let a12 = vector2.z;\n    let a13 = vector2.w;\n\n    let a20 = vector3.x;\n    let a21 = vector3.y;\n    let a22 = vector3.z;\n    let a23 = vector3.w;\n\n    let a30 = vector4.x;\n    let a31 = vector4.y;\n    let a32 = vector4.z;\n    let a33 = vector4.w;\n\n    let b00 = a00 * a11 - a01 * a10;\n    let b01 = a00 * a12 - a02 * a10;\n    let b02 = a00 * a13 - a03 * a10;\n    let b03 = a01 * a12 - a02 * a11;\n    let b04 = a01 * a13 - a03 * a11;\n    let b05 = a02 * a13 - a03 * a12;\n    let b06 = a20 * a31 - a21 * a30;\n    let b07 = a20 * a32 - a22 * a30;\n    let b08 = a20 * a33 - a23 * a30;\n    let b09 = a21 * a32 - a22 * a31;\n    let b10 = a21 * a33 - a23 * a31;\n    let b11 = a22 * a33 - a23 * a32;\n\n    // 计算行列式\n    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n    det = 1.0 / det;\n\n    let m = mat4x4f(\n        (a11 * b11 - a12 * b10 + a13 * b09) * det,\n        (a02 * b10 - a01 * b11 - a03 * b09) * det,\n        (a31 * b05 - a32 * b04 + a33 * b03) * det,\n        (a22 * b04 - a21 * b05 - a23 * b03) * det,\n        (a12 * b08 - a10 * b11 - a13 * b07) * det,\n        (a00 * b11 - a02 * b08 + a03 * b07) * det,\n        (a32 * b02 - a30 * b05 - a33 * b01) * det,\n        (a20 * b05 - a22 * b02 + a23 * b01) * det,\n        (a10 * b10 - a11 * b08 + a13 * b06) * det,\n        (a01 * b08 - a00 * b10 - a03 * b06) * det,\n        (a30 * b04 - a31 * b02 + a33 * b00) * det,\n        (a21 * b02 - a20 * b04 - a23 * b00) * det,\n        (a11 * b07 - a10 * b09 - a12 * b06) * det,\n        (a00 * b09 - a01 * b07 + a02 * b06) * det,\n        (a31 * b01 - a30 * b03 - a32 * b00) * det,\n        (a20 * b03 - a21 * b01 + a22 * b00) * det\n    );\n\n    return m;\n}\n\n// 矩阵转置函数\nfn transpose_matrix(matrix: mat4x4f) -> mat4x4f {\n    let vector1 = matrix[0];\n    let vector2 = matrix[1];\n    let vector3 = matrix[2];\n    let vector4 = matrix[3];\n\n    let a01 = vector1.y;\n    let a02 = vector1.z;\n    let a03 = vector1.w;\n\n    let a12 = vector2.z;\n    let a13 = vector2.w;\n\n    let a23 = vector3.w;\n\n    let m = mat4x4f(\n        vector1.x,\n        vector2.x,\n        vector3.x,\n        vector4.x,\n        a01,\n        vector2.y,\n        vector3.y,\n        vector4.y,\n        a02,\n        a12,\n        vector3.z,\n        vector4.z,\n        a03,\n        a13,\n        a23,\n        vector4.w\n    );\n\n    return m;\n}\n";

const $i = "\nconst COMMON_FLOAT_MAX: f32 = 1.70141184e38;\nconst COMMON_FLOAT_MIN: f32 = 1.17549435e-38;\n\nfn common_packFloat(val: vec4f) -> f32 {\n    let scl = floor(255.0 * val + 0.5);\n    let sgn = select(-1.0, 1.0, scl.a < 128.0);\n    let exn = (scl.a * 2.0 % 256.0) + floor(scl.b / 128.0) - 127.0;\n    let man = 1.0 +\n        (scl.r / 8388608.0) +\n        (scl.g / 32768.0) +\n        (scl.b % 128.0) / 128.0;\n    return sgn * man * pow(2.0, exn);\n}\n\nfn common_unpackFloat(v: f32) -> vec4f {\n    let av = abs(v);\n\n    // Handle special cases\n    if (av < COMMON_FLOAT_MIN) {\n        return vec4f(0.0, 0.0, 0.0, 0.0);\n    } else if (v > COMMON_FLOAT_MAX) {\n        return vec4f(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if (v < -COMMON_FLOAT_MAX) {\n        return vec4f(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n\n    var c = vec4f(0.0, 0.0, 0.0, 0.0);\n\n    // Compute exponent and mantissa\n    let e = floor(log2(av));\n    var m = av * pow(2.0, -e) - 1.0;\n\n    // Unpack mantissa\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n\n    // Unpack exponent\n    var ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n\n    // Unpack sign bit\n    c[0] += 128.0 * step(0.0, -v);\n\n    // Scale back to range\n    return c / 255.0;\n}\n\nfn common_encodeDepth(depth: f32) -> vec4f {\n    let alpha = 1.0;\n    var pack = vec4f(0.0);\n    pack.a = alpha;\n    const code = vec3f(1.0, 255.0, 65025.0);\n    pack = vec4f(vec3f(code * depth), pack.a);\n    pack = vec4f(pack.r, fract(pack.gb), pack.a);\n    pack.r -= pack.g * (1.0 / 256.0);\n    pack.g -= pack.b * (1.0 / 256.0);\n    pack.b -= (pack.b % (4.0 / 255.0));\n    return pack;\n}\n\nfn common_decodeDepth(pack: vec4f) -> f32 {\n    return pack.r + pack.g / 255.0;\n}\n\n// https://cloud.tencent.com/developer/ask/sof/103481834\nfn encodeFloat32(f: f32) -> vec4f {\n    var e = 5.0;\n\n    var F = abs(f);\n    var Sign = step(0.0, -f);\n    var Exponent = floor(log2(F));\n    var Mantissa = (exp2(- Exponent) * F);\n    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n    var rgba = vec4(0.0);\n    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n    rgba[1] = 128.0 * mod(Exponent,2.0) + mod(floor(Mantissa*128.0),128.0);\n    rgba[2] = floor(mod(floor(Mantissa*exp2(23.0 -8.0)),exp2(8.0)));\n    rgba[3] = floor(exp2(23.0)*mod(Mantissa,exp2(-15.0)));\n    return rgba / 255.0;\n}\n\nfn decodeFloat32(rgba: vec4f) -> f32 {\n    rgba *= 255.0;\n    var Sign = 1.0 - step(128.0,rgba[0])*2.0;\n    var Exponent = 2.0 * mod(rgba[0],128.0) + step(128.0,rgba[1]) - 127.0;\n    var Mantissa = mod(rgba[1],128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + float(0x800000);\n    var Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n    return Result;\n}\n\n\n";

const Ji = {
    instance: {
        vert: "\n@group(0) @binding($b) var<uniform> terrainAltitudeScale: f32;\n\n// 获取实例属性矩阵函数\nfn instance_getAttributeMatrix(\n    input: VertexInput\n) -> mat4x4f {\n    let vectorA = input.instance_vectorA;\n    let vectorB = input.instance_vectorB;\n    let vectorC = input.instance_vectorC;\n    var mat = mat4x4f(\n        vectorA.x, vectorB.x, vectorC.x, 0.0,\n        vectorA.y, vectorB.y, vectorC.y, 0.0,\n        vectorA.z, vectorB.z, vectorC.z, 0.0,\n        vectorA.w, vectorB.w, vectorC.w, 1.0\n    );\n\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n    var terrainMat = mat4x4f(\n        1.0, 0.0, 0.0, 0.0,\n        0.0, 1.0, 0.0, 0.0,\n        0.0, 0.0, 1.0, 0.0,\n        0.0, 0.0, aTerrainAltitude * terrainAltitudeScale, 1.0\n    );\n    mat = terrainMat * mat;\n#endif\n\n    return mat;\n}\n\n#ifdef HAS_INSTANCE_COLOR\n// 获取实例颜色函数\nfn instance_getInstanceColor(instance_color: vec4f) -> vec4f {\n    var color = instance_color;\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    color = instance_color * highlight_color;\n#endif\n    return color;\n}\n#endif\n",
        attributes: [ {
            name: "instance_vectorA",
            type: "vec4f"
        }, {
            name: "instance_vectorB",
            type: "vec4f"
        }, {
            name: "instance_vectorC",
            type: "vec4f"
        }, {
            defines: [ "HAS_INSTANCE_TERRAIN_ALTITUDE" ],
            name: "aTerrainAltitude",
            type: "f32"
        }, {
            defines: [ "HAS_INSTANCE_HIGHLIGHT" ],
            name: "highlight_color",
            type: "vec4f"
        }, {
            defines: [ "HAS_INSTANCE_COLOR" ],
            name: "instance_color",
            type: "vec4f"
        } ],
        defines: [ "HAS_INSTANCE" ]
    },
    invert_matrix: {
        vert: Ki,
        frag: Ki
    },
    line_extrusion: {
        vert: "\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n\n    struct LineExtrusionVertex {\n        linePixelScale: f32;\n        #if HAS_LINE_WIDTH\n        #else\n            lineWidth: f32;\n        #endif\n        #if HAS_LINE_HEIGHT\n        #else\n            lineHeight: f32;\n        #endif\n    }\n\n    @group(0) @binding($b) var<uniform> lineExtrusionVertex : LineExtrusionVertex;\n\n    fn getLineExtrudePosition(position: vec3f, input: VertexInput) -> vec3f {\n        #if HAS_LINE_WIDTH\n            let lineWidth: f32 = input.aLineWidth / 2.0;\n        #else\n            let lineWidth: f32 = lineExtrusionVertex.lineWidth;\n        #endif\n        #if HAS_LINE_HEIGHT\n            // aLineHeight单位是分米\n            let lineHeight: f32 = input.aLineHeight / 10.0;\n        #else\n            let lineHeight: f32 = lineExtrusionVertex.lineHeight\n        #endif\n\n        let halfwidth: f32 = lineWidth / 2.0;\n        let outset: f32 = halfwidth;\n        let dist: vec2f = outset * input.aExtrude / EXTRUDE_SCALE;\n        let z_scaled: f32 = position.z * (lineHeight / ALTITUDE_SCALE);\n    return position + vec3f(dist, 0.0) * linePixelScale;\n}\n",
        attributes: [ {
            defines: [ "HAS_LINE_WIDTH" ],
            name: "aLineWidth",
            type: "f32"
        }, {
            defines: [ "HAS_LINE_HEIGHT" ],
            name: "aLineHeight",
            type: "f32"
        } ],
        defines: [ "IS_LINE_EXTRUSION" ]
    },
    mask: {
        defines: [ "HAS_MASK_EXTENT" ],
        vert: "\n#ifdef HAS_MASK_EXTENT\nstruct MaskUniforms {\n    mask_extent: vec4f,\n    mask_maskMode: f32,\n    mask_hasFlatOut: f32,\n    viewMatrix: mat4x4f,\n    mask_heightRatio: f32,\n    mask_heightOffset: f32,\n};\n\n@group(0) @binding($b) var<uniform> maskUniforms: MaskUniforms;\n@group(0) @binding($b) var mask_colorExtentSampler: sampler;\n@group(0) @binding($b) var mask_colorExtent: texture_2d<f32>;\n@group(0) @binding($b) var mask_modeExtentSampler: sampler;\n@group(0) @binding($b) var mask_modeExtent: texture_2d<f32>;\n\nconst CLIPINSIDE_MODE: f32 = 0.2;\nconst FLATINSIDE_MODE: f32 = 0.3;\nconst FLATOUTSIDE_MODE: f32 = 0.4;\nconst ELEVATE_MODE: f32 = 0.7;\n\nfn random(st: vec2f) -> f32 {\n    return fract(sin(dot(st, vec2f(12.9898, 78.233))) * 43758.5453123) * 0.1;\n}\n\nfn isInExtent(color: vec4f) -> bool {\n    return length(color.rgb) > 0.0;\n}\n\nfn getFlatHeight(maskMode: f32, flatHeight: f32, height: f32) -> f32 {\n    if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n        return flatHeight + height;\n    } else {\n        return flatHeight;\n    }\n}\n\nfn getNoErrorPosition(position: vec4f, wPosition: vec4f) -> vec4f {\n    let realPos = uniforms.modelViewMatrix * position; // 未压平，采用 vm 矩阵的坐标\n    let pos = maskUniforms.viewMatrix * wPosition; // 压平的坐标\n    let tempPos = maskUniforms.viewMatrix * uniforms.modelMatrix * position; // 未压平而采用 v*m 矩阵的坐标\n    let deltaX = realPos.x - tempPos.x;\n    let deltaY = realPos.y - tempPos.y;\n    let deltaZ = realPos.z - tempPos.z;\n    pos.x = pos.x + deltaX;\n    pos.y = pos.y + deltaY;\n    pos.z = pos.z + deltaZ;\n    return pos;\n}\n\nfn getMaskPosition(position: vec4f, modelMatrix: mat4x4f, vertexOutput: VertexOutput) -> vec4f {\n    vertexOutput.vWorldPosition = modelMatrix * position;\n    let w = maskUniforms.mask_extent.z - maskUniforms.mask_extent.x;\n    let h = maskUniforms.mask_extent.y - maskUniforms.mask_extent.w;\n    let uvInExtent = vec2f((vertexOutput.vWorldPosition.x - maskUniforms.mask_extent.x) / abs(w), 1.0 - (vertexOutput.vWorldPosition.y - maskUniforms.mask_extent.w) / h);\n    let extentColor = textureSample(mask_colorExtent, mask_colorExtentSampler, uvInExtent);\n    let maskOptionColor = textureSample(mask_modeExtent, mask_modeExtentSampler, uvInExtent).rgb;\n    let maskMode = maskOptionColor.r;\n    let flatHeight = maskOptionColor.g / maskUniforms.mask_heightRatio + maskUniforms.mask_heightOffset;\n    let height = getFlatHeight(maskMode, flatHeight, vertexOutput.vWorldPosition.z);\n    let wPosition = vec4f(vertexOutput.vWorldPosition.x, vertexOutput.vWorldPosition.y, height, vertexOutput.vWorldPosition.w);\n    vertexOutput.vUVInExtent = uvInExtent;\n    vertexOutput.vHeightRatio = maskUniforms.mask_heightRatio;\n    vertexOutput.vHeightOffset = maskUniforms.mask_heightOffset;\n    if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n        return uniforms.modelViewMatrix * position;\n    } else if (maskUniforms.mask_hasFlatOut == 1.0) {\n        return getNoErrorPosition(position, wPosition);\n    }\n    if (isInExtent(extentColor) && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n        return getNoErrorPosition(position, wPosition);\n    }\n    if (isInExtent(extentColor) && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n        return getNoErrorPosition(position, wPosition);\n    } else {\n        return uniforms.modelViewMatrix * position;\n    }\n}\n#endif\n",
        varyings: [ {
            name: "vWorldPosition",
            type: "vec4f"
        }, {
            name: "vUVInExtent",
            type: "vec2f"
        }, {
            name: "vHeightRatio",
            type: "f32"
        }, {
            name: "vHeightOffset",
            type: "f32"
        } ]
    },
    get_output: {
        attributes: [ {
            defines: [ "HAS_MORPH" ],
            name: "POSITION0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION1",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION2",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION3",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION4",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION5",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION6",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION7",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL1",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL2",
            type: "vec3f"
        }, {
            defines: [ "HAS_TERRAIN_ALTITUDE" ],
            name: "aTerrainAltitude",
            type: "f32"
        } ],
        varyings: [ {
            defines: [ "HAS_INSTANCE_COLOR", "HAS_INSTANCE" ],
            name: "vInstanceColor",
            type: "vec4f"
        } ],
        vert: "\n#include <invert_matrix>\n#include <draco_decode_vert>\n\n\n#include <instance_vert>\n\n\n#ifdef HAS_SKIN\n    struct SkinUniforms {\n        skinAnimation: i32,\n    };\n    @group(0) @binding($b) var<uniform> skinUniforms: SkinUniforms;\n    #include <skin_vert>\n#endif\n\n#include <mask_vert>\n\n#ifdef HAS_MORPH\n    struct MorphUniforms {\n        morphWeights1: vec4f,\n        morphWeights2: vec4f,\n    };\n    @group(0) @binding($b) var<uniform> morphUniforms: MorphUniforms;\n#endif\n\n#ifdef HAS_MIN_ALTITUDE\n    struct AltitudeUniforms {\n        minAltitude: f32,\n    };\n    @group(0) @binding($b) var<uniform> altitudeUniforms: AltitudeUniforms;\n#endif\n\n#ifdef HAS_TERRAIN_FLAT_MASK\n    @group(0) @binding($b) var flatMask: texture_2d<f32>;\n    @group(0) @binding($b) var flatMaskSampler: sampler;\n#endif\n\nfn getPositionMatrix(input: VertexInput, vertexOutput: ptr<function, VertexOutput>, positionMatrix: mat4x4f) -> mat4x4f {\n    var worldMatrix: mat4x4f;\n#ifdef HAS_INSTANCE\n    let attributeMatrix = instance_getAttributeMatrix(input);\n    #ifdef HAS_INSTANCE_COLOR\n        vertexOutput.vInstanceColor = instance_getInstanceColor();\n    #endif\n    #ifdef HAS_SKIN\n        if (skinUniforms.skinAnimation == 1) {\n            worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n        } else {\n            worldMatrix = attributeMatrix * positionMatrix;\n        }\n    #else\n        worldMatrix = attributeMatrix * positionMatrix;\n    #endif\n#else\n    #ifdef HAS_SKIN\n        if (skinUniforms.skinAnimation == 1) {\n            worldMatrix = skin_getSkinMatrix() * positionMatrix;\n        } else {\n            worldMatrix = positionMatrix;\n        }\n    #else\n        worldMatrix = positionMatrix;\n    #endif\n#endif\n    return worldMatrix;\n}\n\nfn getPosition(inputPosition: vec3f, vertexInput: VertexInput) -> vec4f {\n    var position = decode_getPosition(inputPosition);\n    #ifdef HAS_MORPH\n        let outputPosition = vec4f(position +\n            morphUniforms.morphWeights1[0] * vertexInput.POSITION0 +\n            morphUniforms.morphWeights1[1] * vertexInput.POSITION1 +\n            morphUniforms.morphWeights1[2] * vertexInput.POSITION2 +\n            morphUniforms.morphWeights1[3] * vertexInput.POSITION3 +\n            morphUniforms.morphWeights2[0] * vertexInput.POSITION4 +\n            morphUniforms.morphWeights2[1] * vertexInput.POSITION5 +\n            morphUniforms.morphWeights2[2] * vertexInput.POSITION6 +\n            morphUniforms.morphWeights2[3] * vertexInput.POSITION7, 1.0);\n    #else\n        var outputPosition = vec4f(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        outputPosition.z += vertexInput.aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_TERRAIN_FLAT_MASK\n        var uv = aTexCoord;\n        uv.y = 1.0 - uv.y;\n        let encodedHeight = textureSample(flatMask, flatMaskSampler, uv);\n        if (length(encodedHeight) < 2.0) {\n            float maskHeight = decodeFloat32(encodedHeight);\n            outputPosition.z = min(outputPosition.z, maskHeight);\n        }\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        outputPosition.z += altitudeUniforms.minAltitude * 100.0;\n    #endif\n    return outputPosition;\n}\n\nfn appendMorphNormal(inputNormal: vec3f, vertexInput: VertexInput) -> vec3f {\n    #ifdef HAS_MORPHNORMALS\n        let normal = inputNormal +\n            morphUniforms.morphWeights1[0] * vertexInput.NORMAL0 +\n            morphUniforms.morphWeights1[1] * vertexInput.NORMAL1 +\n            morphUniforms.morphWeights1[2] * vertexInput.NORMAL2 +\n            morphUniforms.morphWeights1[3] * vertexInput.NORMAL3;\n    #else\n        let normal = inputNormal;\n    #endif\n    return normal;\n}\n"
    },
    skin: {
        vert: "\n// 定义 uniform 变量\nstruct JoinUniforms {\n    numJoints: f32,                     // 关节数量\n};\n\n@group(0) @binding($b) var<uniform> joinUniforms: JoinUniforms;\n\n// 定义采样器\n@group(0) @binding($b) var jointTextureSampler: sampler;\n@group(0) @binding($b) var jointTexture: texture_2df,      // 关节纹理\n\n// 定义采样点坐标\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\n\n// 获取骨骼矩阵函数\nfn skin_getBoneMatrix(jointNdx: f32) -> mat4x4f {\n    let v = (jointNdx + 0.5) / joinUniforms.numJoints;\n    return mat4x4f(\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW0_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW1_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW2_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW3_U, v))\n    );\n}\n\n// 获取皮肤矩阵函数\nfn skin_getSkinMatrix(JOINTS_0: vec4f, WEIGHTS_0: vec4f) -> mat4x4f {\n    var skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                     skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                     skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                     skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n    return skinMatrix;\n}\n",
        attributes: [ {
            name: "WEIGHTS_0",
            type: "vec4f"
        }, {
            name: "JOINTS_0",
            type: "vec4f"
        } ],
        defines: [ "HAS_SKIN" ]
    },
    vertex_color: {
        vert: "\nstruct VertexColorsUniforms {\n    vertexColorsOfType: array<vec4f, VERTEX_TYPES_COUNT>\n}\n\n@group(0) @binding($b) var<uniform> vertexColors: VertexColorsUniforms;\n\nfn vertexColor_update(input: VertexInput, output: ptr<function, VertexOutput>) {\n    // 将 aVertexColorType 转换为整数索引\n    let index: i32 = i32(input.aVertexColorType);\n    // 获取对应的颜色\n    output.vertexColorColor = vertexColors.vertexColorsOfType[index];\n}\n\n",
        frag: "\nfn vertexColor_get(input: VertexOutput) -> vec4<f32> {\n    return input.vertexColorColor;\n}\n",
        attributes: [ {
            name: "aVertexColorType",
            type: "u32"
        } ],
        varyings: [ {
            name: "vertexColorColor",
            type: "vec4f"
        } ],
        defines: [ "HAS_VERTEX_COLOR" ]
    },
    vsm_shadow: {
        defines: t => t.HAS_SHADOWING && !t.HAS_BLOOM,
        vert: "\nstruct ShadowUniforms {\n    shadow_lightProjViewModelMatrix: mat4x4f,\n};\n\n@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;\n\nstruct VertexOutput {\n    shadow_vLightSpacePos: vec4f,\n};\n\nfn shadow_computeShadowPars(position: vec4f, vertexOutput: VertexOutput) {\n    vertexOutput.shadow_vLightSpacePos = shadowUniforms.shadow_lightProjViewModelMatrix * position;\n}\n",
        frag: "\nstruct ShadowUniforms {\n    shadow_opacity: f32,\n    shadow_color: vec3f,\n    esm_shadow_threshold: f32\n};\n\n@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;\n@group(0) @binding($b) var shadow_shadowMapSampler: sampler;\n@group(0) @binding($b) var shadow_shadowMap: texture_2d<f32>;\n\n\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\n\nfn esm(projCoords: vec3f, shadowTexel: vec4f) -> f32 {\n    let compare = projCoords.z;\n    let c = 120.0;\n#ifdef PACK_FLOAT\n    let depth = common_decodeDepth(shadowTexel);\n    if (depth >= 1.0 - 1E-6 || compare <= depth) {\n        return 1.0;\n    }\n#else\n    let depth = shadowTexel.r;\n#endif\n\n    let depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, shadowUniforms.esm_shadow_threshold, 1.0);\n}\n\nfn shadow_computeShadow_coeff(shadowMap: texture_2d<f32>, projCoords: vec3f) -> f32 {\n    let uv = projCoords.xy;\n    let shadowTexel = textureSample(shadowMap, shadow_shadowMapSampler, uv);\n    let esm_coeff = esm(projCoords, shadowTexel);\n    let coeff = esm_coeff * esm_coeff;\n    return 1.0 - (1.0 - coeff) * shadowUniforms.shadow_opacity;\n}\n\nfn shadow_computeShadow(vertexOutput: VertexOutput) -> f32 {\n    let projCoords = vertexOutput.shadow_vLightSpacePos.xyz / vertexOutput.shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if (projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) {\n        return 1.0;\n    }\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\n\nfn shadow_blend(color: vec3f, coeff: f32) -> vec3f {\n    color = color * coeff + shadowUniforms.shadow_color * shadowUniforms.shadow_opacity * (1.0 - coeff);\n    return color;\n}\n",
        varyings: [ {
            name: "shadow_vLightSpacePos",
            type: "vec4f",
            defines: [ "HAS_SHADOWING" ]
        } ]
    },
    draco_decode: {
        vert: "\n#if HAS_DRACO_NORMAL || HAS_DRACO_POSITION || HAS_DRACO_TEXCOORD || HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD || HAS_COMPRESSED_INT16\n    // 定义 uniform 变量\n    struct DracoUniforms {\n        #if HAS_DRACO_NORMAL\n            gltf_u_dec_normal_rangeConstant: f32,\n        #endif\n\n        #if HAS_DRACO_POSITION\n            minValues_pos: vec3f,\n            gltf_u_dec_position_normConstant: f32,\n        #endif\n\n        #if HAS_DRACO_TEXCOORD\n            minValues_tex: vec2f,\n            gltf_u_dec_texcoord_0_normConstant: f32,\n        #endif\n\n        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD\n            decodeMatrix: mat3x3f,\n        #endif\n\n    #if HAS_COMPRESSED_INT16\n        #if HAS_COMPRESSED_INT16_POSITION\n            compressedPositionRange: vec2f, // 压缩位置范围\n        #endif\n        #if HAS_COMPRESSED_INT16_TEXCOORD_0\n            compressedTexcoordRange_0: vec2f, // 压缩纹理坐标范围 0\n        #endif\n        #if HAS_COMPRESSED_INT16_TEXCOORD_1\n            compressedTexcoordRange_1: vec2f, // 压缩纹理坐标范围 1\n        #endif\n        #if HAS_COMPRESSED_INT16_NORMAL\n            compressedNormalRange: vec2f, // 压缩法线范围\n        #endif\n        #if HAS_COMPRESSED_INT16_RATIO\n            compressed_ratio: f32, // 压缩比例\n        #endif\n    #endif\n    };\n\n    @group(0) @binding($b) var<uniform> dracoUniforms: DracoUniforms;\n#endif\n\n    // Draco 位置解码函数\n    #ifdef HAS_DRACO_POSITION\n    fn decodeDracoPosition(aPosition: vec3f) -> vec3f {\n        return dracoUniforms.minValues_pos + aPosition * dracoUniforms.gltf_u_dec_position_normConstant;\n    }\n    #endif\n\n    // Draco 纹理坐标解码函数\n    #ifdef HAS_DRACO_TEXCOORD\n    fn decodeDracoTexcoord(aTexCoord: vec2f) -> vec2f {\n        return dracoUniforms.minValues_tex + aTexCoord * dracoUniforms.gltf_u_dec_texcoord_0_normConstant;\n    }\n    #endif\n\n    // Draco 法线解码函数\n    #ifdef HAS_DRACO_NORMAL\n    fn czm_signNotZero(value: f32) -> f32 {\n        return select(-1.0, 1.0, value >= 0.0);\n    }\n\n    fn czm_signNotZero(value: vec2f) -> vec2f {\n        return vec2f(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n\n    fn decodeDracoNormal(encoded: vec2f, range: f32) -> vec3f {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3f(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        var v = vec3f(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n\n    fn decode_getNormal(aNormal: vec2f) -> vec3f {\n        return decodeDracoNormal(aNormal, dracoUniforms.gltf_u_dec_normal_rangeConstant).zxy;\n    }\n    #endif\n\n    // 压缩属性解码函数\n    #ifdef HAS_COMPRESSED_INT16\n    fn int16ToFloat32(value: f32, range: vec2f) -> f32 {\n        let v = select(value / 32767.0, -(65536.0 - value) / 32768.0, value >= 32768.0);\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n    #endif\n\n    // 顶点位置解码函数\n    fn decode_getPosition(aPosition: vec3f) -> vec3f {\n        var position = aPosition;\n    #if HAS_COMPRESSED_INT16 && HAS_COMPRESSED_INT16_POSITION\n        let x = int16ToFloat32(aPosition.x, dracoUniforms.compressedPositionRange);\n        let y = int16ToFloat32(aPosition.y, dracoUniforms.compressedPositionRange);\n        let z = int16ToFloat32(aPosition.z, dracoUniforms.compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n            position = vec3f(x / dracoUniforms.compressed_ratio, y / dracoUniforms.compressed_ratio, z);\n        #else\n            position = vec3f(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n    }\n\n    // 纹理坐标解码函数\n    fn decode_getTexcoord(aTexCoord: vec2f) -> vec2f {\n        var texcoord = aTexCoord;\n    // if HAS_COMPRESSED_INT16 && (HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1)\n    #if HAS_COMPRESSED_INT16\n        #if HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1\n            let x = int16ToFloat32(aTexCoord.x, dracoUniforms.compressedTexcoordRange_0);\n            let y = int16ToFloat32(aTexCoord.y, dracoUniforms.compressedTexcoordRange_0);\n            texcoord = vec2f(x, y);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #else\n        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD\n            let web3dTexcoord = dracoUniforms.decodeMatrix * vec3f(texcoord, 1.0);\n            return vec2f(web3dTexcoord.x, web3dTexcoord.y);\n        #else\n            return texcoord;\n        #endif\n    #endif\n    }\n\n    // 法线解码函数\n    fn decode_getNormal(aNormal: vec3f) -> vec3f {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, dracoUniforms.compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, dracoUniforms.compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, dracoUniforms.compressedNormalRange);\n    #endif\n        return aNormal;\n    }\n"
    },
    highlight: {
        defines: t => t.HAS_HIGHLIGHT_OPACITY || t.HAS_HIGHLIGHT_COLOR,
        vert: "\n\n    // 顶点着色器函数\n    fn highlight_setVarying(input: VertexInput, output: ptr<function, VertexOutput>) {\n        // 如果有高亮颜色\n    #if HAS_HIGHLIGHT_COLOR\n        output.vHighlightColor = input.aHighlightColor / 255.0;\n    #endif\n\n        // 如果有高亮透明度\n    #if HAS_HIGHLIGHT_OPACITY\n        output.vHighlightOpacity = input.aHighlightOpacity / 255.0;\n    #endif\n    }\n",
        frag: "\n    // 高亮颜色混合函数\n    fn highlight_blendColor(color: vec4f, output: VertexOutput) -> vec4f {\n        var outColor: vec4f = color;\n\n        // 如果有高亮颜色\n        #if HAS_HIGHLIGHT_COLOR\n            outColor.rgb = outColor.rgb * (1.0 - output.vHighlightColor.a) + output.vHighlightColor.rgb * output.vHighlightColor.a;\n            #if HAS_HIGHLIGHT_COLOR_POINT\n            #else\n            // 如果没有高亮颜色点\n                outColor.a = outColor.a * (1.0 - output.vHighlightColor.a) + output.vHighlightColor.a;\n            #endif\n        #endif\n\n            // 如果有高亮透明度\n        #if HAS_HIGHLIGHT_OPACITY\n            outColor *= output.vHighlightOpacity;\n        #endif\n\n        return outColor;\n    }\n",
        attributes: [ {
            defines: [ "HAS_HIGHLIGHT_COLOR" ],
            name: "aHighlightColor",
            type: "vec4f"
        }, {
            defines: [ "HAS_HIGHLIGHT_OPACITY" ],
            name: "aHighlightOpacity",
            type: "f32"
        } ],
        varyings: [ {
            defines: [ "HAS_HIGHLIGHT_COLOR" ],
            name: "vHighlightColor",
            type: "vec4f"
        }, {
            defines: [ "HAS_HIGHLIGHT_OPACITY" ],
            name: "vHighlightOpacity",
            type: "f32"
        } ]
    },
    compute_texcoord: {
        defines: [ "HAS_MAP" ],
        frag: "\n#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    struct TextureTransformUniforms {\n        offset: vec2f,\n        rotation: f32,\n        scale: vec2f,\n    };\n\n    @group(0) @binding($b) var<uniform> textureTransformUniforms: TextureTransformUniforms;\n\n    fn khr_tex_transformTexCoord(texCoords: vec2f, offset: vec2f, rotation: f32, scale: vec2f) -> vec2f {\n        rotation = -rotation;\n        let transform = mat3x3f(\n            cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0,\n            -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0,\n            offset.x, offset.y, 1.0\n        );\n        let transformedTexCoords = (transform * vec3f(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\n\nfn computeTexCoord(vertexOutput: VertexOutput) -> vec2f {\n    let texCoord = vertexOutput.vTexCoord;\n    #ifdef HAS_I3S_UVREGION\n        let atlasScale = vertexOutput.vUvRegion.zw - vertexOutput.vUvRegion.xy;\n        let uvAtlas = fract(texCoord) * atlasScale + vertexOutput.vUvRegion.xy;\n        return uvAtlas;\n    #elif HAS_KHR_TEXTURE_TRANSFORM\n        let uniforms = textureTransformUniforms;\n        return khr_tex_transformTexCoord(texCoord, uniforms.offset, uniforms.rotation, uniforms.scale);\n    #else\n        return texCoord;\n    #endif\n}\n"
    },
    fbo_picking: {
        vert: "\n//--------------------------\n// Picking\n//\n// #define ENABLE_PICKING 整型 是否开启PICKING\n//\n// uniform int batchId geometry的批次id\n//\n//\n// fn fbo_picking_setData(viewPosZ: f32, visible: bool)\n//   设置picking数据,必须在设置gl_Position后调用\n//\n// 示例：\n// fbo_picking_setData(output.position.w, true);\n//--------------------------\n\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 2\n    struct PickingUniforms {\n        uPickingId: f32,\n    }\n    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;\n#endif\n#endif\n\nfn fbo_picking_setData(input: VertexInput, output: ptr<function, VertexOutput>, viewPosZ: f32, visible: bool) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n       output.vPickingId = input.aPickingId;\n    #elif HAS_PICKING_ID == 2\n        output.vPickingId = pickingUniforms.uPickingId;\n    #endif\n        output.vFbo_picking_viewZ = viewPosZ;\n        output.vFbo_picking_visible = select(0.0, 1.0, visible);\n    #endif\n    output.vFbo_picking_fragDepth = viewPosZ + 1.0;\n}\n",
        attributes: [ {
            defines: t => 1 === t.HAS_PICKING_ID,
            name: "aPickingId",
            type: "f32"
        } ],
        varyings: [ {
            defines: [ "ENABLE_PICKING" ],
            name: "vPickingId",
            type: "f32"
        }, {
            defines: [ "ENABLE_PICKING" ],
            name: "vFbo_picking_viewZ",
            type: "f32"
        }, {
            defines: [ "ENABLE_PICKING" ],
            name: "vFbo_picking_visible",
            type: "f32"
        }, {
            name: "vFbo_picking_fragDepth",
            type: "f32"
        } ]
    },
    common_pack_float: {
        vert: $i,
        frag: $i
    },
    excavate: {
        defines: [ "HAS_EXCAVATE_ANALYSIS" ],
        vert: "\n#ifdef HAS_EXCAVATE_ANALYSIS\nstruct ExcavateUniforms {\n    excavateExtent: vec4f\n};\n\n@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;\n\nfn getWorldHeight(localPosition: vec4f, modelMatrix: mat4x4f) -> f32 {\n    let wPosition = uniforms.modelMatrix * localPosition;\n    return wPosition.z;\n}\n\nfn getCoordinateTexcoord(localPosition: vec4f, modelMatrix: mat4x4f) -> vec2f {\n    let wPosition = modelMatrix * localPositionMatrix;\n    let x = (wPosition.x - excavateUniforms.excavateExtent.x) /\n           (excavateUniforms.excavateExtent.z - excavateUniforms.excavateExtent.x);\n    let y = (wPosition.y - excavateUniforms.excavateExtent.y) /\n           (excavateUniforms.excavateExtent.w - excavateUniforms.excavateExtent.y);\n    return vec2f(x, y);\n}\n\n#endif\n",
        frag: "\n#ifdef HAS_EXCAVATE_ANALYSIS\nstruct ExcavateUniforms {\n    excavateHeight: f32,\n    heightRange: vec2f  // Replaces the const range\n};\n\n@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;\n@group(0) @binding($b) var heightmap: texture_2d<f32>;\n@group(0) @binding($b) var heightmapSampler: sampler;\n\n\nfn decodeHeight(pack: vec4f) -> f32 {\n    return pack.r + pack.g / 255.0;\n}\n\nfn excavateColor(fragColor: vec4f, vertexOutput: VertexOutput) -> vec4f {\n    let samplerHeight = decodeHeight(textureSample(heightmap, heightmapSampler, vertexOutput.vCoordinateTexcoord));\n    let realHeight = samplerHeight * (excavateUniforms.heightRange.y - excavateUniforms.heightRange.x) + excavateUniforms.heightRange.x;\n\n    let validHeight = select(\n        0.0,\n        realHeight,\n        realHeight >= excavateUniforms.heightRange.x && realHeight <= excavateUniforms.heightRange.y\n    );\n\n    if (vertexOutput.vExcavateHeight > validHeight) {\n        discard;\n    }\n    return fragColor;\n}\n#endif\n",
        varyings: [ {
            name: "vCoordinateTexcoord",
            type: "vec2f"
        }, {
            name: "vExcavateHeight",
            type: "f32"
        } ]
    },
    hsv: {
        frag: "\nconst HSV_K0 = vec4f(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst HSV_K1 = vec4f(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst HSV_E = 1.0e-10;\n\nfn hsv_rgb2hsv(c: vec3f) -> vec3f {\n    var K = HSV_K0;\n    var p = mix(vec4f(c.bg, K.wz), vec4f(c.gb, K.xy), select(0.0, 1.0, c.b <= c.g));\n    var q = mix(vec4f(p.xyw, c.r), vec4f(c.r, p.yzx), select(0.0, 1.0, p.x <= c.r));\n\n    // Alternative implementation commented out\n    // var p = select(vec4f(c.gb, K.xy), vec4f(c.bg, K.wz), c.g < c.b);\n    // var q = select(vec4f(c.r, p.yzx), vec4f(p.xyw, c.r), c.r < p.x);\n\n    let d = q.x - min(q.w, q.y);\n    let e = HSV_E;\n    return vec3f(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\n\nfn hsv_hsv2rgb(c: vec3f) -> vec3f {\n    let K = HSV_K1;\n    let p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, vec3f(0.0), vec3f(1.0)), c.y);\n}\n\nfn hsv_apply4(c: vec4f, hsvOffset: vec3f) -> vec4f {\n    var hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, vec3f(0), vec3f(1));\n    return vec4f(hsv_hsv2rgb(hsv), c.a);\n}\n\nfn hsv_apply3(c: vec3f, hsvOffset: vec3f) -> vec3f {\n    var hsv = hsv_rgb2hsv(c);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, vec3f(0), vec3f(1));\n    return hsv_hsv2rgb(hsv);\n}\n\nfn contrastMatrix(contrast: f32) -> mat4x4f {\n    let t = (1.0 - contrast) / 2.0;\n    return mat4x4f(\n        vec4f(contrast, 0.0, 0.0, 0.0),\n        vec4f(0.0, contrast, 0.0, 0.0),\n        vec4f(0.0, 0.0, contrast, 0.0),\n        vec4f(t, t, t, 1.0)\n    );\n}\n"
    },
    srgb: {
        frag: "\nfn linearTosRGB(color: vec3f) -> vec3f {\n    return vec3f(\n        select(1.055 * pow(color.r, 1.0/2.4) - 0.055, color.r * 12.92, color.r < 0.0031308),\n        select(1.055 * pow(color.g, 1.0/2.4) - 0.055, color.g * 12.92, color.g < 0.0031308),\n        select(1.055 * pow(color.b, 1.0/2.4) - 0.055, color.b * 12.92, color.b < 0.0031308)\n    );\n}\n\nfn sRGBToLinear(color: vec3f) -> vec3f {\n    return vec3f(\n        select(pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.r * (1.0 / 12.92), color.r < 0.04045),\n        select(pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.g * (1.0 / 12.92), color.g < 0.04045),\n        select(pow((color.b + 0.055) * (1.0 / 1.055), 2.4), color.b * (1.0 / 12.92), color.b < 0.04045)\n    );\n}\n"
    },
    snow: {
        defines: [ "HAS_SNOW" ],
        frag: "\n#ifdef HAS_SNOW\nstruct SnowUniforms {\n    snowHeightThreshold: f32  // Added as a configurable uniform\n};\n\n@group(0) @binding($b) var<uniform> snowUniforms: SnowUniforms;\n\nfn lerp(a: f32, b: f32, w: f32) -> f32 {\n    return a + w * (b - a);\n}\n\nfn snow(sceneColor: vec4f, normalColor: vec3f, height: f32) -> vec3f {\n    let snowIntense = normalColor.b;\n    let fixedC = vec3f(1.0, 1.0, 1.0);\n\n    if (height < snowUniforms.snowHeightThreshold) {\n        let r = lerp(0.5, fixedC.x, snowIntense);\n        let g = lerp(0.5, fixedC.y, snowIntense);\n        let b = lerp(0.5, fixedC.z, snowIntense);\n        return vec3f(r, g, b);\n    } else {\n        let r = lerp(sceneColor.r, fixedC.x, snowIntense);\n        let g = lerp(sceneColor.g, fixedC.y, snowIntense);\n        let b = lerp(sceneColor.b, fixedC.z, snowIntense);\n        return vec3f(r, g, b);\n    }\n}\n#endif\n"
    },
    terrain_normal: {
        defines: [ "HAS_TERRAIN_NORMAL" ],
        frag: "\n#ifdef HAS_TERRAIN_NORMAL\nstruct TerrainNormalUniforms {\n    terrainHeightMapResolution: vec2f,\n    terrainResolution: vec2f,\n    terrainHeightScale: f32,\n    terrainTileResolution: f32,\n    terrainUnpackFactors: vec4f\n};\n\n@group(0) @binding($b) var<uniform> terrainNormalUniforms: TerrainNormalUniforms;\n@group(0) @binding($b) var terrainHeightTexture: texture_2d<f32>;\n@group(0) @binding($b) var terrainHeightSampler: sampler;\n\nfn getHeight(uv: vec2f) -> f32 {\n    let color = textureSample(terrainHeightTexture, terrainHeightSampler, uv) * 255.0;\n    let colorWithAlpha = vec4f(color.rgb, -1.0);\n    return dot(colorWithAlpha, terrainNormalUniforms.terrainUnpackFactors) / 4.0;\n}\n\nfn convertTerrainHeightToNormalMap(uv: vec2f) -> vec3f {\n    let flippedUV = vec2f(uv.x, 1.0 - uv.y);\n    let epsilon = 1.0 / terrainNormalUniforms.terrainHeightMapResolution;\n\n    let a = getHeight(flippedUV + vec2f(-epsilon.x, -epsilon.y));\n    let b = getHeight(flippedUV + vec2f(0.0, -epsilon.y));\n    let c = getHeight(flippedUV + vec2f(epsilon.x, -epsilon.y));\n    let d = getHeight(flippedUV + vec2f(-epsilon.x, 0.0));\n    let e = getHeight(flippedUV + vec2f(epsilon.x, 0.0));\n    let f = getHeight(flippedUV + vec2f(-epsilon.x, epsilon.y));\n    let g = getHeight(flippedUV + vec2f(0.0, epsilon.y));\n    let h = getHeight(flippedUV + vec2f(epsilon.x, epsilon.y));\n\n    let dxy = vec2f(\n        (c + e + e + h) - (a + d + d + f),\n        (f + g + g + h) - (a + b + b + c)\n    );\n    return normalize(vec3f(dxy / epsilon, terrainNormalUniforms.terrainResolution.x));\n}\n#endif\n"
    },
    mesh_picking: {
        vert: "\n#include <fbo_picking_vert>\n#include <get_output>\n\nstruct VertexInput {\n    @location($i) aPosition: vec3f,\n}\n\nstruct Uniforms {\n    projViewModelMatrix: mat4x4f,\n    modelMatrix: mat4x4f,\n    positionMatrix: mat4x4f,\n}\n\n@group(0) @binding($b) var<uniform> uniforms: Uniforms;\n\nstruct VertexOutput {\n    @builtin(position) position: vec4f,\n    // 其他varying变量可以在这里添加\n}\n\n@vertex\nfn main(input: VertexInput) -> VertexOutput {\n    var output: VertexOutput;\n\n    let localPositionMatrix = getPositionMatrix(input, &output, uniforms.modelMatrix);\n    let localPosition = getPosition(vec3f(input.aPosition.xyz), input);\n\n    output.position = uniforms.projViewModelMatrix * localPositionMatrix * localPosition;\n    // 传入Position的depth值\n    fbo_picking_setData(input, &output, output.position.w, true);\n\n    return output;\n}\n"
    }
};

var Yi = {
    register(t, e) {
        if (Ji[t]) throw new Error(`Key of ${t} is already registered in WgslShaderLib.`);
        Ji[t] = e;
    },
    compile: (t, e) => new er(t, e).compile(),
    get: t => Ji[t]
};

const Zi = /^[ \t]*#include +<([\w\d.]+)>/gm, Qi = /\bstruct\s+VertexInput\b/, tr = /\bstruct\s+VertexOutput\b/;

class er {
    constructor(t, e) {
        this.defines = e, this.source = t, this.isVert = t.indexOf("@vertex") > -1, this.varyings = [], 
        this.attributes = [];
    }
    compile() {
        let t = this.source;
        return t = this.parseIncludes(t), this.isVert && (t = this.fillAttributes(t)), t = this.fillVaryings(t), 
        t;
    }
    parseIncludes(t) {
        return t.replace(Zi, ((t, e) => {
            let n = e;
            (e.endsWith("_vert") || e.endsWith("_frag")) && (n = e.substring(0, e.length - 5));
            const i = Ji[n];
            if (!i) throw new Error("Can not resolve #include <" + e + ">");
            if (i.defines && !this.checkDefines(i.defines)) return "";
            if (i.varyings) for (let t = 0; t < i.varyings.length; t++) {
                const e = i.varyings[t];
                e.defines && !this.checkDefines(e.defines) || this.varyings.push(e);
            }
            if (i.attributes) for (let t = 0; t < i.attributes.length; t++) {
                const e = i.attributes[t];
                e.defines && !this.checkDefines(e.defines) || this.attributes.push(e);
            }
            return this.parseIncludes(this.isVert ? i.vert : i.frag);
        }));
    }
    fillAttributes(t) {
        return this.fillStruct(t, Qi, "$i", this.attributes);
    }
    fillVaryings(t) {
        const e = this.isVert ? "$o" : "$i";
        return this.fillStruct(t, tr, e, this.varyings);
    }
    fillStruct(t, e, n, i) {
        if (!i.length) return t;
        const r = t.search(e), s = t.indexOf("}", r), o = t.substring(0, s), a = t.substring(s), c = [];
        for (let t = 0; t < i.length; t++) {
            const {name: e, type: r} = i[t];
            c.push(`@location(${n}) ${e}: ${r},`);
        }
        return o + c.join("\n") + "\n" + a;
    }
    checkDefines(t) {
        if (Array.isArray(t)) for (let e = 0; e < t.length; e++) {
            const n = t[e];
            if (!this.defines[n]) return !1;
        } else if (!t(this.defines)) return !1;
        return !0;
    }
}

const nr = {
    "=": "equal",
    "<": "less",
    "<=": "less-equal",
    "lequal": "less-equal",
    ">": "greater",
    "!=": "not-equal",
    "notequal": "not-equal",
    ">=": "greater-equal",
    "gequal": "greater-equal"
};

function ir(t) {
    return nr[t] || t;
}

const rr = {
    "triangles": "triangle-list",
    "triangle strip": "triangle-strip",
    "lines": "line-list"
};

const sr = {
    0: "zero",
    1: "one",
    "src color": "src",
    "one minus src color": "one-minus-src",
    "src alpha": "src-alpha",
    "one minus src alpha": "one-minus-src-alpha",
    "dst color": "dst",
    "one minus dst color": "one-minus-dst",
    "dst alpha": "dst-alpha",
    "one minus dst alpha": "one-minus-dst-alpha"
};

function or(t) {
    return sr[t] || t;
}

const ar = {
    "clamp": "clamp-to-edge",
    "mirror": "mirror-repeat"
};

function cr(t, e, n, i, r) {
    const s = {
        magFilter: e
    };
    return "nearest" === t || "linear" === t ? s.minFilter = t : "linear mipmap linear" === t || "mipmap" === t ? (s.minFilter = "linear", 
    s.mipmapFilter = "linear") : "nearest mipmap nearest" === t ? (s.minFilter = "linear", 
    s.mipmapFilter = "nearest") : "nearest mipmap linear" === t ? (s.minFilter = "nearest", 
    s.mipmapFilter = "linear") : "linear mipmap nearest" === t && (s.minFilter = "linear", 
    s.mipmapFilter = "nearest"), s.addressModeU = ar[n || "clamp"] || n, s.addressModeV = ar[i || "clamp"] || i, 
    r && (s.compare = r), s;
}

class hr {
    readFromREGLCommand(t, e, n, i) {
        t || (t = {});
        const r = e.getMaterial();
        let s = !1;
        r && (s = r.doubleSided);
        const o = e.geometry.desc.primitive;
        this.topology = function(t) {
            return rr[t] || "triangle-list";
        }(o);
        const a = !i || !!i.depthTexture, c = !i || i.depthTexture && i.depthTexture.gpuFormat.isDepthStencil;
        let h, l;
        if (this.functionProps = [], a && t.polygonOffset && lr(t.polygonOffset.enable, n)) if (this.topology.startsWith("triangle")) {
            const e = t.polygonOffset.offset;
            e && !T(e.units) && (O(e.units) ? (h = e.units(null, n), this.functionProps.push({
                func: e.units,
                v: h
            })) : h = e.units), e && !T(e.factor) && (O(e.factor) ? (l = e.factor(null, n), 
            this.functionProps.push({
                func: e.factor,
                v: l
            })) : l = e.factor);
        } else h = 0, l = 0;
        this.depthBias = h, this.depthBiasSlopeScale = l;
        let f = "less", u = !0;
        const d = t.depth;
        if (a && d && lr(d.enable, n)) {
            if (d.func) {
                let t = d.func;
                O(d.func) && (t = t(null, n), this.functionProps.push({
                    func: d.func,
                    v: t
                })), f = ir(t);
            }
            u = !0, T(d.mask) || (O(d.mask) ? (u = d.mask(null, n), this.functionProps.push({
                func: d.mask,
                v: u
            })) : u = !!d.mask);
        }
        let m, v;
        this.depthCompare = f, this.depthWriteEnabled = u;
        const g = t.stencil;
        if (c && g && lr(g.enable, n) && (g.op && (v = g.op.zpass, O(v) && (v = v(null, n), 
        this.functionProps.push({
            func: g.op.zpass,
            v: v
        }))), g.func)) {
            let t = g.func.cmp;
            t || (t = "always");
            let e = t;
            O(e) && (e = t(null, n), this.functionProps.push({
                func: t,
                v: e
            })), m = ir(e);
        }
        let p, x, _, b;
        this.stencilFrontCompare = m, this.stencilFrontPassOp = v;
        const y = t.blend;
        if (y && lr(y.enable, n) && y.func) {
            const t = y.func;
            if (t.src) {
                let e = t.src;
                O(t.src) && (e = t.src(null, n), this.functionProps.push({
                    func: t.src,
                    v: e
                })), p = or(e), _ = p;
            }
            if (t.dst) {
                let e = t.dst;
                O(t.dst) && (e = t.dst(null, n), this.functionProps.push({
                    func: t.dst,
                    v: e
                })), x = or(e), b = x;
            }
            if (t.srcAlpha) {
                let e = t.srcAlpha;
                O(t.srcAlpha) && (e = t.srcAlpha(null, n) || this.functionProps.push({
                    func: t.srcAlpha,
                    v: e
                })), p = or(e);
            }
            if (t.srcRGB) {
                let e = t.srcRGB;
                O(t.srcRGB) && (e = t.srcRGB(null, n) || this.functionProps.push({
                    func: t.srcRGB,
                    v: e
                })), _ = or(e);
            }
            if (t.dstAlpha) {
                let e = t.dstAlpha;
                O(t.dstAlpha) && (e = t.dstAlpha(null, n) || this.functionProps.push({
                    func: t.dstAlpha,
                    v: e
                })), x = or(e);
            }
            if (t.dstRGB) {
                let e = t.dstRGB;
                O(t.dstRGB) && (e = t.dstRGB(null, n) || this.functionProps.push({
                    func: t.dstRGB,
                    v: e
                })), b = or(e);
            }
        }
        this.blendAlphaDst = x, this.blendAlphaSrc = p, this.blendColorDst = b, this.blendColorSrc = _;
        let w = "none";
        if (!s) {
            const e = t.cull;
            e && lr(e.enable, n) && (w = "back", e.face && (w = e.face, O(e.face) && (w = e.face(null, n) || this.functionProps.push({
                func: e.face,
                v: w
            }))));
        }
        this.cullMode = w, this.frontFace = t.frontFace;
        let S = t.colorMask;
        if (S) {
            O(S) && (S = S(null, n), this.functionProps.push({
                func: t.colorMask,
                v: S
            }));
            let e = 0;
            S[0] && (e |= GPUColorWrite.RED), S[1] && (e |= GPUColorWrite.GREEN), S[2] && (e |= GPUColorWrite.BLUE), 
            S[3] && (e |= GPUColorWrite.ALPHA), this.writeMask = e;
        }
    }
    generateValuesKey(t) {
        return t.map((t => Array.isArray(t) ? t.join() : t)).join("-");
    }
    getFnValuesKey() {
        return this.generateValuesKey(this.functionProps.map((t => t.v)));
    }
    getSignatureKey() {
        return (this.depthBias || 0) + "-" + (this.depthBiasSlopeScale || 0) + "-" + (this.depthCompare || 0) + "-" + (this.depthWriteEnabled || 0) + (this.stencilFrontCompare || 0) + "-" + (this.stencilFrontPassOp || 0) + (this.blendAlphaSrc || 0) + "-" + (this.blendAlphaDst || 0) + "-" + (this.blendColorSrc || 0) + "-" + (this.blendColorDst || 0) + (this.cullMode || 0) + "-" + (this.frontFace || 0) + "-" + (this.topology || 0) + "-" + (this.writeMask || 0);
    }
}

function lr(t, e) {
    return O(t) ? !!(t = t(null, e)) : !!t;
}

class fr {
    constructor(t, e) {
        this.ai = [], this.device = t, this.config = e, this.gpuFormat = function(t, e) {
            if ("depth stencil" === (t = t || "rgba") || "depth24 stencil8" === t) return {
                format: "depth24plus-stencil8",
                bytesPerTexel: 4,
                isDepthStencil: !0
            };
            if ("depth" === t) return {
                format: "depth24plus",
                bytesPerTexel: 4,
                isDepthStencil: !1
            };
            if ("alpha" === t) return {
                format: "r8unorm",
                bytesPerTexel: 1,
                isDepthStencil: !1
            };
            if ("uint8" === (e = e || "uint8")) {
                let e = t;
                return "rgba" === t && (e = "rgba8unorm"), {
                    format: e,
                    bytesPerTexel: 4,
                    isDepthStencil: !1
                };
            }
            return "float16" === e || "half float" === e ? {
                format: "r16float",
                bytesPerTexel: 2,
                isDepthStencil: !1
            } : "float" === e ? {
                format: "r32float",
                bytesPerTexel: 4,
                isDepthStencil: !1
            } : {
                format: t,
                bytesPerTexel: 4,
                isDepthStencil: !1
            };
        }(e.format, e.type), this.update(this.config);
    }
    get width() {
        return this.texture && this.texture.width || this.config && this.config.width;
    }
    get height() {
        return this.texture && this.texture.height || this.config && this.config.height;
    }
    updateFilter() {
        this.ci();
    }
    ci() {
        if (this.ai.length) {
            for (let t = 0; t < this.ai.length; t++) this.ai[t].outdated = !0;
            this.ai = [];
        }
    }
    resize(t, e) {
        this.texture && this.texture.width === t && this.texture.height === e || (this.config.width = t, 
        this.config.height = e, this.update(this.config));
    }
    update(t) {
        const e = this.device.wgpu;
        let n;
        this.texture && (this.texture.destroy(), this.ci());
        {
            let i = t.width, r = t.height;
            if (void 0 === i || void 0 === r) {
                const e = t.data;
                if (R(t.data)) {
                    const e = t.data.length;
                    i = Math.sqrt(e / 4), r = i;
                } else i = e.width, r = e.height;
            }
            const s = this.gpuFormat.format, o = {
                size: [ i, r, 1 ],
                format: s,
                usage: "depth24plus" === s || "depth24plus-stencil8" === s ? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT
            };
            if (t.sampleCount && (o.sampleCount = t.sampleCount), n = e.createTexture(o), t.data) if (R(t.data)) {
                let s = t.data;
                Array.isArray(t.data) && (s = new Float32Array(s)), e.queue.writeTexture({
                    texture: n
                }, s.buffer, {
                    bytesPerRow: i * this.gpuFormat.bytesPerTexel
                }, [ i, r ]);
            } else e.queue.copyExternalImageToTexture({
                source: t.data,
                flipY: !!this.config.flipY
            }, {
                texture: n,
                premultipliedAlpha: !0
            }, [ i, r ]);
        }
        this.texture = n;
    }
    getView() {
        return this.texture.createView();
    }
    addBindGroup(t) {
        this.ai.push(t);
    }
    destroy() {
        this.texture && (this.texture.destroy(), delete this.texture), delete this.ai;
    }
}

class ur {
    constructor(t, e) {
        this.device = t, this.options = e, this.m();
    }
    get color() {
        return [ this.colorTexture ];
    }
    resize(t, e) {
        if ((!this.colorTexture || t !== this.colorTexture.width || e !== this.colorTexture.height) && (this.options.width = t, 
        this.options.height = e, this.colorTexture && this.colorTexture.resize(t, e), this.depthTexture && this.depthTexture.resize(t, e), 
        this.hi)) {
            const t = this.hi.colorAttachments[0];
            t && t.view && this.colorTexture && (t.view = this.colorTexture.getView());
            const e = this.hi.depthStencilAttachment;
            e && e.view && this.depthTexture && (e.view = this.depthTexture.getView());
        }
    }
    m() {
        let t = this.options.colors && this.options.colors[0] || this.options.color;
        const e = this.options.colorFormat, n = this.options.colorType;
        let i, r;
        t ? (i = t.width, r = t.height) : (e || n) && (t = !0), T(this.options.width) || (i = this.options.width), 
        T(this.options.height) || (r = this.options.height), this.width = i, this.height = r, 
        !t || t instanceof fr || (!0 === t && (t = {
            width: i,
            height: r
        }), t.width || (t.width = i), t.height || (t.height = r), t.format || (t.format = e || "rgba"), 
        t.type || (t.type = n || "uint8"), this.li = !0, t = new fr(this.device, t));
        let s = this.options.depth;
        s && (!0 === s ? (this.fi = !0, s = new fr(this.device, {
            width: i,
            height: r,
            format: "depth"
        })) : s instanceof fr || (this.fi = !0, s = new fr(this.device, s)));
        const o = this.options.depthStencil;
        if (o && (!0 === o ? (this.fi = !0, s = new fr(this.device, {
            width: i,
            height: r,
            format: "depth stencil"
        })) : o instanceof fr ? s = o : (this.fi = !0, s = new fr(this.device, o))), this.colorTexture = t, 
        this.depthTexture = s, this.hi = {
            colorAttachments: []
        }, null !== t && (this.hi.colorAttachments[0] = {
            view: this.colorTexture && this.colorTexture.getView(),
            clearValue: [ 0, 0, 0, 0 ],
            loadOp: "load",
            storeOp: "store"
        }), s) {
            const t = this.hi.depthStencilAttachment = {
                view: this.depthTexture.getView(),
                depthClearValue: 1,
                depthLoadOp: "load",
                depthStoreOp: "store"
            };
            s.gpuFormat.isDepthStencil && (t.stencilReadOnly = !1, t.stencilClearValue = 0, 
            t.stencilLoadOp = "load", t.stencilStoreOp = "store");
        }
    }
    getRenderPassDescriptor() {
        const t = this.hi.colorAttachments[0], e = this.hi.depthStencilAttachment;
        let n, i;
        if (!this.colorTexture) {
            const e = this.device.context.getCurrentTexture();
            n = e.width, i = e.height, t.view = e.createView(), t.view.label = "default canvas view";
        }
        if (t && (t.loadOp = this.colorLoadOp || "load", t.clearValue = this.colorClearValue || [ 0, 0, 0, 0 ]), 
        e) {
            e.depthLoadOp = this.depthLoadOp || "load", e.depthClearValue = this.depthClearValue || 1;
            const t = this.depthTexture;
            t.gpuFormat.isDepthStencil && (e.stencilLoadOp = this.stencilLoadOp || "load", e.stencilClearValue = this.stencilClearValue || 0), 
            t && n && i && (t.width !== n || t.height !== i) && (t.resize(n, i), e.view = t.getView());
        }
        return this.ui(), this.hi;
    }
    setClearOptions(t) {
        t.color && (this.colorLoadOp = "clear", this.colorClearValue = t.color), t.depth && (this.depthLoadOp = "clear", 
        this.depthClearValue = t.depth), t.stencil && (this.stencilLoadOp = "clear", this.stencilClearValue = t.stencil);
    }
    ui() {
        this.colorLoadOp = null, this.colorClearValue = null, this.depthLoadOp = null, this.depthClearValue = null, 
        this.stencilLoadOp = null, this.stencilClearValue = null;
    }
    destroy() {
        this.li && this.colorTexture && (this.colorTexture.destroy(), delete this.colorTexture), 
        this.fi && this.depthTexture && (this.depthTexture.destroy(), delete this.depthTexture, 
        delete this.fi);
    }
}

let dr = 0;

class mr {
    constructor(t, e, n) {
        this.name = t, this.uuid = dr++, this.groups = e.groups, this.alignment = n, this.di(e);
    }
    getShaderUniforms() {
        return this.mi;
    }
    getMeshUniforms() {
        return this.vi;
    }
    di(t) {
        this.mi = [], this.mi.index = 0, this.mi.totalSize = 0, this.vi = [], this.vi.index = 0, 
        this.vi.totalSize = 0;
        const e = t.groups;
        if (!e) return;
        const n = e[0];
        if (n) for (let t = 0; t < n.length; t++) {
            const e = n[t];
            if (e) if (e.isGlobal) {
                let t = this.mi.index;
                this.mi[t++] = e, this.mi.index = t, this.mi.totalSize += Ut(e.size, this.alignment);
            } else {
                let t = this.vi.index;
                this.vi[t++] = e, this.vi.index = t, this.vi.totalSize += Ut(e.size, this.alignment);
            }
        }
    }
    createBindGroup(t, e, n, i, r, s) {
        const o = this.name + "-" + e.uuid;
        if (!this.groups) return t.wgpu.createBindGroup({
            layout: i,
            label: o,
            entries: []
        });
        const a = this.groups[0], c = [], h = [];
        for (let i = 0; i < a.length; i++) {
            const o = a[i];
            if (!o) continue;
            const l = o.name;
            if (o.resourceType === nn.Sampler) {
                const i = l.substring(0, l.length - 7);
                let r = n && n[i] || e.getUniform(i) || e.material && e.material.getUniform(i);
                if (r instanceof ur && (r = r.colorTexture), !r) continue;
                const {min: s, mag: a, wrapS: h, wrapT: f, compare: u} = r.config, d = cr(s, a, h, f, u), m = t.wgpu.createSampler(d);
                c.push({
                    binding: o.binding,
                    resource: m
                });
            } else if (o.resourceType === nn.Texture) {
                const i = n && n[l] || e.getUniform(l) || e.material && e.material.getUniform(l);
                let r = i;
                if (r instanceof rt && (r = i.getREGLTexture(t)), r instanceof ur && (r = r.colorTexture), 
                !r) continue;
                h.push(r), c.push({
                    binding: o.binding,
                    resource: r.getView()
                });
            } else {
                const t = o.isGlobal ? r.allocation : s.allocation;
                c.push({
                    binding: o.binding,
                    resource: {
                        buffer: t.gpuBuffer,
                        size: Ut(o.size, this.alignment)
                    }
                });
            }
        }
        const l = t.wgpu.createBindGroup({
            layout: i,
            label: o,
            entries: c
        });
        for (let t = 0; t < h.length; t++) h[t].addBindGroup(l);
        return l;
    }
    dispose() {
        delete this.mi, delete this.vi, delete this.groups;
    }
}

const vr = /\s*#define\s+(\w+)\s+([^\n]+)/g, gr = /#([^\s]*)(\s*)/gm, pr = /#[^\s]*\s*\b[0-9A-Z][0-9A-Z_&&\|=! ]+\b/g;

function xr(t, e) {
    var n;
    if (!t) return;
    const i = t.matchAll(vr), r = {};
    for (const t of i) r[t[1]] = t[2];
    let s = br(t = t.replace(/#define.*$/gm, ""), r);
    const o = null === (n = s.match(pr)) || void 0 === n ? void 0 : n.filter((t => !!isNaN(t) && "" != t)).map((t => {
        const e = t.indexOf(" ");
        return t.substring(e).trim();
    })), {normalizeDefines: a, constValues: c} = function(t, e) {
        var n;
        const i = new Set, r = null === (n = null == t ? void 0 : t.map) || void 0 === n ? void 0 : n.call(t, (t => yr(t, e, i))), s = {};
        for (const t in e) i.has(t) || (s[t] = e[t]);
        return {
            normalizeDefines: r,
            constValues: s
        };
    }(o, e);
    s = br(s, c);
    const h = function(t, e) {
        let n = t;
        const i = (null == e ? void 0 : e.map((t => {
            const e = n.indexOf(t), i = n.slice(0, e);
            return n = n.slice(e + t.length), i;
        }))) || [];
        (null == i ? void 0 : i.length) && i.push(n);
        return i;
    }(s, o);
    return h.length > 0 ? function(t, e) {
        const n = [];
        let i = new _r(!0);
        i.elseIsValid = !1;
        const r = (t, e) => {
            if (t.index + t[0].length != e.length) throw new Error(`#${t[1]} must be immediately followed by a template expression (ie: \${value})`);
        };
        for (let s = 0; s < t.length; ++s) {
            const o = t[s], a = o.matchAll(gr);
            let c = 0, h = !1;
            for (const t of a) {
                switch (i.appendStringToCurrentBranch(o.substring(c, t.index)), t[1]) {
                  case "if":
                  case "ifdef":
                  case "ifndef":
                    r(t, o), h = !0, n.push(i);
                    const a = "ifndef" === t[1] ? !e[s] : !!e[s];
                    i = new _r(a);
                    break;

                  case "elif":
                    r(t, o), h = !0, i.pushBranch(t[1], e[s]);
                    break;

                  case "else":
                    i.pushBranch(t[1], !0), i.appendStringToCurrentBranch(t[2]);
                    break;

                  case "endif":
                    if (!n.length) throw new Error(`#${t[1]} not preceeded by an #if`);
                    const c = i.resolve();
                    i = n.pop(), i.appendStringToCurrentBranch(c, t[2]);
                    break;

                  default:
                    i.appendStringToCurrentBranch(t[0]);
                }
                c = t.index + t[0].length;
            }
            c != o.length && i.appendStringToCurrentBranch(o.substring(c, o.length)), !h && e.length > s && i.appendStringToCurrentBranch(e[s]);
        }
        if (n.length) throw new Error("Mismatched #if/#endif count");
        return i.resolve();
    }(h, a) : s;
}

class _r {
    constructor(t) {
        this.elseIsValid = !0, this.branches = [], this.pushBranch("if", t);
    }
    pushBranch(t, e) {
        if (!this.elseIsValid) throw new Error(`#${t} not preceeded by an #if or #elif`);
        this.elseIsValid = "if" === t || "elif" === t, this.branches.push({
            expression: !!e,
            string: ""
        });
    }
    appendStringToCurrentBranch(...t) {
        for (const e of t) this.branches[this.branches.length - 1].string += e;
    }
    resolve() {
        for (const t of this.branches) if (t.expression) return t.string;
        return "";
    }
}

function br(t, e) {
    var n;
    if (!e) return t;
    let i = t;
    const r = Object.keys(e);
    return null === (n = null == r ? void 0 : r.forEach) || void 0 === n || n.call(r, (t => {
        const n = new RegExp("\\b" + t + "\\b", "g");
        i = i.replace(n, e[t] + "");
    })), i;
}

function yr(t, e, n) {
    if ((null == t ? void 0 : t.includes("&&")) || (null == t ? void 0 : t.includes("||"))) {
        if (t.includes("&&")) {
            const i = t.split("&&").map((t => t.trim()));
            return function(t, e, n) {
                var i;
                let r = 0;
                return null === (i = null == t ? void 0 : t.forEach) || void 0 === i || i.call(t, (t => r += Number(wr(e, t, n) || 0) > 1 ? 1 : Number(wr(e, t, n) || 0))), 
                r === t.length;
            }(i, e, n);
        }
        const i = t.split("||").map((t => t.trim()));
        return !function(t, e, n) {
            var i;
            let r = 0;
            return null === (i = null == t ? void 0 : t.forEach) || void 0 === i || i.call(t, (t => {
                const i = wr(e, t, n);
                return r += i ? 1 : 0;
            })), 0 === r;
        }(i, e, n);
    }
    return wr(e, t, n);
}

function wr(t, e, n) {
    if (e && e.startsWith && e.startsWith("!")) return e = e.substring(1), n && n.add(e), 
    !t[e];
    if (e && e.includes && (e.includes("==") || e.includes("!="))) {
        const i = e.includes("=="), r = e.split(i ? "==" : "!=").map((t => t.trim()));
        return n && n.add(r[0]), i ? t[r[0]] === +r[1] : t[r[0]] !== +r[1];
    }
    return n && n.add(e), t[e];
}

var Sr = Object.freeze({
    __proto__: null,
    WGSLParseDefines: xr,
    getDefineConditionValue: yr
});

class Ar {
    constructor(t, e, n, i, r, s, o, a) {
        this.name = t, this.device = e, this.vert = n, this.frag = i, this.mesh = r, this.contextDesc = s, 
        this.defines = o, this.uniformValues = a;
    }
    build(t, e) {
        const n = this.mesh, i = this.device, r = this.defines;
        let s = Hr(this.vert), o = Hr(this.frag);
        try {
            s = xr(s, r);
        } catch (t) {
            throw t.message = this.name + "(vert):" + t.message, t;
        }
        try {
            o = xr(o, r);
        } catch (t) {
            throw t.message = this.name + "(frag):" + t.message, t;
        }
        s = Ir(s), o && (o = Ir(o));
        const {source: a, index: c} = Pr(s, 0);
        if (s = a, o) {
            const {source: t} = Pr(o, c);
            o = t;
        }
        const h = new li(s), l = this.gi(h, n);
        let f;
        o && (f = new li(o));
        const u = h.getBindGroups();
        let d = [];
        f && (d = f.getBindGroups());
        const m = this.pi(u, d, n, this.uniformValues), v = this.xi(i, s, l, o, m, n, t, e), g = this._i(u, d, n), p = i.wgpu.limits.minUniformBufferOffsetAlignment;
        return {
            uid: -1,
            layout: m,
            pipeline: v,
            vertexInfo: l,
            bindGroupFormat: new mr(this.name, g, p),
            bindGroupMapping: g,
            activeAttributes: this.bi()
        };
    }
    bi() {
        const t = [ {
            name: "position",
            type: 1
        } ];
        return t.key = t.map((t => t.name)).join(), t;
    }
    pi(t, e, n, i) {
        const r = [];
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            for (let t = 0; t < s.length; t++) {
                const e = s[t];
                if (!e) continue;
                const o = this.yi(e.binding, GPUShaderStage.VERTEX, e, n, i);
                r.push(o);
            }
        }
        for (let t = 0; t < e.length; t++) {
            const s = e[t];
            for (let t = 0; t < s.length; t++) {
                const e = s[t];
                if (!e) continue;
                const o = this.yi(e.binding, GPUShaderStage.FRAGMENT, e, n, i);
                r.push(o);
            }
        }
        return r.sort(Cr), this.device.wgpu.createBindGroupLayout({
            label: this.name + "-bindgrouplayout",
            entries: r
        });
    }
    yi(t, e, n, i, r) {
        if (n.resourceType === nn.Sampler) {
            const i = {};
            return n.type && "sampler_comparison" === n.type.name && (i.type = "comparison"), 
            {
                binding: t,
                visibility: e,
                sampler: i
            };
        }
        if (n.resourceType === nn.Texture) {
            const s = n.name, o = r[s] || i.material && i.material.get(s);
            let a;
            o && (o instanceof Gi ? a = o.config.type : o instanceof fr && (a = o.gpuFormat.format));
            let c = "float";
            return a && a.startsWith("depth") && (c = "depth"), {
                binding: t,
                visibility: e,
                texture: {
                    sampleType: c
                }
            };
        }
        return {
            binding: t,
            visibility: e,
            buffer: {
                type: "uniform",
                hasDynamicOffset: !0
            }
        };
    }
    gi(t, e) {
        const n = t.entry.vertex[0].inputs, i = {};
        for (let t = 0; t < n.length; t++) {
            i[n[t].name] = n[t];
        }
        const r = {}, s = e.geometry.data, o = e.geometry.semantic;
        for (const t in s) {
            const e = o[t] || t, n = i[e];
            n && (r[e] = {
                geoAttrName: t,
                location: n.location,
                itemSize: Tr(n.type)
            });
        }
        if (e instanceof vi) {
            const t = e.instancedData;
            for (const e in t) i[e] && (r[e] = {
                geoAttrName: e,
                location: i[e].location,
                itemSize: Tr(i[e].type)
            });
        }
        return r;
    }
    _i(t, e, n) {
        const i = {};
        return this.wi(i, t[0], n, "vert"), this.wi(i, e[0], n, "frag"), i;
    }
    wi(t, e, n, i) {
        if (e) for (let r = 0; r < e.length; r++) {
            const s = e[r];
            if (!s) continue;
            const {group: o, binding: a} = s, c = s.members;
            let h = !1;
            if (c && c.length) for (let t = 0; t < c.length; t++) {
                const e = c[t].name;
                if (Mr(n, e, this.contextDesc)) {
                    if (h) throw new Error("Found a mesh uniform in global struct:" + e + "(" + s.name + ") in " + this.name + "_" + i);
                } else {
                    if (!h && t > 0) throw new Error("Found a global uniform in mesh struct:" + e + "(" + s.name + ") in " + this.name + "_" + i);
                    h = !0;
                }
            } else {
                Mr(n, s.name, this.contextDesc) || (h = !0);
            }
            t.groups = t.groups || [], t.groups[o] = t.groups[o] || [], s.isGlobal = h, s.index = t.groups[o][a] = s;
        }
    }
    xi(t, e, n, i, r, s, o, a) {
        const c = t.wgpu, h = c.createShaderModule({
            label: this.name + "-vertmodule",
            code: e
        });
        let l;
        i && (l = c.createShaderModule({
            label: this.name + "-fragmodule",
            code: i
        })), this.Si || (this.Si = navigator.gpu.getPreferredCanvasFormat());
        const f = s.geometry.getBufferDescriptor(n);
        if (s instanceof vi) {
            const t = s.getBufferDescriptor(n);
            for (let e = 0; e < t.length; e++) t[e] && (f[e] = t[e]);
        }
        const u = c.createPipelineLayout({
            label: this.name + "-pipelinelayout",
            bindGroupLayouts: [ r ]
        }), d = {
            label: this.name + "-pipeline",
            layout: u,
            vertex: {
                module: h,
                buffers: f
            },
            primitive: {
                topology: o.topology,
                cullMode: o.cullMode
            }
        }, m = a && a.colorTexture && a.colorTexture.config.sampleCount;
        m && (d.multisample = {
            count: m
        });
        if (!a || !!a.depthTexture) {
            const t = a && a.depthTexture;
            d.depthStencil = {
                depthBias: o.depthBias,
                depthBiasSlopeScale: o.depthBiasSlopeScale,
                depthWriteEnabled: o.depthWriteEnabled,
                depthCompare: o.depthCompare,
                format: !t || t.gpuFormat.isDepthStencil ? "depth24plus-stencil8" : "depth24plus"
            };
        }
        if (l) {
            const t = a && a.colorTexture && a.colorTexture.gpuFormat.format, e = o.writeMask;
            d.fragment = {
                module: l,
                targets: [ {
                    format: t || this.Si,
                    writeMask: T(e) ? GPUColorWrite.ALL : e
                } ]
            };
        }
        if (o.stencilFrontCompare && (d.depthStencil.stencilBack = d.depthStencil.stencilFront = {
            compare: o.stencilFrontCompare,
            passOp: o.stencilFrontPassOp
        }), l && o.blendAlphaDst) {
            const t = d.fragment.targets;
            for (const e of t) e.blend = {
                color: {
                    srcFactor: o.blendColorSrc,
                    dstFactor: o.blendColorDst,
                    operation: "add"
                },
                alpha: {
                    srcFactor: o.blendAlphaSrc,
                    dstFactor: o.blendAlphaDst,
                    operation: "add"
                }
            };
        }
        return c.createRenderPipeline(d);
    }
}

function Mr(t, e, n) {
    return "modelMatrix" === e || "positionMatrix" === e || "projViewModelMatrix" === e || "modelViewMatrix" === e || "modelNormalMatrix" === e || "polygonFill" === e || "polygonOpacity" === e || "lineColor" === e || "lineOpacity" === e || (n[e] && !n[e].global || t.hasUniform(e) || t.material && t.material.hasUniform(e));
}

function Tr(t) {
    return t.name.startsWith("vec") ? parseInt(t.name[3]) : 1;
}

function Cr(t, e) {
    return t.binding - e.binding;
}

let Or = 0;

const Er = () => "" + Or++;

function Ir(t) {
    Or = 0;
    const e = t.replaceAll("$i", Er);
    Or = 0;
    return e.replaceAll("$o", Er);
}

function Pr(t, e) {
    return Or = e, {
        source: t.replaceAll("$b", Er),
        index: Or
    };
}

function Hr(t) {
    return t ? t.replace(/[ \t]*\/\/.*\n/g, "").replace(/[ \t]*\/\*[\s\S]*?\*\//g, "") : t;
}

class Rr {
    constructor() {
        this.items = [], this.offsets = [], this.index = 0;
    }
    reset() {
        this.index = 0;
    }
    addItem(t, e) {
        const n = this.index++, i = this.items[n];
        i ? (i.binding = t, i.offset = e) : this.items[n] = {
            binding: t,
            offset: e
        };
    }
    addItems(t) {
        for (let e = 0; e < t.length; e++) this.addItem(t[e].binding, t[e].offset);
    }
    getItems() {
        return this.items.slice(0, this.index);
    }
    getDynamicOffsets() {
        const t = this.getItems();
        t.sort(((t, e) => t.binding - e.binding)), this.offsets.length = t.length;
        for (let e = 0; e < t.length; e++) this.offsets[e] = t[e].offset;
        return this.offsets;
    }
}

const kr = "function", Nr = "array";

let Dr = 0;

const Lr = {};

class Fr {
    constructor({vert: t, frag: e, wgslVert: n, wgslFrag: i, uniforms: r, defines: s, extraCommandProps: o, name: a}) {
        this.name = a, this.vert = t, this.frag = e, this.wgslVert = n, this.wgslFrag = i;
        const c = Dr++;
        Object.defineProperty(this, "uid", {
            enumerable: !0,
            configurable: !1,
            get: () => c
        }), this.shaderDefines = s && E({}, s) || {}, r = this.uniforms = (r || []).slice(), 
        this.contextDesc = {};
        for (let t = 0, e = r.length; t < e; t++) {
            const e = r[t];
            if (M(e)) if (e.indexOf("[") > 0) {
                const {name: t, len: n} = Ur(e);
                this.contextDesc[t] = {
                    name: t,
                    type: "array",
                    length: n
                };
            } else this.contextDesc[e] = null; else if (e.name.indexOf("[") > 0) {
                const {name: t, len: n} = Ur(e.name);
                this.contextDesc[t] = {
                    name: t,
                    type: "array",
                    length: n,
                    fn: e.fn
                };
            } else this.contextDesc[e.name] = e;
        }
        this.extraCommandProps = o && E({}, o) || {}, this.commands = {}, this.Ai();
    }
    set shaderDefines(t) {
        this.Mi = t, this.dkey = Object.keys(this.Mi).join();
    }
    get shaderDefines() {
        return this.Mi || {};
    }
    setDefines(t) {
        this.shaderDefines = t;
    }
    setFramebuffer(t) {
        return this.context.framebuffer = t, this;
    }
    run(t, e, n) {
        return e(n);
    }
    getShaderCommandKey(t, e, n) {
        return this.dkey || "default";
    }
    getVersion(t, e) {
        if ("#version" === e.substring(0, 8)) return "";
        return 0 === t.limits.version.indexOf("WebGL 2.0") && 300 === this.version ? "#version 300 es\n" : "#version 100\n";
    }
    getActiveVars(t, e, n, i) {
        const r = i;
        if (Lr[r]) return Lr[r];
        const s = t._gl, o = s.createProgram(), a = s.createShader(35633);
        s.shaderSource(a, e), s.compileShader(a);
        const c = s.createShader(35632);
        s.shaderSource(c, n), s.compileShader(c), s.attachShader(o, c), s.attachShader(o, a), 
        s.linkProgram(o);
        const h = s.getProgramParameter(o, 35721), l = [];
        for (let t = 0; t < h; ++t) {
            const e = s.getActiveAttrib(o, t);
            e && l.push({
                name: e.name,
                type: e.type
            });
        }
        const f = s.getProgramParameter(o, 35718), u = [];
        for (let t = 0; t < f; ++t) {
            const e = s.getActiveUniform(o, t);
            let n = e.name;
            e.name.indexOf("[") > 0 && (n = n.replace("[0]", "")), u.push(n);
        }
        return s.deleteProgram(o), s.deleteShader(a), s.deleteShader(c), Lr[r] = {
            activeUniforms: u,
            activeAttributes: l
        }, Lr[r];
    }
    Ti(t, e) {
        const n = [];
        for (const t in e) F(e, t) && !O(e[t]) && n.push(`#define ${t} ${e[t]}\n`);
        return n.join("") + t;
    }
    createMeshCommand(t, e, n = {}, i) {
        const r = e.getDefines(), s = e.getElements(), o = e instanceof vi, a = e.disableVAO, c = L(t) && !a, h = E({}, this.shaderDefines || {}, r || {}), l = this.Ti(this.vert, h), f = this.getVersion(t, l) + l, u = this.Ti(this.frag, h), d = this.getVersion(t, u) + u, m = q(f) + "_" + q(d), {activeAttributes: v, activeUniforms: g} = this.getActiveVars(t, f, d, m), p = {};
        v.forEach(((e, n) => {
            const i = e.name;
            p[i] = c ? n : t.prop(i);
        }));
        const x = {};
        g.forEach((e => {
            x[e] = t.prop(e);
        }));
        const _ = this.contextDesc;
        for (const e in _) if (_[e] && _[e].type === kr) x[e] = _[e].fn; else if (_[e] && _[e].type === Nr) {
            const n = _[e].name, i = _[e].length;
            for (let e = 0; e < i; e++) {
                const i = `${n}[${e}]`;
                x[i] = t.prop(i);
            }
        } else x[e] = t.prop(e);
        const b = {
            vert: f,
            frag: d,
            uniforms: x,
            attributes: p
        };
        c && (b.vao = t.prop("vao")), c && !o || !s || P(s) || (b.elements = t.prop("elements")), 
        b.count = t.prop("count"), b.offset = t.prop("offset"), b.primitive = t.prop("primitive"), 
        b.framebuffer = t.prop("framebuffer"), o && (b.instances = t.prop("instances")), 
        E(b, this.extraCommandProps, n);
        const y = t(b);
        return v.key = v.map((t => t.name)).join(), y.activeAttributes = v, y;
    }
    dispose() {
        for (const t in this.commands) {
            const e = this.commands[t];
            e && (e.destroy && !e[Q] && (e[Q] = !0, e.destroy()));
        }
        this.commands = {}, delete this.vert, delete this.frag;
    }
    appendDescUniforms(t, e) {
        const n = e, i = this.contextDesc;
        for (const r in i) if (i[r]) if ("array" === i[r].type) {
            const s = r, o = i[r].length;
            let a = e[r];
            if (i[r].fn && (a = i[r].fn(null, e)), !a) continue;
            if (a.length !== o) throw new Error(`${s} uniform's length is not ${o}`);
            n[s] = n[s] || {};
            for (let e = 0; e < o; e++) n[s][`${e}`] = a[e].getREGLTexture ? a[e].getREGLTexture(t) : a[e];
        } else "function" === i[r].type && (Object.getOwnPropertyDescriptor(n, r) || Object.defineProperty(n, r, {
            configurable: !1,
            enumerable: !0,
            get: function() {
                return i[r].fn(null, e);
            }
        }));
        return n;
    }
    setUniforms(t) {
        if (t.modelMatrix || t.positionMatrix) throw new Error("modelMatrix or positionMatrix is reserved uniform name for Mesh, please change to another name");
        return this.contextKeys = t ? Object.keys(t).join() : null, this.context = t, this;
    }
    Ai() {
        this.vert && (this.vert = ji.compile(this.vert)), this.frag && (this.frag = ji.compile(this.frag));
    }
}

function Ur(t) {
    const e = t.indexOf("["), n = t.indexOf("]");
    return {
        name: t.substring(0, e),
        len: +t.substring(e + 1, n)
    };
}

const zr = new hr;

class Gr extends Fr {
    getShaderCommandKey(t, e, n) {
        if (t && t.wgpu) {
            const t = e.getShaderFnValues(this.uid);
            if (t) {
                const {funcs: e, key: i, commandKey: r} = t;
                if (!e.length) return r;
                const s = e.map((t => t(null, n)));
                if (zr.generateValuesKey(s) === i) return r;
            }
            const i = this.Ci, r = this.extraCommandProps;
            zr.readFromREGLCommand(r, e, n, i);
            const s = zr.getSignatureKey();
            return e.setShaderFnValues(this.uid, {
                funcs: zr.functionProps.map((t => t.func)),
                key: zr.getFnValuesKey(),
                commandKey: s
            }), s;
        }
        return super.getShaderCommandKey(t, e, n);
    }
    createMeshCommand(t, e, n, i) {
        if (t && t.wgpu) {
            const r = this.context, s = this.Ci, o = E({}, this.shaderDefines || {}, e.getDefines()), {vert: a, frag: c} = this.Oi(o), h = new Ar(this.name, t, a, c, e, this.contextDesc, o, r), l = new hr, f = E({}, this.extraCommandProps || {}, n || {});
            l.readFromREGLCommand(f, e, i, s);
            const u = h.build(l, s);
            return u.uid = this.uid, u;
        }
        return super.createMeshCommand(t, e, n);
    }
    Oi(t) {
        const e = Yi.compile(this.wgslVert, t);
        let n;
        return this.wgslFrag && (n = Yi.compile(this.wgslFrag, t)), {
            vert: e,
            frag: n
        };
    }
    run(t, e, n) {
        if (!t.wgpu) return super.run(t, e, n);
        if (!n || !n.length) return;
        const i = t;
        this.isGPU = !0;
        const r = i.dynamicBufferPool, s = this.Ei(i);
        s.setPipeline(e.pipeline);
        const {uid: o, bindGroupFormat: a, vertexInfo: c, layout: h} = e;
        this.C || (this.C = {});
        let l = this.C[o];
        l || (l = this.C[o] = new fi(a.getShaderUniforms(), r)), this.Ii || (this.Ii = new Rr), 
        this.Pi || (this.Pi = new Rr), this.Pi.reset(), l.writeBuffer(n[0], this.Pi);
        const f = this.Pi.getItems();
        for (let t = 0; t < n.length; t++) {
            this.Ii.reset();
            const e = n[t].meshObject, u = e.writeDynamicBuffer(o, n[t], a.getMeshUniforms(), r, this.Ii), d = a.uuid + "-" + u.version + "-" + l.version;
            let m = e.getBindGroup(d);
            m && !m.outdated || (m = a.createBindGroup(i, e, n[t], h, l, u), e.setBindGroup(d, m)), 
            this.Ii.addItems(f);
            const v = this.Ii.getDynamicOffsets();
            let g;
            s.setBindGroup(0, m, v), e instanceof vi && (g = e);
            for (const t in c) {
                const n = c[t];
                let i = e.geometry.getBuffer(n.geoAttrName || t);
                !i && g && (i = g.getInstancedBuffer(t)), s.setVertexBuffer(n.location, i, 0, i.byteLength);
            }
            const p = e.getElements(), x = e.geometry.getDrawOffset(), _ = e.geometry.getDrawCount();
            let b = 1;
            g && (b = g.instanceCount), e.geometry.isIndexedElements() ? (s.setIndexBuffer(p, p.itemType), 
            s.drawIndexed(_, b, x)) : s.draw(_, b, x);
        }
        s.end();
    }
    Ei(t) {
        return t.getRenderPassEncoder(this.Ci);
    }
    setFramebuffer(t) {
        return t ? t.getRenderPassDescriptor ? (this.Ci = t, this) : super.setFramebuffer(t) : this.Ci ? (this.Ci = null, 
        this) : super.setFramebuffer(t);
    }
    dispose() {
        if (!this.isGPU) return void super.dispose();
        for (const t in this.C) this.C[t] && this.C[t].dispose();
        const t = this.gpuCommands;
        for (let e = 0; e < t.length; e++) t[e] && t[e].bindGroupFormat && t[e].bindGroupFormat.dispose();
    }
}

class Br extends Gr {
    draw(t, e) {
        if (!e || !e.length) return 0;
        const n = [];
        let i, r = 0;
        for (let s = 0, o = e.length; s < o; s++) {
            if (!e[s].isValid()) {
                s === o - 1 && i && n.length && this.run(t, i, n);
                continue;
            }
            if (!e[s].geometry.getDrawCount() || !this.Hi(e[s])) {
                s === o - 1 && i && n.length && this.run(t, i, n);
                continue;
            }
            const a = e[s].getRenderProps(t);
            this.Ri(a), a.shaderContext = this.context, a.meshObject = e[s], this.appendDescUniforms(t, a);
            const c = this.getMeshCommand(t, e[s], a);
            e[s].appendGeoAttributes(a, t, c.activeAttributes), n.length && i !== c && (this.run(t, i, n), 
            n.length = 0), n.push(a), r++, s < o - 1 ? i = c : s === o - 1 && this.run(t, c, n);
        }
        return r;
    }
    Ri(t) {
        if (this.context && (t.contextKeys || (t.contextKeys = {}), t.contextKeys[this.uid] !== this.contextKeys)) {
            for (const e in this.context) "framebuffer" === e || Object.getOwnPropertyDescriptor(t, e) || Object.defineProperty(t, e, {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.shaderContext[e];
                }
            });
            Object.getOwnPropertyDescriptor(t, "framebuffer") || Object.defineProperty(t, "framebuffer", {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.targetFramebuffer || this.shaderContext && this.shaderContext.framebuffer;
                }
            }), t.contextKeys[this.uid] = this.contextKeys;
        }
    }
    Hi(t) {
        const e = this.filter;
        if (!e) return !0;
        if (Array.isArray(e)) {
            for (let n = 0; n < e.length; n++) if (!e[n](t)) return !1;
            return !0;
        }
        return e(t);
    }
    getMeshCommand(t, e, n) {
        this.ki || (this.ki = {});
        const i = e.getMaterial();
        let r = !1;
        i && (r = i.doubleSided);
        const s = this.getShaderCommandKey(t, e, n);
        let o = this.ki[s];
        o || (o = this.ki[s] = {});
        const a = e.getCommandKey(t);
        o[a] || (o[a] = s + "_" + e.getCommandKey());
        const c = o[a];
        let h = this.commands[c];
        if (!h) {
            const i = {};
            r && this.extraCommandProps && (i.cull = {
                enable: !1
            }), h = this.commands[c] = this.createMeshCommand(t, e, i, n);
        }
        return h;
    }
}

var Vr = "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";

const jr = new Int8Array([ -1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, -1 ]), Wr = new Uint8Array([ 0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0 ]);

class qr extends Br {
    constructor(t) {
        t.vert = t.vert || Vr, t.extraCommandProps = t.extraCommandProps || {}, t.extraCommandProps.depth || (t.extraCommandProps.depth = {
            enable: !1,
            mask: !1
        }), t.extraCommandProps.stencil || (t.extraCommandProps.stencil = {
            enable: !1
        }), super(t);
    }
    draw(t) {
        return this.Ni || this.Di(t), super.draw(t, this.Ni);
    }
    getMeshCommand(t) {
        const e = this.dkey || "";
        return this.commands[e + "_quad"] || (this.commands[e + "_quad"] = this.createMeshCommand(t, this.Ni[0])), 
        this.commands[e + "_quad"];
    }
    Di(t) {
        const e = new qt({
            aPosition: jr,
            aTexCoord: Wr
        }, null, jr.length / 2, {
            positionSize: 2,
            primitive: "triangles"
        });
        e.generateBuffers(t), this.Ni = [ new mi(e) ];
    }
    dispose() {
        if (this.Ni) {
            const t = this.Ni[0];
            t.geometry.dispose(), t.dispose();
        }
        return delete this.Ni, super.dispose();
    }
}

class Xr extends qr {
    constructor() {
        super({
            vert: Vr,
            frag: "#define SHADER_NAME FXAA\nprecision mediump float;\nvarying vec2 vTexCoord;\nuniform float enableFXAA;\nuniform float enableToneMapping;\nuniform float enableSharpen;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\n#ifdef HAS_TAA_TEX\nuniform sampler2D taaTextureSource;\n#ifdef HAS_FXAA_TEX\nuniform sampler2D fxaaTextureSource;\n#endif\n#endif\nuniform float pixelRatio;\nuniform float sharpFactor;\n#ifdef HAS_OUTLINE_TEX\nuniform sampler2D textureOutline;\nuniform float enableOutline;\nuniform float highlightFactor;\nuniform float outlineFactor;\nuniform float outlineWidth;\nuniform vec3 outlineColor;\n#endif\nvec2 c;\nvec4 d(vec2 e) {\n  \n#ifdef HAS_TAA_TEX\nvec4 f = texture2D(textureSource, e);\n  vec4 taa = texture2D(taaTextureSource, e);\n#ifdef HAS_FXAA_TEX\nvec4 h = texture2D(fxaaTextureSource, e);\n#else\nvec4 h = vec4(.0);\n#endif\nvec4 i = taa + f * (1. - taa.a);\n  return h + i * (1. - h.a);\n#else\nreturn texture2D(textureSource, e);\n#endif\n}\nvec3 j(const in vec3 k, const float l) {\n  vec2 m = pixelRatio / resolution.xy;\n  float n = .0;\n  vec4 o = texture2D(textureSource, c + m * vec2(-1., -1.));\n  o.rgb = mix(vec3(.0), o.rgb, sign(o.a));\n  n += mix(.0, 1., sign(o.a));\n  vec4 u = texture2D(textureSource, c + m * vec2(1.));\n  u.rgb = mix(vec3(.0), u.rgb, sign(u.a));\n  n += mix(.0, 1., sign(u.a));\n  vec4 v = texture2D(textureSource, c + m * vec2(1., -1.));\n  v.rgb = mix(vec3(.0), v.rgb, sign(v.a));\n  n += mix(.0, 1., sign(v.a));\n  vec4 A = texture2D(textureSource, c + m * vec2(-1., 1.));\n  A.rgb = mix(vec3(.0), A.rgb, sign(A.a));\n  n += mix(.0, 1., sign(A.a));\n  return k + l * (n * k - o.rgb - v.rgb - A.rgb - u.rgb);\n}\nvec4 B(const in vec4 k) {\n  return vec4(j(k.rgb, sharpFactor), k.a);\n}\nvec3 C(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float D = 2.43;\n  const float E = .59;\n  const float F = .14;\n  return (x * (a * x + b)) / (x * (D * x + E) + F);\n}\nvec3 G(vec3 k) {\n  k = k / (k + vec3(1.));\n  return k = pow(k, vec3(1. / 2.2));\n}\n#ifdef HAS_OUTLINE_TEX\nvec4 H() {\n  float I = 2.;\n  float J = 1.;\n  float K = pixelRatio / resolution[0] * outlineWidth;\n  float L = pixelRatio / resolution[1] * outlineWidth;\n  vec4 M = (texture2D(textureOutline, c + vec2(K, L)));\n  vec4 N = (texture2D(textureOutline, c + vec2(K, .0)));\n  vec4 O = (texture2D(textureOutline, c + vec2(K, -L)));\n  vec4 P = (texture2D(textureOutline, c + vec2(.0, -L)));\n  vec4 Q = (texture2D(textureOutline, c + vec2(-K, -L)));\n  vec4 R = (texture2D(textureOutline, c + vec2(-K, .0)));\n  vec4 S = (texture2D(textureOutline, c + vec2(-K, L)));\n  vec4 T = (texture2D(textureOutline, c + vec2(.0, L)));\n  vec4 U = -I * R + I * N + -J * S + J * M + -J * Q + J * O;\n  vec4 V = -I * P + I * T + -J * Q + J * S + -J * O + J * M;\n  float W = sqrt(dot(V, V) + dot(U, U));\n  bool X = W < 1. / 65025.;\n  vec3 Y = (texture2D(textureOutline, c)).r * outlineColor;\n  if(Y == vec3(.0) || (highlightFactor == .0 && X)) {\n    return vec4(.0);\n  }\n  float Z = X ? highlightFactor : min(1., sqrt(W) * outlineFactor);\n  return Z * vec4(Y, 1.);\n}\nvec4 ba(const in vec4 k) {\n  vec4 H = H();\n  return H + vec4(k) * (1. - H.a);\n}\n#endif\nvoid main() {\n  c = vTexCoord;\n  vec4 k;\n  if(enableFXAA == 1.) {\n    \n  } else {\n    k = d(vTexCoord);\n  }\n  if(enableSharpen == 1.) {\n    k = B(k);\n  }\n#if defined(HAS_NOAA_TEX) || defined(HAS_POINT_TEX)\nvec4 bb = vec4(.0);\n  vec4 bc = vec4(.0);\n#ifdef HAS_POINT_TEX\nbb = texture2D(pointTextureSource, vTexCoord);\n#endif\n#ifdef HAS_NOAA_TEX\nbc = texture2D(noAaTextureSource, vTexCoord);\n#endif\nvec4 bd = bb + bc * (1. - bb.a);\n  k = bd + k * (1. - bd.a);\n#endif\nif(enableToneMapping == 1.) {\n    k.rgb = G(k.rgb);\n  }\n#ifdef HAS_OUTLINE_TEX\nk = ba(k);\n#endif\ngl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.resolution[0],
                    height: (t, e) => e.resolution[1]
                }
            }
        });
    }
    getMeshCommand(t, e) {
        const n = this.dkey || "";
        return this.commands[n + "_fxaa"] || (this.commands[n + "_fxaa"] = this.createMeshCommand(t, e)), 
        this.commands[n + "_fxaa"];
    }
}

var Kr = "#include <gl2_vert>\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nuniform mat4 projViewModelMatrix;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}", $r = "precision mediump float;\n#include <gl2_frag>\nuniform sampler2D baseColorTexture;\nuniform float opacity;\nuniform vec4 baseColor;\nuniform float alphaTest;\n#ifdef HAS_DEBUG\nuniform sampler2D debugTexture;\n#endif\nvarying vec2 vTexCoord;\nvoid main() {\n  vec4 c = texture2D(baseColorTexture, vTexCoord);\n  c *= baseColor;\n#ifdef HAS_DEBUG\nvec4 d = texture2D(debugTexture, vTexCoord);\n  c = vec4(d.rgb + c.rgb * (1. - d.a), d.a + c.a * (1. - d.a));\n#endif\nif(c.a < alphaTest) {\n    discard;\n  }\n  c *= opacity;\n#if __VERSION__ == 100\ngl_FragColor = c;\n#endif\n}";

class Jr extends Br {
    constructor(t) {
        const e = [], n = t && t.extraCommandProps || {};
        t.vert = Kr, t.frag = $r, super({
            name: "image",
            vert: Kr,
            frag: $r,
            wgslVert: "",
            wgslFrag: "",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, n) {
                    return c.multiply(e, n.projViewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: n
        });
    }
    getMeshCommand(t, e) {
        const n = e.getCommandKey(t);
        return this.commands["image_" + n] || (this.commands["image_" + n] = this.createMeshCommand(t, e)), 
        this.commands["image_" + n];
    }
}

class Yr extends qr {
    constructor() {
        super({
            vert: Vr,
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\nuniform float enableVignette;\nuniform float enableGrain;\nuniform float enableLut;\nuniform float timeGrain;\nuniform float grainFactor;\nuniform vec2 lensRadius;\nuniform float frameMod;\nuniform sampler2D lookupTable;\n#include <srgb_frag>\nfloat c(const in vec2 d) {\n  vec3 e = fract(vec3(d.xyx) * .1031);\n  e += dot(e, e.yzx + 19.19);\n  return fract((e.x + e.y) * e.z);\n}\nfloat f() {\n  float h = c(gl_FragCoord.xy + 1000.0 * fract(timeGrain));\n  float i = h * 2. - 1.;\n  h = i * inversesqrt(abs(i));\n  h = max(-1., h);\n  h = h - sign(i) + .5;\n  return (h + .5) * .5;\n}\nvec4 j(const in vec4 k) {\n  float l = f();\n  return vec4(mix(k.rgb, k.rgb * (k.rgb + (1. - k.rgb) * 2. * l), grainFactor), k.a);\n}\nfloat m(const in vec2 d, const in float n) {\n  vec3 o = vec3(.06711056, .00583715, 52.9829189);\n  return fract(o.z * fract(dot(d.xy + n * vec2(47., 17.) * .695, o.xy)));\n}\nfloat u() {\n  vec2 v = lensRadius;\n  v.y = min(v.y, v.x - 1e-4);\n  float A = m(gl_FragCoord.xy, frameMod);\n  A = (v.x - v.y) * (v.x + v.y) * .07 * (A - .5);\n  return smoothstep(v.x, v.y, A + distance(vTexCoord, vec2(.5)));\n}\nvec4 B(const in vec4 k) {\n  float l = u();\n  return vec4(linearTosRGB(sRGBToLinear(k.rgb) * l), clamp(k.a + (1. - l), .0, 1.));\n}\nvec4 C(in vec4 D, in sampler2D E) {\n  mediump float F = D.b * 63.;\n  mediump vec2 G;\n  G.y = floor(floor(F) / 8.);\n  G.x = floor(F) - G.y * 8.;\n  mediump vec2 H;\n  H.y = floor(ceil(F) / 8.);\n  H.x = ceil(F) - H.y * 8.;\n  highp vec2 I;\n  I.x = G.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  I.y = G.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nI.y = 1. - I.y;\n#endif\nhighp vec2 J;\n  J.x = H.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  J.y = H.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nJ.y = 1. - J.y;\n#endif\nlowp vec4 K = texture2D(E, I);\n  lowp vec4 L = texture2D(E, J);\n  lowp vec4 M = mix(K, L, fract(F));\n  return M;\n}\nvoid main() {\n  vec4 k = texture2D(textureSource, vTexCoord);\n  if(enableLut == 1.) {\n    k = C(k, lookupTable);\n  }\n  if(enableVignette == 1.) {\n    k = B(k);\n  }\n  if(enableGrain == 1.) {\n    k = j(k);\n  }\n  gl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.resolution[0],
                    height: (t, e) => e.resolution[1]
                }
            }
        });
    }
    getMeshCommand(t, e) {
        return this.commands.postprocess || (this.commands.postprocess = this.createMeshCommand(t, e)), 
        this.commands.postprocess;
    }
}

const Zr = [ [ .263385, -.0252475 ], [ -.38545, .054485 ], [ -.139795, -.5379925 ], [ -.2793775, .6875475 ], [ .7139025, .4710925 ], [ .90044, -.16422 ], [ .4481775, -.82799 ], [ -.9253375, -.2910625 ], [ .3468025, 1.02292 ], [ -1.13742, .33522 ], [ -.7676225, -.9123175 ], [ -.2005775, -1.1774125 ], [ -.926525, .96876 ], [ 1.12909, -.7500325 ], [ .9603, 1.14625 ] ], Qr = Zr.length, ts = [ 0, 0 ];

for (let t = 0; t < Zr.length; t++) ts[0] += Zr[t][0], ts[1] += Zr[t][1];

ts[0] /= Qr, ts[1] /= Qr;

class es {
    constructor(t) {
        this.Li = 0, this.Fi = t || .05, this.Ui = [ ts[0] * this.Fi, ts[1] * this.Fi ];
    }
    getRatio() {
        return this.Fi;
    }
    setRatio(t) {
        this.Fi !== t && (this.Fi = t, this.reset()), this.Ui = [ ts[0] * this.Fi, ts[1] * this.Fi ];
    }
    getAverage() {
        return this.Ui;
    }
    reset() {
        this.Li = 0;
    }
    getJitter(t) {
        const e = this.Li % Qr, n = this.Fi;
        return u.set(t, Zr[e][0] * n, Zr[e][1] * n), t;
    }
    frame() {
        this.Li++, this.Li % Qr == 0 && (this.Li = 0);
    }
    getSampleCount() {
        return Qr;
    }
}

class ns {
    constructor(t, e, n = 5) {
        this.p = t, this.zi = new pi(t), this.Gi = e, this.Bi = n;
    }
    render(t, e) {
        this.Vi(), this.ji(t), this.Wi(t, e || 0);
        const n = {
            blurTex0: this.qi,
            blurTex1: this.Xi,
            blurTex2: this.Ki,
            blurTex3: this.$i,
            blurTex4: this.Ji
        };
        return this.Bi > 5 && (n.blurTex5 = this.Yi, n.blurTex6 = this.Zi), n;
    }
    Wi(t, e) {
        let n = this.Qi;
        n || (n = this.Qi = {
            "rgbmRange": 7,
            "blurDir": [ 0, 0 ],
            "outSize": [ 0, 0 ],
            "pixelRatio": [ 1, 1 ],
            "outputSize": [ 0, 0 ]
        }), u.set(n.outSize, t.width, t.height), this.tr(this.er, t, this.nr, this.ir, .5, e), 
        this.tr(this.rr, this.ir.color[0], this.sr, this.ar, .5), this.tr(this.cr, this.ar.color[0], this.hr, this.lr, .5), 
        this.tr(this.ur, this.lr.color[0], this.dr, this.mr, .5), this.tr(this.vr, this.mr.color[0], this.gr, this.pr, .5), 
        this.Bi > 5 && (this.tr(this._r, this.pr.color[0], this.br, this.yr, .5), this.tr(this.wr, this.yr.color[0], this.Sr, this.yr, .5));
    }
    tr(t, e, n, i, r, s) {
        const o = Math.ceil(r * e.width), a = Math.ceil(r * e.height);
        n.width === o && n.height === a || n.resize(o, a), i.width === o && i.height === a || i.resize(o, a);
        const c = this.Qi;
        c.luminThreshold = s, c.TextureBlurInput = e, c.inputRGBM = +this.Gi, u.set(c.blurDir, 0, 1), 
        u.set(c.outputSize, n.width, n.height), this.zi.render(t, c, null, n), c.luminThreshold = 0, 
        c.inputRGBM = 1, u.set(c.blurDir, 1, 0), c.TextureBlurInput = n.color[0], this.zi.render(t, c, null, i);
    }
    dispose() {
        this.er && (this.er.dispose(), delete this.er, this.rr.dispose(), this.cr.dispose(), 
        this.ur.dispose(), this.vr.dispose(), this._r && (this._r.dispose(), this.wr.dispose(), 
        delete this._r)), this.Ar && (delete this.Ar, this.nr.destroy(), this.ir.destroy(), 
        this.sr.destroy(), this.ar.destroy(), this.hr.destroy(), this.lr.destroy(), this.dr.destroy(), 
        this.mr.destroy(), this.gr.destroy(), this.pr.destroy(), this.br && (this.br.destroy(), 
        this.yr.destroy(), this.Sr.destroy(), this.Mr.destroy()));
    }
    ji(t) {
        if (this.Ar) return;
        let e = t.width, n = t.height;
        this.Ar = this.Tr(t, e, n), this.nr = this.Cr(this.Ar), this.qi = this.Tr(t), this.ir = this.Cr(this.qi), 
        e = Math.ceil(e / 2), n = Math.ceil(n / 2), this.Or = this.Tr(t, e, n), this.sr = this.Cr(this.Or), 
        this.Xi = this.Tr(t, e, n), this.ar = this.Cr(this.Xi), e = Math.ceil(e / 2), n = Math.ceil(n / 2), 
        this.Er = this.Tr(t, e, n), this.hr = this.Cr(this.Er), this.Ki = this.Tr(t, e, n), 
        this.lr = this.Cr(this.Ki), e = Math.ceil(e / 2), n = Math.ceil(n / 2), this.Ir = this.Tr(t, e, n), 
        this.dr = this.Cr(this.Ir), this.$i = this.Tr(t, e, n), this.mr = this.Cr(this.$i), 
        e = Math.ceil(e / 2), n = Math.ceil(n / 2), this.Pr = this.Tr(t, e, n), this.gr = this.Cr(this.Pr), 
        this.Ji = this.Tr(t, e, n), this.pr = this.Cr(this.Ji), this.Bi > 5 && (e = Math.ceil(e / 2), 
        n = Math.ceil(n / 2), this.Hr = this.Tr(t, e, n), this.br = this.Cr(this.Hr), this.Yi = this.Tr(t, e, n), 
        this.yr = this.Cr(this.Yi), e = Math.ceil(e / 2), n = Math.ceil(n / 2), this.Rr = this.Tr(t, e, n), 
        this.Sr = this.Cr(this.Rr), this.Zi = this.Tr(t, e, n), this.Mr = this.Cr(this.Zi));
    }
    Tr(t, e, n) {
        const i = this.p, r = e || t.width, s = n || t.height;
        return i.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: r,
            height: s
        });
    }
    Cr(t) {
        return this.p.framebuffer({
            width: t.width,
            height: t.height,
            colors: [ t ],
            depth: !1,
            stencil: !1
        });
    }
    Vi() {
        if (!this.er) {
            const t = {
                vert: Vr,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (t, e) => e.outputSize[0],
                        height: (t, e) => e.outputSize[1]
                    }
                },
                frag: "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\nuniform float inputRGBM;\nuniform float luminThreshold;\n#define SHADER_NAME GAUSSIAN_BLUR0\nconst vec3 c = vec3(.2126, .7152, .0722);\nfloat d(const in vec3 e) {\n  return dot(e, c);\n}\nvec4 f(vec4 e) {\n  float h = max(sign(d(e.rgb) - luminThreshold), .0);\n  return e * h;\n}\nvec2 i;\nvec4 j(const in vec3 e, const in float k) {\n  vec4 l;\n  vec3 m = e / k;\n  l.a = clamp(max(max(m.r, m.g), max(m.b, 1e-6)), .0, 1.);\n  l.a = ceil(l.a * 255.) / 255.;\n  l.rgb = m / l.a;\n  return l;\n}\nvec3 n(const in vec4 e, const in float k) {\n  if(inputRGBM == .0)\n    return e.rgb;\n  return k * e.rgb * e.a;\n}\nvec4 o() {\n  vec3 u = .375 * (f(vec4(n(texture2D(TextureBlurInput, i.xy), rgbmRange), 1.))).rgb;\n  vec2 v;\n  vec2 A = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  v = A * 1.2;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy + v.xy), rgbmRange), 1.))).rgb;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy - v.xy), rgbmRange), 1.))).rgb;\n  return vec4(u, 1.);\n}\nvoid main(void) {\n  i = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = o();\n  e = j(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}"
            };
            this.er = new qr(t), t.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR1\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .3125 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.2857142857142858;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this.rr = new qr(t), t.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR2\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2734375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3333333333333333;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.111111111111111;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this.cr = new qr(t), t.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR3\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .24609375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3636363636363635;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.1818181818181817;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this.ur = new qr(t), t.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR4\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2255859375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3846153846153846;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.230769230769231;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.076923076923077;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this.vr = new qr(t), this.Bi > 5 && (t.frag = "precision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR5\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .20947265625 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.4;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2666666666666666;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.133333333333334;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._r = new qr(t), t.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR6\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .196380615234375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.411764705882353;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2941176470588234;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.176470588235294;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this.wr = new qr(t));
        }
    }
}

class is {
    constructor(t) {
        this.p = t, this.zi = new pi(t);
    }
    render(t, e, n, i, r, s, o, a, c) {
        this.Vi(), this.ji(t);
        const h = this.kr.render(e, n);
        return this.Nr(t, h, e, i, r, s, o, a, c);
    }
    Nr(t, e, n, i, r, s, o, a, c) {
        c || this.Dr.width === t.width && this.Dr.height === t.height || this.Lr.resize(t.width, t.height);
        let h = this.Fr;
        const {blurTex0: l, blurTex1: f, blurTex2: d, blurTex3: m, blurTex4: v} = e;
        h || (h = this.Fr = {
            "bloomFactor": 0,
            "bloomRadius": 0,
            "rgbmRange": 7,
            "TextureBloomBlur1": l,
            "TextureBloomBlur2": f,
            "TextureBloomBlur3": d,
            "TextureBloomBlur4": m,
            "TextureBloomBlur5": v,
            "TextureInput": null,
            "TextureSource": null,
            "outputSize": [ 0, 0 ]
        }), h.noAaTextureSource = s, h.pointTextureSource = o, h.enableAA = a, h.bloomFactor = i, 
        h.bloomRadius = r, h.TextureInput = n, h.TextureSource = t, u.set(h.outputSize, t.width, t.height);
        const g = {};
        return s ? g.HAS_NOAA_TEX = 1 : delete g.HAS_NOAA_TEX, o ? g.HAS_POINT_TEX = 1 : delete g.HAS_POINT_TEX, 
        this.Ur.setDefines(g), this.zi.render(this.Ur, h, null, c ? null : this.Lr), c ? null : this.Dr;
    }
    dispose() {
        this.Lr && (this.Lr.destroy(), delete this.Lr), this.kr && (this.kr.dispose(), delete this.kr), 
        delete this.zr;
    }
    ji(t) {
        if (this.Dr) return;
        const e = t.width, n = t.height;
        this.Dr = this.Tr(t, e, n, "uint8"), this.Lr = this.Cr(this.Dr);
    }
    Tr(t, e, n, i) {
        const r = this.zi.device, s = i, o = e || t.width, a = n || t.height;
        return r.texture({
            min: "linear",
            mag: "linear",
            type: s,
            width: o,
            height: a
        });
    }
    Cr(t) {
        return this.zi.device.framebuffer({
            width: t.width,
            height: t.height,
            colors: [ t ],
            depth: !1,
            stencil: !1
        });
    }
    Vi() {
        if (!this.Ur) {
            const t = {
                x: 0,
                y: 0,
                width: (t, e) => e.outputSize[0],
                height: (t, e) => e.outputSize[1]
            };
            this.kr = new ns(this.p, !1), this.Ur = new qr({
                vert: Vr,
                frag: "precision highp float;\nuniform float bloomFactor;\nuniform float bloomRadius;\nuniform float rgbmRange;\nuniform sampler2D TextureBloomBlur1;\nuniform sampler2D TextureBloomBlur2;\nuniform sampler2D TextureBloomBlur3;\nuniform sampler2D TextureBloomBlur4;\nuniform sampler2D TextureBloomBlur5;\nuniform sampler2D TextureInput;\nuniform sampler2D TextureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\nuniform float enableAA;\nuniform vec2 outputSize;\n#define SHADER_NAME bloomCombine\nvec2 c;\n#include <srgb_frag>\nvec3 d(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nfloat h(const float i, const float j) {\n  return mix(i, j * 2. - i, bloomRadius);\n}\nvec4 k() {\n  vec3 l = vec3(.0);\n  const float m = .6;\n  const float n = 1.1;\n  const float o = .9;\n  const float u = .6;\n  const float v = .3;\n  const float A = .1;\n  l += (vec4(d(texture2D(TextureBloomBlur1, c), rgbmRange), 1.)).rgb * h(n, m);\n  l += (vec4(d(texture2D(TextureBloomBlur2, c), rgbmRange), 1.)).rgb * h(o, m);\n  l += (vec4(d(texture2D(TextureBloomBlur3, c), rgbmRange), 1.)).rgb * h(u, m);\n  l += (vec4(d(texture2D(TextureBloomBlur4, c), rgbmRange), 1.)).rgb * h(v, m);\n  l += (vec4(d(texture2D(TextureBloomBlur5, c), rgbmRange), 1.)).rgb * h(A, m);\n  vec4 B;\n  if(enableAA == 1.) {\n    \n  } else {\n    B = texture2D(TextureInput, c);\n  }\n  B.rgb = mix(vec3(.0), B.rgb, sign(B.a));\n  vec4 C = texture2D(TextureSource, c);\n#ifdef HAS_NOAA_TEX\nvec4 D = texture2D(noAaTextureSource, c);\n  C = D + C * (1. - D.a);\n#endif\nvec4 E = vec4(.0);\n#ifdef HAS_POINT_TEX\nE = texture2D(pointTextureSource, c);\n#endif\nfloat F = sqrt((l.r + l.g + l.b) / 3.);\n  vec4 G = vec4(linearTosRGB(l * bloomFactor), F);\n  return E + (B + C * (1. - B.a)) * (1. - E.a) + G;\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  gl_FragColor = e;\n}",
                extraCommandProps: {
                    viewport: t
                }
            });
        }
    }
}

class rs extends qr {
    constructor() {
        const t = [];
        super({
            vert: Vr,
            frag: "precision highp float;\n#include <gl2_frag>\n#define SHADER_NAME COPY_DEPTH\nuniform sampler2D TextureDepth;\nuniform vec2 textureSize;\n#include <common_pack_float>\nvoid main(void) {\n  vec2 c = gl_FragCoord.xy / textureSize.xy;\n  float d = texture2D(TextureDepth, c).r;\n  glFragColor = common_encodeDepth(d);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "textureSize",
                type: "function",
                fn: (e, n) => (t[0] = n.TextureDepth.width, t[1] = n.TextureDepth.height, t)
            } ],
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.TextureDepth.width,
                    height: (t, e) => e.TextureDepth.height
                }
            }
        }), this.version = 300;
    }
    getMeshCommand(t, e) {
        return this.commands.copy_depth || (this.commands.copy_depth = this.createMeshCommand(t, e)), 
        this.commands.copy_depth;
    }
}

class ss {
    static getUniformDeclares() {
        const t = [ [ 0, 0, 0, 0 ], [ 0, 0, 0, 0 ] ], e = new Array(16);
        return [ {
            name: "invProjMatrix",
            type: "function",
            fn: (t, n) => c.invert(e, n.projMatrix)
        }, {
            name: "outputFovInfo",
            type: "array",
            length: 2,
            fn: function(e, n) {
                const i = Math.tan(.5 * n.fov), r = n.outSize[0] / n.outSize[1] * i;
                return l.set(t[0], r, i, r, -i), l.set(t[1], -r, i, -r, -i), t;
            }
        }, {
            name: "reprojViewProjMatrix",
            type: "function",
            fn: (t, e) => c.multiply([], e.prevProjViewMatrix, e.cameraWorldMatrix)
        } ];
    }
    static getDefines() {
        return {
            "HAS_SSR": 1
        };
    }
    constructor(t) {
        this.p = t, this.zi = new pi(t), this.Gi = 0;
    }
    setup(t) {
        this.Vi(), this.ji(t);
    }
    getSSRUniforms(t, e, n) {
        if (!this.Gr) return null;
        const i = this.Gr;
        return {
            "TextureDepth": i,
            "TextureReflected": this.getMipmapTexture(),
            "ssrFactor": e || 1,
            "ssrQuality": n || 2,
            "outSize": [ i.width, i.height ],
            "fov": t.getFov() * Math.PI / 180,
            "prevProjViewMatrix": this._projViewMatrix || t.projViewMatrix,
            "cameraWorldMatrix": t.cameraWorldMatrix
        };
    }
    genMipMap(t, e, n) {
        return this.setup(t), this.Br(t), this.copyDepthTex(e), this._projViewMatrix || (this._projViewMatrix = []), 
        c.copy(this._projViewMatrix, n), delete this.Vr, this.jr;
    }
    getPrevProjViewMatrix() {
        return this._projViewMatrix;
    }
    copyDepthTex(t) {
        if (this.Vr) return null;
        if (this.setup(t), this.Gr) t.width === this.Gr.width && t.height === this.Gr.height || this.Wr.resize(t.width, t.height); else {
            const e = {
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "uint8",
                width: t.width,
                height: t.height
            };
            this.Gr = this.p.texture(e);
            const n = {
                width: t.width,
                height: t.height,
                colors: [ this.Gr ],
                colorFormat: "rgba"
            };
            this.Wr = this.p.framebuffer(n);
        }
        return this.zi.render(this.qr, {
            "TextureDepth": t
        }, null, this.Wr), this.Vr = !0, this.Gr;
    }
    Br(t) {
        const e = this.Xr, n = Math.ceil(.5 * t.width), i = Math.ceil(.5 * t.height);
        e.width === n && e.height === i || e.resize(n, i);
        let r = this.Qi;
        r || (r = this.Qi = {
            "rgbmRange": 7,
            "outputSize": [ 0, 0 ]
        }), r.TextureInput = t, r.inputRGBM = +this.Gi, u.set(r.outputSize, e.width, e.height), 
        this.zi.render(this.Kr, r, null, e);
    }
    getMipmapTexture() {
        return this.jr || (this.jr = this.zi.regl.texture({
            type: "uint8",
            width: 2,
            height: 2
        })), this.jr;
    }
    dispose() {
        this.qr && (this.Kr.dispose(), this.qr.dispose(), this.Xr.destroy(), delete this.qr), 
        this.Gr && (this.Wr.destroy(), delete this.Gr, delete this.Wr);
    }
    Vi() {
        if (!this.qr) {
            this.qr = new rs;
            const t = {
                vert: Vr,
                frag: "#version 100\nprecision mediump float;\nuniform sampler2D TextureInput;\nuniform vec2 outputSize;\n#define SHADER_NAME QUAD\nvec2 c;\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 d = texture2D(TextureInput, c.xy);\n  gl_FragColor = d;\n}",
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (t, e) => e.outputSize[0],
                        height: (t, e) => e.outputSize[1]
                    }
                }
            };
            this.Kr = new qr(t);
        }
    }
    ji(t) {
        if (!this.Xr) {
            const e = this.p;
            this.jr && this.jr.destroy(), this.jr = e.texture({
                min: "linear",
                mag: "linear",
                type: "uint8",
                width: t.width,
                height: t.height
            }), this.Xr = e.framebuffer({
                width: t.width,
                height: t.height,
                colors: [ this.jr ],
                depth: !1,
                stencil: !1
            });
        }
    }
}

class os extends Br {
    constructor(t) {
        const e = t && t.extraCommandProps || {}, n = [];
        super({
            vert: "#define SHADER_NAME HEATMAP\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\nuniform float heatmapIntensity;\nattribute vec3 aPosition;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nattribute highp float aWeight;\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\nuniform mediump float heatmapRadius;\nconst highp float c = 1. / 255. / 16.;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float d = aWeight / 255.;\n  weight = d;\n#else\nhighp float d = heatmapWeight;\n#endif\nmediump float e = heatmapRadius;\n  vec2 f = vec2(mod(aPosition.xy, 2.) * 2. - 1.);\n  float h = sqrt(-2. * log(c / d / heatmapIntensity / GAUSS_COEF)) / 3.;\n  vExtrude = h * f;\n  vec2 i = vExtrude * e * extrudeScale;\n  vec4 j = vec4(floor(aPosition.xy * .5) + i, aPosition.z, 1);\n  gl_Position = projViewModelMatrix * j;\n}",
            frag: "#define SHADER_NAME HEATMAP\nprecision mediump float;\nuniform highp float heatmapIntensity;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float c = weight;\n#else\nhighp float c = heatmapWeight;\n#endif\nfloat d = -.5 * 3. * 3. * dot(vExtrude, vExtrude);\n  float e = c * heatmapIntensity * GAUSS_COEF * exp(d);\n  gl_FragColor = vec4(e, 1., 1., 1.);\n}",
            uniforms: [ {
                name: "extrudeScale",
                type: "function",
                fn: function(t, e) {
                    return e.resolution / e.dataResolution * e.tileRatio;
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(n, e.projViewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: E({}, e, {
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one"
                    },
                    equation: "add"
                }
            })
        });
    }
}

var as = [ -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, 1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, 1, -1, 1, -1, 1, 1, -1, 1, 1, 1, 1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, 1, -1, 1 ], cs = "#define SHADER_NAME SKYBOX\n#if __VERSION__ == 100\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\nprecision highp float;\n#define saturate(x)        clamp(x, 0.0, 1.0)\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\nvarying vec3 vWorldPos;\n#ifdef USE_AMBIENT\nuniform vec3 diffuseSPH[9];\n#else\nuniform samplerCube cubeMap;\nuniform float bias;\nuniform float size;\n#endif\nuniform float environmentExposure;\nuniform float backgroundIntensity;\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\n  vec3 i = e;\n  return textureCubeLod(d, i, h);\n}\nvec3 j(const in vec3 k, const in vec3 l[9]) {\n  float x = k.x;\n  float y = k.y;\n  float z = k.z;\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\n  return max(m, vec3(.0));\n}\nfloat n(const in vec2 o) {\n  vec3 u = fract(vec3(o.xyx) * .1031);\n  u += dot(u, u.yzx + 19.19);\n  return fract((u.x + u.y) * u.z);\n}\n#if defined(TONE_MAPPING)\nconst float v = 1.;\nvec3 A(vec3 B) {\n  vec3 a = B * (B + .0245786) - .000090537;\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\n  return a / b;\n}\nvec3 C(vec3 D) {\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\n  D *= v / .6;\n  D = E * D;\n  D = A(D);\n  D = F * D;\n  return saturate(D);\n}\nvec3 G(vec3 D) {\n  return C(D);\n}\nvec4 H(in vec4 I) {\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\n}\nvec4 J(vec4 I) {\n  return (H(I));\n}\n#endif\nvoid main() {\n  vec4 K;\n#ifdef USE_AMBIENT\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\n  K = vec4(j(k, diffuseSPH), 1.);\n#else\nK = c(cubeMap, vWorldPos, size, bias);\n#endif\nK.rgb *= environmentExposure;\n  K.rgb *= backgroundIntensity;\n  glFragColor = K;\n  if(length(hsv) > .0) {\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\n  }\n#if defined(TONE_MAPPING)\nglFragColor.rgb = G(glFragColor.rgb);\n  glFragColor = J(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class hs extends Br {
    constructor() {
        super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 transformMatrix;\nvarying vec3 vWorldPos;\nvoid main() {\n  vWorldPos = aPosition;\n  mat4 c = mat4(mat3(viewMatrix) * transformMatrix);\n  vec4 d = projMatrix * c * vec4(vWorldPos, 1.);\n  gl_Position = d.xyww;\n}",
            frag: cs,
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: [ 1, 1 ],
                    func: "lequal"
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.resolution[0],
                    height: (t, e) => e.resolution[1]
                }
            }
        }), this.version = 300;
    }
    setMode(t, e) {
        const n = {};
        return t && (n.TONE_MAPPING = 1), 0 === e && (n.USE_AMBIENT = 1), this.$r ? this.$r[0].setDefines(n) : this.Jr = n, 
        this;
    }
    draw(t) {
        return this.$r || this.Yr(t), super.draw(t, this.$r);
    }
    Yr(t) {
        const e = new qt({
            aPosition: new Int8Array(as)
        }, null, as.length / 3);
        e.generateBuffers(t), this.$r = [ new mi(e) ], this.Jr && (this.$r[0].setDefines(this.Jr), 
        delete this.Jr);
    }
    dispose() {
        if (this.$r) {
            const t = this.$r[0];
            t.geometry.dispose(), t.dispose();
        }
        return delete this.$r, super.dispose();
    }
}

class ls extends Br {
    constructor(t, e) {
        const n = {
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: t
        };
        e && e.extraCommandProps && E(n, e.extraCommandProps);
        const i = [];
        super({
            vert: "#define SHADER_NAME HEATMAP_DISPLAY\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 1.);\n}",
            frag: "#define SHADER_NAME HEATMAP_DISPLAY\nprecision mediump float;\nuniform sampler2D inputTexture;\nuniform sampler2D colorRamp;\nuniform vec2 textureOutputSize;\nuniform float heatmapOpacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / textureOutputSize.xy;\n  float t = texture2D(inputTexture, c).r;\n  vec4 d = texture2D(colorRamp, vec2(t, .5));\n  gl_FragColor = d * heatmapOpacity;\n}",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(i, e.projViewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: n
        });
    }
}

class fs extends qr {
    constructor() {
        super({
            vert: Vr,
            frag: "precision highp float;\nuniform sampler2D texture;\nuniform vec2 size;\nuniform float enableSharpen;\nuniform float sharpFactor;\nuniform float pixelRatio;\nvec2 c;\nvec3 d(const in vec3 e, const float f) {\n  vec2 h = pixelRatio / size.xy;\n  float i = .0;\n  vec4 j = texture2D(texture, c + h * vec2(-1., -1.));\n  j.rgb = mix(vec3(.0), j.rgb, sign(j.a));\n  i += mix(.0, 1., sign(j.a));\n  vec4 k = texture2D(texture, c + h * vec2(1.));\n  k.rgb = mix(vec3(.0), k.rgb, sign(k.a));\n  i += mix(.0, 1., sign(k.a));\n  vec4 l = texture2D(texture, c + h * vec2(1., -1.));\n  l.rgb = mix(vec3(.0), l.rgb, sign(l.a));\n  i += mix(.0, 1., sign(l.a));\n  vec4 m = texture2D(texture, c + h * vec2(-1., 1.));\n  m.rgb = mix(vec3(.0), m.rgb, sign(m.a));\n  i += mix(.0, 1., sign(m.a));\n  return e + f * (i * e - j.rgb - l.rgb - m.rgb - k.rgb);\n}\nvoid main() {\n  c = gl_FragCoord.xy / size;\n  vec4 e = texture2D(texture, c);\n  if(enableSharpen == 1.) {\n    e.rgb = d(e.rgb, sharpFactor);\n  }\n  gl_FragColor = e;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.size[0],
                    height: (t, e) => e.size[1]
                }
            }
        });
    }
    getMeshCommand(t, e) {
        return this.commands.copy || (this.commands.copy = this.createMeshCommand(t, e)), 
        this.commands.copy;
    }
}

const us = [], ds = [];

class ms extends qr {
    constructor() {
        super({
            vert: Vr,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform sampler2D sceneMap;\nuniform sampler2D scanEffectMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  vec4 d = texture2D(scanEffectMap, vTexCoord);\n  glFragColor = c + d;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.resolution[0],
                    height: (t, e) => e.resolution[1]
                }
            }
        });
    }
}

const vs = [];

class gs {
    constructor(t, e, n) {
        this.p = t, this.Zr = n, this.Qr = e, this.ts();
    }
    ts() {
        this.es = new Br({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec4 vWorldPosition;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  vec4 e = modelMatrix * d * c;\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vWorldPosition = e;\n}",
            frag: "precision mediump float;\nvarying vec4 vWorldPosition;\nuniform vec2 fogDist;\nuniform vec3 cameraPosition;\nuniform float rainDepth;\nvoid main() {\n  vec3 c = vec3(vWorldPosition[0] - cameraPosition[0], vWorldPosition[1] - cameraPosition[1], vWorldPosition[2] - cameraPosition[2]);\n  float d = length(c);\n  float e = clamp(1. - (d - fogDist.x) / (fogDist.y - fogDist.x), .0, 1.);\n  if(vWorldPosition[2] < rainDepth) {\n    gl_FragColor = vec4(e, .0, .0, 1.);\n  } else {\n    gl_FragColor = vec4(e, 1., .0, 1.);\n  }\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(vs, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this.Qr
            }
        });
        const t = this.Zr.getRenderer().createFBOInfo();
        this.ns = this.p.framebuffer(t), this.rs = new Ti, this.renderer = new pi(this.p);
    }
    render(t, e) {
        this.ss(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.ns
        }), this.rs.setMeshes(t);
        const n = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            cameraPosition: e.cameraPosition,
            fogDist: e.fogDist,
            rainDepth: e.rainDepth
        };
        return this.renderer.render(this.es, n, this.rs, this.ns), this.ns;
    }
    dispose() {
        this.ns && this.ns.destroy(), this.es && this.es.dispose();
    }
    ss() {
        const t = O(this.Qr.width.data) ? this.Qr.width.data() : this.Qr.width, e = O(this.Qr.height.data) ? this.Qr.height.data() : this.Qr.height;
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
}

class ps extends qr {
    constructor() {
        super({
            vert: Vr,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_RAIN\nuniform sampler2D ripplesMap;\n#endif\n#ifdef HAS_SNOW\nuniform sampler2D normalMap;\n#endif\n#ifdef HAS_FOG\nuniform vec3 fogColor;\n#endif\nuniform sampler2D sceneMap;\nuniform sampler2D mixFactorMap;\nuniform float time;\nuniform vec2 resolution;\nuniform float snowIntensity;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\n#define HASHSCALE1 .1031\n#define HASHSCALE3 vec3(.1031, .1030, .0973)\n#define HASHSCALE4 vec3(.1031, .1030, .0973, .1099)\nfloat d = .5;\nfloat e = .2;\nfloat f = .5;\nfloat h = 20.;\nfloat i(float p) {\n  vec3 j = fract(vec3(p) * HASHSCALE1);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.x + j.y) * j.z);\n}\nvec2 k(vec2 p) {\n  vec3 j = fract(vec3(p.xyx) * HASHSCALE3);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.xx + j.yz) * j.zy);\n}\nvec2 l(vec2 m) {\n  float x = fract(sin(dot(m.xy, vec2(122.9898, 783.233))) * 43758.5453);\n  float y = fract(sin(dot(m.xy, vec2(457.6537, 537.2793))) * 37573.5913);\n  return vec2(x, y);\n}\nvec3 n(vec2 o, float u) {\n  vec3 v = vec3(.0);\n  o = o * (2. + u);\n  float A = e * snowIntensity;\n  float B = o.y * (((i(u) * 2. - 1.) * .5 + 1.) * A);\n  float C = (f * time);\n  o += vec2(B, C);\n  vec2 D = k(floor(o) + 31.1759 * u);\n  o = fract(o);\n  o -= (D * 2. - 1.) * .35;\n  o -= .5;\n  float r = length(o);\n  float E = .05 * (1. + .3 * sin(time * d));\n  float F = smoothstep(E, -E, r);\n  vec3 G = vec3(F) * D.x;\n  return G;\n}\nvec3 H() {\n  vec3 v = vec3(0);\n  vec2 o = gl_FragCoord.xy / resolution.xy;\n  o *= vec2(resolution.x / resolution.y, 1.);\n  float I = h * snowIntensity;\n  for(float J = 0.; J < I; J++) {\n    v += n(o, J);\n  }\n  return v;\n}\nvec3 K(vec4 L, vec4 M, float N) {\n  float O = M.b;\n  vec3 P = vec3(1.);\n  if(N < 1.) {\n    float r = c(.5, P.x, O);\n    float g = c(.5, P.y, O);\n    float b = c(.5, P.z, O);\n    return vec3(r, g, b);\n  } else {\n    float r = c(L.r, P.x, O);\n    float g = c(L.g, P.y, O);\n    float b = c(L.b, P.z, O);\n    return vec3(r, g, b);\n  }\n}\nvoid main() {\n  vec4 L = texture2D(sceneMap, vTexCoord);\n  glFragColor = L;\n  vec4 Q = texture2D(mixFactorMap, vTexCoord);\n#ifdef HAS_RAIN\nvec4 R = texture2D(ripplesMap, vTexCoord);\n  if(Q.g < 1.) {\n    L = mix(L, R, .4);\n  }\n  glFragColor = L;\n#endif\n#ifdef HAS_SNOW\nvec3 S = H();\n  glFragColor = vec4(L.rgb + S, L.a);\n#endif\n#ifdef HAS_FOG\nfloat T = Q.r;\n  vec3 U = mix(fogColor, glFragColor.rgb, T);\n  glFragColor = vec4(U, L.a);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.resolution[0],
                    height: (t, e) => e.resolution[1]
                }
            }
        });
    }
}

const xs = [], _s = [ .03, .03, .03 ], bs = [], ys = [], ws = [], Ss = c.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class As {
    constructor(t, e) {
        this.p = t, this.Qr = e, this.ts();
    }
    ts() {
        this.es = new Br({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec2 vTexCoord;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform float rippleRadius;\nuniform float density;\nuniform float time;\nvec3 c(vec2 p) {\n  vec3 q = vec3(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)), dot(p, vec2(419.2, 371.9)));\n  return fract(sin(q) * 43758.5453);\n}\nfloat d(in vec2 x) {\n  vec2 e = x * density / 4000.0;\n  vec2 p = floor(e);\n  vec2 f = fract(e);\n  float h = .0;\n  for(int i = -4; i <= 4; i++)\n    for(int k = -4; k <= 4; k++) {\n      vec2 g = vec2(float(k), float(i));\n      vec3 l = c(p + g);\n      vec2 r = g - f + l.xy;\n      float m = sqrt(dot(r, r));\n      float n = max(mix(smoothstep(.99, .999, max(cos(m - time * 2. + (l.x + l.y) * 5.), 0.)), 0., m), 0.);\n      h += n;\n    }\n  return h;\n}\nvoid main() {\n  vec2 u = vTexCoord;\n  float A = 24. / (rippleRadius * .01);\n  float f = d(A * u) * smoothstep(.0, .4, sin(u.x * 3.151592) * sin(u.y * 3.141592));\n  vec3 B = vec3(-dFdx(f), -dFdy(f), -dFdy(f));\n  glFragColor = vec4(B, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(xs, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this.Qr
            }
        }), this.es.version = 300, this.ns = this.p.framebuffer({
            color: this.p.texture({
                width: this.Qr.width(),
                height: this.Qr.height(),
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.rs = new Ti, this.renderer = new pi(this.p);
    }
    os(t) {
        const e = t.coordinateToPointAtRes(t.getCenter(), t.getGLRes()), n = t.getGLScale() / t.getGLScale(this.cs), i = h.set(ys, n, n, n), r = h.multiply(i, _s, i), s = c.identity(ws);
        c.fromRotationTranslationScale(s, d.fromEuler(bs, 0, 0, 0), [ e.x, e.y, 0 ], r), 
        c.multiply(s, s, Ss), this.hs.setLocalTransform(s);
    }
    ls(t) {
        this.cs = t.getZoom();
        const e = 800 * Math.pow(2, 16.685648411389433 - this.cs), n = [ -e, 0, -e, e, 0, -e, -e, 0, e, e, 0, e ], i = {};
        i.POSITION = n, i.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], i.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const r = new qt(i, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        r.generateBuffers(this.p);
        const s = new Ie;
        return new mi(r, s);
    }
    render(t, e) {
        this.ss(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.ns
        }), this.hs = this.hs || this.ls(t), this.rs.setMeshes(this.hs), this.os(t);
        const n = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            time: e.time,
            rippleRadius: e.rippleRadius,
            density: e.density
        };
        return this.renderer.render(this.es, n, this.rs, this.ns), this.ns;
    }
    dispose() {
        this.ns && this.ns.destroy(), this.es && this.es.dispose();
    }
    ss() {
        const t = O(this.Qr.width.data) ? this.Qr.width.data() : this.Qr.width, e = O(this.Qr.height.data) ? this.Qr.height.data() : this.Qr.height;
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
}

var Ms = "attribute vec3 aPosition;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\n#ifdef HAS_TEXTURE\nattribute vec2 aTexCoord;\nvarying vec2 uv;\nvarying vec4 vPos;\n#endif\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = c * getPosition(aPosition);\n  gl_Position = projViewModelMatrix * d;\n#ifdef HAS_TEXTURE\nuv = aTexCoord;\n  vPos = getPosition(aPosition);\n#endif\n}";

const Ts = [ 0, 0, 0, 1 ];

class Cs {
    constructor(t, e) {
        this.regl = t, this.Qr = e, this.renderer = new pi(t), this.ts();
    }
    ts() {
        this.fs = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.us = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "nearest",
                min: "nearest"
            }),
            depth: !0
        });
        const t = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: (t, e) => c.multiply([], e.projViewMatrix, e.modelMatrix)
        } ];
        this.ds = new Br({
            vert: Ms,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec4 maskColor;\n#ifdef HAS_TEXTURE\nuniform sampler2D maskTexture;\nvarying vec2 uv;\nuniform vec3 mask_position0;\nuniform vec3 mask_position1;\nuniform vec3 mask_position2;\nuniform vec3 mask_position3;\nvarying vec4 vPos;\nvec2 c(vec2 d, vec2 a, vec2 b, vec2 e, vec2 f) {\n  vec2 h = vec2(.5);\n  for(int i = 0; i < 10; i++) {\n    float j = h.x;\n    float k = h.y;\n    vec2 l = (1. - j) * (1. - k) * a + j * (1. - k) * b + j * k * e + (1. - j) * k * f;\n    vec2 m = d - l;\n    if(length(m) < .001)\n      break;\n    vec2 n = -(1. - k) * a + (1. - k) * b + k * e - k * f;\n    vec2 o = -(1. - j) * a - j * b + j * e + (1. - j) * f;\n    float A = n.x * o.y - n.y * o.x;\n    if(abs(A) > .0001) {\n      vec2 B = vec2((m.x * o.y - m.y * o.x) / A, (m.y * n.x - m.x * n.y) / A);\n      h += B;\n    }\n    h = clamp(h, .0, 1.);\n  }\n  return h;\n}\n#endif\nvoid main() {\n  \n#ifdef HAS_TEXTURE\nvec2 d = vPos.xy;\n  vec2 C = c(d, mask_position0.xy, mask_position1.xy, mask_position2.xy, mask_position3.xy);\n  gl_FragColor = texture2D(maskTexture, C);\n  gl_FragColor.a *= maskColor.a;\n#else\nif(maskColor.a == .0) {\n    discard;\n  }\n  gl_FragColor = maskColor;\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this.Qr,
                depth: {
                    enable: !0,
                    func: "lequal"
                }
            }
        }), this.vs = new Br({
            vert: Ms,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform float maskMode;\n#ifdef HAS_MASK_FLAT\nuniform float flatHeight;\n#endif\n#ifdef HAS_MASK_COLOR\nuniform vec2 heightRange;\n#endif\nvoid main() {\n  \n#if defined(HAS_MASK_FLAT)\ngl_FragColor = vec4(maskMode, flatHeight, .0, 1.);\n#elif defined(HAS_MASK_COLOR)\ngl_FragColor = vec4(maskMode, .0, heightRange.x, heightRange.y);\n#else\ngl_FragColor = vec4(maskMode, .0, .0, .0);\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this.Qr
            }
        }), this.rs = new Ti;
    }
    render(t, e) {
        this.ss(), this.renderer.clear({
            color: Ts,
            depth: 1,
            framebuffer: this.fs
        }), this.renderer.clear({
            color: Ts,
            depth: 1,
            framebuffer: this.us
        }), this.rs.setMeshes(t);
        const n = {
            projViewMatrix: e
        };
        return this.renderer.render(this.ds, n, this.rs, this.fs), this.renderer.render(this.vs, n, this.rs, this.us), 
        {
            colorExtent: this.fs,
            modeExtent: this.us
        };
    }
    ss() {
        const t = O(this.Qr.width) ? this.Qr.width() : this.Qr.width.data(), e = O(this.Qr.height) ? this.Qr.height() : this.Qr.height.data();
        !this.fs || this.fs.width === t && this.fs.height === e || (this.fs.resize(t, e), 
        this.us.resize(t, e));
    }
    dispose() {
        this.fs && (this.fs.destroy(), delete this.fs), this.us && (this.us.destroy(), delete this.us), 
        this.ds && (this.ds.dispose(), delete this.ds), this.vs && (this.vs.dispose(), delete this.vs);
    }
}

const Os = "\n#ifdef GL_ES\n  precision highp float;\n#endif\nuniform mat3 ring;\n\nuniform float effectTime;\nvarying vec4 vWorldPosition;\n\nvec3 hsb2rgb(in vec3 c) {\n    vec3 rgb = clamp(abs(mod(c.x * 6.0 + vec3(0.0,4.0,2.0), 6.0)-3.0)-1.0, 0.0, 1.0 );\n    rgb = rgb*rgb*(3.0-2.0*rgb);\n    return c.z * mix( vec3(1.0), rgb, c.y);\n}\n\nvec4 glowring(vec4 worldPos, vec2 center, float radius, float speed, vec3 effectColor, float direction, float height) {\n  vec2 dir = vec2(worldPos.xy) - center;\n  float len = length(dir);\n  if (len > radius) {\n    return vec4(0.0);\n  } else {\n    vec2 uv = vec2(0.0);\n    if (direction == 0.0) {\n      vec2 lefttop = vec2(center.x - radius, center.y + radius);\n      vec2 rightbottom = vec2(center.x + radius, center.y - radius);\n      uv = vec2(abs(worldPos.x - lefttop.x) / (2.0 * radius), abs(worldPos.y - rightbottom.y) / (2.0 * radius));\n      uv.x -= 0.5;\n      uv.y -= 0.5;\n    } else {\n      if (worldPos.z < 0.1) {\n        return vec4(0.0);\n      }\n      uv = vec2(0.0, worldPos.z / height);\n    }\n    float itime = (effectTime / 2.0) * speed;\n    float r = length(uv) * 3.0;\n    vec3 color = hsb2rgb(effectColor);\n\n    float a = pow(r, 2.0);\n    float b = sin(r * 0.8 - 1.6);\n    float c = sin(r - 0.010);\n    float s = sin(a - itime * 3.0 + b) * c;\n    float t = abs(1.0 / (s * 10.8)) - 0.01;\n    color *= t;\n    vec4 newColor = vec4(color, t);\n    return newColor;\n  }\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    gl_FragColor = color;\n}\n", Es = [];

class Is {
    constructor(t, e, n) {
        this.p = t, this.Zr = n, this.Qr = e, this.ts(), this.gs = 0;
    }
    ts() {
        const t = this.Zr.getRenderer().createFBOInfo();
        this.ns = this.p.framebuffer(t), this.rs = new Ti, this.renderer = new pi(this.p);
    }
    render(t, e) {
        this.ss(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.ns
        }), this.rs.setMeshes(t);
        const n = e.effectInfos;
        if (!this.es || n.length !== this.gs) {
            this.es && this.es.dispose();
            const t = this.ps(n);
            this.es = new Br({
                vert: "#include <gl2_vert>\n#define SHADER_NAME SCANEFFECT\nprecision highp float;\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vWorldPosition;\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    #ifdef IS_LINE_EXTRUSION\n        vec3 linePosition = getLineExtrudePosition(aPosition);\n        //linePixelScale = tileRatio * resolution / tileResolution\n        vec4 localVertex = getPosition(linePosition);\n    #else\n        vec4 localVertex = getPosition(aPosition);\n    #endif\n    vec4 worldPosition = modelMatrix * localPositionMatrix * localVertex;\n    vWorldPosition = worldPosition;\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localVertex;\n}\n",
                frag: t,
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, e) {
                        return c.multiply(Es, e.viewMatrix, e.modelMatrix);
                    }
                } ],
                extraCommandProps: {
                    viewport: this.Qr
                }
            }), this.gs = n.length;
        }
        const i = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            effectTime: e.effectTime,
            minAltitude: 0
        };
        return this.xs(i, n), this.renderer.render(this.es, i, this.rs, this.ns), this.ns;
    }
    ps(t) {
        let e = "";
        for (let n = 0; n < t.length; n++) e += `uniform mat3 ring${n};\n`;
        e = Os.replace("uniform mat3 ring;", e);
        let n = "";
        for (let e = 0; e < t.length; e++) n += `\n                vec2 center${e} = vec2(ring${e}[0][0], ring${e}[0][1]);\n                float radius${e} = ring${e}[0][2];\n                float speed${e} = ring${e}[1][0];\n                vec3 color${e} = vec3(ring${e}[1][1], ring${e}[1][2], ring${e}[2][0]);\n                float direction${e} = ring${e}[2][1];\n                float height${e} = ring${e}[2][2];\n                vec4 ringColor${e} = glowring(vWorldPosition, center${e}, radius${e}, speed${e}, color${e}, direction${e}, height${e});\n                color += ringColor${e};\n            `;
        return n += "gl_FragColor = color;", e = e.replace("gl_FragColor = color;", n), 
        e;
    }
    xs(t, e) {
        for (let n = 0; n < e.length; n++) t[`ring${n}`] = e[n];
    }
    dispose() {
        this.ns && this.ns.destroy(), this.es && this.es.dispose();
    }
    ss() {
        const t = O(this.Qr.width.data) ? this.Qr.width.data() : this.Qr.width, e = O(this.Qr.height.data) ? this.Qr.height.data() : this.Qr.height;
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
}

const Ps = [], Hs = {
    width: 4,
    type: "float"
};

class Rs {
    constructor(t, e, n) {
        this.p = t, this.joints = e, this.inverseBindMatrices = [], this.jointMatrices = [], 
        this.jointData = new Float32Array(16 * e.length);
        for (let t = 0; t < e.length; ++t) this.inverseBindMatrices.push(new Float32Array(n.buffer, n.byteOffset + 16 * Float32Array.BYTES_PER_ELEMENT * t, 16)), 
        this.jointMatrices.push(new Float32Array(this.jointData.buffer, 16 * Float32Array.BYTES_PER_ELEMENT * t, 16));
        this.jointTextureSize = [ 4, 6 ];
    }
    update(t, e, n) {
        c.invert(Ps, t);
        for (let t = 0; t < this.joints.length; ++t) {
            const n = this.joints[t], i = this.jointMatrices[t];
            c.multiply(i, Ps, e[n.nodeIndex]), c.multiply(i, i, this.inverseBindMatrices[t]);
        }
        Hs.height = this.joints.length, Hs.data = this.jointData;
        const i = Hs;
        return n ? n(i) : n = this.p.texture(i), n;
    }
}

const ks = [ 0, 0, 0 ], Ns = [ 0, 0, 0, 1 ], Ds = [ 1, 1, 1 ], Ls = [];

class Fs {
    constructor(t = [ 0, 0, 0 ], e = [ 0, 0, 0, 1 ], n = [ 1, 1, 1 ]) {
        this.translation = t, this.rotation = e, this.scale = n;
    }
    getMatrix() {
        return c.fromRotationTranslationScale(Ls, this.rotation, this.translation, this.scale);
    }
    decompose(t) {
        c.getTranslation(this.translation, t), c.getRotation(this.rotation, t), c.getScaling(this.scale, t);
    }
    update(t) {
        t && (t.translation && !h.equals(t.translation, ks) && h.copy(this.translation, t.translation), 
        t.rotation && !d.equals(t.rotation, Ns) && d.copy(this.rotation, t.rotation), t.scale && !h.equals(t.scale, Ds) && h.copy(this.scale, t.scale));
    }
}

class Us {
    constructor(t) {
        this.ts(t);
    }
    ts(t) {
        this.bbox = t.bbox, this.geometry = t.geometry, this.nodeMatrix = t.nodeMatrix, 
        this.materialInfo = t.materialInfo, this.extraInfo = t.extraInfo, this.animationMatrix = t.animationMatrix, 
        this.morphWeights = t.morphWeights, this.skin = t.skin, this.nodeIndex = t.nodeIndex;
    }
    copyEdgeGeometry() {
        this.copyGeometry || (this.copyGeometry = this._s(this.geometry));
    }
    createCopyBarycentric() {
        this.copyGeometry && !this.copyGeometry.data.aBarycentric && (this.copyGeometry.buildUniqueVertex(), 
        this.copyGeometry.createBarycentric("aBarycentric"));
    }
    _s(t) {
        const e = t.data, n = t.indices || t.elements, i = {};
        for (const n in e) if (n === t.desc.positionAttribute) if (R(e[n])) i[n] = e[n].slice(); else if (e[n].buffer && e[n].buffer.destroy) i[n] = {
            buffer: e[n].buffer
        }, R(e[n].array) && (i[n].array = e[n].array.slice()); else {
            const e = t.q(n);
            n !== t.desc.positionAttribute ? i[n] = e : i[n] = e.slice();
        }
        const r = void 0 !== n.length ? n.slice() : n, s = JSON.parse(JSON.stringify(t.desc)), o = new Te(i, r, 0, s);
        return o.properties = t.properties, o;
    }
}

let zs = 0;

const Gs = [], Bs = [];

class Vs {
    constructor(t, e) {
        this.gltf = t, this.regl = e, this.geometries = [], e && (this.bs = e.texture({
            width: 2,
            height: 2
        }));
    }
    getMeshesInfo() {
        if (!this.gltf) return null;
        if (this.geometries.length) return this.geometries;
        this.ji(this.gltf.textures), this.ys(this.gltf.skins);
        return this.gltf.scenes[0].nodes.forEach((t => {
            this.ws(t, this.geometries);
        })), this.Ss(), this.geometries;
    }
    getGLTFBBox() {
        if (!this.gltf) return null;
        const t = this.geometries;
        if (!t || !t.length) return null;
        const e = [ 1 / 0, 1 / 0, 1 / 0 ], n = [ -1 / 0, -1 / 0, -1 / 0 ];
        for (let i = 0; i < t.length; i++) {
            const r = t[i].bbox, s = r.min, o = r.max;
            s[0] < e[0] && (e[0] = s[0]), s[1] < e[1] && (e[1] = s[1]), s[2] < e[2] && (e[2] = s[2]), 
            o[0] > n[0] && (n[0] = o[0]), o[1] > n[1] && (n[1] = o[1]), o[2] > n[2] && (n[2] = o[2]);
        }
        return {
            min: e,
            max: n
        };
    }
    ys(t) {
        if (t) {
            this.As = {};
            for (let e = 0; e < t.length; e++) {
                const n = t[e];
                n.joints = n.joints.map((t => this.gltf.nodes[t])), this.As[e] = new Rs(this.regl, n.joints, n.inverseBindMatrices.array), 
                delete n.inverseBindMatrices;
            }
        }
    }
    ji(t) {
        if (t) {
            this.Ms = {};
            for (let e = 0; e < t.length; e++) {
                const n = t[e];
                this.Ms[e] || (this.Ms[e] = this.Ts(n), delete n.image);
            }
        }
    }
    Ss() {
        if (!this.Cs()) for (let t = 0; t < this.geometries.length; t++) {
            const e = this.geometries[t].materialInfo.baseColorFactor;
            e && 0 === e[3] && (e[3] = 1);
        }
    }
    Cs() {
        for (let t = 0; t < this.geometries.length; t++) {
            const e = this.geometries[t].materialInfo.baseColorFactor;
            if (e && e[3] > 0) return !0;
        }
        return !1;
    }
    dispose() {
        this.bs && this.bs.destroy();
        const t = this.getMeshesInfo();
        if (t) {
            t.forEach((t => {
                t.geometry.dispose();
                for (const e in t.materialInfo) {
                    const n = t.materialInfo[e];
                    n && n.destroy && !n[Q] && n.destroy();
                }
            }));
            for (const t in this.Ms) {
                const e = this.Ms[t];
                e && e.destroy && !e[Q] && e.destroy();
            }
            delete this.gltf;
        }
    }
    updateAnimation(t, e, n, i, r, s, o, a) {
        const c = this.gltf;
        if (!c) return;
        const h = A();
        if (zs = c.animations ? h.GLTFLoader.getAnimationTimeSpan(c, i) : null, !zs) return;
        t -= r;
        let l = 0;
        l = e || !e && this.Os(t, n, i, r) ? t * n * .001 % (zs.max - zs.min) + zs.min : t * n * .001 + zs.min, 
        c.scenes[0].nodes.forEach((t => {
            this.Es(i, l, t, null, s, a);
        }));
        for (const t in this.gltf.nodes) {
            const e = this.gltf.nodes[t], n = s[e.nodeIndex];
            if (e.skin && n) {
                const t = e.skin.update(n, s, o[e.nodeIndex] && o[e.nodeIndex].jointTexture);
                o[e.nodeIndex] || (o[e.nodeIndex] = {
                    jointTextureSize: e.skin.jointTextureSize,
                    numJoints: e.skin.joints.length
                }), o[e.nodeIndex].jointTexture = t;
            }
        }
    }
    Os(t, e, n, i) {
        const r = this.gltf;
        if (!i || !r) return !0;
        const s = A();
        return zs = r.animations ? s.GLTFLoader.getAnimationTimeSpan(r, n) : null, t * e * .001 / (zs.max - zs.min) < 1;
    }
    hasSkinAnimation() {
        return !!this.Is;
    }
    Es(t, e, n, i, r, s) {
        n.trs && (s ? s.indexOf(Number(n.nodeIndex)) > -1 && this.Ps(n, e, t) : this.Ps(n, e, t)), 
        r[n.nodeIndex] = i ? c.multiply(r[n.nodeIndex] || [], i, n.matrix || n.trs.getMatrix()) : c.copy(r[n.nodeIndex] || [], n.matrix || n.trs.getMatrix()), 
        n.children && n.children.forEach((i => {
            this.Es(t, e, i, r[n.nodeIndex], r, s);
        }));
    }
    Ps(t, e, n) {
        const i = A().GLTFLoader.getAnimationClip(this.gltf, Number(t.nodeIndex), e, n);
        i.weights && this.Hs(t, i.weights), t.trs.update(i);
    }
    Hs(t, e) {
        const n = e.length;
        if (!t.influencesList) {
            t.influencesList = [];
            for (let e = 0; e < n; e++) t.influencesList[e] = [ e, 0 ];
        }
        const i = t.influencesList;
        for (let t = 0; t < i.length; t++) {
            const n = i[t];
            n[0] = t, n[1] = e[t];
        }
        i.sort(Ws);
        const r = [];
        for (let t = 0; t < 8; t++) r[t] = [ t, 0 ];
        for (let t = 0; t < 8; t++) t < n && i[t][1] ? (r[t][0] = i[t][0], r[t][1] = i[t][1]) : (r[t][0] = Number.MAX_SAFE_INTEGER, 
        r[t][1] = 0);
        r.sort(js);
        t.geometries.forEach((t => {
            const e = t.properties.morphTargets;
            for (let n = 0; n < 8; n++) {
                const i = r[n], s = i[0], o = i[1];
                s !== Number.MAX_SAFE_INTEGER && o ? (t.updateData("POSITION" + n, e["POSITION_" + s].array), 
                t.properties.morphWeights[n] = o) : t.properties.morphWeights[n] = 0;
            }
        }));
    }
    ws(t, e, n) {
        if (t.isParsed) return;
        t.nodeMatrix = t.nodeMatrix || c.identity([]), t.localMatrix = t.localMatrix || c.identity([]), 
        t.matrix ? (t.trs = new Fs, t.trs.decompose(t.matrix)) : t.trs = new Fs(t.translation, t.rotation, t.scale), 
        t.localMatrix = t.trs.getMatrix(), n ? c.multiply(t.nodeMatrix, n, t.matrix || t.localMatrix) : c.copy(t.nodeMatrix, t.matrix || t.localMatrix);
        const i = t.nodeMatrix;
        if (t.children) for (let n = 0; n < t.children.length; n++) {
            const r = t.children[n];
            this.ws(r, e, i);
        }
        if (C(t.skin)) {
            this.Is = !0;
            const e = t.skin;
            t.trs = new Fs, t.skin = this.As[e];
        }
        if (C(t.mesh)) {
            const n = t.mesh;
            t.mesh = this.gltf.meshes[n], t.mesh.node = t, t.geometries = t.geometries || [], 
            t.mesh.primitives.forEach((n => {
                const r = this.Rs(n.material), s = function(t, e, n) {
                    const i = t.attributes, r = i.COLOR_0;
                    if (r && r.array instanceof Float32Array) {
                        const t = new Uint8Array(r.array.length);
                        for (let e = 0; e < t.length; e++) t[e] = Math.round(255 * r.array[e]);
                        r.array = t;
                    } else if (r && (r.array instanceof Uint16Array || r.array instanceof Int16Array || r.array instanceof Uint32Array || r.array instanceof Int32Array)) {
                        const t = new Uint8Array(r.array);
                        r.array = t;
                    }
                    n && i.TEXCOORD_0 && !i.TEXCOORD_0 && (i.TEXCOORD_1 = i.TEXCOORD_0);
                    const s = {};
                    for (const t in i) s[t] = E({}, i[t]), e && (s[t].buffer = ge(e, i[t], {
                        dimension: i[t].itemSize
                    }));
                    if (t.morphTargets) {
                        const t = j(s.POSITION) ? s.POSITION.itemSize * s.POSITION.count : s.POSITION.array.length;
                        for (let e = 0; e < 8; e++) s[`POSITION${e}`] || (s[`POSITION${e}`] = new Float32Array(t).fill(0));
                        for (let t = 0; t < 4; t++) {
                            const e = s.NORMAL.array ? s.NORMAL.array.length : s.NORMAL.length;
                            s[`NORMAL${t}`] || (s[`NORMAL${t}`] = new Float32Array(e).fill(0));
                        }
                    }
                    let o = t.indices;
                    o && void 0 === o.bufferView && o.array && (o = o.array);
                    const a = new qt(s, o, 0, {
                        primitive: P(t.mode) ? ne(t.mode) : t.mode,
                        positionAttribute: "POSITION",
                        normalAttribute: "NORMAL",
                        uv0Attribute: "TEXCOORD_0",
                        uv1Attribute: "TEXCOORD_1",
                        color0Attribute: "COLOR_0"
                    });
                    t.morphTargets && (a.properties.morphWeights = []);
                    t.mode > 3 && !a.data.NORMAL && a.createNormal("NORMAL");
                    return a;
                }(n, this.regl, r.occlusionTexture);
                s.properties.morphTargets = n.morphTargets, t.geometries.push(s);
                let o = s.boundingBox.copy();
                o = o.transform(c.identity(Gs), i);
                const a = {
                    geometry: s,
                    bbox: o,
                    nodeMatrix: i,
                    materialInfo: r,
                    extraInfo: this.ks(n.material),
                    animationMatrix: t.trs.getMatrix(),
                    morphWeights: t.weights,
                    nodeIndex: t.nodeIndex
                };
                t.skin && (a.skin = {
                    jointTextureSize: [ 4, 6 ],
                    numJoints: t.skin.joints.length,
                    jointTexture: t.skin.jointTexture
                });
                const h = new Us(a);
                e.push(h);
            }));
        }
        t.isParsed = !0;
    }
    Rs(t) {
        const e = {};
        if (this.gltf.materials && this.gltf.materials[t]) {
            const n = this.gltf.materials[t], i = n.pbrMetallicRoughness;
            if (i) {
                const t = i.metallicRoughnessTexture, n = i.baseColorTexture;
                n && (e.baseColorTexture = this.Ns(n), n.KHR_texture_transform && (e.khr_offset = n.KHR_texture_transform.offset || [ 0, 0 ], 
                e.khr_rotation = n.KHR_texture_transform.rotation || 0, e.khr_scale = n.KHR_texture_transform.scale || [ 1, 1 ])), 
                i.baseColorFactor && (e.baseColorFactor = i.baseColorFactor), t ? e.metallicRoughnessTexture = this.Ns(t) : (e.metallicFactor = C(i.metallicFactor) ? i.metallicFactor : 1, 
                e.roughnessFactor = C(i.roughnessFactor) ? i.roughnessFactor : 1);
            }
            const r = n.extensions;
            if (r && r.KHR_materials_pbrSpecularGlossiness) {
                const t = r.KHR_materials_pbrSpecularGlossiness;
                e.name = "pbrSpecularGlossiness";
                for (const n in t) C(t[n].index) ? e[n] = this.Ns(t[n]) : e[n] = t[n];
            }
            n.normalTexture && (e.normalTexture = this.Ns(n.normalTexture)), n.occlusionTexture && (e.occlusionTexture = this.Ns(n.occlusionTexture)), 
            n.emissiveTexture && (e.emissiveTexture = this.Ns(n.emissiveTexture)), n.emissiveFactor && (e.emissiveFactor = n.emissiveFactor), 
            e.alphaCutoff = n.alphaCutoff || .5, e.doubleSided = n.doubleSided, e.alphaMode = n.alphaMode || "OPAQUE";
        }
        return e;
    }
    ks(t) {
        const e = {};
        if (this.gltf.materials && this.gltf.materials[t]) {
            const n = this.gltf.materials[t];
            e.doubleSided = n.doubleSided, e.alphaMode = n.alphaMode || "OPAQUE";
        }
        return e;
    }
    Ns(t) {
        const e = t.extensions, n = t.index;
        if (!C(n)) return null;
        e && e.KHR_texture_transform && (t.KHR_texture_transform = e.KHR_texture_transform);
        const i = this.Ms[n];
        return i.texInfo = t, i;
    }
    Ts(t) {
        if (!t) return this.bs;
        const e = t.image.array, n = t.sampler || {}, i = t.image.width, r = t.image.height;
        return new Gi({
            width: i,
            height: r,
            data: e,
            mag: he(n.magFilter) || "linear",
            min: fe(n.minFilter) || "linear mipmap linear",
            wrapS: de(n.wrapS) || "repeat",
            wrapT: de(n.wrapT) || "repeat"
        });
    }
    arrangeAlongLine(t, e, n, i, r, s) {
        const o = [], a = this.Ds(t, e), c = (t.z || 0) - (e.z || 0), h = this.Ls(n, c);
        let l = this.Fs(i, s);
        l /= r;
        const f = Math.sqrt(n * n + c * c), u = Math.floor(f / l);
        let d = s.direction || 0;
        if (1 === d ? d = 2 : 2 === d && (d = 1), u >= 1) {
            for (let n = 1; n <= u; n++) {
                const i = l * (n - .5) / f, r = {
                    coordinates: qs(t, e, i),
                    t: i,
                    scale: [ 1, 1, 1 ],
                    rotation: [ 0, 0, a ],
                    rotationZ: a,
                    rotationXY: h
                };
                o.push(r);
            }
            if (s.scaleVertex) {
                const n = (l * u + (f - l * u) / 2) / f, i = (f - l * u) / l, r = [ 1, 1, 1 ];
                r[d] = i;
                const s = {
                    coordinates: qs(t, e, n),
                    t: n,
                    scale: r,
                    rotation: [ 0, 0, a ],
                    rotationZ: a,
                    rotationXY: h
                };
                o.push(s);
            }
        } else if (s.scaleVertex) {
            const n = f / l, i = [ 1, 1, 1 ];
            i[d] = n;
            const r = {
                coordinates: qs(t, e, .5),
                t: .5,
                scale: i,
                rotation: [ 0, 0, a ],
                rotationZ: a,
                rotationXY: h
            };
            o.push(r);
        }
        return o;
    }
    calModelHeightScale(t, e) {
        const n = this.getGLTFBBox(), i = e / Math.abs(n.max[1] - n.min[1]);
        return h.set(t, i, i, i);
    }
    Fs(t, e) {
        const n = this.getGLTFBBox(), i = e.direction || 0, r = h.sub(Bs, n.max, n.min);
        h.multiply(r, r, t);
        const s = e.gapLength;
        return r[i] + s;
    }
    Ds(t, e) {
        return function(t, e, n, i) {
            const r = n - t, s = i - e;
            return Math.atan2(s, r);
        }(e.x, e.y, t.x, t.y) / Math.PI * 180;
    }
    Ls(t, e) {
        return 180 * Math.atan(e / t) / Math.PI;
    }
}

function js(t, e) {
    return t[0] - e[0];
}

function Ws(t, e) {
    return Math.abs(e[1]) - Math.abs(t[1]);
}

function qs(t, e, n) {
    const i = Xs(t.x, e.x, n), r = Xs(t.y, e.y, n), s = Xs(t.z || 0, e.z || 0, n);
    return new t.constructor(i, r, s);
}

function Xs(t, e, n) {
    return t + n * (e - t);
}

function Ks(t, e) {
    const {Ajax: n} = A(), {fetchOptions: i, gltfLoaderOptions: r, urlModifier: s} = e, o = r || {};
    o.urlModifier = s;
    const a = t.lastIndexOf("/"), c = t.slice(0, a), h = t.slice(t.lastIndexOf(".")).toLowerCase();
    return ".gltf" === h ? n.getJSON(t, i, s).then((t => Js(c, t, o))) : ".glb" === h ? n.getArrayBuffer(t, i, s).then((t => Js(c, {
        buffer: t.data,
        byteOffset: 0
    }, o))) : null;
}

function $s(t, e) {
    return new Vs(t, e);
}

function Js(t, e, n) {
    const {GLTFLoader: i} = A();
    return new i(t, e, n).load();
}

var Ys = Object.freeze({
    __proto__: null,
    exportGLTFPack: $s,
    load: Ks,
    loadGLTF: Js
});

const Zs = [ -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, 1 ], Qs = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], to = [ 3, 1, 0, 0, 2, 3 ], eo = [ 0, 0, 1, 0, 0, 1, 1, 1 ], no = {
    vertices: [ -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0 ],
    normals: [ -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012 ],
    indices: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
}, io = [ "cube", "plane", "pyramid" ], ro = {
    "cube": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array([ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ])
                    },
                    NORMAL: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1 ])
                    },
                    TEXCOORD_0: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1 ])
                    }
                },
                indices: new Uint16Array([ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    "plane-cube": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(Zs)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(eo)
                    }
                },
                indices: new Uint16Array(to),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, -60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ -60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, 60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, -60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            } ]
        } ]
    },
    "plane": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(Zs)
                    },
                    NORMAL: {
                        array: new Int8Array(Qs)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(eo)
                    }
                },
                indices: new Uint16Array(to),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    "pyramid": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Float32Array(no.vertices)
                    },
                    NORMAL: {
                        array: new Float32Array(no.normals)
                    },
                    TEXCOORD_0: {
                        array: new Float32Array(no.uv)
                    }
                },
                indices: new Uint16Array(no.indices),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    }
};

const so = function() {
    const t = [ 0, 0, 0 ], e = 90 * Math.PI / 180, n = [ 0, 0, 0, 0 ], i = new Array(16);
    return function(r, s, o, a, h, l) {
        const f = [ c.lookAt([], t, [ 1, 0, 0 ], l && l[0] || [ 0, -1, 0 ]), c.lookAt([], t, [ -1, 0, 0 ], l && l[1] || [ 0, -1, 0 ]), c.lookAt([], t, [ 0, 1, 0 ], l && l[2] || [ 0, 0, 1 ]), c.lookAt([], t, [ 0, -1, 0 ], l && l[3] || [ 0, 0, -1 ]), c.lookAt([], t, [ 0, 0, 1 ], l && l[4] || [ 0, -1, 0 ]), c.lookAt([], t, [ 0, 0, -1 ], l && l[5] || [ 0, -1, 0 ]) ], u = {
            context: {
                viewMatrix: function(t, e, n) {
                    return f[n];
                },
                projMatrix: c.perspective(i, e, 1, .5, 1.1)
            }
        };
        s && (s.faces ? u.framebuffer = function(t, e, n) {
            return s.faces[n];
        } : u.framebuffer = s);
        return r(u)(6, ((t, e, i) => {
            const c = {
                color: n,
                depth: 1
            };
            s && (c.framebuffer = s.faces ? s.faces[i] : s), r.clear(c), o(a), h && h();
        })), s;
    };
}();

var oo = {
    vertices: [ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ],
    textures: [ 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0 ],
    indices: [ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]
}, ao = "#define SHADER_NAME CUBE_MAP\nattribute vec3 aPosition;\nvarying vec3 vWorldPos;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nvoid main() {\n  vWorldPos = aPosition;\n  gl_Position = projMatrix * viewMatrix * vec4(vWorldPos, 1.);\n}", co = "#define SHADER_NAME CUBEMAP\nprecision highp float;\nuniform samplerCube cubeMap;\nuniform float exposure;\nvarying vec3 vWorldPos;\n#ifdef ENCODE_RGBM\nvec4 c(const in vec3 d, const in float e) {\n  if(e <= .0)\n    return vec4(d, 1.);\n  vec4 f;\n  vec3 h = d / e;\n  f.a = clamp(max(max(h.r, h.g), max(h.b, 1e-6)), .0, 1.);\n  f.a = ceil(f.a * 255.) / 255.;\n  f.rgb = h / f.a;\n  return f;\n}\n#endif\nvoid main() {\n  vec4 i = textureCube(cubeMap, vWorldPos);\n  i.rgb *= exposure;\n#ifdef ENCODE_RGBM\ni = c(i.rgb, 7.);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = i;\n#endif\n}", ho = "precision highp float;\n#define PI 3.1415926\nvarying vec3 vWorldPos;\nuniform sampler2D equirectangularMap;\nconst vec2 c = vec2(.1591, .3183);\nvec2 d(vec3 e) {\n  vec2 f = vec2(atan(e.y, e.x), asin(e.z));\n  f *= c;\n  f += .5;\n  return f;\n}\nvoid main() {\n  vec2 f = d(normalize(vWorldPos));\n  vec4 h = texture2D(equirectangularMap, f);\n  gl_FragColor = vec4(h.rgb, 1.);\n}", lo = "#define SHADER_NAME PBR_prefilter\nprecision highp float;\nvarying vec3 vWorldPos;\nuniform samplerCube environmentMap;\nuniform sampler2D distributionMap;\nuniform float roughness;\nuniform float resolution;\nconst float c = 3.14159265359;\nfloat d(vec3 e, vec3 f, float h) {\n  float a = h * h;\n  float i = a * a;\n  float j = max(dot(e, f), .0);\n  float k = j * j;\n  float l = i;\n  float m = (k * (i - 1.) + 1.);\n  m = c * m * m;\n  return l / m;\n}\nvec3 n(float o, vec3 e, float h) {\n  vec4 u = texture2D(distributionMap, vec2(h, o));\n  vec3 f = u.xyz;\n  float v = sign(u.w - .5);\n  float A = sign(u.w - 200.0 / 255. * clamp(v, .0, 1.) - .15);\n  f.x *= v;\n  f.y *= A;\n  vec3 B = abs(e.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 C = normalize(cross(B, e));\n  vec3 D = cross(e, C);\n  vec3 E = C * f.x + D * f.y + e * f.z;\n  return normalize(E);\n}\nvoid main() {\n  vec3 e = normalize(vWorldPos);\n  vec3 F = e;\n  vec3 G = F;\n  const int I = 1024;\n  vec3 J = vec3(.0);\n  float K = .0;\n  for(int L = 0; L < I; ++L) {\n    vec3 f = n(float(L) / float(I), e, roughness);\n    vec3 M = normalize(2. * dot(G, f) * f - G);\n    float O = max(dot(e, M), .0);\n    if(O > .0) {\n      J += textureCube(environmentMap, M).rgb * O;\n      K += O;\n    }\n  }\n  J = J / K;\n  gl_FragColor = vec4(J, 1.);\n}", fo = "precision highp float;\nvarying vec2 vTexCoords;\nuniform sampler2D distributionMap;\nconst float c = 3.14159265359;\nvec4 d(float a, float b) {\n  a *= 65535.;\n  b *= 65535.;\n  vec4 rgba;\n  rgba[0] = mod(a, 255.);\n  rgba[1] = (a - rgba[0]) / 65280.0;\n  rgba[2] = mod(b, 255.);\n  rgba[3] = (b - rgba[2]) / 65280.0;\n  return rgba;\n}\nvec3 e(float f, vec3 h, float i) {\n  vec4 j = texture2D(distributionMap, vec2(i, f));\n  vec3 k = j.xyz;\n  float l = sign(j.w - .5);\n  float m = sign(j.w - clamp(l, .0, 1.) * 200.0 / 255. - .15);\n  k.x *= l;\n  k.y *= m;\n  vec3 n = abs(h.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 o = normalize(cross(n, h));\n  vec3 u = cross(h, o);\n  vec3 v = o * k.x + u * k.y + h * k.z;\n  return normalize(v);\n}\nfloat A(float B, float i) {\n  float a = i;\n  float C = (a * a) / 2.;\n  float D = B;\n  float E = B * (1. - C) + C;\n  return D / E;\n}\nfloat F(float B, float G, float i) {\n  float I = A(B, i);\n  float J = A(G, i);\n  return J * I;\n}\nvec2 K(float B, float i) {\n  vec3 L;\n  L.x = sqrt(1. - B * B);\n  L.y = .0;\n  L.z = B;\n  float M = .0;\n  float O = .0;\n  vec3 h = vec3(.0, .0, 1.);\n  const int P = 1024;\n  for(int Q = 0; Q < P; ++Q) {\n    vec3 k = e(float(Q) / float(P), h, i);\n    vec3 R = normalize(2. * dot(L, k) * k - L);\n    float G = max(R.z, .0);\n    float S = max(k.z, .0);\n    float T = max(dot(L, k), .0);\n    float B = max(dot(h, L), .0);\n    if(G > .0) {\n      float U = F(B, G, i);\n      float W = (U * T) / (S * B);\n      float X = pow(1. - T, 5.);\n      M += (1. - X) * W;\n      O += X * W;\n    }\n  }\n  M /= float(P);\n  O /= float(P);\n  return vec2(M, O);\n}\nvoid main() {\n  vec2 Y = K(vTexCoords.x, vTexCoords.y);\n  gl_FragColor = d(Y.x, Y.y);\n}", uo = "attribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoords;\nvoid main() {\n  vTexCoords = aTexCoord;\n  gl_Position = vec4(aPosition, 1.);\n}";

/*!
 * from claygl
 * https://github.com/pissang/claygl/
 * License: BSD-2-Clause
 */
function mo(t, e) {
    const n = t[0], i = t[1], r = t[2];
    return 0 === e ? 1 : 1 === e ? n : 2 === e ? i : 3 === e ? r : 4 === e ? n * r : 5 === e ? i * r : 6 === e ? n * i : 7 === e ? 3 * r * r - 1 : n * n - i * i;
}

const vo = {
    px: [ 2, 1, 0, -1, -1, 1 ],
    nx: [ 2, 1, 0, 1, -1, -1 ],
    py: [ 0, 2, 1, 1, -1, -1 ],
    ny: [ 0, 2, 1, 1, 1, 1 ],
    pz: [ 0, 1, 2, -1, -1, -1 ],
    nz: [ 0, 1, 2, 1, -1, 1 ]
}, go = [ "px", "nx", "py", "ny", "pz", "nz" ];

let po;

const xo = ji.compile(cs);

function _o(t, e, n, i, r = 1, s = !1) {
    const o = t({
        frag: (s ? "#define ENCODE_RGBM\n" : "") + co,
        vert: ao,
        attributes: {
            "aPosition": oo.vertices
        },
        uniforms: {
            "projMatrix": t.context("projMatrix"),
            "viewMatrix": t.context("viewMatrix"),
            "cubeMap": e,
            "exposure": r
        },
        elements: oo.indices
    }), a = [], c = t.texture({
        radius: n,
        min: "linear",
        mag: "linear",
        type: i ? "float" : "uint8",
        format: "rgba"
    }), h = t.framebuffer({
        radius: n,
        color: c
    });
    return so(t, h, o, {
        size: n
    }, (function() {
        const e = t.read();
        if (i) {
            const t = new Uint16Array(e.length);
            for (let n = 0; n < e.length; n++) t[n] = Math.min(Di.toHalfFloat(e[n]), 65504);
            a.push(t);
        } else a.push(e);
    })), o.destroy(), h.destroy(), a;
}

const bo = new Int8Array([ -1, 1, 0, -1, -1, 0, 1, 1, 0, 1, -1, 0 ]), yo = new Int8Array([ 0, 1, 0, 0, 1, 1, 1, 0 ]);

function wo(t) {
    return t.vao && t || function() {
        if (!po) {
            const t = document.createElement("canvas").getContext("webgl");
            po = y({
                optionalExtensions: [ "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear" ],
                attributes: {
                    alpha: !0,
                    depth: !0,
                    stencil: !0,
                    preserveDrawingBuffer: !0
                },
                gl: t
            }), po.on("lost", (() => {
                po.destroy(), po = null;
            }));
        }
        return po;
    }();
}

function So(t, e, n, i) {
    const r = wo(t);
    e = e || 256;
    const s = Ao(n = n || 1024, i = i || 256), o = r.texture({
        data: s,
        width: i,
        height: n,
        min: "nearest",
        mag: "nearest"
    }), a = r.buffer({
        data: bo,
        name: "aPosition"
    }), c = r.buffer({
        data: yo,
        name: "aTexCoord"
    }), h = r.framebuffer({
        radius: e,
        colorType: "uint8",
        colorFormat: "rgba",
        min: "linear",
        mag: "linear"
    }), l = r({
        frag: fo,
        vert: uo,
        attributes: {
            "aPosition": {
                buffer: a
            },
            "aTexCoord": {
                buffer: c
            }
        },
        uniforms: {
            "distributionMap": o
        },
        framebuffer: h,
        viewport: {
            x: 0,
            y: 0,
            width: e,
            height: e
        },
        count: bo.length / 3,
        primitive: "triangle strip"
    });
    if (l(), t.wgpu) {
        const e = r.read({
            framebuffer: h
        });
        return new fr(t, {
            data: e,
            width: h.width,
            height: h.height
        });
    }
    return l.destroy(), a.destroy(), c.destroy(), o.destroy(), h;
}

function Ao(t, e) {
    const n = new Float32Array(t * e * 4);
    for (let i = 0; i < t; i++) {
        const {x: r, y: s} = Mo(i, t);
        for (let t = 0; t < e; t++) {
            const o = t / e, a = o * o, c = 2 * Math.PI * r, h = Math.sqrt((1 - s) / (1 + (a * a - 1) * s)), l = Math.sqrt(1 - h * h), f = 4 * (i * e + t), u = l * Math.cos(c), d = l * Math.sin(c);
            n[f] = Math.abs(255 * u), n[f + 1] = Math.abs(255 * d), n[f + 2] = 255 * h, n[f + 3] = (u > 0 ? 200 : 0) + (d > 0 ? 55 : 0);
        }
    }
    return n;
}

function Mo(t, e) {
    let n = (t << 16 | t >>> 16) >>> 0;
    return n = ((1431655765 & n) << 1 | (2863311530 & n) >>> 1) >>> 0, n = ((858993459 & n) << 2 | (3435973836 & n) >>> 2) >>> 0, 
    n = ((252645135 & n) << 4 | (4042322160 & n) >>> 4) >>> 0, n = (((16711935 & n) << 8 | (4278255360 & n) >>> 8) >>> 0) / 4294967296, 
    {
        x: t / e,
        y: n
    };
}

function To(t) {
    return t._gl instanceof WebGL2RenderingContext || t.hasExtension("OES_texture_half_float");
}

var Co = Object.freeze({
    __proto__: null,
    createIBLMaps: function(t, e = {}) {
        t = wo(t);
        const n = e.envTexture, i = e.envCubeSize || 512, r = e.sampleSize || 1024, s = e.roughnessLevels || 256, o = e.prefilterCubeSize || 256;
        let a, c = !1;
        if (Array.isArray(n)) {
            const e = t.cube({
                flipY: !0,
                faces: n
            });
            a = function(t, e, n) {
                const i = t({
                    frag: xo,
                    vert: ao,
                    attributes: {
                        "aPosition": oo.vertices
                    },
                    uniforms: {
                        "hsv": [ 0, 0, 0 ],
                        "projMatrix": t.context("projMatrix"),
                        "viewMatrix": t.context("viewMatrix"),
                        "cubeMap": e,
                        "bias": 0,
                        "size": e.width,
                        "environmentExposure": 1,
                        "backgroundIntensity": 1
                    },
                    elements: oo.indices
                }), r = t.cube({
                    width: n,
                    height: n,
                    min: "linear",
                    mag: "linear",
                    format: "rgba"
                }), s = t.framebufferCube({
                    radius: n,
                    color: r
                });
                return so(t, s, i, {
                    size: n
                }, null, [ [ 0, 0, -1 ], [ 0, 0, -1 ], [ 0, 0, 1 ], [ 0, 0, 1 ], [ 0, -1, 0 ], [ 0, -1, 0 ] ]), 
                i.destroy(), s;
            }(t, e, i), e.destroy();
        } else a = function(t, e, n) {
            if (!To(t)) throw new Error("HDR is not supported for lack of support for float 16 texture");
            n = n || 512;
            const i = t({
                frag: ho,
                vert: ao,
                attributes: {
                    "aPosition": oo.vertices
                },
                uniforms: {
                    "projMatrix": t.context("projMatrix"),
                    "viewMatrix": t.context("viewMatrix"),
                    "equirectangularMap": e
                },
                elements: oo.indices
            }), r = t.cube({
                width: n,
                height: n,
                min: "linear mipmap linear",
                mag: "linear",
                type: "float16",
                format: "rgba"
            }), s = t.framebufferCube({
                radius: n,
                color: r
            });
            return so(t, s, i), i.destroy(), s;
        }(t, n, i), c = !0;
        const {prefilterMap: l, prefilterMipmap: f} = function(t, e, n, i, r, s) {
            const o = function(t, e, n, i, r, s) {
                i = i || 1024, r = r || 256;
                const o = Ao(i, r), a = t.texture({
                    data: o,
                    width: r,
                    height: i,
                    min: "nearest",
                    mag: "nearest"
                }), c = t({
                    frag: lo,
                    vert: ao,
                    attributes: {
                        "aPosition": oo.vertices
                    },
                    uniforms: {
                        "projMatrix": t.context("projMatrix"),
                        "viewMatrix": t.context("viewMatrix"),
                        "environmentMap": e,
                        "distributionMap": a,
                        "roughness": t.prop("roughness"),
                        "resolution": n
                    },
                    elements: oo.indices,
                    viewport: {
                        x: 0,
                        y: 0,
                        width: t.prop("size"),
                        height: t.prop("size")
                    }
                });
                let h = n;
                const l = t.texture({
                    radius: n,
                    min: "linear",
                    mag: "linear",
                    type: s ? "float" : "uint8"
                }), f = t.framebuffer({
                    radius: n,
                    color: l
                }), u = Math.log(h) / Math.log(2), d = [];
                for (let e = 0; e <= u; e++) {
                    let n = 0;
                    so(t, f, c, {
                        roughness: e / (u - 1),
                        size: h
                    }, (function() {
                        const e = t.read({
                            framebuffer: f
                        });
                        let i = e;
                        if (s) {
                            i = new Uint16Array(e.length);
                            for (let t = 0; t < e.length; t++) i[t] = Math.min(Di.toHalfFloat(e[t]), 65504);
                        }
                        d[n] || (d[n] = {
                            mipmap: []
                        }), d[n].mipmap.push(i), n++;
                    })), h /= 2, f.resize(h);
                }
                return a.destroy(), f.destroy(), c.destroy(), d;
            }(t, e, n, i, r, s), a = t.cube({
                radius: n,
                min: "linear",
                mag: "linear",
                type: s ? "float16" : "uint8",
                faces: o,
                format: "rgba"
            });
            return {
                prefilterMap: a,
                prefilterMipmap: o
            };
        }(t, a, o, r, s, c);
        let u;
        if (!e.ignoreSH) {
            const n = o;
            u = function(t, e, n) {
                const i = new Array(9), r = [], s = [], o = [];
                for (let a = 0; a < 9; a++) {
                    const c = [ 0, 0, 0 ];
                    for (let i = 0; i < go.length; i++) {
                        const l = t[i], f = [ 0, 0, 0 ];
                        let u = 0, d = 0;
                        const m = vo[go[i]];
                        for (let t = 0; t < n; t++) for (let i = 0; i < e; i++) {
                            r[0] = i / (e - 1) * 2 - 1, r[1] = t / (n - 1) * 2 - 1, r[2] = -1, h.normalize(r, r), 
                            o[0] = r[m[0]] * m[3], o[1] = r[m[1]] * m[4], o[2] = r[m[2]] * m[5], s[0] = l[d++] / 255, 
                            s[1] = l[d++] / 255, s[2] = l[d++] / 255;
                            const c = l[d++] / 255 * 7;
                            s[0] *= c, s[1] *= c, s[2] *= c, h.scaleAndAdd(f, f, s, mo(o, a) * -r[2]), u += -r[2];
                        }
                        h.scaleAndAdd(c, c, f, 1 / u);
                    }
                    i[a] = h.scale(c, c, 1 / 6);
                }
                return i;
            }(_o(t, l, n, !1, e.environmentExposure, !0), n, n);
            const i = [];
            for (let t = 0; t < u.length; t++) i.push(...u[t]);
            u = i;
        }
        const d = {
            envMap: a,
            isHDR: c,
            prefilterMap: l
        };
        return u && (d.sh = u), "array" === e.format && (d.envMap = {
            width: a.width,
            height: a.height,
            faces: _o(t, a, i, c)
        }, d.prefilterMap = {
            width: l.width,
            height: l.height,
            faces: f
        }, a.destroy(), l.destroy()), d;
    },
    generateDFGLUT: So,
    supportFloat16: To
});

const Oo = {
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "uvRotation": 0,
    "textureOrigin": null,
    "textureWidth": null,
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "emissiveFactor": [ 0, 0, 0 ],
    "baseColorIntensity": 1,
    "emitColorFactor": 1,
    "occlusionFactor": 1,
    "roughnessFactor": .4,
    "metallicFactor": 0,
    "normalMapFactor": 1,
    "specularF0": .5,
    "emitMultiplicative": 1,
    "normalMapFlipY": 0,
    "outputSRGB": 1,
    "baseColorTexture": null,
    "normalTexture": null,
    "occlusionTexture": null,
    "metallicRoughnessTexture": null,
    "emissiveTexture": null,
    "uvOrigin": [ 0, 0 ],
    "noiseTexture": null,
    "specularAAVariance": 20,
    "specularAAThreshold": 20,
    "hsv": [ 0, 0, 0 ],
    "contrast": 1,
    "bumpTexture": null,
    "bumpScale": .05,
    "bumpMinLayers": 5,
    "bumpMaxLayers": 20,
    "alphaTest": 0
};

class Eo extends Ie {
    constructor(t) {
        const e = E({}, Oo);
        (t.metallicRoughnessTexture || t.metallicRoughnessTexture) && (e.roughnessFactor = 1, 
        e.metallicFactor = 1), super(t, e);
    }
    appendDefines(t, e) {
        super.appendDefines(t, e);
        const n = this.uniforms, i = e.data[e.desc.positionAttribute];
        i.buffer && i.buffer.itemType && i.buffer.itemType.startsWith("sint") && (t.POSITION_IS_INT = 1);
        const r = e.data[e.desc.normalAttribute];
        r && r.buffer && r.buffer.itemType && r.buffer.itemType.startsWith("sint") && (t.NORMAL_IS_INT = 1), 
        n.GAMMA_CORRECT_INPUT && (t.GAMMA_CORRECT_INPUT = 1), e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1);
        if (e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, t.COLOR0_SIZE = e.getColor0Size()), 
        e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
        e.data.aVertexColorType && (t.HAS_VERTEX_COLOR = 1), !e.data[e.desc.uv0Attribute]) return t;
        n.baseColorTexture && (t.HAS_ALBEDO_MAP = 1), n.metallicRoughnessTexture && (t.HAS_METALLICROUGHNESS_MAP = 1), 
        n.occlusionTexture && e.data[e.desc.uv1Attribute] && (t.HAS_AO_MAP = 1), n.emissiveTexture && (t.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (t.HAS_NORMAL_MAP = 1), n.bumpTexture && (t.HAS_BUMP_MAP = 1), 
        n.skinTexture && (t.HAS_SKIN_MAP = 1), (t.HAS_ALBEDO_MAP || t.HAS_METALLICROUGHNESS_MAP || t.HAS_AO_MAP || t.HAS_EMISSIVE_MAP || t.HAS_NORMAL_MAP || t.HAS_BUMP_MAP || t.HAS_SKIN_MAP) && (t.HAS_MAP = 1), 
        n.noiseTexture && (t.HAS_RANDOM_TEX = 1), e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1);
        const s = n.alphaMode && n.alphaMode.toUpperCase();
        return "MASK" === s ? t.ALPHA_MODE = 1 : "OPAQUE" === s && (t.ALPHA_MODE = 2), t;
    }
}

class Io extends(De(Eo)){}

function Po(t, e, n) {
    if (n.ambientUpdate) {
        const {iblTexes: i} = t, r = n.target;
        i ? (ko(i), t.iblTexes = Ro(e, r)) : t.iblTexes = Ro(e, r), r.getRenderer().setToRedraw();
    }
}

const Ho = [ 0, 0 ];

function Ro(t, e) {
    const n = e.getLightManager(), i = n && n.getAmbientResource();
    if (!i) return null;
    const r = i.isHDR;
    return {
        "prefilterMap": t.cube({
            width: i.prefilterMap.width,
            height: i.prefilterMap.height,
            faces: i.prefilterMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: r ? "float16" : "uint8"
        }),
        "envMap": t.cube({
            width: i.envMap.width,
            height: i.envMap.height,
            faces: i.envMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: r ? "float16" : "uint8"
        }),
        "sh": i.sh
    };
}

function ko(t) {
    for (const e in t) t[e] && t[e].destroy && t[e].destroy(), delete t[e];
}

var No = Object.freeze({
    __proto__: null,
    createIBLTextures: Ro,
    disposeIBLTextures: ko,
    getIBLResOnCanvas: function(t) {
        const {dfgLUT: e, iblTexes: n} = t;
        return {
            dfgLUT: e,
            iblTexes: n
        };
    },
    getPBRUniforms: function(t, e, n, i, r) {
        const s = t.viewMatrix, o = t.projMatrix, a = t.cameraPosition, c = t.getRenderer().canvas, h = function(t, e) {
            const n = t.getLightManager(), i = n && n.getAmbientResource(), r = n && n.getAmbientLight() || {}, s = n && n.getDirectionalLight() || {};
            let o;
            if (i) {
                const t = e.prefilterMap.width, n = Math.log(t) / Math.log(2);
                o = {
                    "prefilterMap": e.prefilterMap,
                    "diffuseSPH": e.sh,
                    "prefilterMiplevel": [ n, n ],
                    "prefilterSize": [ t, t ],
                    "hdrHSV": r.hsv || [ 0, 0, 0 ]
                };
            } else o = {
                "ambientColor": r.color || [ .2, .2, .2 ]
            };
            return o.environmentExposure = P(r.exposure) ? r.exposure : 1, o.environmentOrientation = r.orientation || 0, 
            o.light0_diffuse = [ ...s.color || [ 1, 1, 1 ], 1 ], o.light0_viewDirection = s.direction || [ 1, 1, -1 ], 
            o;
        }(t, e), l = E({
            viewMatrix: s,
            projMatrix: o,
            projViewMatrix: t.projViewMatrix,
            cameraPosition: a,
            outSize: [ c.width, c.height ],
            cameraNearFar: [ t.cameraNear, t.cameraFar ]
        }, h);
        return l.brdfLUT = n, i && i.renderUniforms && E(l, i.renderUniforms), l.halton = r || Ho, 
        l;
    },
    isSupported: function(t) {
        return !!t.wgpu || t.hasExtension("EXT_shader_texture_lod");
    },
    loginIBLResOnCanvas: function(t, e, n) {
        if (!t.dfgLUT && (t.dfgLUT = So(e), t.dfgLUT.mtkRefCount = 0, n)) {
            const i = (...n) => Po.call(this, t, e, ...n);
            n.on("updatelights", i), t.Us = i;
        }
        t.dfgLUT.mtkRefCount++;
        const i = n.getLightManager();
        return i && i.getAmbientResource() ? (t.iblTexes || (t.iblTexes = Ro(e, n)), {
            dfgLUT: t.dfgLUT,
            iblTexes: t.iblTexes
        }) : {
            dfgLUT: t.dfgLUT,
            iblTexes: null
        };
    },
    logoutIBLResOnCanvas: function(t, e) {
        let n = !1;
        if (t.dfgLUT && (t.dfgLUT.mtkRefCount--, t.dfgLUT.mtkRefCount <= 0)) {
            if (n = !0, e) {
                const n = t.Us;
                e.off("updatelights", n);
            }
            t.dfgLUT.destroy(), delete t.dfgLUT;
        }
        t.iblTexes && n && (ko(t.iblTexes), delete t.iblTexes);
    }
});

class Do extends Br {
    constructor(t) {
        super({
            vert: "attribute vec3 aPosition;\nuniform mat4 lightProjViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vPosition;\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 d = getLineExtrudePosition(aPosition);\n  vec4 e = getPosition(d);\n#else\nvec4 e = getPosition(aPosition);\n#endif\ngl_Position = lightProjViewModelMatrix * c * e;\n  vPosition = gl_Position;\n}",
            frag: "#define SHADER_NAME vsm_mapping\nprecision highp float;\nvarying vec4 vPosition;\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\nvoid main() {\n  \n#if defined(USE_ESM)\n#ifdef PACK_FLOAT\ngl_FragColor = common_encodeDepth(gl_FragCoord.z);\n#else\ngl_FragColor = vec4(gl_FragCoord.z, .0, .0, 1.);\n#endif\n#endif\n}",
            uniforms: [ {
                name: "lightProjViewModelMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply([], e.lightProjViewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {},
            defines: t
        });
    }
    filter(t) {
        return t.castShadow;
    }
}

class Lo extends qr {
    constructor({blurOffset: t}) {
        super({
            vert: Vr,
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\n#include <common_pack_float>\nvoid main() {\n  float c = .0;\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      float f = common_decodeDepth(texture2D(textureSource, e));\n      float s = max(.0, sign(1. - f));\n      d += sign(f) * s;\n      c += f;\n    }\n  float h = c / max(1., d);\n  gl_FragColor = common_encodeDepth(h);\n}",
            defines: {
                "BOXBLUR_OFFSET": t || 2
            }
        }), this.zs = t || 2;
    }
    getMeshCommand(t, e) {
        const n = "box_shadow_blur_" + this.zs;
        return this.commands[n] || (this.commands[n] = this.createMeshCommand(t, e)), this.commands[n];
    }
}

let Fo = null, Uo = null;

class zo {
    constructor(t, {width: e, height: n, blurOffset: i, defines: r}) {
        this.renderer = t, this.width = e || 512, this.height = n || 512, this.blurOffset = T(i) ? 2 : i, 
        this.ts(r);
    }
    render(t, {cameraProjViewMatrix: e, lightDir: n, farPlane: i, cameraLookAt: r}) {
        return {
            lightProjViewMatrix: this.Gs(t, e, n, i, r),
            shadowMap: this.blurTex || this.depthTex,
            depthFBO: this.depthFBO,
            blurFBO: this.blurFBO
        };
    }
    resize(t, e) {
        return this.depthTex && (this.depthTex.resize(t, e), this.depthFBO.resize(t, e)), 
        this.width = t, this.blurFBO && (this.blurTex.resize(t, e), this.blurFBO.resize(t, e)), 
        this.height = e, this;
    }
    Gs(t, e, n, i, r) {
        const s = this.renderer, o = Fo(e);
        if (i) for (let t = 4; t < 8; t++) o[t] = i[t - 4];
        const a = Uo(r, o, n);
        return s.clear({
            color: [ 1, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.depthFBO
        }), s.render(this.shadowMapShader, {
            lightProjViewMatrix: a
        }, t, this.depthFBO), this.blurFBO && (this.boxBlurShader || (this.boxBlurShader = new Lo({
            blurOffset: this.blurOffset
        })), s.clear({
            color: [ 1, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.blurFBO
        }), s.render(this.boxBlurShader, {
            resolution: [ this.depthTex.width, this.depthTex.height ],
            textureSource: this.depthTex
        }, null, this.blurFBO)), a;
    }
    ts(t) {
        const e = this.renderer.device, n = "uint8", i = this.width, r = this.height;
        this.depthTex = e.texture({
            width: i,
            height: r,
            format: "rgba",
            type: n,
            min: "nearest",
            mag: "nearest"
        }), this.shadowMapShader = new Do(t), this.shadowMapShader.filter = t => t.castShadow, 
        this.depthFBO = e.framebuffer({
            color: this.depthTex
        }), this.blurOffset <= 0 || (this.blurTex = e.texture({
            width: i,
            height: r,
            format: "rgba",
            type: n,
            min: "linear",
            mag: "linear"
        }), this.blurFBO = e.framebuffer({
            color: this.blurTex
        }));
    }
    dispose() {
        this.depthTex && (this.depthTex.destroy(), this.depthFBO.destroy(), delete this.depthTex, 
        delete this.depthFBO), this.blurTex && (this.blurTex.destroy(), this.blurFBO.destroy(), 
        delete this.blurTex, delete this.blurFBO), this.shadowMapShader && (this.shadowMapShader.dispose(), 
        delete this.shadowMapShader), this.boxBlurShader && (this.boxBlurShader.dispose(), 
        delete this.boxBlurShader);
    }
}

Fo = function() {
    const t = [ [ -1, -1, -1, 1 ], [ 1, -1, -1, 1 ], [ 1, 1, -1, 1 ], [ -1, 1, -1, 1 ], [ -1, -1, 1, 1 ], [ 1, -1, 1, 1 ], [ 1, 1, 1, 1 ], [ -1, 1, 1, 1 ] ], e = new Array(16);
    return function(n) {
        c.invert(e, n);
        const i = [];
        for (let n = 0; n < t.length; n++) {
            const r = l.transformMat4([], t[n], e);
            l.scale(r, r, 1 / r[3]), i.push(r);
        }
        return i;
    };
}(), Uo = function() {
    let t = new Array(4);
    const e = new Array(3), n = [ 0, 0, 0, 0 ], i = [ 0, 1, 0 ], r = new Array(3);
    let s = new Array(16), o = new Array(16);
    const a = new Array(16), f = [ 1, 1, 1 ], u = [ 0, 0, 0 ];
    return function(d, m, v) {
        l.set(n, ...d, 1), h.scale(e, v, -1), s = c.lookAt(s, h.add(r, n, h.normalize(r, e)), n, i), 
        l.transformMat4(t, m[0], s);
        let g = t[2], p = t[2], x = t[0], _ = t[0], b = t[1], y = t[1];
        for (let e = 1; e < 8; e++) t = l.transformMat4(t, m[e], s), t[2] > p && (p = t[2]), 
        t[2] < g && (g = t[2]), t[0] > _ && (_ = t[0]), t[0] < x && (x = t[0]), t[1] > y && (y = t[1]), 
        t[1] < b && (b = t[1]);
        o = c.ortho(o, -1, 1, -1, 1, -p, -g);
        const w = f[0] = 2 / (_ - x), S = f[1] = -2 / (y - b);
        u[0] = -.5 * (x + _) * w, u[1] = -.5 * (b + y) * S, c.identity(a), c.translate(a, a, u), 
        c.scale(a, a, f);
        const A = c.multiply(o, a, o);
        return c.multiply(new Array(16), A, s);
    };
}();

class Go extends Br {
    constructor(t) {
        super({
            vert: "#define SHADER_NAME SHADOW_DISPLAY\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelViewMatrix;\nuniform vec2 halton;\nuniform vec2 globalTexSize;\nvarying vec4 vPosition;\n#include <vsm_shadow_vert>\nvoid main() {\n  vec4 c = vec4(aPosition, 1.);\n  vec4 d = modelViewMatrix * c;\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / globalTexSize.xy;\n  gl_Position = e * d;\n  vPosition = gl_Position;\n  shadow_computeShadowPars(c);\n}",
            frag: "#define SHADER_NAME SHADOW_DISPLAY\nprecision mediump float;\nuniform vec3 color;\n#include <vsm_shadow_frag>\nvoid main() {\n  float c = shadow_computeShadow();\n  float d = 1. - c;\n  gl_FragColor = vec4(color * d, d);\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    const n = [];
                    return c.multiply(n, e.viewMatrix, e.modelMatrix), n;
                }
            } ],
            defines: t || {
                "USE_ESM": 1
            },
            extraCommandProps: {
                depth: {
                    enable: !0,
                    mask: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (t, e) => e.globalTexSize[0],
                    height: (t, e) => e.globalTexSize[1]
                }
            }
        });
    }
    getMeshCommand(t, e) {
        return this.commands.shadow_display || (this.commands.shadow_display = this.createMeshCommand(t, e)), 
        this.commands.shadow_display;
    }
}

function Bo(t) {
    return 256 * t[2] * 256 + 256 * t[1] + t[0];
}

const Vo = new Uint8Array(4), jo = new Float32Array(Vo.buffer);

let Wo, qo;

const Xo = [ 1, 1 ], Ko = "\n    vec3 unpack(highp float f) {\n        highp vec3 color;\n        color.b = floor(f / 65536.0);\n        color.g = floor((f - color.b * 65536.0) / 256.0);\n        color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n        // now we have a vec3 with the 3 components in range [0..255]. Let's normalize it!\n        return color / 255.0;\n    }\n", $o = "\nfn unpack(f: f32) -> vec3f {\n    var color: vec3f;\n    color.b = floor(f / 65536.0);\n    color.g = floor((f - color.b * 65536.0) / 256.0);\n    color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n    return color / 255.0;\n}\n", Jo = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    uniform float fbo_picking_meshId;\n\n    ${Ko}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), fbo_picking_meshId / 255.0);\n    }\n`, Yo = `\n    ${$o}  // Assuming unpack function is defined in this include\n\n    struct PickingUniforms {\n        fbo_picking_meshId: f32,\n    };\n\n    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;\n\n    struct VertexOutput {\n        @location($i) vPickingId: f32,\n        @location($i) vFbo_picking_visible: f32,\n    };\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n\n        let rgb = unpack(vertexOutput.vPickingId);\n        let alpha = pickingUniforms.fbo_picking_meshId / 255.0;\n        return vec4f(rgb, alpha);\n        // return vec4f(1.0, 0.0, 0.0, 1.0);\n    }\n`, Zo = `\n    precision highp float;\n\n    uniform int fbo_picking_meshId;\n    varying float vFbo_picking_visible;\n\n    ${Ko}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(float(fbo_picking_meshId)), 1.0);\n        // gl_FragColor = vec4(unpack(float(35)), 1.0);\n    }\n`, Qo = `\n    ${$o}\n\n    struct PickingUniforms {\n        fbo_picking_meshId: f32,\n    };\n\n    @group(0) @binding(0) var<uniform> pickingUniforms: PickingUniforms;\n\n    struct VertexOutput {\n        @location($i) vFbo_picking_visible: f32,\n    };\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n\n        let meshIdFloat = pickingUniforms.fbo_picking_meshId;\n        let rgb = unpack(meshIdFloat);\n\n        return vec4f(rgb, 1.0);\n    }\n`, ta = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    ${Ko}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), 1.0);\n    }\n`, ea = `\n    ${$o}\n\n    struct VertexOutput {\n        @location($i) vPickingId: f32,\n        @location($i) vFbo_picking_visible: f32,\n    };\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n        let rgb = unpack(vertexOutput.vPickingId);\n        return vec4f(rgb, 1.0);\n    }\n`;

function na(t, e, n) {
    const i = e[0], r = e[1], s = e[2], o = 1 / (n[3] * i + n[7] * r + n[11] * s + n[15]);
    return t[0] = (n[0] * i + n[4] * r + n[8] * s + n[12]) * o, t[1] = (n[1] * i + n[5] * r + n[9] * s + n[13]) * o, 
    t[2] = (n[2] * i + n[6] * r + n[10] * s + n[14]) * o, t;
}

function ia(t) {
    return P(t) && (Xo[0] = Xo[1] = t, t = Xo), t;
}

const ra = t => t && t.geometry && void 0 === t.geometry.properties.shaderHash, sa = [], oa = [], aa = [ {
    name: "modelViewMatrix",
    type: "function",
    fn: (t, e) => c.multiply(sa, e.viewMatrix, e.modelMatrix)
}, {
    name: "modelViewProjMatrix",
    type: "function",
    fn: (t, e) => {
        const n = c.multiply(sa, e.viewMatrix, e.modelMatrix);
        return c.multiply(sa, e.projMatrix, n);
    }
}, {
    name: "modelMatrixInverse",
    type: "function",
    fn: (t, e) => c.invert(sa, e.modelMatrix)
}, {
    name: "projMatrixInverse",
    type: "function",
    fn: (t, e) => c.invert(sa, e.projMatrix)
}, {
    name: "modelViewMatrixInverse",
    type: "function",
    fn: (t, e) => (c.multiply(sa, e.viewMatrix, e.modelMatrix), c.invert(sa, sa))
}, {
    name: "modelViewProjMatrixInverse",
    type: "function",
    fn: (t, e) => {
        const n = c.multiply(sa, e.viewMatrix, e.modelMatrix);
        return c.multiply(sa, e.projMatrix, n), c.invert(sa, sa);
    }
}, {
    name: "modelInverseTransposeMatrix",
    type: "function",
    fn: (t, e) => {
        const n = f.fromMat4(oa, e.modelMatrix), i = f.transpose(n, n);
        return f.invert(i, i);
    }
}, {
    name: "modelViewInverseTransposeMatrix",
    type: "function",
    fn: (t, e) => {
        const n = c.multiply(sa, e.viewMatrix, e.modelMatrix), i = f.fromMat4(oa, n), r = f.transpose(i, i);
        return f.invert(r, r);
    }
} ], ca = {
    "LOCAL": "positionMatrix",
    "MODEL": "modelMatrix",
    "VIEW": "viewMatrix",
    "PROJECTION": "projMatrix",
    "MODELVIEW": "modelViewMatrix",
    "MODELVIEWPROJECTION": "modelViewProjMatrix",
    "MODELINVERSE": "modelMatrixInverse",
    "VIEWINVERSE": "viewMatrixInverse",
    "PROJECTIONINVERSE": "projMatrixInverse",
    "MODELVIEWINVERSE": "modelViewMatrixInverse",
    "MODELVIEWPROJECTIONINVERSE": "modelViewProjMatrixInverse",
    "MODELINVERSETRANSPOSE": "modelInverseTransposeMatrix",
    "MODELVIEWINVERSETRANSPOSE": "modelViewInverseTransposeMatrix",
    "VIEWPORT": "viewport",
    "JOINTMATRIX": "jointMatrix",
    "ALPHACUTOFF": "alphaCutoff"
};

class ha {
    constructor(t, e, n) {
        this.activeBuffer = null, this.device = t, this.usedBuffers = [], this.poolBuffers = [], 
        this.bufferSize = e, this.bufferAlignment = n;
    }
    destroy() {
        this.poolBuffers.forEach((t => {
            t.gpuBuffer.destroy();
        })), this.poolBuffers.length = 0, this.usedBuffers.length = 0, this.activeBuffer = null;
    }
    alloc(t, e) {
        if (this.activeBuffer) {
            const t = Ut(this.activeBuffer.size, this.bufferAlignment);
            this.bufferSize - t < e && this.scheduleSubmit();
        }
        this.activeBuffer || (this.activeBuffer = this.poolBuffers.pop(), this.activeBuffer || (this.activeBuffer = {
            gpuBuffer: this.createBuffer(this.device, this.bufferSize),
            storage: new ArrayBuffer(this.bufferSize),
            offset: 0,
            size: 0
        }), this.activeBuffer.offset = 0, this.activeBuffer.size = 0);
        const n = this.activeBuffer, i = Ut(n.size, this.bufferAlignment);
        t.gpuBuffer = n.gpuBuffer, t.offset = i, t.storage = n.storage, n.size = i + e;
    }
    createBuffer(t, e) {
        return t.createBuffer({
            size: e,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
    }
    scheduleSubmit() {
        this.activeBuffer && (this.usedBuffers.push(this.activeBuffer), this.activeBuffer = null);
    }
    submit() {
        this.scheduleSubmit();
        const t = this.usedBuffers.length;
        if (t) {
            const e = this.device, n = this.poolBuffers;
            for (let i = t - 1; i >= 0; i--) {
                const t = this.usedBuffers[i], {storage: r, gpuBuffer: s, offset: o, size: a} = t;
                e.queue.writeBuffer(s, 0, r, o, a), n.push(t);
            }
            this.usedBuffers.length = 0;
        }
    }
}

let la = 0;

class fa {
    constructor(t, e, n) {
        this.commandBuffers = [], this.Bs = {}, this.wgpu = t, this.adapter = n;
        const i = navigator.gpu.getPreferredCanvasFormat();
        e.configure({
            device: t,
            format: i,
            alphaMode: "premultiplied"
        }), this.context = e;
        const r = t.limits;
        this.dynamicBufferPool = new ha(t, 1048576, r.minUniformBufferOffsetAlignment);
    }
    hasExtension(t) {
        return this.Vs || (this.Vs = W(this.wgpu)), this.Vs[t], !0;
    }
    getCommandEncoder() {
        let t = this.commandEncoder;
        return t || (t = this.wgpu.createCommandEncoder(), this.commandEncoder = t), t;
    }
    endCommandEncoder() {
        const {commandEncoder: t} = this;
        if (t) {
            const e = t.finish();
            this.addCommandBuffer(e, !1), this.commandEncoder = null;
        }
    }
    getDefaultFramebuffer() {
        let t = this.js;
        if (!t) {
            const e = this.context.canvas;
            t = this.js = new ur(this, {
                width: e.width,
                height: e.height,
                depthStencil: !0
            }), t.uid = la++;
        }
        return t;
    }
    getRenderPassEncoder(t) {
        const e = (t = t || this.getDefaultFramebuffer()).getRenderPassDescriptor();
        return this.getCommandEncoder().beginRenderPass(e);
    }
    addCommandBuffer(t, e) {
        e ? this.commandBuffers.unshift(t) : this.commandBuffers.push(t);
    }
    submit() {
        this.endCommandEncoder(), this.dynamicBufferPool.submit(), this.commandBuffers.length > 0 && (this.wgpu.queue.submit(this.commandBuffers), 
        this.commandBuffers.length = 0);
    }
    buffer(t) {
        return qt.createBuffer(this, t, t.name);
    }
    framebuffer(t, e) {
        let n;
        return P(t) ? (void 0 === e && (e = t), n = {
            color: !0,
            depthStencil: !0,
            width: t,
            height: e
        }) : n = t, new ur(this, n);
    }
    texture(t) {
        return P(t) && (t = {
            width: t,
            height: t
        }), new fr(this, t);
    }
    clear(t) {
        (t.framebuffer || this.getDefaultFramebuffer()).setClearOptions(t);
    }
    read(t) {
        const e = t.framebuffer || this.js, n = e.width, i = e.height;
        let {width: r, height: s} = t;
        r || (r = n), s || (s = i);
        const o = this.wgpu;
        this.submit();
        const a = {
            x: t.x,
            y: i - t.y,
            z: 0
        };
        a.x + r > n && (a.x = n - r), a.y + s > i && (a.y = i - s);
        const c = t.pixels || new Uint8Array(r * s * 4);
        if (e === this.js) {
            const t = new OffscreenCanvas(r, s).getContext("2d", {
                willReadFrequently: !0
            });
            t.drawImage(this.context.canvas, a.x, a.y, r, s, 0, 0, r, s);
            const e = t.getImageData(0, 0, r, s).data;
            for (let t = 0; t < c.length; t += 4) c[t] = e[t], c[t + 1] = e[t + 1], c[t + 2] = e[t + 2], 
            c[t + 3] = e[t + 3];
            return c;
        }
        const h = [ "opaque", "premultiplied" ], l = h.map((() => new OffscreenCanvas(r, s)));
        return l.map(((t, e) => {
            const n = t.getContext("webgpu");
            return n.configure({
                device: o,
                format: "bgra8unorm",
                usage: GPUTextureUsage.COPY_DST,
                alphaMode: h[e]
            }), n.getCurrentTexture();
        })).map(((t, n) => {
            const i = o.createCommandEncoder();
            i.copyTextureToTexture({
                texture: e.colorTexture.texture,
                origin: a
            }, {
                texture: t
            }, {
                width: r,
                height: s
            }), this.wgpu.queue.submit([ i.finish() ]);
            const f = new OffscreenCanvas(r, s).getContext("2d", {
                willReadFrequently: !0
            });
            f.drawImage(l[n], 0, 0);
            const u = f.getImageData(0, 0, r, s).data, d = h[n];
            for (let t = 0; t < c.length; t += 4) "premultiplied" === d ? c[t + 3] = u[t + 3] : (c[t] = u[t], 
            c[t + 1] = u[t + 1], c[t + 2] = u[t + 2]);
        })), c;
    }
    destroy() {
        this.js && (this.js.destroy(), delete this.js);
        for (const t in this.Bs) {
            const e = this.Bs[t];
            e && e.destroy();
        }
        this.Bs = {};
    }
}

const ua = {
    parseHDR: Ri
}, da = {
    PBRHelper: Co,
    StandardMaterial: Eo,
    StandardSpecularGlossinessMaterial: Io,
    StandardShader: class extends Br {
        constructor(t = {}) {
            let e = t.extraCommandProps || {};
            const n = t.uniforms;
            e = E({}, e);
            const i = t.defines || {}, r = [], s = [], o = [], a = [], h = [], l = [ {
                name: "modelNormalMatrix",
                type: "function",
                fn: (t, e) => f.fromMat4(r, e.modelMatrix)
            }, {
                name: "modelViewNormalMatrix",
                type: "function",
                fn: (t, e) => {
                    const n = c.multiply(s, e.viewMatrix, e.modelMatrix), i = c.invert(n, n), r = c.transpose(i, i);
                    return f.fromMat4(o, r);
                }
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: (t, e) => c.multiply(a, e.viewMatrix, e.modelMatrix)
            }, {
                name: "environmentTransform",
                type: "function",
                global: !0,
                fn: (t, e) => {
                    const n = e.environmentOrientation || 0;
                    return f.fromRotation(h, Math.PI * n / 180);
                }
            } ];
            n && l.push(...n);
            super({
                name: "standard",
                vert: t.vert || "#include <gl2_vert>\n#define SHADER_NAME PBR\nattribute vec3 aPosition;\n#if defined(HAS_MAP) || defined(HAS_TERRAIN_FLAT_MASK)\nattribute vec2 aTexCoord;\n#include <common_pack_float>\n#endif\n#if defined(HAS_MAP)\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nuniform float uvRotation;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\nvec3 c;\nvec3 d;\nvec4 e;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform mediump vec3 cameraPosition;\nuniform mat3 modelNormalMatrix;\n#ifdef HAS_SSR\nuniform mat3 modelViewNormalMatrix;\nvarying vec3 vViewNormal;\n#ifdef HAS_TANGENT\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\nvarying vec3 vModelVertex;\n#if defined(HAS_MAP)\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\n#include <highlight_vert>\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\nvarying vec3 vColor0;\n#else\nattribute vec4 aColor0;\nvarying vec4 vColor0;\n#endif\n#endif\n#include <line_extrusion_vert>\n#include <get_output>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <heatmap_render_vert>\n#include <vertex_color_vert>\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#if __VERSION__ == 100\nmat3 f(in mat3 h) {\n  vec3 i = h[0];\n  vec3 j = h[1];\n  vec3 k = h[2];\n  return mat3(vec3(i.x, j.x, k.x), vec3(i.y, j.y, k.y), vec3(i.z, j.z, k.z));\n}\n#else\nmat3 f(in mat3 h) {\n  return transpose(h);\n}\n#endif\n#endif\nvoid l(const highp vec4 q, out highp vec3 m) {\n  m = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid l(const highp vec4 q, out highp vec3 m, out highp vec3 t) {\n  l(q, m);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\nconst float o = .5;\nvec2 u(vec2 v, float A) {\n  return vec2(cos(A) * (v.x - o) + sin(A) * (v.y - o) + o, cos(A) * (v.y - o) - sin(A) * (v.x - o) + o);\n}\n#if defined(HAS_MAP)\nvec2 B(vec2 v) {\n  vec2 C = decode_getTexcoord(v);\n#ifdef HAS_RANDOM_TEX\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale + uvOffset;\n  return mod(D, 1.) + E;\n#else\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale;\n  if(uvRotation != .0) {\n    D = u(D, uvRotation);\n    E = u(E, uvRotation);\n  }\n  return mod(D, 1.) + E + uvOffset;\n#endif\n}\n#endif\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <excavate_vert>\nvoid main() {\n  mat4 F = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 G = getLineExtrudePosition(aPosition);\n  vec4 H = getPosition(G);\n#else\nvec4 H = getPosition(aPosition);\n#endif\nvModelVertex = (modelMatrix * H).xyz;\n  vec4 I = F * H;\n  vec4 J = modelViewMatrix * I;\n  vViewVertex = J;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(I, modelMatrix);\n#else\ngl_Position = projMatrix * J;\n#endif\n#ifdef PICKING_MODE\nfloat K = 1.;\n#if defined(HAS_COLOR)\nK *= aColor.a;\n#endif\n#if defined(HAS_COLOR0) && COLOR0_SIZE == 4\nK *= aColor0.a;\n#endif\nfbo_picking_setData(gl_Position.w, K != .0);\n#else\n#if defined(HAS_MAP)\nvTexCoord = B(aTexCoord);\n#ifdef HAS_AO_MAP\nvTexCoord1 = B(aTexCoord1);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\n#endif\n#if defined(HAS_TANGENT) || defined(HAS_NORMAL)\nmat3 L = mat3(F);\n  mat3 M = modelNormalMatrix * L;\n#if defined(HAS_TANGENT)\nvec3 t;\n  l(aTangent, d, t);\n  vModelTangent = vec4(M * t, aTangent.w);\n#else\nd = decode_getNormal(aNormal);\n#endif\nvec3 N = d;\n  vModelNormal = M * N;\n#else\nd = vec3(.0);\n  vModelNormal = vec3(.0);\n#endif\n#if defined(HAS_TANGENT)\nvModelBiTangent = cross(vModelNormal, vModelTangent.xyz) * sign(aTangent.w);\n#endif\n#ifdef HAS_SSR\nmat3 O = modelViewNormalMatrix * L;\n  vViewNormal = O * d;\n#if defined(HAS_TANGENT)\nvec4 P = vec4(t, aTangent.w);\n  vViewTangent = vec4(O * P.xyz, P.w);\n#endif\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\nhighlight_setVarying();\n#if defined(HAS_COLOR0)\nvColor0 = aColor0 / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(I);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * F, H);\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nmat3 Q = f(mat3(vModelTangent.xyz, vModelBiTangent, vModelNormal));\n  vTangentViewPos = Q * cameraPosition;\n  vTangentFragPos = Q * vModelVertex;\n#endif\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nvCoordinateTexcoord = getCoordinateTexcoord(I);\n  vExcavateHeight = getWorldHeight(I);\n#endif\n#endif\n}",
                frag: t.frag || "#define PI 3.141593\n#define RECIPROCAL_PI 1.0\n#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\n#include <srgb_frag>\nuniform vec3 hsv;\nuniform float contrast;\nstruct MaterialUniforms {\n  vec2 roughnessMetalness;\n  vec3 albedo;\n  float alpha;\n  vec3 normal;\n  vec3 emit;\n  float ao;\n  vec3 specularColor;\n  float glossiness;\n  vec4 skinColor;\n} c;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\nuniform float glossinessFactor;\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\nuniform vec3 emissiveFactor;\nuniform vec4 baseColorFactor;\nuniform float baseColorIntensity;\nuniform float emitColorFactor;\nuniform float occlusionFactor;\nuniform float environmentExposure;\nuniform float roughnessFactor;\nuniform float metallicFactor;\nuniform float normalMapFactor;\nuniform float specularF0;\nuniform int emitMultiplicative;\nuniform int normalMapFlipY;\nuniform int outputSRGB;\nuniform mat3 environmentTransform;\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nuniform sampler2D metallicRoughnessTexture;\n#endif\n#if defined(HAS_EMISSIVE_MAP)\nuniform sampler2D emissiveTexture;\n#endif\n#if defined(HAS_AO_MAP)\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nuniform sampler2D normalTexture;\n#endif\n#if defined(HAS_SKIN_MAP)\nuniform sampler2D skinTexture;\n#endif\n#if defined(ALPHA_MODE) && ALPHA_MODE == 1\nuniform float alphaCutoff;\n#endif\n#ifdef HAS_RANDOM_TEX\nuniform highp vec2 uvOrigin;\nuniform sampler2D noiseTexture;\n#endif\nuniform sampler2D brdfLUT;\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\nuniform vec2 cameraNearFar;\nuniform vec3 light0_viewDirection;\nuniform vec4 light0_diffuse;\n#ifdef HAS_SSR\nvarying vec3 vViewNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelVertex;\nvarying vec4 vViewVertex;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vModelNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvarying vec3 vColor0;\n#else\nvarying vec4 vColor0;\n#endif\n#endif\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\nvarying float vOpacity;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\nuniform float currentTime;\nuniform float animSpeedScale;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatternGapColor;\nuniform vec2 uvScale;\nvarying float vPatternHeight;\nvarying float vLinesofar;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvec2 d(vec2 e) {\n  vec2 f = mod(e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#include <heatmap_render_frag>\n#include <snow_frag>\n#include <mask_frag>\n#include <terrain_normal_frag>\n#include <vertex_color_frag>\n#include <excavate_frag>\n#ifdef HAS_RANDOM_TEX\nconst float j = .5;\nvec2 k(vec2 f, float l) {\n  return vec2(cos(l) * (f.x - j) + sin(l) * (f.y - j) + j, cos(l) * (f.y - j) - sin(l) * (f.x - j) + j);\n}\nfloat m(vec3 n) {\n  return n.x + n.y + n.z;\n}\n#endif\nvec4 o(sampler2D u, in vec2 f) {\n  \n#ifdef HAS_RANDOM_TEX\nhighp vec2 A = uvOrigin;\n  highp vec2 B = f + A - mod(A, 1.);\n  float C = texture2D(noiseTexture, .005 * B).x;\n  vec2 D = dFdx(B);\n  vec2 E = dFdx(B);\n  float F = C * 8.;\n  float G = fract(F);\n#if 1\nfloat H = floor(F);\n  float I = H + 1.;\n#else\nfloat H = floor(F + .5);\n  float I = floor(F);\n  G = min(G, 1. - G) * 2.;\n#endif\nvec2 J = sin(vec2(3., 7.) * H);\n  vec2 K = sin(vec2(3., 7.) * I);\n  float L = .5;\n  vec4 M = texture2DGradEXT(u, f + L * J, D, E);\n  vec4 N = texture2DGradEXT(u, f + L * K, D, E);\n  return mix(M, N, smoothstep(.2, .8, G - .1 * m(M.xyz - N.xyz)));\n#else\nreturn texture2D(u, f);\n#endif\n}\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nuniform sampler2D bumpTexture;\nuniform float bumpScale;\nuniform float bumpMaxLayers;\nuniform float bumpMinLayers;\nvec2 O(vec2 f, vec3 P) {\n  float Q = mix(bumpMaxLayers, bumpMinLayers, abs(dot(vec3(.0, .0, 1.), P)));\n  float R = 1. / Q;\n  float S = .0;\n  vec2 T = P.xy * bumpScale / (P.z * Q);\n  vec2 U = f;\n  float V = o(bumpTexture, U).r;\n  for(int W = 0; W < 30; W++) {\n    S += R;\n    U -= T;\n    V = o(bumpTexture, U).r;\n    if(V < S) {\n      break;\n    }\n  }\n  vec2 X = U + T;\n  float Y = V - S;\n  float Z = o(bumpTexture, X).r - S + R;\n  return mix(U, X, Y / (Y - Z));\n}\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#endif\n#define SHADER_NAME PBR\nvec3 ba() {\n  return c.albedo;\n}\nfloat bb() {\n  return c.alpha;\n}\nfloat bc() {\n  return c.roughnessMetalness.y;\n}\nfloat bd() {\n  \n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn 1. - c.glossiness;\n#else\nreturn c.roughnessMetalness.x;\n#endif\n}\nvec3 be() {\n  return c.emit;\n}\nvec4 bf() {\n  return c.skinColor;\n}\nvec3 bg() {\n  return c.normal;\n}\nfloat bh() {\n  return c.ao;\n}\nfloat bi(const in vec4 bj) {\n  return bj.r + bj.g / 255.;\n}\nvec3 bk(const in float bl, in vec3 bm, const in vec3 t, const in vec3 b, in vec3 bn) {\n  bm.xy = bl * bm.xy;\n  mat3 bo = mat3(t, b, bn);\n  return normalize(bo * bm);\n}\nfloat bp(const float bq, const vec3 bm, const vec3 br) {\n  float bs = clamp(dot(bm, br), 0., 1.);\n  float a = bq * bq;\n  float bt = a * a;\n  float bu = (bs * bt - bs) * bs + 1.;\n  return bt / (PI * bu * bu);\n}\nvec3 bv(const vec3 bw, const float bx, const in vec3 by, const in vec3 br) {\n  float bz = clamp(dot(by, br), 0., 1.);\n  bz = pow(1. - bz, 5.);\n  return bx * bz + (1. - bz) * bw;\n}\nfloat bA(const in vec3 bm, const in vec3 bB, const in float bq, const float bC) {\n  float bD = clamp(dot(bm, bB), 0., 1.);\n  float a = bq * bq;\n  float bE = bD * (bC * (1. - a) + a);\n  float bF = bC * (bD * (1. - a) + a);\n  return .5 / (bF + bE);\n}\nvec3 bG(const float bq, const vec3 bm, const vec3 bB, const vec3 by, const vec3 bH, const float bC, const float bx) {\n  vec3 br = normalize(bB + by);\n  float bI = bp(bq, bm, br);\n  float bJ = bA(bm, bB, bq, bC);\n  vec3 bK = bv(bH, bx, by, br);\n  return (bI * bJ * PI) * bK;\n}\nvec3 bL(const in vec3 bM) {\n  return RECIPROCAL_PI * bM;\n}\nvoid bN(const in vec3 bm, const in vec3 bB, const in float bC, const in float bq, const in vec3 bO, const in vec3 bH, const in vec3 bP, const in vec3 by, const in float bx, out vec3 bQ, out vec3 bR) {\n  if(bC <= .0) {\n    bR = bQ = vec3(.0);\n    return;\n  }\n  vec3 a = bC * bP;\n  vec3 bS = bG(bq, bm, bB, by, bH, bC, bx);\n  bR = a * bS;\n  bQ = a * bL(bO);\n}\n#if defined(HAS_IBL_LIGHTING)\nvec3 bT(const in vec3 bm) {\n  vec3 bn = environmentTransform * bm;\n  float x = bn.x;\n  float y = bn.y;\n  float z = bn.z;\n  vec3 bU = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bU = hsv_apply(bU, hdrHSV);\n  }\n  return max(bU, vec3(.0));\n}\nvec3 bV(const in float bq, const in vec3 bW) {\n  vec3 bX = bW;\n  float bY = prefilterMiplevel.x;\n  float bZ = min(bY, bq * prefilterMiplevel.y);\n  vec3 ca = textureCubeLod(prefilterMap, bX, bZ).rgb;\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(ca, hdrHSV);\n  } else {\n    return ca;\n  }\n}\nvec3 cb(const in vec3 cc, const in vec3 bB, const in float bq, const in vec3 cd, const in vec3 bO) {\n  float ce = 1. - bq;\n  vec3 bW = mix(cc, reflect(-bB, cc), ce * (sqrt(ce) + bq));\n  float bl = clamp(1. + dot(bW, cd), .0, 1.);\n  vec3 cf = bV(bq, environmentTransform * bW) * bl * bl;\n  return cf;\n}\n#else\nvec3 cb(const in vec3 bm, const in vec3 cg, const in float bq, const in vec3 cd, const in vec3 bO) {\n  return ambientColor * bL(bO);\n}\n#endif\nvec3 ch(const in vec3 ci, const in float bq, const in float bD, const in float bx) {\n  vec4 rgba = texture2D(brdfLUT, vec2(bD, bq)) * vec4(255., 65280.0, 255., 65280.0);\n  float b = (rgba[3] + rgba[2]);\n  float a = (rgba[1] + rgba[0]);\n  return (ci * a + b * bx) / 65535.;\n}\nvec3 cj(const in vec3 bm, const in vec3 cg, const in float bD, const in float bq, const in vec3 bH, const in vec3 cd, const in float bx, const in vec3 bO) {\n  return cb(bm, cg, bq, cd, bO) * ch(bH, bq, bD, bx);\n}\nfloat ck(const in float cl, const in float bD) {\n  float bu = bD + cl;\n  return clamp(bu * bu - 1. + cl, .0, 1.);\n}\nvoid cm() {\n  \n#ifdef HAS_MAP\nvec2 f = computeTexCoord(vTexCoord);\n#endif\n#ifdef HAS_UV_FLIP\nf.y = 1. - f.y;\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nf = O(f, normalize(vTangentViewPos - vTangentFragPos));\n#endif\nc.albedo = baseColorIntensity * baseColorFactor.rgb;\n  c.alpha = baseColorFactor.a * vOpacity;\n#if defined(HAS_PATTERN)\nfloat cn = vLinesofar;\n  vec2 i = vTexInfo.zw;\n#ifdef HAS_PATTERN_GAP\nfloat co = vLinePatternGap;\n#else\nfloat co = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat cp = vLinePatternAnimSpeed;\n#else\nfloat cp = linePatternAnimSpeed;\n#endif\nfloat cq = ceil(i.x * vPatternHeight / i.y);\n  float cr = cq * (1. + co);\n  cp /= animSpeedScale;\n  cn += mod(currentTime * -cp * .2, cr);\n  float cs = mod(cn / cr, 1.);\n  float ct = mod(flipY * vNormalY, 1.);\n  vec2 f = d(vec2(cs * (1. + co) * uvScale[0], ct * uvScale[1]));\n  vec4 cu = texture2D(linePatternFile, f);\n  float cv = clamp(sign(1. / (1. + co) - cs) + .000001, .0, 1.);\n  cu = mix(linePatternGapColor, cu, cv);\n#ifdef IS_SQUARE_TUBE\nfloat n = clamp(sign(abs(vNormalY) - .999999), .0, 1.);\n  cu = mix(cu, vec4(1.), n);\n#endif\nc.albedo *= cu.rgb;\n  c.alpha *= cu.a;\n#endif\n#if defined(HAS_ALBEDO_MAP)\nvec4 cw = o(baseColorTexture, f);\n  c.albedo *= sRGBToLinear(cw.rgb);\n  c.alpha *= cw.a;\n#endif\n#if defined(HAS_SKIN_MAP)\nvec4 cx = o(skinTexture, f);\n  c.skinColor = cx;\n#endif\n#if defined(HAS_COLOR0)\nc.albedo *= vColor0.rgb;\n#if COLOR0_SIZE == 4\nc.alpha *= vColor0.a;\n#endif\n#endif\n#if defined(HAS_COLOR)\nc.albedo *= vColor.rgb;\n  c.alpha *= vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nc.albedo *= lineColor.rgb;\n  c.alpha *= lineColor.a;\n#else\nc.albedo *= polygonFill.rgb;\n  c.alpha *= polygonFill.a;\n#endif\n#if defined(HAS_INSTANCE_COLOR)\nc.albedo *= vInstanceColor.rgb;\n  c.alpha *= vInstanceColor.a;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nc.roughnessMetalness = o(metallicRoughnessTexture, f).gb * vec2(roughnessFactor, metallicFactor);\n#else\nc.roughnessMetalness = vec2(roughnessFactor, metallicFactor);\n#endif\nc.emit = emissiveFactor;\n#if defined(HAS_EMISSIVE_MAP)\nif(emitMultiplicative == 1) {\n    c.emit *= sRGBToLinear(o(emissiveTexture, f).rgb);\n  } else {\n    c.emit += sRGBToLinear(o(emissiveTexture, f).rgb);\n  }\n#endif\nc.emit *= emitColorFactor;\n#if defined(HAS_AO_MAP)\nvec2 cy = computeTexCoord(vTexCoord1);\n  c.ao = o(occlusionTexture, cy).r;\n#else\nc.ao = 1.;\n#endif\nc.ao *= occlusionFactor;\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nvec3 cz = o(normalTexture, f).xyz * 2. - 1.;\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#else\nc.normal = normalize(vModelNormal);\n#endif\n#if defined(HAS_TERRAIN_NORMAL) && defined(HAS_TANGENT)\nvec3 cz = convertTerrainHeightToNormalMap(f);\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#endif\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nc.albedo *= diffuseFactor.rgb;\n  c.alpha *= diffuseFactor.a;\n#if defined(HAS_DIFFUSE_MAP)\nvec4 cA = o(diffuseTexture, f);\n  c.albedo *= sRGBToLinear(cA.rgb);\n  c.alpha *= cA.a;\n#endif\nc.specularColor = specularFactor;\n  c.glossiness = glossinessFactor;\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nvec4 cB = o(specularGlossinessTexture, f);\n  c.specularColor *= sRGBToLinear(cB.rgb);\n  c.glossiness *= cB.a;\n#endif\n#endif\n}\nvec3 cC(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float cD = 2.43;\n  const float bu = .59;\n  const float cE = .14;\n  return (x * (a * x + b)) / (x * (cD * x + bu) + cE);\n}\nvec3 cF(vec3 cG) {\n  cG = cC(cG);\n  return cG = pow(cG, vec3(1. / 2.2));\n}\nuniform float specularAAVariance;\nuniform float specularAAThreshold;\nfloat cH(float bq, const vec3 cI) {\n  \n#if defined(GL_OES_standard_derivatives) || __VERSION__ == 300\nvec3 cJ = dFdx(cI);\n  vec3 cK = dFdy(cI);\n  float cL = specularAAVariance * (dot(cJ, cJ) + dot(cK, cK));\n  float cM = min(2. * cL, specularAAThreshold);\n  float cN = saturate(bq * bq + cM);\n  return sqrt(cN);\n#else\nreturn bq;\n#endif\n}\n#ifdef HAS_SSR\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nvec3 cO(const in mat4 cP, const in vec3 cQ) {\n  vec4 cR = cP * vec4(cQ, 1.);\n  return vec3(.5 + .5 * cR.xy / cR.w, cR.w);\n}\nvec3 cS(const in float cT, const in vec2 f) {\n  return texture2D(TextureReflected, f).rgb;\n}\nfloat cU(float cV) {\n  highp mat4 cP = projMatrix;\n  highp float z = cV * 2. - 1.;\n  return -cP[3].z / (z + cP[2].z);\n}\nfloat cW(const vec2 f) {\n  float cV = bi(texture2D(TextureDepth, f));\n  return cV;\n}\nfloat cX(const in vec2 cY, const in float cZ) {\n  vec3 da = vec3(.06711056, .00583715, 52.9829189);\n  return fract(da.z * fract(dot(cY.xy + cZ * vec2(47., 17.) * .695, da.xy))) * .5;\n}\nvec3 db(const in float cZ, const in vec3 dc, const in vec3 dd, const in vec3 de, const in vec3 cg, const in float df) {\n  vec2 dg;\n  dg.x = cX(gl_FragCoord.yx, cZ);\n  dg.y = fract(dg.x * 52.9829189);\n  dg.y = mix(dg.y, 1., .7);\n  float dh = 2. * 3.14159 * dg.x;\n  float di = pow(max(dg.y, .000001), df / (2. - df));\n  float dj = sqrt(1. - di * di);\n  vec3 dk = vec3(dj * cos(dh), dj * sin(dh), di);\n  dk = dk.x * dc + dk.y * dd + dk.z * de;\n  return normalize((2. * dot(cg, dk)) * dk - cg);\n}\nfloat dl(const in float cZ) {\n  return (cX(gl_FragCoord.xy, cZ) - .5);\n}\nvec3 dm(const in vec3 dn, const in float dp, const in vec3 dq) {\n  vec3 dr = cO(projMatrix, vViewVertex.xyz + dq * dp);\n  dr.z = 1. / dr.z;\n  dr -= dn;\n  float ds = min(1., .99 * (1. - dn.x) / max(1e-5, dr.x));\n  float dt = min(1., .99 * (1. - dn.y) / max(1e-5, dr.y));\n  float dw = min(1., .99 * dn.x / max(1e-5, -dr.x));\n  float dx = min(1., .99 * dn.y / max(1e-5, -dr.y));\n  return dr * min(ds, dt) * min(dw, dx);\n}\nfloat dy(const in vec3 dn, const in vec3 dr, inout float dz, inout float dA) {\n  float dB = (dA + dz) * .5;\n  vec3 dC = dn + dr * dB;\n  float z = cW(dC.xy);\n  float cV = cU(z);\n  float dD = -1. / dC.z;\n  dz = cV > dD ? dz : dB;\n  dA = cV > dD ? dB : dA;\n  return dB;\n}\nvec4 dE(const in vec3 dn, const in float dp, in float dF, const in vec3 dq, const in float bq, const in float cZ) {\n  int dG = 20;\n  float dH = 1. / float(dG);\n  dF *= dH;\n  vec3 dr = dm(dn, dp, dq);\n  float dI = dH;\n  vec3 dJ = vec3(.0, dI, 1.);\n  vec3 dC;\n  float z, cV, dD, dK, dL, dM;\n  bool dN;\n  float dO = 1.;\n  float dB;\n  for(int W = 0; W < dG; W++) {\n    dC = dn + dr * dJ.y;\n    z = cW(dC.xy);\n    cV = cU(z);\n    dD = -1. / dC.z;\n    float dP = clamp(sign(.999 - z), .0, 1.);\n    dK = dP * (dD - cV);\n    dK *= clamp(sign(abs(dK) - dp * dH * dH), .0, 1.);\n    dN = abs(dK + dF) < dF;\n    dL = clamp(dJ.x / (dJ.x - dK), .0, 1.);\n    dM = dN ? dJ.y + dL * dH - dH : 1.;\n    dJ.z = min(dJ.z, dM);\n    dJ.x = dK;\n    if(dN) {\n      float dz = dJ.y - dH;\n      float dA = dJ.y;\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dO = dB;\n      break;\n    }\n    dJ.y += dH;\n  }\n  return vec4(dn + dr * dO, 1. - dO);\n}\nvec4 dQ(in vec4 dR, const in float dS, const in vec3 dT, const in vec3 dU, const in float bq) {\n  vec4 dV = mix(outputFovInfo[0], outputFovInfo[1], dR.x);\n  dR.xyz = vec3(mix(dV.xy, dV.zw, dR.y), 1.) * -1. / dR.z;\n  dR.xyz = (reprojViewProjMatrix * vec4(dR.xyz, 1.)).xyw;\n  dR.xy /= dR.z;\n  float dW = clamp(6. - 6. * max(abs(dR.x), abs(dR.y)), .0, 1.);\n  dR.xy = .5 + .5 * dR.xy;\n  vec3 dX = dU * cS(bq * (1. - dR.w), dR.xy);\n  return vec4(mix(dT, dX, dS * dW), 1.);\n}\nvec3 ssr(const in vec3 dT, const in vec3 dU, const in float bq, const in vec3 bm, const in vec3 cg) {\n  float dY = .0;\n  vec4 bU = vec4(.0);\n  float df = bq * bq;\n  df = df * df;\n  vec3 dZ = abs(bm.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 dc = normalize(cross(dZ, bm));\n  vec3 dd = cross(bm, dc);\n  float dS = ssrFactor * clamp(-4. * dot(cg, bm) + 3.8, .0, 1.);\n  dS *= clamp(4.7 - bq * 5., .0, 1.);\n  vec3 dn = cO(projMatrix, vViewVertex.xyz);\n  dn.z = 1. / dn.z;\n  vec3 dq = db(dY, dc, dd, bm, cg, df);\n  float dp = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, dq.z * .5 + .5);\n  float dF = .5 * dp;\n  vec4 dR;\n  if(dot(dq, bm) > .001 && dS > .0) {\n    dR = dE(dn, dp, dF, dq, bq, dY);\n    if(dR.w > .0)\n      bU += dQ(dR, dS, dT, dU, bq);\n    \n  }\n  return bU.w > .0 ? bU.rgb / bU.w : dT;\n}\n#endif\n#include <highlight_frag>\nvec4 ea(in vec4 eb) {\n  return vec4(mix(pow(eb.rgb, vec3(.41666)) * 1.055 - vec3(.055), eb.rgb * 12.92, vec3(lessThanEqual(eb.rgb, vec3(.0031308)))), eb.a);\n}\nvec4 ec(vec4 eb) {\n  return (ea(eb));\n}\nvoid main() {\n  cm();\n  vec3 cg = normalize(cameraPosition - vModelVertex.xyz);\n#if defined(HAS_DOUBLE_SIDE)\nvec3 cd = gl_FrontFacing ? normalize(vModelNormal) : -normalize(vModelNormal);\n#else\nvec3 cd = normalize(vModelNormal);\n#endif\n#if defined(HAS_TANGENT)\nvec4 ed;\n  ed = vModelTangent;\n#if defined(HAS_DOUBLE_SIDE)\ned.xyz = gl_FrontFacing ? normalize(ed.xyz) : -normalize(ed.xyz);\n#else\ned.xyz = normalize(ed.xyz);\n#endif\nvec3 ee = normalize(vModelBiTangent);\n#endif\nfloat bw = .08 * specularF0;\n  float ef = bc();\n  vec3 bO = ba();\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nvec3 eg = c.specularColor;\n#else\nvec3 eg = mix(vec3(bw), bO, ef);\n#endif\nbO *= 1. - ef;\n  float eh = clamp(50.0 * eg.g, .0, 1.);\n  float ei = bd();\n  if(specularAAVariance > .0) {\n    ei = cH(ei, cd);\n  }\n  vec3 ej = be();\n  vec3 ek = bg();\n  vec3 el = vec3(ek);\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nel = bk(normalMapFactor, el, ed.xyz, ee, cd);\n#endif\nvec3 cA = vec3(.0);\n  vec3 bH = vec3(.0);\n#if defined(HAS_IBL_LIGHTING)\ncA = bO * bT(el) * .5;\n#else\ncA = bO * ambientColor;\n#endif\nfloat bD = dot(el, cg);\n  bH = cj(el, cg, bD, ei, eg, cd, eh, bO);\n  float em;\n  float en = 1.;\n  float eo = bh();\n  cA *= environmentExposure * eo;\n#ifdef HAS_IBL_LIGHTING\nen = ck(eo, bD);\n#endif\n#ifdef HAS_SSR\nvec3 ep = normalize(gl_FrontFacing ? vViewNormal : -vViewNormal);\n  vec3 eq = ep;\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nvec4 er;\n  er = vViewTangent;\n  er = gl_FrontFacing ? er : -er;\n  er.xyz = normalize(er.xyz);\n  vec3 es = normalize(cross(ep, er.xyz)) * er.w;\n  eq = bk(normalMapFactor, ek, er.xyz, es, ep);\n#endif\nbH = ssr(bH, eg * en, ei, eq, -normalize(vViewVertex.xyz));\n#endif\nbH *= environmentExposure * en;\n  vec3 et, eu;\n  vec3 ev = vModelNormal;\n  vec3 ew = -light0_viewDirection;\n  float ex = saturate(dot(ew, el));\n  bN(el, cg, ex, max(.045, ei), bO, eg, light0_diffuse.rgb, ew, eh, eu, et);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ey = shadow_computeShadow();\n  eu = shadow_blend(eu, ey).rgb;\n  et = shadow_blend(et, ey).rgb;\n#endif\ncA += eu;\n  bH += et;\n  cA += ej;\n  vec3 ez = bH + cA;\n  if(outputSRGB == 1)\n    ez = linearTosRGB(ez);\n  \n#ifdef HAS_SKIN_MAP\nvec4 eA = bf();\n  ez.rgb = ez.rgb * (1. - eA.a) + eA.rgb * eA.a;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nez.rgb = shadow_blend(ez.rgb, ey).rgb;\n#endif\n#endif\nfloat eB = bb();\n  if(eB < alphaTest) {\n    discard;\n  }\n#if defined(ALPHA_MODE)\n#if ALPHA_MODE == 1\nif(eB < alphaCutoff) {\n    discard;\n  } else {\n    eB = 1.;\n  }\n#else\neB = 1.;\n#endif\n#endif\n#if defined(IS_LINE_EXTRUSION)\neB *= lineOpacity;\n#else\neB *= polygonOpacity;\n#endif\nglFragColor = vec4(ez * eB, eB);\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nglFragColor = excavateColor(glFragColor);\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_SNOW\nglFragColor.rgb = snow(glFragColor, bg(), 1.);\n#endif\nif(contrast != 1.) {\n    glFragColor = contrastMatrix(contrast) * glFragColor;\n  }\n  if(length(hsv) > .0) {\n    glFragColor = hsv_apply(glFragColor, hsv);\n  }\n#ifdef OUTPUT_NORMAL\nglFragColor = vec4(cd, 1.);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                wgslVert: t.wgslVert || "",
                wgslFrag: t.wgslFrag || "",
                uniforms: l,
                extraCommandProps: e,
                defines: i
            }), this.version = 300;
        }
        getGeometryDefines(t) {
            const e = {};
            return t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
            t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1), t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, 
            e.COLOR0_SIZE = t.getColor0Size()), e;
        }
    },
    StandardDepthShader: class extends Br {
        constructor(t = {}) {
            const e = [];
            super({
                vert: "#define SHADER_NAME depth_vert\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform vec2 outSize;\nuniform vec2 halton;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec4 d = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 d = getPosition(aPosition);\n#endif\nvec4 e = modelViewMatrix * c * d;\n  mat4 f = projMatrix;\n  f[2].xy += halton.xy / outSize.xy;\n  gl_Position = f * e;\n}",
                frag: "#define SHADER_NAME depth_frag\nprecision highp float;\nvoid main() {\n  gl_FragColor = vec4(1., .0, .0, 1.);\n}",
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, n) => c.multiply(e, n.viewMatrix, n.modelMatrix)
                } ],
                extraCommandProps: t.extraCommandProps,
                defines: t.defines
            });
        }
    },
    PBRUtils: No
}, ma = ct;

ma.flatten = kt;

var va = Object.freeze({
    __proto__: null,
    AbstractTexture: rt,
    BloomPass: is,
    BoundingBox: at,
    BoxBlurShader: class extends qr {
        constructor({blurOffset: t}) {
            super({
                vert: Vr,
                frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\nuniform float ignoreTransparent;\nvoid main() {\n  vec4 c = vec4(.0);\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      vec4 f = texture2D(textureSource, e);\n      float h;\n      if(ignoreTransparent == 1.) {\n        h = sign(f.a);\n      } else {\n        h = 1.;\n      }\n      d += h;\n      c += h * f;\n    }\n  gl_FragColor = c / max(d, 1.) * clamp(sign(d - 1.), .0, 1.);\n}",
                defines: {
                    "BOXBLUR_OFFSET": t || 2
                },
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (t, e) => e.resolution[0],
                        height: (t, e) => e.resolution[1]
                    }
                }
            }), this.zs = t || 2;
        }
        getMeshCommand(t, e) {
            const n = "box_blur_" + this.zs;
            return this.commands[n] || (this.commands[n] = this.createMeshCommand(t, e)), this.commands[n];
        }
    },
    Constants: et,
    CopyShader: fs,
    EdgeGeometry: Te,
    EdgeShader: class extends Br {
        constructor(t = {}) {
            const e = [], n = t.uniforms, i = [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    return c.multiply(e, n.viewMatrix, n.modelMatrix);
                }
            } ];
            n && i.push(...n), super({
                vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n}",
                frag: "precision mediump float;\nuniform vec4 lineColor;\nuniform float lineOpacity;\nvoid main() {\n  gl_FragColor = lineColor;\n  gl_FragColor.a *= lineOpacity;\n}",
                uniforms: i,
                defines: t.defines || {},
                extraCommandProps: t.extraCommandProps || {}
            });
        }
    },
    ExtentPass: Cs,
    FBORayPicking: class {
        constructor(t, {name: e, vert: n, wgslVert: i, uniforms: r, defines: s, extraCommandProps: o, enableStencil: a}, c, h) {
            this.zi = t, this.ns = c, this.Ws = h, this.qs(c), this.Xs = e || "fboraypicking", 
            this.Ks = n, this.$s = i, this.zr = r, this.En = s, this.Js = E({}, o), delete this.Js.blend, 
            a ? this.Js.stencil = {
                enable: a,
                mask: 255,
                func: {
                    cmp: "<",
                    ref: 1,
                    mask: 255
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            } : delete this.Js.stencil, this.Ys = [], this.ts();
        }
        ts() {
            const t = [];
            this.zr && t.push(...this.zr);
            const e = {
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            };
            if (this.En) for (const t in this.En) e[t] = this.En[t];
            const n = this.Ks, i = this.$s, r = this.Js;
            this.Zs = new Br({
                name: this.Xs + "-0",
                vert: n,
                frag: Jo,
                wgslVert: i,
                wgslFrag: Yo,
                uniforms: t,
                defines: e,
                extraCommandProps: r
            }), this.Qs = new Br({
                name: this.Xs + "-2",
                vert: n,
                frag: ta,
                wgslVert: i,
                wgslFrag: ea,
                uniforms: t,
                defines: e,
                extraCommandProps: r
            });
            const s = {
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            };
            if (this.En) for (const t in this.En) s[t] = this.En[t];
            this.eo = new Br({
                name: this.Xs + "-1",
                vert: n,
                frag: Zo,
                wgslVert: i,
                wgslFrag: Qo,
                uniforms: t,
                defines: s,
                extraCommandProps: r
            }), this.no = new Br({
                name: this.Xs + "-depth",
                vert: n,
                frag: "\n    #ifdef GL_ES\n        precision highp float;\n    #endif\n    #if __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n        #extension GL_EXT_frag_depth : enable\n    #endif\n    #include <gl2_frag>\n    #include <common_pack_float>\n    varying float vFbo_picking_viewZ;\n    uniform float logDepthBufFC;\n    varying float vFbo_picking_fragDepth;\n\n    const float PackUpscale = 256. / 255.;\n    const float UnpackDownscale = 255. / 256.;\n    const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\n    const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\n    const float ShiftRight8 = 1. / 256.;\n    vec4 packDepthToRGBA(const in float v ) {\n        vec4 r = vec4(fract(v * PackFactors), v);\n        r.yzw -= r.xyz * ShiftRight8;\n        return r * PackUpscale;\n    }\n\n    void main() {\n        float fragDepth = vFbo_picking_fragDepth > 1.0 ? vFbo_picking_fragDepth : vFbo_picking_viewZ + 1.0;\n        #if __VERSION__ == 300 || __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n            gl_FragDepthEXT = log2(fragDepth) * logDepthBufFC * 0.5;\n        #endif\n        vec4 depthColor = packDepthToRGBA(fragDepth - 1.0);\n        glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n        #if __VERSION__ == 100\n            gl_FragColor = glFragColor;\n        #endif\n    }\n",
                wgslVert: i,
                wgslFrag: "\n    #include <common_pack_float>\n\n    struct DepthPackingUniforms {\n        logDepthBufFC: f32,\n    };\n\n    @group(0) @binding($b) var<uniform> depthPackingUniforms: DepthPackingUniforms;\n\n    struct VertexOutput {\n        @location($i) vFbo_picking_viewZ: f32,\n        @location($i) vFbo_picking_fragDepth: f32,\n    };\n\n    const PackUpscale = 256.0 / 255.0;\n    const UnpackDownscale = 255.0 / 256.0;\n    const PackFactors = vec3f(256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0);\n    const UnpackFactors = UnpackDownscale / vec4f(PackFactors, 1.0);\n    const ShiftRight8 = 1.0 / 256.0;\n\n    fn packDepthToRGBA(v: f32) -> vec4f {\n        var r = vec4f(fract(v * PackFactors), v);\n        // r.yzw -= r.xyz * ShiftRight8;\n        r = vec4f(r.x, r.yzw - r.xyz * ShiftRight8);\n        return r * PackUpscale;\n    }\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        let fragDepth = select(\n            vertexOutput.vFbo_picking_viewZ + 1.0,\n            vertexOutput.vFbo_picking_fragDepth,\n            vertexOutput.vFbo_picking_fragDepth > 1.0\n        );\n\n        let depthColor = packDepthToRGBA(fragDepth - 1.0);\n        var glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n\n        return glFragColor;\n    }\n",
                uniforms: t,
                defines: s,
                extraCommandProps: r
            }), this.rs = new Ti, this.io = new Ti;
        }
        filter() {
            return !0;
        }
        render(t, e, n = !1) {
            if (!t || !t.length) return this;
            const i = this.ns;
            n && this.clear(), t = t.filter((t => t && t.isValid && t.isValid())), this.rs.setMeshes(t);
            const r = this.ro(t, n);
            r.filter = this.filter, this.so && r !== this.so && this.clear(), this.so = r, t.forEach(((t, e) => {
                t.setUniform("fbo_picking_meshId", e + this.Ys.length);
            }));
            for (let e = 0; e < t.length; e++) this.Ys.push(t[e]);
            return this.zi.render(r, e, this.rs, i), this;
        }
        pickAll(t, e, n, i, r) {
            n = ia(n);
            const {meshIds: s, pickingIds: o, coords: a, points: c} = this.oo(t, e, n, i, r), h = [];
            if (o && s) {
                const t = {};
                for (let e = 0; e < s.length; e++) {
                    const n = `${o[e]}_${s[e]}`;
                    null == s[e] || null == o[e] || t[n] || (t[n] = !0, h.push({
                        meshId: s[e],
                        pickingId: o[e],
                        point: c[e] || null,
                        coordinate: a[e] || null
                    }));
                }
            }
            return h;
        }
        pick(t, e, n, i, r = {}) {
            n = ia(n);
            const {meshIds: s, pickingIds: o, width: a, coords: c, points: h} = this.oo(t, e, n, i, r);
            if (o && s) {
                const t = [];
                for (let e = 0; e <= n[0]; e++) t.push(e), e > 0 && t.push(-e);
                for (let e = 0; e < t.length; e++) for (let i = 0; i < t.length; i++) {
                    const r = (t[i] + n[1]) * a + (t[e] + n[0]);
                    if (null != s[r]) return {
                        meshId: s[r],
                        pickingId: o[r],
                        point: h[r] || null,
                        coordinate: c[r] || null
                    };
                }
            }
            return {
                pickingId: null,
                meshId: null,
                point: null
            };
        }
        oo(t, e, n, i, r = {}) {
            const s = this.so, o = this.Ys;
            if (!s || !o || !o.length) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            t = Math.round(t), e = Math.round(e);
            const a = this.ns;
            if (t <= 2 || t >= a.width - 2 || e <= 2 || e >= a.height - 2) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            const {px: c, py: h, width: l, height: f} = this.ao(t, e, n, a), u = new Uint8Array(4 * l * f), d = this.zi.device.read({
                data: u,
                x: c,
                y: h,
                framebuffer: a,
                width: l,
                height: f
            }), m = [];
            let v = [];
            for (let t = 0; t < d.length; t += 4) {
                const {pickingId: e, meshId: n} = this.co(d.subarray(t, t + 4), s);
                m.push(n), v.push(e);
            }
            const g = {}, p = m.filter((t => null != t && !g[t] && (g[t] = 1, !0))).map((t => o[t]));
            let x;
            for (let t = 0; t < p.length; t++) if (p[t] && p[t].geometry) {
                x = p[t];
                break;
            }
            if (!x) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            const _ = x.geometry.desc.pickingIdAttribute;
            m.length && s === this.eo && (void 0 !== x.getUniform("uPickingId") || x.geometry.data[_]) && (v = this.ho(c, h, l, f, u, p, i));
            const b = [], y = [];
            if (m.length && r.returnPoint) {
                const {viewMatrix: n, projMatrix: s} = r, o = this.lo(c, h, l, f, u, p, i);
                for (let i = 0; i < o.length; i++) if (o[i] && null != m[i]) {
                    const r = this.fo(t, e, o[i], n, s), a = this.uo(r);
                    b.push(r), y.push(a);
                } else b.push(null), y.push(null);
            }
            return {
                meshIds: m,
                pickingIds: v,
                coords: y,
                points: b,
                width: l,
                height: f
            };
        }
        uo(t) {
            const e = this.Ws;
            if (!e) return null;
            const n = e.getGLRes();
            if (!Wo) {
                const t = e.getCenter();
                qo = new t.constructor(0, 0, 0);
                const n = e.coordToPoint(t);
                Wo = new n.constructor(0, 0);
            }
            Wo.set(t[0], t[1]);
            const i = e.pointAtResToCoord(Wo, n, qo), r = e.pointAtResToAltitude(t[2], n);
            return [ i.x, i.y, r ];
        }
        clear() {
            return this.ns && this.qs(this.ns), this.Ys = [], delete this.so, this;
        }
        getMeshAt(t) {
            return this.Ys ? this.Ys[t] : null;
        }
        getRenderedMeshes() {
            return this.Ys;
        }
        dispose() {
            this.clear(), this.Zs && this.Zs.dispose(), this.eo && this.eo.dispose(), this.Qs && this.Qs.dispose(), 
            this.rs && this.rs.clear(), this.io && this.io.clear();
        }
        fo(t, e, n, i, r) {
            const s = this.ns, o = [], a = s.width / 2 || 1, h = s.height / 2 || 1, l = [ (t - a) / a, (h - e) / h, 0, 1 ], f = [ (t - a) / a, (h - e) / h, 1, 1 ], u = c.invert(o, r), d = [], m = [];
            na(d, l, u), na(m, f, u);
            const v = -d[2], g = (n - v) / (-m[2] - v), p = c.multiply(o, r, i), x = c.invert(o, p), _ = na(l, l, x), b = na(f, f, x);
            return [ H(_[0], b[0], g), H(_[1], b[1], g), H(_[2], b[2], g) ];
        }
        ho(t, e, n, i, r, s, o) {
            const a = this.zi.device, c = this.mo();
            this.qs(c), this.io.setMeshes(s), this.zi.render(this.Qs, o, this.io, c);
            const h = a.read({
                data: r,
                x: t,
                y: e,
                framebuffer: c,
                width: n,
                height: i
            }), l = [];
            for (let t = 0; t < h.length; t += 4) l.push(Bo(h.subarray(t, t + 4)));
            return l;
        }
        lo(t, e, n, i, r, s, o) {
            const a = this.zi.device, c = this.mo();
            this.io.setMeshes(s), this.qs(c), o.logDepthBufFC = 2 / (Math.log(this.Ws.cameraFar + 1) / Math.LN2), 
            this.zi.render(this.no, o, this.io, c);
            const h = a.read({
                data: r,
                x: t,
                y: e,
                framebuffer: c,
                width: n,
                height: i
            }), l = [];
            for (let t = 0; t < h.length; t += 4) l.push((f = h.subarray(t, t + 4), Vo[0] = f[3], 
            Vo[1] = f[2], Vo[2] = f[1], Vo[3] = f[0], jo[0]));
            var f;
            return l;
        }
        co(t, e) {
            if (255 === t[0] && 255 === t[1] && 255 === t[2] && 255 === t[3]) return {
                meshId: null,
                pickingId: null
            };
            let n = null, i = null;
            return e === this.eo ? i = Bo(t) : e === this.Zs ? (i = t[3], n = Bo(t)) : (i = null, 
            n = Bo(t)), {
                meshId: i,
                pickingId: n
            };
        }
        qs(t) {
            this.zi.device.clear({
                color: [ 1, 1, 1, 1 ],
                depth: 1,
                stencil: 255,
                framebuffer: t
            });
        }
        ro(t, e) {
            return e && t.length < 256 ? this.Zs : this.eo;
        }
        mo() {
            const t = this.zi.device, e = this.ns;
            return this.vo ? this.vo.width === e.width && this.vo.height === e.height || this.vo.resize(e.width, e.height) : this.vo = t.framebuffer(e.width, e.height), 
            this.vo;
        }
        ao(t, e, n, i) {
            const r = n[0], s = n[1];
            t -= r, e = i.height - e;
            let o = 2 * r + 1, a = 2 * s + 1;
            const c = t + o, h = (e -= s) + a;
            return c > i.width && (o -= c - i.width), h > i.height && (a -= h - i.height), {
                px: t = t < 0 ? 0 : t,
                py: e = e < 0 ? 0 : e,
                width: o,
                height: a
            };
        }
        getPickingVert() {
            return this.Ks;
        }
        getPickingWGSLVert() {
            return this.$s;
        }
        getUniformDeclares() {
            return this.zr;
        }
    },
    FogPass: gs,
    FogShader: ps,
    FxaaShader: Xr,
    GLTFHelper: Ys,
    GLTFManager: class {
        constructor(t, e) {
            this.regl = t, this.resourceMap = {}, this.options = e || {};
        }
        getGLTF(t) {
            return this.resourceMap[t];
        }
        loginGLTF(t, e) {
            if (this.resourceMap[t]) this.resourceMap[t].refCount += 1; else {
                if (ro[t]) {
                    const e = function(t) {
                        let e = null;
                        return ro[t] && (e = {
                            meshes: ro[t].meshes
                        }, e.scenes = JSON.parse(JSON.stringify(ro[t].scenes))), e;
                    }(t);
                    this.resourceMap[t] = this.po(e, t, !1);
                } else this.resourceMap[t] = e ? e(t).then((e => (this.resourceMap[t] = this.po(e, t), 
                this.resourceMap[t]))) : this.xo(t);
                this.resourceMap[t].refCount = 1;
            }
        }
        logoutGLTF(t) {
            if (this.resourceMap[t] && (this.resourceMap[t].refCount -= 1, this.resourceMap[t].refCount < 1)) {
                const e = this.resourceMap[t].resources;
                if (e) for (let t = 0; t < e.length; t++) e[t].geometry.dispose(), e[t].copyGeometry && e[t].copyGeometry.dispose(), 
                e[t].material && e[t].material.dispose();
                this.resourceMap[t].gltfPack && this.resourceMap[t].gltfPack.dispose(), delete this.resourceMap[t];
            }
        }
        isSimpleModel(t) {
            return ro[t];
        }
        addSimpleModel(t, e) {
            !function(t, e) {
                "string" == typeof t && io.indexOf(t) < 0 && (ro[t] = e);
            }(t, e);
        }
        removeSimpleModel(t) {
            delete ro[t];
        }
        po(t, e, n = !0) {
            if (!t) return null;
            const i = $s(t, n ? this.regl : null), r = i.getMeshesInfo();
            return {
                bbox: i.getGLTFBBox(),
                gltfPack: i,
                resources: r,
                json: t.json,
                refCount: this.resourceMap[e] ? this.resourceMap[e].refCount : 0
            };
        }
        fetchGLTF(t) {
            return Ks(t, this.options).then((t => t));
        }
        xo(t) {
            return this.fetchGLTF(t).then((e => (this.resourceMap[t] = this.po(e, t), this.resourceMap[t])));
        }
    },
    Geometry: qt,
    GraphicsDevice: fa,
    GraphicsFramebuffer: ur,
    GraphicsTexture: fr,
    HDR: ua,
    HeatmapDisplayShader: ls,
    HeatmapShader: os,
    ImageShader: Jr,
    InstancedMesh: vi,
    Jitter: es,
    KHRTechniquesWebglManager: class {
        constructor(t, e, n) {
            this.p = t, this._o = {}, this.bo = e, this.yo = n;
        }
        getExcludeFilter() {
            return ra;
        }
        forEachShader(t) {
            for (const e in this._o) {
                const n = this._o[e];
                t(n.shader, n.filter, n.uniformSemantics);
            }
        }
        createMesh(t, e, n, i) {
            const r = e.extensions.KHR_techniques_webgl, s = e.materials[t.material].extensions.KHR_techniques_webgl, {technique: o, values: a} = s, c = r.techniques[o], h = r.programs[c.program], l = r.shaders[h.vertexShader], f = r.shaders[h.fragmentShader];
            f.content = function(t) {
                if (t && t.indexOf("precision") < 0) return "precision mediump float;\n" + t;
                return t;
            }(f.content);
            const u = q(l.content) + "-" + q(f.content);
            this._o[u] || (this._o[u] = this.wo(u, r, o, this.bo, i));
            const {attributeSemantics: d} = this._o[u], m = this.So(t, d, n, u), v = E({}, a);
            for (const t in a) if (c.uniforms[t] && 35678 === c.uniforms[t].type) {
                const n = a[t].index, i = e.textures[n];
                v[t] = this.Ns(i);
            }
            return {
                geometry: m,
                material: new Ie(v)
            };
        }
        So(t, e, n, i) {
            const r = t.attributes, s = "COLOR_0";
            if (r[s]) {
                const t = r[s].array || r[s];
                if (t instanceof Float32Array) {
                    const e = new Uint8Array(t.length);
                    for (let n = 0; n < e.length; n++) e[n] = Math.round(255 * t[n]);
                    r[s].array ? (r[s].array = e, r[s].componentType = 5121) : r[s] = e;
                }
            }
            const o = {};
            for (const t in r) {
                const n = ge(this.p, r[t], {
                    dimension: r[t].itemSize,
                    name: t
                }), i = e[t] || t;
                o[i] = {
                    buffer: n
                }, r[t].quantization && (o[i].quantization = r[t].quantization), i === e.POSITION && (o[i].array = r[t].array);
            }
            const a = new qt(o, t.indices.array ? t.indices.array : t.indices, 0, {
                positionAttribute: e.POSITION,
                normalAttribute: e.NORMAL,
                uv0Attribute: e.TEXCOORD_0,
                uv1Attribute: e.TEXCOORD_1,
                color0Attribute: e.COLOR_0,
                tangentAttribute: e.TANGENT,
                textureCoordMatrixAttribute: e.TextureCoordMatrix,
                primitive: void 0 === t.mode ? "triangles" : ne(t.mode)
            });
            a.generateBuffers(this.p, {
                excludeElementsInVAO: n
            }), a.properties.shaderHash = i;
            const c = a.data[a.desc.positionAttribute];
            return c && c.array && delete c.array, a;
        }
        Ns(t) {
            const e = {
                type: t.type ? re(t.type) : "uint8",
                format: t.format ? ae(t.format) : "rgba",
                flipY: !!t.flipY
            }, n = t.image;
            n.array ? e.data = n.array : n.mipmap && (e.mipmap = n.mipmap), e.width = n.width, 
            e.height = n.height;
            const i = t.sampler || t.texture.sampler;
            return i && (i.magFilter && (e.mag = he(i.magFilter)), i.minFilter && (e.min = fe(i.minFilter)), 
            i.wrapS && (e.wrapS = de(i.wrapS)), i.wrapT && (e.wrapT = de(i.wrapT))), new Gi(e, this.yo);
        }
        wo(t, e, n, i, r) {
            const {techniques: s, programs: o, shaders: a} = e, c = s[n], h = o[c.program], l = a[h.vertexShader].content, f = a[h.fragmentShader].content, u = {};
            for (const t in c.uniforms) {
                const e = c.uniforms[t];
                e.semantic && (u[e.semantic] = t);
            }
            const d = aa.slice();
            for (const t in u) {
                const e = u[t];
                d.push({
                    name: e,
                    type: "function",
                    fn: (e, n) => n[ca[t]]
                });
            }
            const m = new Br({
                vert: l,
                frag: f,
                uniforms: d,
                extraCommandProps: i
            });
            r && (m.version = 300);
            const v = {};
            for (const t in c.attributes) {
                v[c.attributes[t].semantic] = t;
            }
            return {
                shader: m,
                filter: e => e && e.geometry && e.geometry.properties.shaderHash === t,
                uniformSemantics: u,
                attributeSemantics: v
            };
        }
        dispose() {
            for (const t in this._o) {
                const {shader: e} = this._o[t];
                e.dispose();
            }
            this._o = {};
        }
    },
    Material: Ie,
    Mesh: mi,
    MeshShader: Br,
    PhongMaterial: Re,
    PhongShader: class extends Br {
        constructor(t = {}) {
            const e = [], n = [], i = t.uniforms, r = [ {
                name: "modelNormalMatrix",
                type: "function",
                fn: function(t, n) {
                    return f.fromMat4(e, n.modelMatrix);
                }
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(n, e.viewMatrix, e.modelMatrix);
                }
            } ];
            i && r.push(...i), super({
                name: "phong",
                vert: t.vert || "#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nvarying vec3 vFragPos;\nvarying vec3 vNormal;\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <highlight_vert>\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nattribute float aExtrusionOpacity;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_TANGENT)\nvarying vec4 vTangent;\n#endif\nvoid c(const highp vec4 q, out highp vec3 d) {\n  d = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid c(const highp vec4 q, out highp vec3 d, out highp vec3 t) {\n  c(q, d);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\n#include <vertex_color_vert>\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 e = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 e = getPosition(aPosition);\n#endif\nmat4 f = getPositionMatrix();\n  vFragPos = vec3(modelMatrix * f * e);\n#if defined(HAS_NORMAL) || defined(HAS_TANGENT)\nmat3 h = modelNormalMatrix * mat3(f);\n  vec3 i;\n#if defined(HAS_TANGENT)\nvec3 t;\n  c(aTangent, i, t);\n  vTangent = vec4(h * t, aTangent.w);\n#else\ni = decode_getNormal(aNormal);\n#endif\nvec3 j = appendMorphNormal(i);\n  vNormal = normalize(h * j);\n#else\nvNormal = vec3(.0);\n#endif\nmat4 k = projMatrix;\n  k[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = k * getMaskPosition(f * e, modelMatrix);\n#else\ngl_Position = k * modelViewMatrix * f * e;\n#endif\n#ifdef HAS_MAP\nvec2 l = decode_getTexcoord(aTexCoord);\n  vTexCoord = l * uvScale + uvOffset;\n#endif\n#ifdef HAS_AO_MAP\nvec2 m = decode_getTexcoord(aTexCoord1);\n  vTexCoord1 = m * uvScale + uvOffset;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nvExtrusionOpacity = aExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(f * e);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * f, e);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n}",
                frag: t.frag || "precision mediump float;\n#include <gl2_frag>\nuniform vec4 baseColorFactor;\nuniform float materialShininess;\nuniform float environmentExposure;\nuniform float specularStrength;\nuniform vec3 light0_viewDirection;\nuniform vec3 ambientColor;\nuniform vec4 light0_diffuse;\nuniform vec3 lightSpecular;\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#ifdef HAS_TOON\nuniform float toons;\nuniform float specularToons;\n#endif\n#ifdef HAS_TANGENT\nvarying vec4 vTangent;\n#endif\n#ifdef HAS_MAP\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vNormal;\nvarying vec3 vFragPos;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nuniform vec2 extrusionOpacityRange;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_AO_MAP\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#include <heatmap_render_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#include <mask_frag>\n#include <vertex_color_frag>\nvec3 c() {\n  \n#if defined(HAS_NORMAL_MAP)\nvec3 d = normalize(vNormal);\n  vec3 e = texture2D(normalTexture, computeTexCoord(vTexCoord)).xyz * 2. - 1.;\n#if defined(HAS_TANGENT)\nvec3 t = normalize(vTangent.xyz);\n  vec3 b = normalize(cross(d, t) * sign(vTangent.w));\n  mat3 f = mat3(t, b, d);\n  return normalize(f * e);\n#else\nreturn normalize(e);\n#endif\n#else\nreturn normalize(vNormal);\n#endif\n}\nvec4 h() {\n  \n#if defined(HAS_BASECOLOR_MAP)\nreturn texture2D(baseColorTexture, computeTexCoord(vTexCoord));\n#elif defined(HAS_DIFFUSE_MAP)\nreturn texture2D(diffuseTexture, computeTexCoord(vTexCoord));\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn diffuseFactor;\n#else\nreturn baseColorFactor;\n#endif\n}\nvec3 i() {\n  \n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn specularFactor;\n#else\nreturn vec3(1.);\n#endif\n}\nvoid main() {\n  vec4 j = h();\n#ifdef SHADING_MODEL_UNLIT\nvec3 k = vec3(1.);\n#else\nvec3 k = ambientColor;\n#endif\nvec3 l = environmentExposure * k * j.rgb;\n#ifdef HAS_INSTANCE_COLOR\nl *= vInstanceColor.rgb;\n#endif\nvec3 m = c();\n  vec3 o = normalize(-light0_viewDirection);\n  float u = max(dot(m, o), .0);\n#ifdef HAS_TOON\nfloat v = floor(u * toons);\n  u = v / toons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 A = vec3(.0);\n#else\nvec3 A = light0_diffuse.rgb;\n#endif\nvec3 B = A * u * j.rgb;\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvec3 C = vColor.rgb;\n#elif defined(IS_LINE_EXTRUSION)\nvec3 C = lineColor.rgb;\n#else\nvec3 C = polygonFill.rgb;\n#endif\n#ifdef HAS_INSTANCE_COLOR\nC *= vInstanceColor.rgb;\n#endif\nl *= C.rgb;\n  B *= C.rgb;\n  vec3 D = normalize(cameraPosition - vFragPos);\n  vec3 E = normalize(o + D);\n  float F = pow(max(dot(m, E), .0), materialShininess);\n#ifdef HAS_TOON\nfloat G = floor(F * specularToons);\n  F = G / specularToons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 H = vec3(.0);\n#else\nvec3 H = lightSpecular;\n#endif\nvec3 I = specularStrength * H * F * i();\n#ifdef HAS_OCCLUSION_MAP\nfloat J = texture2D(occlusionTexture, computeTexCoord(vTexCoord1)).r;\n  l *= J;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat K = shadow_computeShadow();\n  B = shadow_blend(B, K).rgb;\n  I = shadow_blend(I, K).rgb;\n  l = shadow_blend(l, K).rgb;\n#endif\nvec3 L = l + B + I;\n#ifdef HAS_EMISSIVE_MAP\nvec3 M = texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n  L += M;\n#endif\n#ifdef IS_LINE_EXTRUSION\nglFragColor = vec4(L, lineOpacity * j.a);\n#else\nglFragColor = vec4(L, polygonOpacity * j.a);\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nfloat N = vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nfloat N = lineColor.a;\n#else\nfloat N = polygonFill.a;\n#endif\nglFragColor *= N;\n#ifdef HAS_EXTRUSION_OPACITY\nfloat O = extrusionOpacityRange.x;\n  float P = extrusionOpacityRange.y;\n  float Q = O + vExtrusionOpacity * (P - O);\n  Q = clamp(Q, .0, 1.);\n  glFragColor *= Q;\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                wgslVert: "",
                wgslFrag: "",
                uniforms: r,
                defines: t.defines || {},
                extraCommandProps: t.extraCommandProps || {}
            }), this.version = 300;
        }
        getGeometryDefines(t) {
            const e = {};
            return t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
            e;
        }
    },
    PhongSpecularGlossinessMaterial: Le,
    Plane: Bi,
    PointLineShader: class extends Br {
        constructor(t = {}) {
            const e = [];
            super({
                vert: "attribute vec3 aPosition;\n#ifdef HAS_COLOR0\nattribute vec4 aColor0;\nvarying vec4 vColor;\n#endif\nuniform mat4 modelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float pointSize;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#endif\n#include <get_output>\n#include <heatmap_render_vert>\n#ifdef HAS_FLOODANALYSE\nvarying float vHeight;\n#endif\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_PointSize = pointSize;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * d * c;\n#endif\n#ifdef HAS_COLOR0\nvColor = aColor0 / 255.;\n#endif\n#ifdef HAS_MAP\nvTexCoord = aTexCoord;\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * d, c);\n#endif\n}",
                frag: "precision mediump float;\n#include <gl2_frag>\n#if defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#include <heatmap_render_frag>\nuniform vec4 baseColorFactor;\n#if defined(HAS_MAP)\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\nvarying vec2 vTexCoord;\n#endif\n#include <mask_frag>\nvoid main() {\n  \n#ifdef HAS_COLOR0\nglFragColor = vColor * baseColorFactor;\n#else\nglFragColor = vec4(1.) * baseColorFactor;\n#endif\n#ifdef HAS_MAP\n#ifdef HAS_ALBEDO_MAP\nglFragColor *= texture2D(baseColorTexture, vTexCoord);\n#endif\n#ifdef HAS_DIFFUSE_MAP\nglFragColor *= texture2D(diffuseTexture, vTexCoord);\n#endif\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: (t, n) => c.multiply(e, n.projViewMatrix, n.modelMatrix)
                } ],
                defines: t.defines || {},
                extraCommandProps: t.extraCommandProps || {}
            });
        }
    },
    PostProcessShader: Yr,
    QuadShader: qr,
    REGLHelper: xe,
    RainRipplesPass: As,
    Renderer: pi,
    ResourceLoader: bi,
    ScanEffectPass: Is,
    ScanEffectShader: ms,
    Scene: Ti,
    Shader: Gr,
    ShaderLib: ji,
    ShadowDisplayShader: Go,
    ShadowMapShader: Do,
    ShadowPass: zo,
    SkyboxShader: hs,
    SsrPass: ss,
    StandardLiteMaterial: class extends Ie {
        constructor(t) {
            super(t, ke);
        }
        appendDefines(t, e) {
            super.appendDefines(t, e);
            const n = this.uniforms;
            n.extrusionOpacity && (t.HAS_EXTRUSION_OPACITY = 1), e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1);
            return e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, t.COLOR0_SIZE = e.getColor0Size()), 
            e.data[e.desc.uv0Attribute] ? (n.baseColorTexture && (t.HAS_BASECOLOR_MAP = 1), 
            n.occlusionTexture && e.data[e.desc.uv1Attribute] && (t.HAS_AO_MAP = 1), n.emissiveTexture && (t.HAS_EMISSIVE_MAP = 1), 
            n.normalTexture && (t.HAS_NORMAL_MAP = 1), (t.HAS_BASECOLOR_MAP || t.HAS_AO_MAP || t.HAS_EMISSIVE_MAP || t.HAS_NORMAL_MAP) && (t.HAS_MAP = 1), 
            t.ALPHATEST = .01, t.GAMMA_INPUT = 1, t.GAMMA_FACTOR = 1, t.TONEMAP_OUTPUT = 1, 
            t.ENVMAP_MODE_REFLECTION = 1, t.ENV_RGBM = 1, t.IRR_RGBM = 1, t) : t;
        }
    },
    StandardLiteShader: class extends Br {
        constructor(t = {}) {
            const e = [], n = t.uniforms, i = [ {
                name: "viewMatrixInverse",
                type: "function",
                fn: (t, e) => c.invert(us, e.viewMatrix)
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    return c.multiply(e, n.viewMatrix, n.modelMatrix);
                }
            }, {
                name: "environmentTransform",
                type: "function",
                fn: (t, e) => {
                    const n = e.environmentOrientation || 0;
                    return f.fromRotation(ds, Math.PI * n / 180);
                }
            } ];
            n && i.push(...n), super({
                vert: "precision mediump float;\n#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvarying vec3 vViewPosition;\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 c = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 c = getPosition(aPosition);\n#endif\nmat4 d = getPositionMatrix();\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = e * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = e * modelViewMatrix * d * c;\n#endif\nvec4 f = modelViewMatrix * d * c;\n  vViewPosition = -f.xyz;\n#ifdef HAS_MAP\nvec2 h = decode_getTexcoord(aTexCoord);\n  vTexCoord = h * uvScale + uvOffset;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n}",
                frag: "#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\n#define GET_BASEMAP(UV) (texture2D(baseColorTexture, (UV)))\nuniform mat4 viewMatrix;\nuniform mat4 projMatrix;\nuniform vec3 cameraPosition;\n#if defined(HAS_IBL_LIGHTING)\nuniform mat4 viewMatrixInverse;\n#endif\nuniform vec4 baseColorFactor;\nuniform vec3 emissiveFactor;\nuniform vec3 specularFactor;\nuniform float opacity;\nuniform float envRotationSin;\nuniform float envRotationCos;\nuniform float rgbmRange;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\nvec3 c(vec3 d, vec3 e) {\n  vec3 f = dFdx(d.xyz);\n  vec3 h = dFdy(d.xyz);\n  vec3 i = normalize(f - h);\n  vec3 j = normalize(-f + h);\n  vec3 k = normalize(e);\n  vec3 l = texture2D(normalTexture, computeTexCoord(vTexCoord)).rgb * 2. - 1.;\n  mat3 m = mat3(i, j, k);\n  return normalize(m * l);\n}\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#ifdef GAMMA_INPUT\nvec3 n(vec3 o) {\n  return o * o;\n}\nfloat n(float o) {\n  return o * o;\n}\n#else\nvec3 n(vec3 o) {\n  return o;\n}\nfloat n(float o) {\n  return o;\n}\n#endif\nvec3 u() {\n  \n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn specularFactor;\n#endif\n#else\nreturn specularFactor;\n#endif\n}\nvec3 v() {\n  \n#ifdef HAS_EMISSIVE_MAP\nreturn texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn emissiveFactor;\n#endif\n}\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT > 0\nuniform float exposureBias;\nfloat A(vec3 rgb) {\n  return dot(rgb, vec3(.299, .587, .114));\n}\nfloat B(vec3 rgb) {\n  return dot(rgb, vec3(.212671, .715160, .072169));\n}\nvec3 C(vec3 xyz) {\n  vec3 D = vec3(3.240479, -1.53715, -.498535);\n  vec3 E = vec3(-.969256, 1.875992, .041556);\n  vec3 F = vec3(.055648, -.204043, 1.057311);\n  vec3 rgb;\n  rgb.b = dot(xyz, F);\n  rgb.g = dot(xyz, E);\n  rgb.r = dot(xyz, D);\n  return rgb;\n}\nvec3 H(vec3 rgb) {\n  vec3 I = vec3(.412453, .35758, .180423);\n  vec3 J = vec3(.212671, .71516, .0721688);\n  vec3 K = vec3(.0193338, .119194, .950227);\n  vec3 xyz;\n  xyz.x = dot(rgb, I);\n  xyz.y = dot(rgb, J);\n  xyz.z = dot(rgb, K);\n  return xyz;\n}\nvec3 L(vec3 xyz) {\n  float M = xyz.x + xyz.y + xyz.z;\n  M = 1. / M;\n  vec3 O;\n  O.z = xyz.y;\n  O.x = xyz.x * M;\n  O.y = xyz.y * M;\n  return O;\n}\nvec3 P(vec3 O) {\n  float x = O.x;\n  float y = O.y;\n  float J = O.z;\n  vec3 xyz;\n  xyz.y = J;\n  xyz.x = x * (J / y);\n  xyz.z = (1. - x - y) * (J / y);\n  return xyz;\n}\nfloat Q(float x) {\n  float U = pow(x, 1.60525727);\n  float V = ((1.05542877 * 4.68037409) * U) / (4.68037409 * U + 1.);\n  return clamp(V, .0, 1.);\n}\nconst float W = 1. / .18;\nfloat ba(float x) {\n  x *= W;\n  const float bb = .2;\n  const float F = .34;\n  const float bc = .002;\n  const float bd = 1.68;\n  const float be = .0005;\n  const float bf = .252;\n  const float bg = 1. / .833837;\n  return ((x * (bb * x + bc * F) + bd * be) / (x * (bb * x + F) + bd * bf) - be / bf) * bg;\n}\nvec3 bh(vec3 x) {\n  x *= W;\n  const float bb = .27;\n  const float F = .29;\n  const float bc = .052;\n  const float bd = .2;\n  const float bf = .18;\n  const float bg = 1. / .897105;\n  return ((x * (bb * x + bc * F)) / (x * (bb * x + F) + bd * bf)) * bg;\n}\nvec3 bi(vec3 x) {\n  vec3 bj = x.rgb;\n  bj = min(bj, vec3(3.));\n  float bk = B(bj);\n  if(bk > .0) {\n    float bl = Q(bk);\n    bj = bj * (bl / bk);\n    bj = clamp(bj, vec3(.0), vec3(1.));\n  }\n  float bm = 1. / 2.2;\n  bj = pow(bj, vec3(bm));\n  return bj;\n}\n#endif\n#endif\n#if defined(IRR_RGBM) || defined(ENV_RGBM) || defined(ENV_GAMMA) || defined(IRR_GAMMA)\nuniform float envMapExposure;\n#endif\nuniform vec4 themingColor;\nuniform mat3 environmentTransform;\nvec3 bn(vec3 bo, vec3 bp) {\n  \n#if defined(HAS_SHADOWMAP)\nfloat bq = dot(shadowLightDir, bp);\n  float br = (bq + 1.) / 2.;\n  br = min(1., br * 1.5);\n  float bs = 1.;\n  vec3 bt = bo * min(bs, br);\n  return bt;\n#else\nreturn bo;\n#endif\n}\n#ifdef HAS_IBL_LIGHTING\nuniform float reflectivity;\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\n#if defined(HAS_IBL_LIGHTING)\nvec3 bu(const in vec3 bv) {\n  vec3 bw = environmentTransform * bv;\n  float x = bw.x;\n  float y = bw.y;\n  float z = bw.z;\n  vec3 bt = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bt = hsv_apply(bt, hdrHSV);\n  }\n  return max(bt, vec3(.0));\n}\nvec3 bx(const in vec4 by, const in float bz) {\n  if(bz <= .0)\n    return by.rgb;\n  return bz * by.rgb * by.a;\n}\nfloat bA(const in float bB) {\n  return bB;\n}\nvec3 bC(const in float bD, const in vec3 D) {\n  vec3 bE = D;\n  float bF = prefilterMiplevel.x;\n  float bG = min(bF, bA(bD) * prefilterMiplevel.y);\n  vec3 bH = bx(textureCubeLod(prefilterMap, bE, bG), rgbmRange);\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(bH, hdrHSV);\n  } else {\n    return bH;\n  }\n}\nvec3 bI(const in vec3 k, const in vec3 D, const in float bJ) {\n  float bK = 1. - bJ;\n  float bL = bK * (sqrt(bK) + bJ);\n  return mix(k, D, bL);\n}\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  vec3 D = reflect(-bN, bv);\n  D = bI(bv, D, bO);\n  vec3 bQ = bC(bO, environmentTransform * D);\n  float bR = clamp(1. + dot(D, bP), .0, 1.);\n  bQ *= bR * bR;\n  return bQ;\n}\n#else\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  return ambientColor;\n}\n#endif\nvarying highp vec3 vViewPosition;\nvec3 bS(vec3 bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\nfloat bW(float bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\n#include <srgb_frag>\nvoid main() {\n  glFragColor = vec4(vec3(1.), opacity);\n#ifdef HAS_BASECOLOR_MAP\nvec4 bX = GET_BASEMAP(computeTexCoord(vTexCoord));\n#ifdef GAMMA_INPUT\nbX.xyz *= bX.xyz;\n#endif\nglFragColor = glFragColor * bX;\n#endif\n#ifdef ALPHATEST\nif(glFragColor.a < ALPHATEST)\n    discard;\n  \n#endif\nfloat bY = 1.;\n  vec3 bZ = dFdx(vViewPosition);\n  vec3 ca = dFdy(vViewPosition);\n  vec3 bv = normalize(cross(bZ, ca));\n  vec3 cb;\n  if(projMatrix[3][3] == .0) {\n    cb = normalize(vViewPosition);\n  } else {\n    cb = vec3(.0, .0, 1.);\n  }\n  bv = faceforward(bv, -cb, bv);\n  vec3 cc = bv;\n#ifdef HAS_NORMAL_MAP\nbv = c(-vViewPosition, bv);\n#endif\nvec3 cd = vec3(.0);\n  vec3 ce = vec3(.0);\n#ifdef HAS_IBL_LIGHTING\nvec3 bp = mat3(viewMatrixInverse) * bv;\n  vec3 cf = glFragColor.rgb * bu(bp) * .5;\n  cf = bn(cf, bp);\n  cd += n(baseColorFactor.rgb) * cf;\n#endif\nvec3 cg = v();\n#ifdef METAL\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb) + ce);\n#else\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb)) + ce;\n#endif\nvec3 ch;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ci = shadow_computeShadow();\n  ch = shadow_blend(ch, ci).rgb;\n#endif\n#ifdef HAS_COLOR\nglFragColor = glFragColor * vColor;\n#endif\nglFragColor.rgb += ch;\n  glFragColor.rgb = linearTosRGB(glFragColor.rgb);\n#if defined(HAS_IBL_LIGHTING)\nvec3 cj;\n#if defined(HAS_NORMAL_MAP)\n#ifdef ENVMAP_MODE_REFLECTION\ncj = reflect(-cb, bv);\n#else\ncj = refract(-cb, bv, 1.);\n#endif\n#else\ncj = reflect(-cb, bv);\n#endif\ncj = mat3(viewMatrixInverse) * cj;\n  float ck = 1.;\n  vec3 cl;\n#ifdef HAS_IBL_LIGHTING\ncl = vec3(.0);\n#elif\ncl = ambientColor;\n#endif\ncl *= ck;\n  float bV = dot(cb, bv);\n  if(bV < -1e-2 || reflectivity == .0)\n    bV = 1.;\n  else\n    bV = max(1e-6, bV);\n  vec3 cm;\n  vec3 cn = u();\n#ifdef METAL\ncm = n(cn);\n#else\ncm = bS(n(cn), bV) * (1. - envRotationSin);\n  glFragColor.a = mix(glFragColor.a, bW(glFragColor.a, bV), reflectivity) * envRotationCos;\n  float co = pow(1. - bV * .5, 5.);\n  float cp = (28. / 23.) * (1. - co) * (1. - co);\n  glFragColor.rgb *= cp * (1. - n(cn));\n#endif\nglFragColor.rgb += cl.rgb * bY * cm.rgb;\n#endif\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT == 1\nglFragColor.rgb = bi(exposureBias * glFragColor.rgb);\n#elif TONEMAP_OUTPUT == 2\nglFragColor.rgb = bh(exposureBias * glFragColor.rgb);\n#endif\n#endif\nglFragColor.rgb = mix(glFragColor.rgb, themingColor.rgb, themingColor.a);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: i,
                defines: t.defines || {},
                extraCommandProps: t.extraCommandProps || {}
            }), this.version = 300;
        }
    },
    Texture2D: Gi,
    Util: Y,
    WGSLParseDefines: Sr,
    WaterShader: class extends Br {
        constructor(t = {}) {
            super({
                vert: "const float c = 3.141592653589793;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nattribute vec3 aNormal;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nvec4 d(mat4 e, mat4 f, vec3 h) {\n  return e * modelMatrix * f * vec4(h, 1.);\n}\nvec3 i(in vec3 h, in vec3 j) {\n  return normalize(h + j);\n}\nmat3 k(in vec3 l) {\n  vec3 t = normalize(cross(vec3(.0, .0, 1.), l));\n  vec3 b = normalize(cross(l, t));\n  return mat3(t, b, l);\n}\nvoid m() {\n  \n}\nvoid main(void) {\n  vuv = aTexCoord;\n  vpos = (modelMatrix * vec4(aPosition, 1.)).xyz;\n  vnormal = aNormal;\n  vtbnMatrix = k(vnormal);\n  gl_Position = d(projMatrix, viewMatrix, vpos);\n  m();\n}",
                frag: "precision highp float;\nprecision highp sampler2D;\nuniform sampler2D texWaveNormal;\nuniform sampler2D texWavePerturbation;\nuniform vec3 octaveTextureRepeat;\nuniform vec4 waveParams;\nuniform vec2 waveDirection;\nuniform vec4 waterColor;\nuniform vec3 lightingDirection;\nuniform vec3 lightingIntensity;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nconst vec2 c = vec2(6. / 25., 5. / 24.);\nvec2 d(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rg - 1.;\n}\nfloat h(vec2 f) {\n  return texture2D(texWavePerturbation, f).b;\n}\nvec3 i(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rgb - 1.;\n}\nfloat j(vec2 f, float k) {\n  return fract(k);\n}\nfloat l(vec2 f, float k) {\n  float m = j(f, k);\n  return 1. - abs(1. - 2. * m);\n}\nvec3 n(sampler2D o, vec2 f, float k, float u) {\n  float v = waveParams[2];\n  float A = waveParams[3];\n  vec2 B = d(o, f) * v;\n  float m = j(f, k + u);\n  float C = l(f, k + u);\n  vec2 D = f;\n  D -= B * (m + A);\n  D += u;\n  D += (k - m) * c;\n  return vec3(D, C);\n}\nconst float E = .3737;\nconst float F = 7.77;\nvec3 G(sampler2D H, sampler2D I, vec2 f, vec2 J, float k) {\n  float K = waveParams[0];\n  vec2 L = k * -J;\n  float M = h(f * E) * F;\n  vec3 N = n(I, f + L, k + M, .0);\n  vec3 O = n(I, f + L, k + M, .5);\n  vec3 P = i(H, N.xy) * N.z;\n  vec3 Q = i(H, O.xy) * O.z;\n  vec3 R = normalize(P + Q);\n  R.xy *= K;\n  R.z = sqrt(1. - dot(R.xy, R.xy));\n  return R;\n}\nvec3 S(vec2 f, float k) {\n  float T = waveParams[1];\n  return G(texWaveNormal, texWavePerturbation, f * T, waveDirection, k);\n}\nconst float U = 3.141592653589793;\nconst float V = 1. / U;\nconst float W = .3183098861837907;\nconst float X = 1.570796326794897;\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nfloat Y = 2.2;\nvec3 Z(float ba, vec3 bb, float bc) {\n  return bb + (bc - bb) * pow(1. - ba, 5.);\n}\nfloat bd(float be, float bf) {\n  float bg = bf * bf;\n  float bh = be * be;\n  float bi = pow((bh * (bg - 1.) + 1.), Y) * U;\n  return bg / bi;\n}\nfloat bj(float bk) {\n  return .25 / (bk * bk);\n}\nvec3 bl(in PBRShadingWater bm, float bf, vec3 bn, float bo) {\n  vec3 bp = Z(bm.VdotH, bn, bo);\n  float bq = bd(bm.NdotH, bf);\n  float br = bj(bm.LdotH);\n  return (bq * br) * bp;\n}\nvec3 bs(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float bt = 2.2;\nconst float bu = .4545454545;\nvec4 bv(vec4 bw) {\n  return vec4(pow(bw.rgb, vec3(bu)), bw.w);\n}\nvec3 bx(vec3 bw) {\n  return pow(bw, vec3(bt));\n}\nconst vec3 by = vec3(.02, 1., 5.);\nconst vec2 bz = vec2(.02, .1);\nconst float bf = .06;\nconst vec3 bA = vec3(0, .6, .9);\nconst vec3 bB = vec3(.72, .92, 1.);\nPBRShadingWater bC;\nvec3 bD(in float bE, in vec3 bF, in vec3 bG) {\n  float bH = pow((1. - bE), by[2]);\n  return mix(bG, bF, bH);\n}\nvec3 bI(in vec3 bJ, in vec3 bK, in vec3 bL, vec3 bw, in vec3 bM, in vec3 bN, in float bO) {\n  vec3 bP = bx(bw);\n  vec3 bQ = normalize(bL + bK);\n  bC.NdotL = clamp(dot(bJ, bL), .0, 1.);\n  bC.NdotV = clamp(dot(bJ, bK), .001, 1.);\n  bC.VdotN = clamp(dot(bK, bJ), .001, 1.);\n  bC.NdotH = clamp(dot(bJ, bQ), .0, 1.);\n  bC.VdotH = clamp(dot(bK, bQ), .0, 1.);\n  bC.LdotH = clamp(dot(bL, bQ), .0, 1.);\n  float bR = max(dot(bN, bK), .0);\n  vec3 bS = bx(bB);\n  vec3 bT = bx(bA);\n  vec3 bB = bD(bR, bS, bT);\n  float bU = max(dot(bN, bL), .0);\n  bB *= .1 + bU * .9;\n  float bV = clamp(bO, .8, 1.);\n  vec3 bW = Z(bC.VdotN, vec3(by[0]), by[1]) * bB * bV;\n  vec3 bX = bP * mix(bB, bU * bM * V, 2. / 3.) * bV;\n  vec3 bY = vec3(.0);\n  if(bR > .0 && bU > .0) {\n    vec3 bZ = bl(bC, bf, vec3(bz[0]), bz[1]);\n    vec3 ca = bM * V * bO;\n    bY = bC.NdotL * ca * bZ;\n  }\n  return bs(bW + bX + bY);\n}\nvoid main() {\n  vec3 bN = vnormal;\n  vec3 cb = S(vuv, timeElapsed);\n  vec3 bJ = normalize(vtbnMatrix * cb);\n  vec3 bK = -normalize(vpos - camPos);\n  vec3 bL = normalize(-lightingDirection);\n  float bO = 1.;\n  vec4 cc = vec4(bI(bJ, bK, bL, waterColor.rgb, lightingIntensity, bN, bO), waterColor.w);\n  gl_FragColor = bv(cc);\n}",
                defines: t.defines || {},
                extraCommandProps: t.extraCommandProps || {}
            });
        }
    },
    WebGLConstants: zi,
    WgslShaderLib: Yi,
    WireFrameMaterial: class extends Ie {
        constructor(t) {
            super(t, Pe);
        }
    },
    WireframeShader: class extends Br {
        constructor(t = {}) {
            let e = t.extraCommandProps || {};
            const n = [];
            e = E({}, e, {
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                },
                sample: {
                    alpha: !0
                }
            }), super({
                vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aBarycentric;\nvarying vec3 vBarycentric;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nvarying vec3 vPosition;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(c * d, modelMatrix);\n#else\ngl_Position = projMatrix * modelViewMatrix * c * d;\n#endif\nvBarycentric = aBarycentric;\n  vPosition = aPosition;\n}",
                frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec3 vBarycentric;\nuniform float time;\nuniform float thickness;\nuniform float secondThickness;\nuniform float dashRepeats;\nuniform float dashLength;\nuniform bool dashOverlap;\nuniform bool dashEnabled;\nuniform bool dashAnimate;\nuniform bool seeThrough;\nuniform bool insideAltColor;\nuniform bool dualStroke;\nuniform bool squeeze;\nuniform float squeezeMin;\nuniform float squeezeMax;\nuniform vec4 stroke;\nuniform vec4 fill;\nuniform float opacity;\nuniform bool noiseEnable;\nvarying vec3 vPosition;\n#ifdef HAS_INSTANCE\nvarying vec4 vInstanceColor;\n#endif\n#include <mask_frag>\n#define F4 0.309016994374947451\n#define halfDist 0.5\nvec4 c(vec4 x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nfloat c(float x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nvec4 d(vec4 x) {\n  return c((x * 34. + 1.) * x);\n}\nfloat d(float x) {\n  return c((x * 34. + 1.) * x);\n}\nvec4 e(vec4 r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nfloat e(float r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nvec4 f(float h, vec4 i) {\n  const vec4 k = vec4(1., 1., 1., -1.);\n  vec4 p, s;\n  p.xyz = floor(fract(vec3(h) * i.xyz) * 7.) * i.z - 1.;\n  p.w = 1.5 - dot(abs(p.xyz), k.xyz);\n  s = vec4(lessThan(p, vec4(.0)));\n  p.xyz = p.xyz + (s.xyz * 2. - 1.) * s.www;\n  return p;\n}\nfloat l(vec4 m) {\n  const vec4 n = vec4(.138196601125011, .276393202250021, .414589803375032, -.447213595499958);\n  vec4 o = floor(m + dot(m, vec4(F4)));\n  vec4 u = m - o + dot(o, n.xxxx);\n  vec4 A;\n  vec3 B = step(u.yzw, u.xxx);\n  vec3 D = step(u.zww, u.yyz);\n  A.x = B.x + B.y + B.z;\n  A.yzw = 1. - B;\n  A.y += D.x + D.y;\n  A.zw += 1. - D.xy;\n  A.z += D.z;\n  A.w += 1. - D.z;\n  vec4 E = clamp(A, .0, 1.);\n  vec4 F = clamp(A - 1., .0, 1.);\n  vec4 G = clamp(A - 2., .0, 1.);\n  vec4 H = u - G + n.xxxx;\n  vec4 I = u - F + n.yyyy;\n  vec4 J = u - E + n.zzzz;\n  vec4 K = u + n.wwww;\n  o = c(o);\n  float L = d(d(d(d(o.w) + o.z) + o.y) + o.x);\n  vec4 M = d(d(d(d(o.w + vec4(G.w, F.w, E.w, 1.)) + o.z + vec4(G.z, F.z, E.z, 1.)) + o.y + vec4(G.y, F.y, E.y, 1.)) + o.x + vec4(G.x, F.x, E.x, 1.));\n  vec4 i = vec4(1. / 294., 1. / 49., 1. / 7., .0);\n  vec4 N = f(L, i);\n  vec4 O = f(M.x, i);\n  vec4 P = f(M.y, i);\n  vec4 Q = f(M.z, i);\n  vec4 R = f(M.w, i);\n  vec4 S = e(vec4(dot(N, N), dot(O, O), dot(P, P), dot(Q, Q)));\n  N *= S.x;\n  O *= S.y;\n  P *= S.z;\n  Q *= S.w;\n  R *= e(dot(R, R));\n  vec3 T = max(.6 - vec3(dot(u, u), dot(H, H), dot(I, I)), .0);\n  vec2 U = max(.6 - vec2(dot(J, J), dot(K, K)), .0);\n  T = T * T;\n  U = U * U;\n  return 49. * (dot(T * T, vec3(dot(N, u), dot(O, H), dot(P, I))) + dot(U * U, vec2(dot(Q, J), dot(R, K))));\n}\nconst float V = 3.14159265359;\nfloat W(float X, float Y) {\n  float Z = fwidth(Y) * halfDist;\n  return smoothstep(X - Z, X + Z, Y);\n}\nvec4 ba(vec3 bb) {\n  float bc = min(min(bb.x, bb.y), bb.z);\n  float bd = .0;\n  if(noiseEnable)\n    bd += l(vec4(vPosition.xyz * 80.0, time * halfDist)) * .12;\n  bc += bd;\n  float be = max(bb.x, bb.y);\n  if(bb.y < bb.x && bb.y < bb.z) {\n    be = 1. - be;\n  }\n  float bf = thickness;\n  if(squeeze) {\n    bf *= mix(squeezeMin, squeezeMax, (1. - sin(be * V)));\n  }\n  if(dashEnabled) {\n    float bg = 1. / dashRepeats * dashLength / 2.;\n    if(!dashOverlap) {\n      bg += 1. / dashRepeats / 2.;\n    }\n    if(dashAnimate) {\n      bg += time * .22;\n    }\n    float bh = fract((be + bg) * dashRepeats);\n    bf *= 1. - W(dashLength, bh);\n  }\n  float bi = 1. - W(bf, bc);\n#ifdef HAS_INSTANCE\nvec4 bj = vInstanceColor;\n#else\nvec4 bj = stroke;\n#endif\nvec4 bk = vec4(.0);\n  if(seeThrough) {\n    bk = vec4(bj.xyz, bi);\n    if(insideAltColor && !gl_FrontFacing) {\n      bk.rgb = fill.xyz;\n    }\n  } else {\n    vec3 bl = mix(fill.xyz, bj.xyz, bi);\n    bk.a = fill.a;\n    if(dualStroke) {\n      float bm = 1. - W(secondThickness, bc);\n      vec3 bn = mix(fill.xyz, stroke.xyz, abs(bm - bi));\n      bk.rgb = bn;\n    } else {\n      bk.rgb = bl;\n    }\n  }\n  return bk;\n}\nvoid main() {\n  glFragColor = ba(vBarycentric);\n  glFragColor *= halfDist + opacity;\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, e) => c.multiply(n, e.viewMatrix, e.modelMatrix)
                } ],
                extraCommandProps: e
            }), this.version = 300;
        }
    },
    earcut: ma,
    glMatrix: m,
    mat2: v,
    mat2d: g,
    mat3: f,
    mat4: c,
    pbr: da,
    quat: d,
    quat2: p,
    vec2: u,
    vec3: h,
    vec4: l
});

function ga(t) {
    return t && t.Ao && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

var pa = {
    exports: {}
}, xa = {
    exports: {}
}, _a = function(t) {
    return !(!t || "string" == typeof t) && (t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && "String" !== t.constructor.name));
}, ba = Array.prototype.concat, ya = Array.prototype.slice, wa = xa.exports = function(t) {
    for (var e = [], n = 0, i = t.length; n < i; n++) {
        var r = t[n];
        _a(r) ? e = ba.call(e, ya.call(r)) : e.push(r);
    }
    return e;
};

wa.wrap = function(t) {
    return function() {
        return t(wa(arguments));
    };
};

var Sa = xa.exports, Aa = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, Ma = Sa, Ta = Object.hasOwnProperty, Ca = Object.create(null);

for (var Oa in Aa) Ta.call(Aa, Oa) && (Ca[Aa[Oa]] = Oa);

var Ea = pa.exports = {
    to: {},
    get: {}
};

function Ia(t, e, n) {
    return Math.min(Math.max(e, t), n);
}

function Pa(t) {
    var e = Math.round(t).toString(16).toUpperCase();
    return e.length < 2 ? "0" + e : e;
}

Ea.get = function(t) {
    var e, n;
    switch (t.substring(0, 3).toLowerCase()) {
      case "hsl":
        e = Ea.get.hsl(t), n = "hsl";
        break;

      case "hwb":
        e = Ea.get.hwb(t), n = "hwb";
        break;

      default:
        e = Ea.get.rgb(t), n = "rgb";
    }
    return e ? {
        model: n,
        value: e
    } : null;
}, Ea.get.rgb = function(t) {
    if (!t) return null;
    var e, n, i, r = [ 0, 0, 0, 1 ];
    if (e = t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
        for (i = e[2], e = e[1], n = 0; n < 3; n++) {
            var s = 2 * n;
            r[n] = parseInt(e.slice(s, s + 2), 16);
        }
        i && (r[3] = parseInt(i, 16) / 255);
    } else if (e = t.match(/^#([a-f0-9]{3,4})$/i)) {
        for (i = (e = e[1])[3], n = 0; n < 3; n++) r[n] = parseInt(e[n] + e[n], 16);
        i && (r[3] = parseInt(i + i, 16) / 255);
    } else if (e = t.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
        for (n = 0; n < 3; n++) r[n] = parseInt(e[n + 1], 0);
        e[4] && (e[5] ? r[3] = .01 * parseFloat(e[4]) : r[3] = parseFloat(e[4]));
    } else {
        if (!(e = t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (e = t.match(/^(\w+)$/)) ? "transparent" === e[1] ? [ 0, 0, 0, 0 ] : Ta.call(Aa, e[1]) ? ((r = Aa[e[1]])[3] = 1, 
        r) : null : null;
        for (n = 0; n < 3; n++) r[n] = Math.round(2.55 * parseFloat(e[n + 1]));
        e[4] && (e[5] ? r[3] = .01 * parseFloat(e[4]) : r[3] = parseFloat(e[4]));
    }
    for (n = 0; n < 3; n++) r[n] = Ia(r[n], 0, 255);
    return r[3] = Ia(r[3], 0, 1), r;
}, Ea.get.hsl = function(t) {
    if (!t) return null;
    var e = t.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var n = parseFloat(e[4]);
        return [ (parseFloat(e[1]) % 360 + 360) % 360, Ia(parseFloat(e[2]), 0, 100), Ia(parseFloat(e[3]), 0, 100), Ia(isNaN(n) ? 1 : n, 0, 1) ];
    }
    return null;
}, Ea.get.hwb = function(t) {
    if (!t) return null;
    var e = t.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var n = parseFloat(e[4]);
        return [ (parseFloat(e[1]) % 360 + 360) % 360, Ia(parseFloat(e[2]), 0, 100), Ia(parseFloat(e[3]), 0, 100), Ia(isNaN(n) ? 1 : n, 0, 1) ];
    }
    return null;
}, Ea.to.hex = function() {
    var t = Ma(arguments);
    return "#" + Pa(t[0]) + Pa(t[1]) + Pa(t[2]) + (t[3] < 1 ? Pa(Math.round(255 * t[3])) : "");
}, Ea.to.rgb = function() {
    var t = Ma(arguments);
    return t.length < 4 || 1 === t[3] ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
}, Ea.to.rgb.percent = function() {
    var t = Ma(arguments), e = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), i = Math.round(t[2] / 255 * 100);
    return t.length < 4 || 1 === t[3] ? "rgb(" + e + "%, " + n + "%, " + i + "%)" : "rgba(" + e + "%, " + n + "%, " + i + "%, " + t[3] + ")";
}, Ea.to.hsl = function() {
    var t = Ma(arguments);
    return t.length < 4 || 1 === t[3] ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
}, Ea.to.hwb = function() {
    var t = Ma(arguments), e = "";
    return t.length >= 4 && 1 !== t[3] && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
}, Ea.to.keyword = function(t) {
    return Ca[t.slice(0, 3)];
};

var Ha = pa.exports, Ra = {
    exports: {}
}, ka = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, Na = {};

for (var Da in ka) ka.hasOwnProperty(Da) && (Na[ka[Da]] = Da);

var La = Ra.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [ "hex" ]
    },
    keyword: {
        channels: 1,
        labels: [ "keyword" ]
    },
    ansi16: {
        channels: 1,
        labels: [ "ansi16" ]
    },
    ansi256: {
        channels: 1,
        labels: [ "ansi256" ]
    },
    hcg: {
        channels: 3,
        labels: [ "h", "c", "g" ]
    },
    apple: {
        channels: 3,
        labels: [ "r16", "g16", "b16" ]
    },
    gray: {
        channels: 1,
        labels: [ "gray" ]
    }
};

for (var Fa in La) if (La.hasOwnProperty(Fa)) {
    if (!("channels" in La[Fa])) throw new Error("missing channels property: " + Fa);
    if (!("labels" in La[Fa])) throw new Error("missing channel labels property: " + Fa);
    if (La[Fa].labels.length !== La[Fa].channels) throw new Error("channel and label counts mismatch: " + Fa);
    var Ua = La[Fa].channels, za = La[Fa].labels;
    delete La[Fa].channels, delete La[Fa].labels, Object.defineProperty(La[Fa], "channels", {
        value: Ua
    }), Object.defineProperty(La[Fa], "labels", {
        value: za
    });
}

La.rgb.hsl = function(t) {
    var e, n, i = t[0] / 255, r = t[1] / 255, s = t[2] / 255, o = Math.min(i, r, s), a = Math.max(i, r, s), c = a - o;
    return a === o ? e = 0 : i === a ? e = (r - s) / c : r === a ? e = 2 + (s - i) / c : s === a && (e = 4 + (i - r) / c), 
    (e = Math.min(60 * e, 360)) < 0 && (e += 360), n = (o + a) / 2, [ e, 100 * (a === o ? 0 : n <= .5 ? c / (a + o) : c / (2 - a - o)), 100 * n ];
}, La.rgb.hsv = function(t) {
    var e, n, i, r, s, o = t[0] / 255, a = t[1] / 255, c = t[2] / 255, h = Math.max(o, a, c), l = h - Math.min(o, a, c), f = function(t) {
        return (h - t) / 6 / l + .5;
    };
    return 0 === l ? r = s = 0 : (s = l / h, e = f(o), n = f(a), i = f(c), o === h ? r = i - n : a === h ? r = 1 / 3 + e - i : c === h && (r = 2 / 3 + n - e), 
    r < 0 ? r += 1 : r > 1 && (r -= 1)), [ 360 * r, 100 * s, 100 * h ];
}, La.rgb.hwb = function(t) {
    var e = t[0], n = t[1], i = t[2];
    return [ La.rgb.hsl(t)[0], 100 * (1 / 255 * Math.min(e, Math.min(n, i))), 100 * (i = 1 - 1 / 255 * Math.max(e, Math.max(n, i))) ];
}, La.rgb.cmyk = function(t) {
    var e, n = t[0] / 255, i = t[1] / 255, r = t[2] / 255;
    return [ 100 * ((1 - n - (e = Math.min(1 - n, 1 - i, 1 - r))) / (1 - e) || 0), 100 * ((1 - i - e) / (1 - e) || 0), 100 * ((1 - r - e) / (1 - e) || 0), 100 * e ];
}, La.rgb.keyword = function(t) {
    var e = Na[t];
    if (e) return e;
    var n, i, r, s = 1 / 0;
    for (var o in ka) if (ka.hasOwnProperty(o)) {
        var a = ka[o], c = (i = t, r = a, Math.pow(i[0] - r[0], 2) + Math.pow(i[1] - r[1], 2) + Math.pow(i[2] - r[2], 2));
        c < s && (s = c, n = o);
    }
    return n;
}, La.keyword.rgb = function(t) {
    return ka[t];
}, La.rgb.xyz = function(t) {
    var e = t[0] / 255, n = t[1] / 255, i = t[2] / 255;
    return [ 100 * (.4124 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92)), 100 * (.2126 * e + .7152 * n + .0722 * i), 100 * (.0193 * e + .1192 * n + .9505 * i) ];
}, La.rgb.lab = function(t) {
    var e = La.rgb.xyz(t), n = e[0], i = e[1], r = e[2];
    return i /= 100, r /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, 
    [ 116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16, 500 * (n - i), 200 * (i - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116)) ];
}, La.hsl.rgb = function(t) {
    var e, n, i, r, s, o = t[0] / 360, a = t[1] / 100, c = t[2] / 100;
    if (0 === a) return [ s = 255 * c, s, s ];
    e = 2 * c - (n = c < .5 ? c * (1 + a) : c + a - c * a), r = [ 0, 0, 0 ];
    for (var h = 0; h < 3; h++) (i = o + 1 / 3 * -(h - 1)) < 0 && i++, i > 1 && i--, 
    s = 6 * i < 1 ? e + 6 * (n - e) * i : 2 * i < 1 ? n : 3 * i < 2 ? e + (n - e) * (2 / 3 - i) * 6 : e, 
    r[h] = 255 * s;
    return r;
}, La.hsl.hsv = function(t) {
    var e = t[0], n = t[1] / 100, i = t[2] / 100, r = n, s = Math.max(i, .01);
    return n *= (i *= 2) <= 1 ? i : 2 - i, r *= s <= 1 ? s : 2 - s, [ e, 100 * (0 === i ? 2 * r / (s + r) : 2 * n / (i + n)), 100 * ((i + n) / 2) ];
}, La.hsv.rgb = function(t) {
    var e = t[0] / 60, n = t[1] / 100, i = t[2] / 100, r = Math.floor(e) % 6, s = e - Math.floor(e), o = 255 * i * (1 - n), a = 255 * i * (1 - n * s), c = 255 * i * (1 - n * (1 - s));
    switch (i *= 255, r) {
      case 0:
        return [ i, c, o ];

      case 1:
        return [ a, i, o ];

      case 2:
        return [ o, i, c ];

      case 3:
        return [ o, a, i ];

      case 4:
        return [ c, o, i ];

      case 5:
        return [ i, o, a ];
    }
}, La.hsv.hsl = function(t) {
    var e, n, i, r = t[0], s = t[1] / 100, o = t[2] / 100, a = Math.max(o, .01);
    return i = (2 - s) * o, n = s * a, [ r, 100 * (n = (n /= (e = (2 - s) * a) <= 1 ? e : 2 - e) || 0), 100 * (i /= 2) ];
}, La.hwb.rgb = function(t) {
    var e, n, i, r, s, o, a, c = t[0] / 360, h = t[1] / 100, l = t[2] / 100, f = h + l;
    switch (f > 1 && (h /= f, l /= f), i = 6 * c - (e = Math.floor(6 * c)), 1 & e && (i = 1 - i), 
    r = h + i * ((n = 1 - l) - h), e) {
      default:
      case 6:
      case 0:
        s = n, o = r, a = h;
        break;

      case 1:
        s = r, o = n, a = h;
        break;

      case 2:
        s = h, o = n, a = r;
        break;

      case 3:
        s = h, o = r, a = n;
        break;

      case 4:
        s = r, o = h, a = n;
        break;

      case 5:
        s = n, o = h, a = r;
    }
    return [ 255 * s, 255 * o, 255 * a ];
}, La.cmyk.rgb = function(t) {
    var e = t[0] / 100, n = t[1] / 100, i = t[2] / 100, r = t[3] / 100;
    return [ 255 * (1 - Math.min(1, e * (1 - r) + r)), 255 * (1 - Math.min(1, n * (1 - r) + r)), 255 * (1 - Math.min(1, i * (1 - r) + r)) ];
}, La.xyz.rgb = function(t) {
    var e, n, i, r = t[0] / 100, s = t[1] / 100, o = t[2] / 100;
    return n = -.9689 * r + 1.8758 * s + .0415 * o, i = .0557 * r + -.204 * s + 1.057 * o, 
    e = (e = 3.2406 * r + -1.5372 * s + -.4986 * o) > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, 
    n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, 
    [ 255 * (e = Math.min(Math.max(0, e), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (i = Math.min(Math.max(0, i), 1)) ];
}, La.xyz.lab = function(t) {
    var e = t[0], n = t[1], i = t[2];
    return n /= 100, i /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, 
    [ 116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (e - n), 200 * (n - (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116)) ];
}, La.lab.xyz = function(t) {
    var e, n, i, r = t[0];
    e = t[1] / 500 + (n = (r + 16) / 116), i = n - t[2] / 200;
    var s = Math.pow(n, 3), o = Math.pow(e, 3), a = Math.pow(i, 3);
    return n = s > .008856 ? s : (n - 16 / 116) / 7.787, e = o > .008856 ? o : (e - 16 / 116) / 7.787, 
    i = a > .008856 ? a : (i - 16 / 116) / 7.787, [ e *= 95.047, n *= 100, i *= 108.883 ];
}, La.lab.lch = function(t) {
    var e, n = t[0], i = t[1], r = t[2];
    return (e = 360 * Math.atan2(r, i) / 2 / Math.PI) < 0 && (e += 360), [ n, Math.sqrt(i * i + r * r), e ];
}, La.lch.lab = function(t) {
    var e, n = t[0], i = t[1];
    return e = t[2] / 360 * 2 * Math.PI, [ n, i * Math.cos(e), i * Math.sin(e) ];
}, La.rgb.ansi16 = function(t) {
    var e = t[0], n = t[1], i = t[2], r = 1 in arguments ? arguments[1] : La.rgb.hsv(t)[2];
    if (0 === (r = Math.round(r / 50))) return 30;
    var s = 30 + (Math.round(i / 255) << 2 | Math.round(n / 255) << 1 | Math.round(e / 255));
    return 2 === r && (s += 60), s;
}, La.hsv.ansi16 = function(t) {
    return La.rgb.ansi16(La.hsv.rgb(t), t[2]);
}, La.rgb.ansi256 = function(t) {
    var e = t[0], n = t[1], i = t[2];
    return e === n && n === i ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5);
}, La.ansi16.rgb = function(t) {
    var e = t % 10;
    if (0 === e || 7 === e) return t > 50 && (e += 3.5), [ e = e / 10.5 * 255, e, e ];
    var n = .5 * (1 + ~~(t > 50));
    return [ (1 & e) * n * 255, (e >> 1 & 1) * n * 255, (e >> 2 & 1) * n * 255 ];
}, La.ansi256.rgb = function(t) {
    if (t >= 232) {
        var e = 10 * (t - 232) + 8;
        return [ e, e, e ];
    }
    var n;
    return t -= 16, [ Math.floor(t / 36) / 5 * 255, Math.floor((n = t % 36) / 6) / 5 * 255, n % 6 / 5 * 255 ];
}, La.rgb.hex = function(t) {
    var e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
    return "000000".substring(e.length) + e;
}, La.hex.rgb = function(t) {
    var e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!e) return [ 0, 0, 0 ];
    var n = e[0];
    3 === e[0].length && (n = n.split("").map((function(t) {
        return t + t;
    })).join(""));
    var i = parseInt(n, 16);
    return [ i >> 16 & 255, i >> 8 & 255, 255 & i ];
}, La.rgb.hcg = function(t) {
    var e, n = t[0] / 255, i = t[1] / 255, r = t[2] / 255, s = Math.max(Math.max(n, i), r), o = Math.min(Math.min(n, i), r), a = s - o;
    return e = a <= 0 ? 0 : s === n ? (i - r) / a % 6 : s === i ? 2 + (r - n) / a : 4 + (n - i) / a + 4, 
    e /= 6, [ 360 * (e %= 1), 100 * a, 100 * (a < 1 ? o / (1 - a) : 0) ];
}, La.hsl.hcg = function(t) {
    var e = t[1] / 100, n = t[2] / 100, i = 1, r = 0;
    return (i = n < .5 ? 2 * e * n : 2 * e * (1 - n)) < 1 && (r = (n - .5 * i) / (1 - i)), 
    [ t[0], 100 * i, 100 * r ];
}, La.hsv.hcg = function(t) {
    var e = t[1] / 100, n = t[2] / 100, i = e * n, r = 0;
    return i < 1 && (r = (n - i) / (1 - i)), [ t[0], 100 * i, 100 * r ];
}, La.hcg.rgb = function(t) {
    var e = t[0] / 360, n = t[1] / 100, i = t[2] / 100;
    if (0 === n) return [ 255 * i, 255 * i, 255 * i ];
    var r, s = [ 0, 0, 0 ], o = e % 1 * 6, a = o % 1, c = 1 - a;
    switch (Math.floor(o)) {
      case 0:
        s[0] = 1, s[1] = a, s[2] = 0;
        break;

      case 1:
        s[0] = c, s[1] = 1, s[2] = 0;
        break;

      case 2:
        s[0] = 0, s[1] = 1, s[2] = a;
        break;

      case 3:
        s[0] = 0, s[1] = c, s[2] = 1;
        break;

      case 4:
        s[0] = a, s[1] = 0, s[2] = 1;
        break;

      default:
        s[0] = 1, s[1] = 0, s[2] = c;
    }
    return r = (1 - n) * i, [ 255 * (n * s[0] + r), 255 * (n * s[1] + r), 255 * (n * s[2] + r) ];
}, La.hcg.hsv = function(t) {
    var e = t[1] / 100, n = e + t[2] / 100 * (1 - e), i = 0;
    return n > 0 && (i = e / n), [ t[0], 100 * i, 100 * n ];
}, La.hcg.hsl = function(t) {
    var e = t[1] / 100, n = t[2] / 100 * (1 - e) + .5 * e, i = 0;
    return n > 0 && n < .5 ? i = e / (2 * n) : n >= .5 && n < 1 && (i = e / (2 * (1 - n))), 
    [ t[0], 100 * i, 100 * n ];
}, La.hcg.hwb = function(t) {
    var e = t[1] / 100, n = e + t[2] / 100 * (1 - e);
    return [ t[0], 100 * (n - e), 100 * (1 - n) ];
}, La.hwb.hcg = function(t) {
    var e = t[1] / 100, n = 1 - t[2] / 100, i = n - e, r = 0;
    return i < 1 && (r = (n - i) / (1 - i)), [ t[0], 100 * i, 100 * r ];
}, La.apple.rgb = function(t) {
    return [ t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255 ];
}, La.rgb.apple = function(t) {
    return [ t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535 ];
}, La.gray.rgb = function(t) {
    return [ t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255 ];
}, La.gray.hsl = La.gray.hsv = function(t) {
    return [ 0, 0, t[0] ];
}, La.gray.hwb = function(t) {
    return [ 0, 100, t[0] ];
}, La.gray.cmyk = function(t) {
    return [ 0, 0, 0, t[0] ];
}, La.gray.lab = function(t) {
    return [ t[0], 0, 0 ];
}, La.gray.hex = function(t) {
    var e = 255 & Math.round(t[0] / 100 * 255), n = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
}, La.rgb.gray = function(t) {
    return [ (t[0] + t[1] + t[2]) / 3 / 255 * 100 ];
};

var Ga = Ra.exports, Ba = Ga;

function Va(t) {
    var e = function() {
        for (var t = {}, e = Object.keys(Ba), n = e.length, i = 0; i < n; i++) t[e[i]] = {
            distance: -1,
            parent: null
        };
        return t;
    }(), n = [ t ];
    for (e[t].distance = 0; n.length; ) for (var i = n.pop(), r = Object.keys(Ba[i]), s = r.length, o = 0; o < s; o++) {
        var a = r[o], c = e[a];
        -1 === c.distance && (c.distance = e[i].distance + 1, c.parent = i, n.unshift(a));
    }
    return e;
}

function ja(t, e) {
    return function(n) {
        return e(t(n));
    };
}

function Wa(t, e) {
    for (var n = [ e[t].parent, t ], i = Ba[e[t].parent][t], r = e[t].parent; e[r].parent; ) n.unshift(e[r].parent), 
    i = ja(Ba[e[r].parent][r], i), r = e[r].parent;
    return i.conversion = n, i;
}

var qa = Ga, Xa = function(t) {
    for (var e = Va(t), n = {}, i = Object.keys(e), r = i.length, s = 0; s < r; s++) {
        var o = i[s];
        null !== e[o].parent && (n[o] = Wa(o, e));
    }
    return n;
}, Ka = {};

Object.keys(qa).forEach((function(t) {
    Ka[t] = {}, Object.defineProperty(Ka[t], "channels", {
        value: qa[t].channels
    }), Object.defineProperty(Ka[t], "labels", {
        value: qa[t].labels
    });
    var e = Xa(t);
    Object.keys(e).forEach((function(n) {
        var i = e[n];
        Ka[t][n] = function(t) {
            var e = function(e) {
                if (null == e) return e;
                arguments.length > 1 && (e = Array.prototype.slice.call(arguments));
                var n = t(e);
                if ("object" == typeof n) for (var i = n.length, r = 0; r < i; r++) n[r] = Math.round(n[r]);
                return n;
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(i), Ka[t][n].raw = function(t) {
            var e = function(e) {
                return null == e ? e : (arguments.length > 1 && (e = Array.prototype.slice.call(arguments)), 
                t(e));
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(i);
    }));
}));

var $a = Ha, Ja = Ka, Ya = [].slice, Za = [ "keyword", "gray", "hex" ], Qa = {};

Object.keys(Ja).forEach((function(t) {
    Qa[Ya.call(Ja[t].labels).sort().join("")] = t;
}));

var tc = {};

function ec(t, e) {
    if (!(this instanceof ec)) return new ec(t, e);
    if (e && e in Za && (e = null), e && !(e in Ja)) throw new Error("Unknown model: " + e);
    var n, i;
    if (null == t) this.model = "rgb", this.color = [ 0, 0, 0 ], this.valpha = 1; else if (t instanceof ec) this.model = t.model, 
    this.color = t.color.slice(), this.valpha = t.valpha; else if ("string" == typeof t) {
        var r = $a.get(t);
        if (null === r) throw new Error("Unable to parse color from string: " + t);
        this.model = r.model, i = Ja[this.model].channels, this.color = r.value.slice(0, i), 
        this.valpha = "number" == typeof r.value[i] ? r.value[i] : 1;
    } else if (t.length) {
        this.model = e || "rgb", i = Ja[this.model].channels;
        var s = Ya.call(t, 0, i);
        this.color = rc(s, i), this.valpha = "number" == typeof t[i] ? t[i] : 1;
    } else if ("number" == typeof t) t &= 16777215, this.model = "rgb", this.color = [ t >> 16 & 255, t >> 8 & 255, 255 & t ], 
    this.valpha = 1; else {
        this.valpha = 1;
        var o = Object.keys(t);
        "alpha" in t && (o.splice(o.indexOf("alpha"), 1), this.valpha = "number" == typeof t.alpha ? t.alpha : 0);
        var a = o.sort().join("");
        if (!(a in Qa)) throw new Error("Unable to parse color from object: " + JSON.stringify(t));
        this.model = Qa[a];
        var c = Ja[this.model].labels, h = [];
        for (n = 0; n < c.length; n++) h.push(t[c[n]]);
        this.color = rc(h);
    }
    if (tc[this.model]) for (i = Ja[this.model].channels, n = 0; n < i; n++) {
        var l = tc[this.model][n];
        l && (this.color[n] = l(this.color[n]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}

function nc(t, e, n) {
    return (t = Array.isArray(t) ? t : [ t ]).forEach((function(t) {
        (tc[t] || (tc[t] = []))[e] = n;
    })), t = t[0], function(i) {
        var r;
        return arguments.length ? (n && (i = n(i)), (r = this[t]()).color[e] = i, r) : (r = this[t]().color[e], 
        n && (r = n(r)), r);
    };
}

function ic(t) {
    return function(e) {
        return Math.max(0, Math.min(t, e));
    };
}

function rc(t, e) {
    for (var n = 0; n < e; n++) "number" != typeof t[n] && (t[n] = 0);
    return t;
}

ec.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(t) {
        var e = this.model in $a.to ? this : this.rgb(), n = 1 === (e = e.round("number" == typeof t ? t : 1)).valpha ? e.color : e.color.concat(this.valpha);
        return $a.to[e.model](n);
    },
    percentString: function(t) {
        var e = this.rgb().round("number" == typeof t ? t : 1), n = 1 === e.valpha ? e.color : e.color.concat(this.valpha);
        return $a.to.rgb.percent(n);
    },
    array: function() {
        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        for (var t = {}, e = Ja[this.model].channels, n = Ja[this.model].labels, i = 0; i < e; i++) t[n[i]] = this.color[i];
        return 1 !== this.valpha && (t.alpha = this.valpha), t;
    },
    unitArray: function() {
        var t = this.rgb().color;
        return t[0] /= 255, t[1] /= 255, t[2] /= 255, 1 !== this.valpha && t.push(this.valpha), 
        t;
    },
    unitObject: function() {
        var t = this.rgb().object();
        return t.r /= 255, t.g /= 255, t.b /= 255, 1 !== this.valpha && (t.alpha = this.valpha), 
        t;
    },
    round: function(t) {
        return t = Math.max(t || 0, 0), new ec(this.color.map(function(t) {
            return function(e) {
                return function(t, e) {
                    return Number(t.toFixed(e));
                }(e, t);
            };
        }(t)).concat(this.valpha), this.model);
    },
    alpha: function(t) {
        return arguments.length ? new ec(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
    },
    red: nc("rgb", 0, ic(255)),
    green: nc("rgb", 1, ic(255)),
    blue: nc("rgb", 2, ic(255)),
    hue: nc([ "hsl", "hsv", "hsl", "hwb", "hcg" ], 0, (function(t) {
        return (t % 360 + 360) % 360;
    })),
    saturationl: nc("hsl", 1, ic(100)),
    lightness: nc("hsl", 2, ic(100)),
    saturationv: nc("hsv", 1, ic(100)),
    value: nc("hsv", 2, ic(100)),
    chroma: nc("hcg", 1, ic(100)),
    gray: nc("hcg", 2, ic(100)),
    white: nc("hwb", 1, ic(100)),
    wblack: nc("hwb", 2, ic(100)),
    cyan: nc("cmyk", 0, ic(100)),
    magenta: nc("cmyk", 1, ic(100)),
    yellow: nc("cmyk", 2, ic(100)),
    black: nc("cmyk", 3, ic(100)),
    x: nc("xyz", 0, ic(100)),
    y: nc("xyz", 1, ic(100)),
    z: nc("xyz", 2, ic(100)),
    l: nc("lab", 0, ic(100)),
    a: nc("lab", 1),
    b: nc("lab", 2),
    keyword: function(t) {
        return arguments.length ? new ec(t) : Ja[this.model].keyword(this.color);
    },
    hex: function(t) {
        return arguments.length ? new ec(t) : $a.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var t = this.rgb().color;
        return (255 & t[0]) << 16 | (255 & t[1]) << 8 | 255 & t[2];
    },
    luminosity: function() {
        for (var t = this.rgb().color, e = [], n = 0; n < t.length; n++) {
            var i = t[n] / 255;
            e[n] = i <= .03928 ? i / 12.92 : Math.pow((i + .055) / 1.055, 2.4);
        }
        return .2126 * e[0] + .7152 * e[1] + .0722 * e[2];
    },
    contrast: function(t) {
        var e = this.luminosity(), n = t.luminosity();
        return e > n ? (e + .05) / (n + .05) : (n + .05) / (e + .05);
    },
    level: function(t) {
        var e = this.contrast(t);
        return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        var t = this.rgb().color;
        return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        for (var t = this.rgb(), e = 0; e < 3; e++) t.color[e] = 255 - t.color[e];
        return t;
    },
    lighten: function(t) {
        var e = this.hsl();
        return e.color[2] += e.color[2] * t, e;
    },
    darken: function(t) {
        var e = this.hsl();
        return e.color[2] -= e.color[2] * t, e;
    },
    saturate: function(t) {
        var e = this.hsl();
        return e.color[1] += e.color[1] * t, e;
    },
    desaturate: function(t) {
        var e = this.hsl();
        return e.color[1] -= e.color[1] * t, e;
    },
    whiten: function(t) {
        var e = this.hwb();
        return e.color[1] += e.color[1] * t, e;
    },
    blacken: function(t) {
        var e = this.hwb();
        return e.color[2] += e.color[2] * t, e;
    },
    grayscale: function() {
        var t = this.rgb().color, e = .3 * t[0] + .59 * t[1] + .11 * t[2];
        return ec.rgb(e, e, e);
    },
    fade: function(t) {
        return this.alpha(this.valpha - this.valpha * t);
    },
    opaquer: function(t) {
        return this.alpha(this.valpha + this.valpha * t);
    },
    rotate: function(t) {
        var e = this.hsl(), n = e.color[0];
        return n = (n = (n + t) % 360) < 0 ? 360 + n : n, e.color[0] = n, e;
    },
    mix: function(t, e) {
        if (!t || !t.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
        var n = t.rgb(), i = this.rgb(), r = void 0 === e ? .5 : e, s = 2 * r - 1, o = n.alpha() - i.alpha(), a = ((s * o == -1 ? s : (s + o) / (1 + s * o)) + 1) / 2, c = 1 - a;
        return ec.rgb(a * n.red() + c * i.red(), a * n.green() + c * i.green(), a * n.blue() + c * i.blue(), n.alpha() * r + i.alpha() * (1 - r));
    }
}, Object.keys(Ja).forEach((function(t) {
    if (-1 === Za.indexOf(t)) {
        var e = Ja[t].channels;
        ec.prototype[t] = function() {
            if (this.model === t) return new ec(this);
            if (arguments.length) return new ec(arguments, t);
            var n, i = "number" == typeof arguments[e] ? e : this.valpha;
            return new ec((n = Ja[this.model][t].raw(this.color), Array.isArray(n) ? n : [ n ]).concat(i), t);
        }, ec[t] = function(n) {
            return "number" == typeof n && (n = rc(Ya.call(arguments), e)), new ec(n, t);
        };
    }
}));

var sc = ga(ec);

const oc = "function" == typeof Object.assign, ac = [];

function cc(t) {
    if (oc) Object.assign.apply(Object, arguments); else for (let e = 1; e < arguments.length; e++) {
        const n = arguments[e];
        for (const e in n) t[e] = n[e];
    }
    return t;
}

function hc(t) {
    return null == t;
}

function lc(t) {
    return "number" == typeof t && !isNaN(t);
}

function fc(t) {
    return !hc(t) && ("function" == typeof t || null !== t.constructor && t.constructor === Function);
}

const uc = [];

function dc(t, e) {
    const n = e._get2DExtentAtRes(e.getGLRes()), i = n.getWidth(), r = n.getHeight(), s = t;
    c.identity(s);
    const o = h.copy(ac, e.cameraLookAt);
    return o[2] = 0, c.translate(s, s, o), c.scale(s, s, h.set(uc, i, r, 1)), s;
}

function mc(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}

function vc(t) {
    for (let e = 1; e < arguments.length; e++) {
        const n = arguments[e];
        if (n) for (let e = 0, i = n.length; e < i; e++) t.push(n[e]);
    }
    return t.length;
}

const gc = {};

function pc(t, e) {
    if (!Array.isArray(e)) {
        const t = e;
        e = gc[t] = gc[t] || sc(e).unitArray();
    }
    for (let n = 0; n < e.length; n++) t[n] = e[n];
    return 3 === e.length && (t[3] = 1), t;
}

function xc(t, e) {
    if (!Array.isArray(e)) {
        const t = e;
        e = gc[t] = gc[t] || sc(e).unitArray();
    }
    for (let n = 0; n < e.length; n++) t[n] = 255 * e[n];
    return 3 === t.length && t.push(255), t;
}

function _c(t, n, i = 0) {
    if (!(t && n instanceof e)) return null;
    const r = t.coordinateToPointAtRes(n, t.getGLRes());
    return [ r.x, r.y, i ];
}

const bc = [ 0, 0 ], yc = [ 0, 0, 0 ];

let wc;

class Sc {
    static getUniformDeclares() {
        const t = [], e = [];
        return e.push({
            name: "shadow_lightProjViewModelMatrix",
            type: "function",
            fn: function(e, n) {
                const i = n.shadow_lightProjViewMatrix, r = n.modelMatrix;
                return c.multiply(t, i, r);
            }
        }), e;
    }
    constructor(t, e) {
        this.renderer = new pi(t), this.Mo = .3, this.Zr = e, this.ts();
    }
    resize() {
        const t = this.canvas;
        t.width = this.Zr.getRenderer().canvas.width, t.height = this.Zr.getRenderer().canvas.height;
    }
    ts() {
        const t = (this.Zr.To() || {}).shadow || {}, e = this.Co(), n = this.getDefines();
        this.Oo = new zo(this.renderer, {
            width: e,
            height: e,
            blurOffset: t.blurOffset,
            defines: n
        }), this.Eo = new Go(n), this.Io();
    }
    Co() {
        let t = 2048;
        const e = ((this.Zr.To() || {}).shadow || {}).quality;
        return "medium" === e ? t = 1024 : "low" === e && (t = 512), t;
    }
    getDefines() {
        return {
            "HAS_SHADOWING": 1,
            "PACK_FLOAT": 1,
            "USE_ESM": 1
        };
    }
    render(t, e, n, i, r, s, o, a, l, f) {
        this.Po();
        const u = this.Zr.getMap(), d = this.Co();
        let m, v;
        if (f || d !== this.Oo.width || this.Ho(u, o, !!t)) {
            d !== this.Oo.width && this.Oo.resize(d, d), this.Ro = this.Ro || [], this.ko = this.ko || [];
            const i = c.multiply(this.Ro, e, n), r = h.normalize(this.ko, s);
            wc || (wc = u.getContainerExtent());
            let a = u.height;
            u.getPitch() > 62 && (a = u._getVisualHeight(62));
            const l = wc.set(0, u.height - a, u.width, u.height).convertTo((t => u._containerPointToPointAtRes(t, u.getGLRes()))).toArray();
            t && o.addMesh(this.No);
            const f = l.map((t => [ t.x, t.y, 0, 1 ])), {lightProjViewMatrix: g, shadowMap: p, blurFBO: x} = this.Oo.render(o, {
                cameraProjViewMatrix: i,
                lightDir: r,
                farPlane: f,
                cameraLookAt: u.cameraLookAt
            });
            m = this.Do = g, v = this.Lo = p, this.Fo = x, this.Uo = o.getMeshes().reduce(((t, e) => (e.castShadow && e.geometry && (t[e.uuid] = {
                v0: e.version,
                v1: e.geometry.version
            }), t)), {}), this.zo = {
                count: o.getMeshes().length - +!!t,
                displayShadow: !!t
            }, this.Go = !0;
        } else m = this.Do, v = this.Lo, this.Go = !1;
        this.Bo = e, this.Vo = n, hc(r) && (r = 1), t && o.getMeshes().length && this.displayShadow(i, r, a, l);
        return {
            "shadow_lightProjViewMatrix": m,
            "shadow_shadowMap": v,
            "shadow_opacity": r,
            "shadow_color": i || yc,
            "esm_shadow_threshold": this.Mo
        };
    }
    displayShadow(t, e, n, i) {
        const r = this.Do, s = this.No, o = this.jo || [], a = this.Zr.getRenderer().canvas, h = this.Wo = this.Wo || [];
        h[0] = a.width, h[1] = a.height, this.renderer.render(this.Eo, {
            "halton": n || bc,
            "globalTexSize": h,
            "projMatrix": this.Bo,
            "viewMatrix": this.Vo,
            "shadow_lightProjViewModelMatrix": c.multiply(o, r, s.localTransform),
            "shadow_shadowMap": this.Lo,
            "esm_shadow_threshold": this.Mo,
            "shadow_opacity": e,
            "color": t || yc
        }, this.qo, i);
    }
    dispose() {
        this.Oo.dispose(), this.Eo.dispose(), this.No && (this.No.geometry.dispose(), this.No.dispose()), 
        delete this.renderer;
    }
    isUpdated() {
        return !1 !== this.Go;
    }
    Ho(t, e, n) {
        if (!this.Uo) return !0;
        const i = this.zo;
        if (e.getMeshes().length !== i.count || n !== i.displayShadow) return !0;
        const r = e.getMeshes();
        for (let t = 0; t < r.length; t++) {
            const e = this.Uo[r[t].uuid];
            if (r[t].castShadow && (r[t].hasSkinAnimation() || !e || e.v0 !== r[t].version || e.v1 !== r[t].geometry.version)) return !0;
        }
        return !1;
    }
    Io() {
        const t = new Bi;
        t.generateBuffers(this.renderer.device), this.No = new mi(t), this.qo = new Ti([ this.No ]);
    }
    Po() {
        const t = this.Zr.getMap(), e = dc(this.No.localTransform, t);
        this.No.setLocalTransform(e);
    }
}

const Ac = [ 0, 0 ], Mc = new t.Coordinate(0, 0), Tc = new t.Coordinate(0, 0), Cc = [], Oc = [], Ec = [];

function Ic(t, e, n, i) {
    const r = t.getGLRes(), s = t.distanceToPointAtRes(e, e, r, n ? Mc : null, Tc);
    return i ? s.y : s.x;
}

const {getIBLResOnCanvas: Pc, logoutIBLResOnCanvas: Hc, getPBRUniforms: Rc, loginIBLResOnCanvas: kc} = da.PBRUtils, Nc = [ 0, 0 ], Dc = [ 1, 1 ], Lc = [], Fc = [], Uc = [], zc = [], Gc = [];

class Bc {
    static getGroundTransform(t, e) {
        return dc(t, e);
    }
    constructor(t, e) {
        this.p = t, this.renderer = new pi(t), this.Zr = e, this.Xo = new bi(null), this.Ko = (...t) => this.$o.call(this, ...t), 
        this.ts();
        const n = this.getMap().getRenderer().canvas;
        kc(n, t, this.getMap());
    }
    needToRedraw() {
        const t = this.Jo();
        return t && (t[0] || t[1]);
    }
    getMap() {
        return this.Zr && this.Zr.getMap();
    }
    getSymbol() {
        const t = this.Zr.getGroundConfig();
        return t && t.symbol;
    }
    isEnable() {
        const t = this.Zr.getGroundConfig();
        return t && t.enable;
    }
    paint(t) {
        if (!this.isEnable()) return !1;
        const e = this.ro();
        if (this.Yo(t) && e === this.Zo) return !1;
        const n = this.Qo(t);
        n && this.No.setDefines(n), this.No.material !== this.material && this.No.setMaterial(this.material);
        const i = this.Zr.getGroundConfig();
        (i && i.symbol).ssr ? this.No.ssr = 1 : this.No.ssr = 0, this.Po();
        const r = this.ta(t);
        r.offsetFactor = t.offsetFactor, r.offsetUnits = t.offsetUnits;
        const s = t && t.renderTarget && t.renderTarget.fbo, o = this.Zr.getRenderer();
        return e === this.Zo ? (this.renderer.render(e, r, this.qo, s), o.setCanvasUpdated && o.setCanvasUpdated(), 
        !0) : (e.filter = t.sceneFilter, this.renderer.render(e, r, this.qo, s), o.setCanvasUpdated && o.setCanvasUpdated(), 
        !0);
    }
    Yo(t) {
        return !(!this.Zr.getRenderer().isEnableSSR || !this.Zr.getRenderer().isEnableSSR()) && !(!t || !t.ssr);
    }
    update() {
        const t = this.Zr.getGroundConfig();
        if (!t) return;
        const e = t && t.symbol, n = t.urlModifier;
        if (e) {
            this.ea = this.na(e.polygonFill || [ 1, 1, 1, 1 ]), this.ia = void 0 === e.polygonOpacity ? 1 : e.polygonOpacity;
            const t = e.polygonPatternFile;
            if (t) {
                if (!this.ra || this.ra._pattern_src !== t) {
                    const e = new Image;
                    e.onload = () => {
                        this.ra && this.ra.destroy(), this.ra = this.sa(e), this.ra._pattern_src = t, this.setToRedraw();
                    }, e.src = n && n(t) || t;
                }
            } else this.ra && (this.ra.destroy(), delete this.ra);
        } else this.ea = [ 1, 1, 1, 1 ], this.ia = 1, this.ra && (this.ra.destroy(), delete this.ra);
        this.oa();
    }
    setToRedraw() {
        const t = this.Zr.getRenderer();
        t && t.setToRedraw();
    }
    dispose() {
        this.material && (this.material.dispose(), delete this.material), this.No && (this.No.geometry.dispose(), 
        this.No.material && this.No.material.dispose(), this.No.dispose(), delete this.No), 
        this.ra && (this.ra.destroy(), delete this.ra), this.Zo && (this.Zo.dispose(), delete this.Zo), 
        this.aa && (this.aa.dispose(), delete this.aa), this.ca();
    }
    ro() {
        const t = this.Zr.getGroundConfig();
        if (!t || !t.renderPlugin) return this.Zo;
        const e = t.renderPlugin.type;
        if ("lit" === e) return this.aa;
        if ("fill" === e) return this.Zo;
        throw new Error("unsupported render plugin of " + e + " for layer ground");
    }
    ta(t) {
        const e = this.ha(t);
        e.polygonFill = this.ea, e.polygonOpacity = this.ia;
        return this.ro() === this.Zo && this.ra && (e.polygonPatternFile = this.ra), e;
    }
    ha(t) {
        let e;
        if ("lit" === this.Zr.getGroundConfig().renderPlugin.type) {
            const n = this.getMap().getRenderer().canvas, {iblTexes: i, dfgLUT: r} = Pc(n);
            e = Rc(this.getMap(), i, r, t && t.ssr, t && t.jitter);
        } else {
            e = {
                projViewMatrix: this.getMap().projViewMatrix
            };
        }
        return this.la(e, t), e;
    }
    la(t, e) {
        const n = e && e.includes;
        if (n) for (const i in n) n[i] && e[i].renderUniforms && cc(t, e[i].renderUniforms);
    }
    ca() {
        const t = this.getMap().getRenderer().canvas;
        Hc(t, this.getMap());
    }
    ts() {
        const t = this.fa(), e = Sc.getUniformDeclares(), n = [];
        e.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(t, e) {
                return c.multiply(n, e.projViewMatrix, e.modelMatrix);
            }
        }), this.Zo = new Br({
            name: "ground-fill",
            vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\nattribute vec2 aTexCoord;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvTexCoord = aTexCoord * uvScale + uvOffset;\n#endif\nvec3 c = vec3(aPosition);\n  gl_Position = projViewModelMatrix * vec4(c, 1.);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(vec4(c, 1.));\n#endif\n}",
            frag: "precision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D polygonPatternFile;\nvarying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvec4 c = texture2D(polygonPatternFile, vTexCoord);\n#else\nvec4 c = polygonFill;\n#endif\ngl_FragColor = c * polygonOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat d = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, d);\n#endif\n}",
            wgslFrag: null,
            wgslVert: null,
            uniforms: e,
            extraCommandProps: t,
            defines: {}
        });
        const i = Sc.getUniformDeclares();
        i.push(...ss.getUniformDeclares()), this.aa = new da.StandardShader({
            uniforms: i,
            extraCommandProps: t
        }), this.Io(), this.update();
    }
    fa() {
        const t = [ 0, 1 ], e = this.Zr.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => e.width,
                height: () => e.height
            },
            cull: {
                enable: !0
            },
            depth: {
                enable: !0,
                mask: () => {
                    const t = this.Zr.getGroundConfig();
                    return t.depth || void 0 === t.depth;
                },
                range: () => {
                    const e = this.Zr.getGroundConfig(), n = e && e.renderPlugin.sceneConfig;
                    return n && n.depthRange || t;
                },
                func: "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: {
                    factor: (t, e) => e.offsetFactor,
                    units: (t, e) => e.offsetUnits
                }
            }
        };
    }
    ua() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    Io() {
        const t = new Bi;
        t.data.aTexCoord = new Uint8Array([ 0, 0, 1, 0, 0, 1, 1, 1 ]), t.createTangent(), 
        t.generateBuffers(this.renderer.device), this.No = new mi(t, null, {
            castShadow: !1
        });
        const e = this.aa.getGeometryDefines(t);
        this.No.setDefines(e), this.qo = new Ti([ this.No ]);
    }
    Po() {
        const t = this.getMap(), e = Bc.getGroundTransform(this.No.localTransform, t);
        this.No.setLocalTransform(e);
        const n = t.getGLRes(), i = t._get2DExtentAtRes(n), r = i.getWidth(), s = i.getHeight(), o = t.cameraLookAt, a = o[0] - r, c = o[1] - s, h = this.ra ? this.ra.width / this.ra.height : 1, l = this.getSymbol(), f = this.material ? this.material.get("textureOrigin") : l.polygonPatternFileOrigin, d = !!(this.material ? this.material.get("uvOffsetInMeter") : l.uvOffsetInMeter), m = (this.material ? this.material.get("uvOffset") : l.uvOffset) || Nc, v = this.material && this.material.get("uvScale") || Dc, g = this.material ? this.material.get("textureWidth") : l.polygonPatternFileWidth, p = this.material ? g * (v[1] / v[0]) : l.polygonPatternFileHeight, x = this.Jo(), [_, b, y, w, S] = function(t, e, n, i, r, s, o, a, c, h, l) {
            const f = t.getGLRes();
            i && (Mc.set(i[0], i[1]), t.coordToPointAtRes(Mc, f, Tc), e -= Tc.x, n -= Tc.y);
            const d = i ? Mc : null;
            h = u.copy(Oc, h);
            const m = !c && h || Ac;
            let v = c && h || Ac;
            v = u.copy(Cc, v), v[0] && (v[0] = Ic(t, v[0], d)), v[1] && (v[1] = Ic(t, v[1], d, 1));
            let g = .5;
            r && (g = Ic(t, r, d));
            let p = g / o;
            if (s && (p = Ic(t, s, d, 1)), l && (l[0] || l[1])) {
                const e = performance.now() / 1e3;
                let n = l[0], i = l[1];
                c && (n = -Ic(t, l[0], d), i = -Ic(t, l[1], d, 1)), l[0] && (c ? v[0] = e * n : m[0] = e * n), 
                l[1] && (c ? v[1] = e * i : m[1] = e * i);
            }
            const x = (e + v[0]) / (g / a[0]), _ = (n - v[1]) / (p / a[1]);
            return Ec[0] = g / a[0], Ec[1] = p / a[1], Ec[2] = x, Ec[3] = _, Ec[4] = m, Ec;
        }(t, a, c, f, g, p, h, v, d, m, x), A = 2 * i.getWidth() / _, M = 2 * i.getHeight() / b;
        if (!this.material) return this.No.setUniform("uvScale", u.set(Lc, A, M)), void this.No.setUniform("uvOffset", u.set(Fc, y % 1 + S[0], w % 1 + S[1]));
        this.No.setUniform("uvScale", u.set(Gc, A, M)), this.No.setUniform("uvOffset", u.set(Uc, y % 1 + S[0], w % 1 + S[1])), 
        this.No.setUniform("uvOrigin", u.set(zc, y - y % 1, w - w % 1)), this.No.setUniform("uvRotation", 0);
    }
    Qo(t) {
        let e = !1;
        const n = this.No.defines, i = this.Zr.To && this.Zr.To(), r = this.Zr.getGroundConfig();
        function s(t, i) {
            t ? n[i] || (n[i] = 1, e = !0) : n[i] && (delete n[i], e = !0);
        }
        s(this.ua(), "HAS_IBL_LIGHTING");
        s(t && t.ssr && r && r.symbol && r.symbol.ssr, "HAS_SSR");
        const o = t && i && i.shadow && i.shadow.enable;
        s(o, "HAS_SHADOWING"), s(o, "USE_ESM");
        return s(!!this.ra, "HAS_PATTERN"), e ? n : null;
    }
    oa() {
        const t = this.getSymbol() && this.getSymbol().material || {}, e = {};
        let n = !1;
        const i = this.Zr.getGroundConfig();
        this.Xo.setURLModifier(i.urlModifier);
        for (const i in t) if (mc(t, i)) if (i.indexOf("Texture") > 0) {
            let r = t[i];
            if (!r) continue;
            r = "string" == typeof r ? {
                url: r,
                wrap: "repeat"
            } : r, r.flipY = !0, r.min = "linear mipmap linear", r.mag = "linear", r.flipY = !0, 
            e[i] = new Gi(r, this.Xo), n = !0;
        } else e[i] = t[i];
        this.material ? (this.da = new da.StandardMaterial(e), this.da.isReady() ? this.$o() : this.da.once("complete", this.Ko)) : (this.material = new da.StandardMaterial(e), 
        this.material.once("complete", this.Ko, this)), n || this.$o();
    }
    $o() {
        this.da && (this.material.dispose(), this.material = this.da, delete this.da), this.setToRedraw();
    }
    sa(t) {
        t = $(t);
        const e = this.p, n = {
            width: t.width,
            height: t.height,
            data: t,
            mag: "linear",
            min: "linear mipmap linear",
            flipY: !0,
            wrap: "repeat"
        };
        return e.texture(n);
    }
    na(t) {
        return pc([], t);
    }
    Jo() {
        return this.material && this.material.get("uvOffsetAnim");
    }
    getRenderMeshes() {
        return this.qo.getMeshes();
    }
}

const {createIBLTextures: Vc, disposeIBLTextures: jc} = da.PBRUtils, Wc = [ 0, 0, 0 ], qc = [], Xc = [];

class Kc {
    constructor(t, e) {
        this.ma = 4, this.p = t, this.renderer = new pi(t), this.Zr = e, this.ts(), this.va();
    }
    paint(t) {
        if (!this.isEnable() || !this.ga) return;
        const e = this.ta(t), n = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.es, e, null, n);
    }
    update() {
        const t = this.getMap();
        if (!t || !this.isEnable()) return;
        const e = t.getLightManager(), n = e && e.getAmbientResource();
        n !== this.ga && this.pa && (jc(this.pa), delete this.pa), this.ga = n, this.va();
    }
    dispose() {
        this.es.dispose(), jc(this.pa), delete this.es, delete this.pa, delete this.ga;
    }
    getMap() {
        return this.Zr.getMap();
    }
    va() {
        if (!this.ga) return;
        const t = this.Zr.To().environment || {};
        this.es.setMode(t.toneMapping, t.mode ? 1 : 0);
    }
    isEnable() {
        const t = this.Zr.To();
        return this.ua() && t && t.environment && t.environment.enable;
    }
    ua() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    ta() {
        const t = this.getMap(), e = this.getMap().getLightManager(), n = e && e.getAmbientLight();
        let i = this.pa;
        i || (i = this.pa = Vc(this.p, t));
        const r = this.Zr.getRenderer().canvas, s = this.Zr.To().environment || {}, o = s.level || 0, a = i.prefilterMap.width, c = this.xa = this.xa || [], l = n && n.hsv || Wc, u = s.brightness || 0, d = s.intensity || 1;
        return h.copy(qc, l), u && (qc[2] += u), Xc[0] = r.width, Xc[1] = r.height, {
            "cubeMap": i.prefilterMap,
            "bias": o,
            "size": a / Math.pow(2, Math.max(0, o - 1)),
            "environmentExposure": lc(n && n.exposure) ? n.exposure : 1,
            "backgroundIntensity": d,
            "diffuseSPH": i.sh,
            "viewMatrix": t.viewMatrix,
            "projMatrix": t.projMatrix,
            "resolution": Xc,
            "hsv": qc,
            "transformMatrix": f.fromRotation(c, n && Math.PI / 180 * -n.orientation || 0)
        };
    }
    ts() {
        const t = this.getMap();
        if (t.on("updatelights", this.update, this), this.es = new hs, t.options.lights) {
            const t = this.getMap().getLightManager().getAmbientResource();
            this.ga = t;
        }
    }
}

const $c = [], Jc = [ .03, .03, .03 ], Yc = [], Zc = [], Qc = [], th = [ 1, 1, 1 ], eh = [ -1200, -1200, 0 ], nh = [ 1200, 1200, 1e3 ], ih = {
    min: [],
    max: []
}, rh = c.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class sh {
    constructor(t, e) {
        this.p = t, this.renderer = new pi(t), this.Zr = e, this._a = new oh, this.ts();
    }
    getMap() {
        return this.Zr && this.Zr.getMap();
    }
    ts() {
        const t = this.Zr.getRenderer().canvas, e = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.es = new Br({
            vert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat c(float x, float y) {\n  return atan(y, x);\n}\nvec2 d(vec2 e, vec2 f, vec2 h) {\n  vec2 i = vec2(.0);\n  float j = distance(h, f);\n  float a = c(e.x - f.x, e.y - f.y);\n  h.x > f.x ? a -= .785 : a += .785;\n  i.x = cos(a) * j;\n  i.y = sin(a) * j;\n  return i + f;\n  return i;\n}\nvoid main() {\n  vec4 k = getPosition(aPosition);\n  mat4 l = getPositionMatrix();\n  vec2 m = d(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(k.x, k.z));\n  float n = top - bottom;\n  float y = aNormal.y - bottom - n * time;\n  y = y + (y < .0 ? n : .0);\n  float o = (1. - y / n) * (1. - y / n);\n  y = n * (1. - o);\n  y += bottom;\n  y += aPosition.y - aNormal.y;\n  k = vec4(m.x, y, m.y, 1.);\n  gl_Position = projMatrix * modelViewMatrix * l * k;\n  vTexCoord = aTexCoord;\n}",
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n  vec4 c = texture2D(rainMap, vTexCoord);\n  vec4 d = vec4(diffuse, opacity);\n  d *= c;\n  gl_FragColor = d;\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply($c, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: e,
                depth: {
                    enable: !0,
                    mask: !1,
                    func: "less",
                    range: [ 0, 1 ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        }), this.ba();
    }
    ba() {
        const t = this.p.texture({
            width: 2,
            height: 2
        });
        if (this.hs = this.ya(), !this.hs) return;
        this.rs = new Ti(this.hs);
        const e = this.wa();
        e.rainTexture ? this.Sa(e.rainTexture).then((t => {
            this.hs.material.set("rainMap", t);
        })) : (this.hs.material.set("rainMap", t), console.warn("should set rain texture."));
    }
    ya() {
        const t = this.getMap(), e = this.wa();
        if (!e) return null;
        this.cs = t.getZoom();
        const n = this.Aa(), i = this.Ma = e.density, r = this.Ta = e.rainWidth || 1, s = this.Ca = e.rainHeight || 1, o = [], a = [], c = [], h = [];
        for (let t = 0; t < i; t++) {
            const e = {};
            e.x = Math.random() * (n.max[0] - n.min[0]) + n.min[0], e.y = Math.random() * (n.max[2] - n.min[2]) + n.min[2], 
            e.z = Math.random() * (n.max[1] - n.min[1]) + n.min[1];
            const i = (n.max[2] - n.min[2]) / 37.5 * s, l = i / 3 * r;
            o.push(e.x + l, e.y + i, e.z, e.x - l, e.y + i, e.z, e.x - l, e.y, e.z, e.x + l, e.y, e.z), 
            a.push(e.x, e.y - i / 2, e.z, e.x, e.y - i / 2, e.z, e.x, e.y - i / 2, e.z, e.x, e.y - i / 2, e.z), 
            c.push(1, 1, 0, 1, 0, 0, 1, 0), h.push(4 * t + 0, 4 * t + 1, 4 * t + 2, 4 * t + 0, 4 * t + 2, 4 * t + 3);
        }
        const l = {};
        l.POSITION = o, l.NORMAL = a, l.TEXCOORD_0 = c;
        const f = new qt(l, h, 0, {
            primitive: "triangles",
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        f.generateBuffers(this.renderer.device);
        const u = new Ie({
            rainMap: this.p.texture({
                width: 2,
                height: 2
            }),
            diffuse: e.color || [ 1, 1, 1 ],
            opacity: e.opacity || 1
        }), d = new mi(f, u);
        return d.setUniform("top", n.max[2]), d.setUniform("bottom", n.min[2]), this.Oa(d), 
        d.transparent = !0, d;
    }
    Sa(t) {
        const e = new Image;
        return e.src = this.Ea = t, new Promise(((t, n) => {
            e.onload = () => {
                const n = this.p.texture({
                    mag: "linear",
                    min: "linear mipmap nearest",
                    wrapS: "clamp",
                    wrapT: "clamp",
                    data: e
                });
                t(n);
            }, e.onerror = t => {
                n(t);
            };
        }));
    }
    paint(t) {
        if (!this.rs) return;
        const e = this.wa(), n = {}, i = this.getMap();
        n.projMatrix = i.projMatrix, n.viewMatrix = i.viewMatrix, n.cameraPosition = i.cameraPosition;
        const r = e.speed || 1, s = this._a.getElapsedTime() / (2 / r) % 1;
        n.time = s, this.hs.material.set("diffuse", e.color || th), this.hs.material.set("opacity", e.opacity || 1), 
        this.Oa(this.hs);
        const o = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.es, n, this.rs, o), this.Zr.getRenderer().setCanvasUpdated();
    }
    Oa(t) {
        const e = this.getMap(), n = e.coordinateToPointAtRes(e.getCenter(), e.getGLRes()), i = e.getGLScale() / e.getGLScale(this.cs), r = h.set(Zc, i, i, i), s = h.multiply(r, Jc, r), o = c.identity(Qc), a = this.wa(), l = e.getBearing();
        c.fromRotationTranslationScale(o, d.fromEuler(Yc, a.windDirectionX || 0, a.windDirectionY || 0, 90 - l), [ n.x, n.y, 0 ], s), 
        c.multiply(o, o, rh), t.setLocalTransform(o);
    }
    setToRedraw() {
        const t = this.Zr.getRenderer();
        t && t.setToRedraw();
    }
    update() {
        const t = this.wa();
        if (t) {
            if (this.hs || this.ba(), t.density !== this.Ma || t.rainWidth !== this.Ta || t.rainHeight !== this.Ca) {
                const t = this.hs.material.get("rainMap");
                this.hs.geometry.dispose(), this.hs.dispose(), this.rs.clear(), this.hs = this.ya(), 
                this.hs.material.set("rainMap", t), this.rs.setMeshes(this.hs);
            }
            t.rainTexture !== this.Ea && this.Sa(t.rainTexture).then((t => {
                this.hs.material.set("rainMap", t);
            }));
        }
    }
    dispose() {
        this.hs && (this.hs.geometry.dispose(), this.hs.material && this.hs.material.dispose(), 
        this.hs.dispose(), delete this.hs), this.es && (this.es.dispose(), delete this.es);
    }
    isEnable() {
        const t = this.wa();
        return t && t.enable;
    }
    wa() {
        const t = this.Zr.getWeatherConfig();
        return t && t.rain;
    }
    Aa() {
        const t = 16.685648411389433 - this.getMap().getZoom();
        return h.scale(ih.min, eh, Math.pow(2, t)), h.scale(ih.max, nh, Math.pow(2, t)), 
        ih;
    }
}

class oh {
    constructor(t) {
        this.autoStart = void 0 === t || t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, 
        this.running = !1;
    }
    start() {
        this.startTime = ("undefined" == typeof performance ? Date : performance).now(), 
        this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const e = ("undefined" == typeof performance ? Date : performance).now();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return 0;
    }
}

const ah = [], ch = [ .03, .03, .03 ], hh = [], lh = [], fh = [], uh = c.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class dh {
    constructor(t, e) {
        this.p = t, this.Zr = e, this.ts();
    }
    ts() {
        const t = this.Zr.getRenderer().canvas, e = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.es = new Br({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n  gl_Position = projMatrix * modelViewMatrix * c * d;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\nvoid main() {\n  float d = texture2D(perlinTexture, vTexCoord).r;\n  vec3 e = vec3(1.);\n  float r = c(.5, e.x, d);\n  float g = c(.5, e.y, d);\n  float b = c(.5, e.z, d);\n  glFragColor = vec4(r, g, b, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(ah, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: e
            }
        }), this.es.version = 300, this.rs = new Ti, this.Ia = this.Pa(), this.rs.setMeshes(this.Ia), 
        this.renderer = new pi(this.p);
        const n = this.Ha();
        n && (n.snowGroundTexture ? this.Ra(n.snowGroundTexture) : (this.ka = this.p.texture({
            width: 2,
            height: 2
        }), console.warn("should set snow ground texture.")));
    }
    render(t) {
        this.ka && this.Ia.material.set("perlinTexture", this.ka);
        const e = this.Zr.getMap();
        this.Na(e);
        const n = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            cameraPosition: e.cameraPosition
        }, i = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.es, n, this.rs, i), this.Zr.getRenderer().setCanvasUpdated();
    }
    Na(t) {
        const e = t.coordinateToPointAtRes(t.getCenter(), t.getGLRes()), n = t.getGLScale() / t.getGLScale(this.cs), i = h.set(lh, n, n, n), r = h.multiply(i, ch, i), s = c.identity(fh);
        c.fromRotationTranslationScale(s, d.fromEuler(hh, 0, 0, 0), [ e.x, e.y, .005 ], r), 
        c.multiply(s, s, uh), this.Ia.setLocalTransform(s);
    }
    Ra(t) {
        const e = new Image;
        e.onload = () => {
            this.ka = this.p.texture({
                mag: "linear",
                min: "linear mipmap nearest",
                wrapS: "repeat",
                wrapT: "repeat",
                data: e
            });
        }, e.onerror = t => {
            console.log(t);
        }, e.src = this.Da = t;
    }
    Pa() {
        const t = this.Zr.getMap();
        this.cs = t.getZoom();
        const e = 16e3 * Math.pow(2, 16.685648411389433 - this.cs), n = [ -e, 0, -e, e, 0, -e, -e, 0, e, e, 0, e ], i = {};
        i.POSITION = n, i.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], i.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const r = new qt(i, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        r.generateBuffers(this.p);
        const s = new Ie({
            perlinTexture: this.p.texture({
                width: 2,
                height: 2
            })
        });
        return new mi(r, s);
    }
    getMeshes() {
        return this.Ia;
    }
    dispose() {
        this.Ia && (this.Ia.geometry.dispose(), this.Ia.material && this.Ia.material.dispose(), 
        this.Ia.dispose(), delete this.Ia), this.es && (this.es.dispose(), delete this.es);
    }
    update() {
        const t = this.Ha();
        t && t.snowGroundTexture === !this.Da && this.Ra(t.snowGroundTexture);
    }
    isEnable() {
        const t = this.Ha();
        return t && t.enable;
    }
    Ha() {
        const t = this.Zr.getWeatherConfig();
        return t && t.snow;
    }
}

const mh = [];

class vh {
    constructor(t, e, n) {
        this.p = t, this.Zr = e, this.La = n, this.ts();
    }
    ts() {
        this.renderer = new pi(this.p);
        const t = this.Zr.getRenderer(), e = this.Qr = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Fa = e.width, this.Ua = e.height, this.ns = this.p.framebuffer({
            color: this.p.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this.p.texture({
            width: 2,
            height: 2
        }), this.za = new sh(this.p, this.Zr), this.Ga = new As(this.p, e), this.Ba = new dh(this.p, this.Zr), 
        this.Va = new gs(this.p, e, this.Zr), this.ja = new ps, this.ja.version = 300;
    }
    getMap() {
        return this.Zr && this.Zr.getMap();
    }
    renderScene(t) {
        this.renderSnowMask(t), this.renderRain(t);
    }
    renderRain(t) {
        this.isEnableRain() && this.za.paint(t);
    }
    renderSnowMask(t) {
        if (!this.isEnableSnow() || !this.Wa()) return;
        const e = this.getMap();
        this.Ba.render(t, e);
    }
    paint(t, e) {
        if (!e || !e.length) return t;
        this.ss();
        const n = this.Zr.getWeatherConfig(), i = {};
        if (this.isEnableRain() ? (i.ripplesMap = this.qa(), this.ja.shaderDefines.HAS_RAIN = 1) : delete this.ja.shaderDefines.HAS_RAIN, 
        this.isEnableSnow() ? (this.ja.shaderDefines.HAS_SNOW = 1, i.snowIntensity = P(n.snow.snowIntensity) ? n.snow.snowIntensity : .5, 
        e.forEach((t => {
            t.defines.HAS_SNOW = 1;
        }))) : (delete this.ja.shaderDefines.HAS_SNOW, e.forEach((t => {
            delete t.defines.HAS_SNOW;
        }))), this.isEnableFog()) {
            const t = n.fog;
            i.fogColor = t.color || [ .9, .9, .9 ], this.ja.shaderDefines.HAS_FOG = 1;
        } else delete this.ja.shaderDefines.HAS_FOG;
        return this.ja.setDefines(this.ja.shaderDefines), i.mixFactorMap = this.Xa(e) || this.EMPTY_TEXTURE, 
        i.sceneMap = t, i.time = this.Ka() / 1e3, i.resolution = u.set(mh, this.ns.width, this.ns.height), 
        this.renderer.render(this.ja, i, null, this.ns), this.$a = e, this.ns;
    }
    Xa(t) {
        const e = {}, n = this.getMap(), i = n.getZoom(), r = Math.pow(2, 16.685648411389433 - i), s = this.Zr.getWeatherConfig(), o = s.fog;
        if (!o || !o.enable) return null;
        const a = o.start || .1, c = o.end || 100;
        e.projMatrix = n.projMatrix, e.viewMatrix = n.viewMatrix, e.cameraPosition = n.cameraPosition, 
        e.fogDist = [ a * r, c * r ], e.rainDepth = n.altitudeToPoint(s.rain && s.rain.rainDepth || .1, n.getGLRes());
        const h = this.Va.render(t, e);
        return this.Zr.getRenderer().Ja(h);
    }
    qa() {
        const t = this.getMap(), e = this.Zr.getWeatherConfig(), n = e.rain.rippleRadius || 24, i = {};
        i.projMatrix = t.projMatrix, i.viewMatrix = t.viewMatrix, i.time = this.Ka() / 1e3, 
        i.rippleRadius = n, i.density = e.rain.density || 2e3;
        return this.Ga.render(t, i);
    }
    Ka() {
        if (!this.Zr) return 0;
        if (void 0 === this.Ya && (this.Ya = 0), this.isPlaying()) {
            const t = this.Zr.getRenderer();
            this.Ya = t.getFrameTime();
        }
        return this.Ya;
    }
    isEnable() {
        const t = this.Zr.getWeatherConfig();
        return t && t.enable;
    }
    isEnableRain() {
        const t = this.Zr.getWeatherConfig();
        return t && t.enable && t.rain && t.rain.enable;
    }
    isEnableFog() {
        const t = this.Zr.getWeatherConfig();
        return t && t.enable && t.fog && t.fog.enable;
    }
    isEnableSnow() {
        const t = this.Zr.getWeatherConfig();
        return t && t.enable && t.snow && t.snow.enable;
    }
    Wa() {
        const t = this.Zr.getWeatherConfig();
        return this.isEnableSnow() && !1 === t.snow.showGround;
    }
    isPlaying() {
        const t = this.Zr.getWeatherConfig();
        return !!t && !1 !== t.playing;
    }
    Za() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }
    update() {
        !this.isEnable() && this.$a && this.$a.forEach((t => {
            delete t.defines.HAS_SNOW, delete t.defines.HAS_RAIN, delete t.defines.HAS_FOG;
        })), this.isEnableRain() && (this.za = this.za || new sh(this.p, this.Zr), this.za.update()), 
        this.isEnableSnow() && (this.Ba = this.Ba || new dh(this.p, this.Zr), this.Ba.update());
    }
    getShadowMeshes() {
        return this.Ba.getMeshes();
    }
    ss() {
        const t = this.Fa(), e = this.Ua();
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
    dispose() {
        this.ns && this.ns.destroy(), this.ja && (this.ja.dispose(), delete this.ja), this.za && (this.za.dispose(), 
        delete this.za), this.Ba && (this.Ba.dispose(), delete this.Ba);
    }
}

const gh = [], ph = t => !!t.bloom, xh = t => !!t.ssr;

class _h {
    constructor(t, e) {
        this.p = t, this.Zr = e, this.zi = new pi(t), this.Qa = new Xr, this.tc = new fs, 
        this.ec = new ss(this.p);
    }
    setContextIncludes() {}
    bloom(t, e, n, i, r, s, o) {
        this.nc || (this.nc = new is(this.p));
        const a = this.Zr.getRenderer().Ja(this.ic);
        return this.nc.render(t, a, i, r, s, e, n, o);
    }
    drawBloom(t) {
        const e = this.Zr.getRenderer(), n = this.p, i = this.ic;
        if (i) {
            const {width: e, height: r} = t;
            i.width === e && i.height === r || i.resize(e, r), n.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: i
            });
        } else {
            const e = this.rc(t);
            this.ic = n.framebuffer(e);
        }
        const r = e.getFrameTime(), s = e.getFrameEvent(), o = e.getFrameContext(), a = o.renderMode, c = o.sceneFilter, h = o.renderTarget;
        o.isPostProcess = !0, o.renderMode = "default", o.sceneFilter = ph, o.renderTarget = {
            fbo: this.ic,
            getFramebuffer: bh,
            getDepthTexture: yh
        };
        const l = e.reglGL;
        return l.resetDrawCalls(), s ? e.forEachRenderer((t => {
            e.clearStencil(t, i), t.drawOnInteracting(s, r, o);
        })) : e.forEachRenderer((t => {
            e.clearStencil(t, i), t.draw(r, o);
        })), delete o.isPostProcess, o.renderMode = a, o.sceneFilter = c, o.renderTarget = h, 
        l.getDrawCalls();
    }
    genSsrMipmap(t, e) {
        const n = this.Zr.getMap().projViewMatrix;
        this.ec.genMipMap(t, e, n);
    }
    getPrevSsrProjViewMatrix() {
        return this.ec && this.ec.getPrevProjViewMatrix();
    }
    drawSSR(t, e, n) {
        n && this.ec.copyDepthTex(t);
        const i = this.Zr.getRenderer(), r = i.getFrameTime(), s = i.getFrameEvent(), o = i.getFrameContext();
        o.isPostProcess = !0, o.ssr = this.getSSRContext();
        const a = o.renderMode, c = o.sceneFilter;
        o.renderMode = "default", o.sceneFilter = xh, o.renderTarget.fbo = e;
        const h = i.reglGL;
        let l = !1;
        s ? i.forEachRenderer((t => {
            i.clearStencil(t, e), l || (h.resetDrawCalls(), l = !0), t.drawOnInteracting(s, r, o);
        })) : i.forEachRenderer((t => {
            i.clearStencil(t, e), l || (h.resetDrawCalls(), l = !0), t.draw(r, o);
        }));
        const f = i.drawGround();
        return delete o.ssr, delete o.isPostProcess, o.renderMode = a, o.sceneFilter = c, 
        this.sc = h.getDrawCalls() > 0, f;
    }
    getSSRUniforms() {
        const t = this.Zr.To(), e = t && t.postProcess, n = this.Zr.getMap();
        return this.ec.getSSRUniforms(n, e.ssr.factor, e.ssr.quality);
    }
    getSSRContext() {
        const t = this.Zr.To(), e = t && t.postProcess, n = this.Zr.getMap(), i = this.ec.getSSRUniforms(n, e.ssr.factor, e.ssr.quality);
        if (!i) return null;
        return {
            renderUniforms: i,
            defines: {
                "HAS_SSR": 1
            }
        };
    }
    fxaa(t, e, n, i, r, s, o, a, c, h, l, f) {
        !t || t.width === e.fbo && t.height === e.height || t.resize(e.width, e.height);
        const d = {};
        a ? d.HAS_OUTLINE_TEX = 1 : delete d.HAS_OUTLINE_TEX, this.Qa.setDefines(d), this.zi.render(this.Qa, {
            textureSource: e,
            resolution: u.set(gh, e.width, e.height),
            enableFXAA: n,
            enableToneMapping: i,
            enableSharpen: r,
            pixelRatio: s,
            sharpFactor: o,
            textureOutline: a,
            highlightFactor: c,
            outlineFactor: h,
            outlineWidth: l,
            outlineColor: f
        }, null, t);
    }
    renderFBOToScreen(t, e, n, i) {
        this.oc || (this.oc = []), this.oc[0] = t.width, this.oc[1] = t.height;
        const r = this.Zr.getRenderer();
        this.zi.render(this.tc, {
            texture: t.color && r.Ja(t) || t,
            size: this.oc,
            enableSharpen: +!!e,
            sharpFactor: n,
            pixelRatio: i
        });
    }
    postprocess(t, e, n) {
        this.ac || (this.ac = new Yr);
        const i = this.Zr && this.Zr.getRenderer(), r = n || i.Ja(t);
        return e.resolution = u.set(gh, r.width, r.height), e.textureSource = r, e.timeGrain = performance.now(), 
        this.zi.render(this.ac, e), this.cc;
    }
    dispose() {
        this.ic && (this.ic.destroy(), delete this.ic), this.nc && (this.nc.dispose(), delete this.nc), 
        this.ac && (this.ac.dispose(), delete this.ac), this.Qa && (this.Qa.dispose(), delete this.Qa), 
        this.tc && (this.tc.dispose(), delete this.tc);
    }
    rc(t, e) {
        const {width: n, height: i} = this.Zr.getRenderer().canvas, r = this.p;
        let s;
        s = this.Zr.getRenderer().hc() ? r.renderbuffer({
            width: n,
            height: i,
            samples: this.Zr.options.multiSamples,
            format: "rgba8"
        }) : r.texture({
            min: "nearest",
            mag: "nearest",
            format: e || "rgba",
            width: n,
            height: i
        });
        const o = {
            width: n,
            height: i,
            colors: [ s ]
        };
        return t && (o.depthStencil = t), o;
    }
}

function bh(t) {
    return t._framebuffer.framebuffer;
}

function yh(t) {
    return t.depthStencil._texture.texture;
}

class wh extends qr {
    constructor(t) {
        super({
            vert: "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\nuniform vec3 flood_waterColor;\nuniform float flood_waterOpacity;\nuniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\nuniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\nuniform vec4 viewshed_visibleColor;\nuniform vec4 viewshed_invisibleColor;\nuniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\nuniform vec4 insight_visibleColor;\nuniform vec4 insight_invisibleColor;\nuniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\nuniform sampler2D meshesMap;\nuniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\nuniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\nuniform sampler2D crosscutMap;\nuniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\nuniform vec3 limitColor;\nuniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  glFragColor = c;\n#ifdef HAS_VIEWSHED\nvec4 d = texture2D(viewshedMap, vTexCoord);\n  if(d.r > .99) {\n    glFragColor = vec4(mix(viewshed_invisibleColor.rgb, c.rgb, viewshed_invisibleColor.a), c.a);\n  } else if(d.g > .99) {\n    glFragColor = vec4(mix(viewshed_visibleColor.rgb, c.rgb, viewshed_visibleColor.a), c.a);\n  } else if(d.a < .01) {\n    glFragColor = vec4(d.rgb, 1.);\n  }\n  \n  \n#endif\n#ifdef HAS_FLOODANALYSE\nvec4 e = texture2D(floodMap, vTexCoord);\n  if(e.r > .0) {\n    glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n  }\n#endif\n#ifdef HAS_SKYLINE\nvec4 f = texture2D(skylineMap, vTexCoord);\n  if(f.r > .0 || f.g > .0 || f.b > .0) {\n    glFragColor = f;\n  }\n#endif\n#ifdef HAS_INSIGHT\nvec4 h = texture2D(insightMap, vTexCoord);\n  if(h.g > .0) {\n    glFragColor = insight_visibleColor;\n  } else if(h.r > .0) {\n    glFragColor = insight_invisibleColor;\n  }\n  \n#endif\n#ifdef HAS_CUT\nvec4 i = texture2D(invisibleMap, vTexCoord);\n  vec4 j = texture2D(meshesMap, vTexCoord);\n  if(i.r == 1. && i.g == .0 && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == 1. && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == .0 && i.b == 1.) {\n    glFragColor = c;\n  }\n  \n  \n#endif\n#ifdef HAS_EXCAVATE\nvec4 k = texture2D(excavateMap, vTexCoord);\n  if(k.r == 1. && k.g == .0 && k.b == .0) {\n    glFragColor = c;\n  } else {\n    glFragColor = k;\n  }\n#endif\n#ifdef HAS_CROSSCUT\nvec4 l = texture2D(crosscutMap, vTexCoord);\n  if(l.r > .0) {\n    glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, .99), glFragColor.a);\n  }\n#endif\n#ifdef HAS_HEIGHTLIMIT\nvec4 m = texture2D(heightLimitMap, vTexCoord);\n  if(m.r > .0) {\n    glFragColor = vec4(mix(limitColor, glFragColor.rgb, .6), glFragColor.a);\n  }\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: t,
                cull: {
                    enable: !0
                },
                blend: {
                    enable: !0,
                    func: {
                        srcRGB: "src alpha",
                        srcAlpha: 1,
                        dstRGB: "one minus src alpha",
                        dstAlpha: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
}

class Sh {
    constructor(t, e, n) {
        this.p = t, this.Zr = e, this.La = n, this.ts();
    }
    ts() {
        this.renderer = new pi(this.p);
        const t = this.Zr.getRenderer(), e = this.Qr = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.ns = this.p.framebuffer({
            color: this.p.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.es = new wh(e);
    }
    getMap() {
        return this.Zr && this.Zr.getMap();
    }
    paint(t, e) {
        if (!e && e.length) return t;
        this.ss();
        const n = {}, i = this.Zr.lc;
        if (!this.fc()) return t;
        this.p.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            stencil: 0,
            framebuffer: this.ns
        }), delete this.es.shaderDefines.HAS_FLOODANALYSE, delete this.es.shaderDefines.HAS_VIEWSHED, 
        delete this.es.shaderDefines.HAS_SKYLINE, delete this.es.shaderDefines.HAS_INSIGHT, 
        delete this.es.shaderDefines.HAS_CUT, delete this.es.shaderDefines.HAS_CROSSCUT, 
        delete this.es.shaderDefines.HAS_HEIGHTLIMIT;
        for (let t = 0; t < i.length; t++) {
            const r = i[t];
            if (!r.isEnable()) continue;
            const s = r.getDefines();
            cc(this.es.shaderDefines, s);
            const o = this.getMap(), a = o.width, c = o.height, h = this.uc(e, r.getExcludeLayers()), l = r.renderAnalysis(h, a, c);
            l && cc(n, l);
        }
        return n.sceneMap = t, this.es.setDefines(this.es.shaderDefines), this.renderer.render(this.es, n, null, this.ns), 
        this.ns;
    }
    uc(t, e) {
        let n = [];
        for (let i = 0; i < t.length; i++) {
            if (e.indexOf(t[i].getId()) > -1) continue;
            const r = t[i].getRenderer();
            if (r && r.getAnalysisMeshes) {
                const t = r.getAnalysisMeshes();
                t.forEach((t => {
                    t.setUniform("useAnalysis", 1);
                })), n = n.concat(t);
            }
        }
        return n;
    }
    ss() {
        const t = n.isFunction(this.Qr.width.data) ? this.Qr.width.data() : this.Qr.width, e = n.isFunction(this.Qr.height.data) ? this.Qr.height.data() : this.Qr.height;
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
    fc() {
        const t = this.Zr && this.Zr.lc;
        if (!t) return !1;
        for (let e = 0; e < t.length; e++) if (t[e].isEnable()) return !0;
        return !1;
    }
}

const Ah = [], Mh = new t.Coordinate(0, 0);

let Th = {};

class Ch {
    constructor(t, e) {
        this.p = t, this.Zr = e, this.ts();
    }
    ts() {
        this.renderer = new pi(this.p);
        const t = this.Zr.getRenderer(), e = this.Qr = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Fa = e.width, this.Ua = e.height, this.ns = this.p.framebuffer({
            color: this.p.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this.p.texture({
            width: 2,
            height: 2
        }), this.es = new ms, this.dc = new Is(this.p, e, this.Zr), this.es.version = 300;
    }
    getMap() {
        return this.Zr && this.Zr.getMap();
    }
    paint(t, e) {
        if (!e || !e.length) return t;
        const n = this.Zr.getMap();
        this.ss();
        const i = this.Zr.getScanEffectConfig(), r = {}, {effects: s} = i, o = n.getGLRes(), a = [];
        this.mc !== s.length && (Th = {});
        for (let t = 0; t < s.length; t++) {
            const {center: e, radius: i, speed: r, color: c, direction: h, height: l} = s[t], u = Oh(e), d = n.coordinateToPointAtRes(u, o, Mh).toArray(), m = n.distanceToPointAtRes(i, 0, o).x, v = "vertical" === h ? 1 : 0, g = n.altitudeToPoint(l || 0, o);
            Th[t] = Th[t] || [];
            const p = f.set(Th[t], d[0], d[1], m, r, c[0], c[1], c[2], v, g);
            a.push(p);
        }
        const c = {
            projMatrix: n.projMatrix,
            viewMatrix: n.viewMatrix,
            effectInfos: a,
            effectTime: this.Ka() / 1e3
        }, h = this.Zr.getRenderer(), l = this.dc.render(e, c) || this.EMPTY_TEXTURE;
        return r.scanEffectMap = h.Ja(l), r.sceneMap = t, r.resolution = u.set(Ah, this.ns.width, this.ns.height), 
        this.renderer.render(this.es, r, null, this.ns), this.ns;
    }
    Ka() {
        if (!this.Zr) return 0;
        if (void 0 === this.Ya && (this.Ya = 0), this.isPlaying()) {
            const t = this.Zr.getRenderer();
            this.Ya = t.getFrameTime();
        }
        return this.Ya;
    }
    isPlaying() {
        const t = this.Zr.getScanEffectConfig();
        return !!t && !1 !== t.playing;
    }
    ss() {
        const t = this.Fa(), e = this.Ua();
        !this.ns || this.ns.width === t && this.ns.height === e || this.ns.resize(t, e);
    }
    dispose() {
        this.ns && this.ns.destroy(), this.es && (this.es.dispose(), delete this.es), this.dc && this.dc.dispose();
    }
}

function Oh(t) {
    return Array.isArray(t) ? (Mh.x = t[0], Mh.y = t[1], Mh) : t;
}

function Eh(t, e, n, i, r) {
    const s = {
        alpha: !0,
        depth: !0,
        stencil: !0,
        preserveDrawingBuffer: e
    }, o = function(t, e, n) {
        const i = n ? [ "webgl", "experimental-webgl" ] : [ "webgl2", "webgl", "experimental-webgl" ];
        let r = null;
        for (let n = 0; n < i.length; ++n) {
            try {
                r = t.getContext(i[n], e);
            } catch (t) {}
            if (r) break;
        }
        r || console.error("Browser doesn't support WebGL.");
        return r;
    }(t, s, n);
    !function(t, e, n) {
        e && e.forEach((e => {
            t.getExtension(e);
        }));
        n && n.forEach((e => {
            t.getExtension(e);
        }));
    }(o, i, r), o.wrap = () => new w(o);
    const a = o.wrap(), c = y({
        gl: a,
        attributes: s,
        extensions: i,
        optionalExtensions: r
    }), h = {
        gl: o,
        reglGL: a,
        regl: c,
        getImageData: (e, n, i, r) => {
            const s = new Uint8Array(i * r * 4);
            return c.read({
                x: e,
                y: t.height - n,
                width: i,
                height: r,
                data: s
            }), new ImageData(new Uint8ClampedArray(s.buffer), i, r);
        }
    };
    return {
        gl: o,
        reglGL: a,
        regl: c,
        context: h
    };
}

const Ih = function(t) {
    return class extends t {
        createContext() {
            this.createCanvas();
            const t = this.getMap(), {preserveDrawingBuffer: e, onlyWebGL1: n, extensions: i, optionalExtensions: r} = t.options, {gl: s, regl: o, reglGL: a, context: c} = Eh(this.canvas, e, n, i, r);
            this.gl = s, this.regl = o, this.reglGL = a, this.context = c;
        }
        clearContext() {
            this.regl && this.regl.clear({
                color: [ 0, 0, 0, 0 ],
                depth: 1,
                stencil: 255
            });
        }
    };
}, {LayerAbstractRenderer: Ph} = t.renderer, Hh = [ 0, 0, 0, 0 ], Rh = [ 1, 1, -1 ], kh = [ 0, 0 ], Nh = t => !t.bloom && !t.ssr, Dh = t => !t.bloom, Lh = t => !t.ssr;

class Fh extends(Ih(Ph)){
    setToRedraw() {
        this.setRetireFrames(), super.setToRedraw();
    }
    onAdd() {
        super.onAdd(), this.prepareCanvas();
    }
    updateSceneConfig() {
        this.vc && this.vc.update(), this.gc && this.gc.update(), this.xc && this.xc.update(), 
        this.setToRedraw();
    }
    render(...t) {
        this.getMap() && this.layer.isVisible() && (this.forEachRenderer((t => {
            t._replacedDrawFn || (t.draw = this._c(t.draw), t.drawOnInteracting = this.bc(t.drawOnInteracting), 
            t.setToRedraw = this.yc(t.setToRedraw), t._replacedDrawFn = !0);
        })), this.prepareRender(), this.prepareCanvas(), this.layer.wc(), this._toRedraw = !1, 
        this.Sc("render", t), this.Ac(), this.Mc());
    }
    prepareCanvas() {
        super.prepareCanvas(), this.forEachRenderer((t => {
            t.prepareCanvas();
        }));
    }
    drawOnInteracting(...t) {
        this.getMap() && this.layer.isVisible() && (this.layer.wc(), this._toRedraw = !1, 
        this.Sc("drawOnInteracting", t), this.Ac(), this.Mc());
    }
    Sc(t, e) {
        this.Tc = "default";
        const n = this.hasRenderTarget(), i = this.Cc(e);
        if (n && (this.Oc.renderTarget = this.Ec()), this.gc.paint(i), this.drawGround(!0), 
        !n) return void this.Ic("default", null, t, e, !0);
        const r = this.reglGL, s = this.layer.To(), o = s && s.postProcess, a = this.isSSROn();
        i.jitter = kh;
        const c = this.layer.getGroundConfig();
        i.hasSSRGround = !!(a && c && c.enable && c.symbol && c.symbol.ssr), r.resetDrawCalls(), 
        this.Ic("default", this.Xr, t, e, !0), a && this.Pc.drawSSR(this.Hc(), this.Xr);
        o.bloom && o.bloom.enable && (this.Rc = this.Pc.drawBloom(this.kc)), 2 === a && this.Pc.drawSSR(this.Hc(), this.Xr, !0), 
        r.resetDrawCalls(), this.xc.renderScene(i), this.Nc = r.getDrawCalls();
    }
    Ic(t, e, n, i, r) {
        this.Tc = t;
        const s = this.Cc(i);
        s.renderMode = this.Tc, s.renderTarget && (s.renderTarget.fbo = e), r && (s.isFinalRender = !0), 
        this.forEachRenderer(((t, r) => {
            r.isVisible() && (this.clearStencil(t, e), t[n].apply(t, i));
        }));
    }
    Cc(t) {
        let e = t[0];
        return Uh(e) || (e = t[1]), e !== this.Dc && (this.forEachRenderer(((t, e) => {
            e.isVisible() && t.needRetireFrames && t.needRetireFrames() && this.setRetireFrames();
        })), this.Oc = this.Lc(e), this.Dc = e, this.Fc = Uh(t[0]) ? null : t[0]), this.Oc;
    }
    Ac() {
        if (!this.isEnableOutline()) return;
        const t = this.Uc(), e = this.reglGL;
        e.resetDrawCalls(), this.forEachRenderer(((e, n) => {
            n.isVisible() && e.drawOutline && e.drawOutline(t);
        })), this.zc = e.getDrawCalls();
    }
    Uc() {
        const {width: t, height: e} = this.canvas;
        let n = this.Gc;
        if (n) t === n.width && e === n.height || n.resize(t, e); else {
            const i = this.regl.texture({
                width: t,
                height: e,
                format: "rgba4",
                sampleCount: 4
            });
            n = this.Gc = this.regl.framebuffer({
                width: t,
                height: e,
                colors: [ i ],
                depth: !1,
                stencil: !1
            });
        }
        return n;
    }
    Ja(t) {
        if (this.hc()) {
            const e = this.Bc(t);
            return e.width !== t.width || e.height !== t.height ? e.resize(t.width, t.height) : this.regl.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: e
            }), e.blit(t), e.color[0];
        }
        return t.color[0];
    }
    Hc() {
        if (this.kc.subimage) return this.kc;
        const {width: t, height: e} = this.kc;
        if (!this.Vc) {
            const n = this.regl, i = {
                depthStencil: n.texture({
                    min: "nearest",
                    mag: "nearest",
                    mipmap: !1,
                    type: "depth stencil",
                    width: t,
                    height: e,
                    format: "depth stencil"
                }),
                colors: [ n.renderbuffer({
                    width: t,
                    height: e,
                    format: "rgba4"
                }) ],
                colorFormat: "rgba4",
                width: t,
                height: e
            };
            this.Vc = n.framebuffer(i);
        }
        return this.Vc.width === t && this.Vc.height === e || this.Vc.resize(t, e), this.regl.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            framebuffer: this.Vc
        }), this.Vc.blit(this.Xr, 256, "nearest"), this.Vc.depthStencil;
    }
    Bc(t) {
        if (this.jc || (this.jc = []), !t.Wc) {
            const e = this.qc(!0, t.width, t.height), n = this.regl.framebuffer(e);
            this.jc.push(n), t.Wc = n;
        }
        return t.Wc;
    }
    hc() {
        if (this.device && this.device.wgpu) return !1;
        return 0 === this.regl.limits.version.indexOf("WebGL 2.0") && this.layer.options.antialias;
    }
    hasRenderTarget() {
        const t = this.layer.To(), e = t && t.postProcess;
        return !(!e || !e.enable);
    }
    testIfNeedRedraw() {
        if (this.layer.options.forceRedrawPerFrame) return !0;
        if (this._toRedraw) return this._toRedraw = !1, !0;
        if (this.getMap().isInteracting() && (this.vc && this.vc.isEnable() || this.gc && this.gc.isEnable())) return !0;
        if (this.xc && this.xc.isEnable()) return !0;
        if (this.isEnableScanEffect()) return !0;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const e = t.getRenderer();
            if (e && e.testIfNeedRedraw()) return this.Xc = !0, !0;
        }
        const e = this.Kc();
        for (const t of e) {
            if (!t) continue;
            const e = t.getRenderer();
            if (e && e.testIfNeedRedraw()) return this.Xc = !0, !0;
        }
        return !1;
    }
    isRenderComplete() {
        const t = this.Kc();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && !t.isRenderComplete()) return !1;
        }
        return !0;
    }
    mustRenderOnInteracting() {
        const t = this.Kc();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && t.mustRenderOnInteracting()) return !0;
        }
        return !1;
    }
    isCanvasUpdated() {
        if (super.isCanvasUpdated()) return !0;
        const t = this.Kc();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && t.isCanvasUpdated()) return !0;
        }
        return !1;
    }
    isBlank() {
        if (this.vc && this.vc.isEnable()) return !1;
        if (this.gc && this.gc.isEnable()) return !1;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const e = t.getRenderer();
            if (e && !e.isBlank()) return !1;
        }
        const e = this.Kc();
        for (const t of e) {
            const e = t.getRenderer();
            if (e && !e.isBlank()) return !1;
        }
        return !0;
    }
    initContext() {
        if (super.initContext(), !this.context) return;
        this.forEachRenderer((t => {
            t.canvas && t.initContext();
        }));
        const t = this.layer, {regl: e, gl: n, reglGL: i, device: r} = this.context;
        this.device = r || e, this.regl = e, this.reglGL = i, this.gl = n, this.canvas.gl = this.gl, 
        this.$c = [ 0, 0 ];
        const s = e || r;
        this.vc = new Bc(s, this.layer), this.gc = new Kc(s, this.layer);
        const o = this.layer.getWeatherConfig();
        this.xc = new vh(s, t, o), this.Jc = new Sh(s, t), this.Yc = new Ch(s, t);
        const a = this.layer.To() || {}, c = a && a.postProcess, h = c && c.antialias && c.antialias.jitterRatio || .2;
        this.Zc = new es(h), this.Pc = new _h(s, this.layer, this.Zc), this.Qc = new Sc(s, this.layer);
    }
    clearContext() {
        super.clearContext(), this.th();
    }
    th() {
        const t = this.regl;
        this.Xr && t.clear({
            color: Hh,
            depth: 1,
            stencil: 255,
            framebuffer: this.Xr
        }), this.Gc && t.clear({
            color: Hh,
            depth: 1,
            stencil: 255,
            framebuffer: this.Gc
        });
    }
    resizeCanvas() {
        const t = this.canvas.width, e = this.canvas.height;
        !this.Xr || this.Xr.width === t && this.Xr.height === e || (super.resizeCanvas(), 
        this.Xr.resize(t, e), this.th(), this.forEachRenderer((t => {
            t.canvas && t.resizeCanvas();
        })));
    }
    Kc() {
        return this.layer.Kc();
    }
    forEachRenderer(t) {
        const e = this.Kc();
        for (const n of e) {
            if (!n.isVisible() || !n.options.beneathTerrain) continue;
            const e = n.getRenderer();
            e && t(e, n);
        }
        const n = this.layer.getTerrainLayer();
        if (n) {
            const e = n.getRenderer();
            e && t(e, n);
        }
        for (const n of e) {
            if (!n.isVisible() || n.options.beneathTerrain) continue;
            const e = n.getRenderer();
            e && t(e, n);
        }
    }
    clearStencil(t, e) {
        const n = {
            stencil: t.getStencilValue ? t.getStencilValue() : 255
        };
        e && (n.framebuffer = e), this.device.clear(n);
    }
    onRemove() {
        const t = this.canvas.pickingFBO;
        t && t.destroy && !t.___disposed && (t.___disposed = !0, t.destroy()), this.eh(), 
        this.vc && (this.vc.dispose(), delete this.vc), this.gc && (this.gc.dispose(), delete this.gc), 
        this.Qc && (this.Qc.dispose(), delete this.Qc), this.Pc && (this.Pc.dispose(), delete this.Pc), 
        this.Gc && (this.Gc.destroy(), delete this.Gc), this.xc && (this.xc.dispose(), delete this.xc), 
        delete this.gl, delete this.regl, super.onRemove();
    }
    hitDetect() {
        return !1;
    }
    eh() {
        if (this.Xr && (this.Xr.destroy(), delete this.Xr, this.nh && (this.nh.destroy(), 
        delete this.nh), this.Vc && (this.Vc.destroy(), delete this.Vc), this.jc)) {
            for (let t = 0; t < this.jc.length; t++) this.jc[t] && this.jc[t].destroy();
            delete this.jc;
        }
    }
    setRetireFrames() {
        this.ih = !0;
    }
    getFrameTime() {
        return this.Dc;
    }
    getFrameEvent() {
        return this.Fc;
    }
    getFrameContext() {
        return this.Oc;
    }
    drawGround(t) {
        const e = this.layer.getGroundConfig();
        if (!e || !e.enable) return !1;
        if (!this.vc) return !1;
        const n = this.getFrameContext(), i = n.jitter;
        n.jitter = kh;
        const r = this.layer.getPolygonOffsetCount();
        let s;
        n.offsetFactor = r + 1, n.offsetUnits = r + 1, t && (s = n.sceneFilter, delete n.sceneFilter);
        const o = this.vc.paint(n);
        return this.vc.needToRedraw() && this.setToRedraw(), s && (n.sceneFilter = s), n.jitter = i, 
        o;
    }
    _c(t) {
        const e = this;
        return function(n, i) {
            return (i = i || e.Oc) && i.renderTarget && (i.renderTarget.getFramebuffer = zh, 
            i.renderTarget.getDepthTexture = Gh), t.call(this, n, i);
        };
    }
    bc(t) {
        const e = this;
        return function(n, i, r) {
            return (r = r || e.Oc) && r.renderTarget && (r.renderTarget.getFramebuffer = zh, 
            r.renderTarget.getDepthTexture = Gh), t.call(this, n, i, r);
        };
    }
    yc(t) {
        return function(...e) {
            return t.apply(this, e);
        };
    }
    isEnableSSR() {
        const t = this.layer.To(), e = t && t.postProcess;
        return e && e.enable && e.ssr && e.ssr.enable;
    }
    isSSROn() {
        const t = this.isEnableSSR(), e = this.getMap();
        if (!t || e.getPitch() <= -.001) return 0;
        const n = e.projViewMatrix, i = this.Pc.getPrevSsrProjViewMatrix();
        return i && c.exactEquals(i, n) ? 1 : 2;
    }
    isEnableTAA() {
        return !1;
    }
    isEnableSSAO() {
        return !1;
    }
    isEnableOutline() {
        const t = this.layer.To(), e = t && t.postProcess;
        return e && e.enable && e.outline && e.outline.enable;
    }
    isEnableWeather() {
        const t = this.layer.To(), e = t && t.weather;
        return e && e.enable;
    }
    rh() {
        const t = this.layer.getMap();
        if (!this.zo) {
            this.zo = {
                center: t.getCenter(),
                bearing: t.getBearing(),
                pitch: t.getPitch(),
                res: t.getResolution()
            };
            let e = !1;
            if (t.options.lights) {
                const n = t.getLightManager().getDirectionalLight().direction || Rh;
                this.zo.lightDirection = h.copy([], n), e = !0;
            }
            return {
                viewChanged: !0,
                lightDirectionChanged: e
            };
        }
        const e = t.getResolution() / this.zo.res, n = t.coordToContainerPoint(this.zo.center), i = this.layer.options.viewMoveThreshold, r = n._sub(t.width / 2, t.height / 2).mag() > i || e < .95 || e > 1.05;
        let s = !1;
        if (t.options.lights) {
            const e = t.getLightManager().getDirectionalLight().direction || Rh;
            s = !h.equals(this.zo.lightDirection, e), s && (this.zo.lightDirection = h.copy([], e));
        }
        return r && (this.zo.center = t.getCenter(), this.zo.bearing = t.getBearing(), this.zo.pitch = t.getPitch(), 
        this.zo.res = t.getResolution()), {
            viewChanged: r,
            lightDirectionChanged: s
        };
    }
    Lc(t) {
        const e = this.layer.To(), n = e && e.postProcess, i = e && e.weather, r = {
            timestamp: t,
            renderMode: this.Tc || "default",
            includes: {},
            states: this.rh(),
            testSceneFilter: t => !r.sceneFilter || r.sceneFilter(t),
            isFinalRender: !1,
            weather: {
                fog: i && i.fog
            }
        }, s = n && n.antialias && n.antialias.jitterRatio || .2, o = this.Zc;
        o && o.setRatio(s);
        const a = this.isSSROn();
        let c;
        if (n && n.enable) {
            if (this.isEnableTAA()) {
                (this.getMap().isInteracting() || this.ih) && o.reset(), o.getJitter(this.$c), o.frame();
            } else u.set(this.$c, 0, 0);
            r.jitter = this.$c;
            const t = n.bloom && n.bloom.enable;
            t && a ? (r.bloom = 1, r.sceneFilter = Nh) : t ? (r.bloom = 1, r.sceneFilter = Dh) : a && (r.sceneFilter = Lh), 
            c = this.Ec(), c && (r.renderTarget = c);
        } else this.eh();
        return "noAa" !== this.Tc && (this.oh = this.ah(r), this.oh && (r.includes.shadow = 1), 
        this.hh = this.lh(r)), this.oh && (r.shadow = this.oh, r.includes.shadow = 1), r.states.includesChanged = this.hh, 
        n && n.enable && this.Pc && this.Pc.setContextIncludes(r), r;
    }
    fh(t) {
        const e = this.Kc().filter((t => t.isVisible()));
        return this.layer.getTerrainLayer() && e.push(this.layer.getTerrainLayer()), this.Jc.paint(t, e);
    }
    lh(t) {
        let e = !1;
        const n = Object.keys(t.includes), i = this.uh;
        if (i) {
            const t = n.filter((t => -1 === i.indexOf(t))).concat(i.filter((t => -1 === n.indexOf(t))));
            t.length && (e = t.reduce(((t, e) => (t[e] = 1, t)), {}));
        }
        return this.uh = n, e;
    }
    ah(t) {
        const e = this.layer.To();
        if (!e || !e.shadow || !e.shadow.enable) return this.Qc && (this.Qc.dispose(), delete this.Qc), 
        null;
        this.Qc || (this.Qc = new Sc(this.regl, this.layer));
        const n = {
            config: e.shadow,
            defines: this.Qc.getDefines(),
            uniformDeclares: Sc.getUniformDeclares()
        };
        return n.renderUniforms = this.Gs(t), n;
    }
    Gs(t) {
        const e = t.renderTarget && t.renderTarget.fbo, n = this.layer.To(), i = [];
        let r = t.states.lightDirectionChanged || t.states.viewChanged;
        this.forEachRenderer(((t, e) => {
            if (!t.getShadowMeshes || !e.isVisible()) return;
            const n = t.getShadowMeshes();
            if (Array.isArray(n)) for (let t = 0; t < n.length; t++) n[t] && (n[t].needUpdateShadow && (r = !0, 
            n[t].needUpdateShadow = !1), n[t].hasFunctionUniform && (n[t].hasFunctionUniform("minAltitude") || n[t].setFunctionUniform("minAltitude", (() => e && e.options.altitude || 0)), 
            i.push(n[t])));
        })), this.dh || (this.dh = new Ti), this.dh.setMeshes(i);
        const s = this.getMap(), o = n.shadow, a = s.getLightManager(), c = a && a.getDirectionalLight().direction || Rh, h = !n.ground || !n.ground.enable;
        return this.Qc.render(h, s.projMatrix, s.viewMatrix, o.color, o.opacity, c, this.dh, this.$c, e, r);
    }
    mh(t) {
        let e = [];
        if (this.forEachRenderer(((t, n) => {
            if (!t.getAnalysisMeshes || !n.isVisible()) return;
            const i = t.getAnalysisMeshes();
            e = e.concat(i);
        })), this.vc) {
            const t = this.vc.getRenderMeshes();
            e = e.concat(t);
        }
        const n = this.layer.getWeatherConfig();
        return this.xc.paint(t, e, n);
    }
    gh(t) {
        let e = [];
        if (this.forEachRenderer(((t, n) => {
            if (!t.getAnalysisMeshes || !n.isVisible()) return;
            const i = t.getAnalysisMeshes();
            e = e.concat(i);
        })), this.vc) {
            const t = this.vc.getRenderMeshes();
            e = e.concat(t);
        }
        return this.Yc.paint(t, e);
    }
    getGroundMesh() {
        if (this.vc) {
            return this.vc.getRenderMeshes();
        }
        return [];
    }
    Ec() {
        const t = this.layer.To(), e = t && t.postProcess;
        if (!this.Xr) {
            const t = this.regl;
            let n = this.kc;
            (!n || !n._texture || n._texture.refCount <= 0) && (n = null);
            const i = this.createFBOInfo(e, n);
            this.kc = i.depth || i.depthStencil, this.Xr = t.framebuffer(i), this.th();
        }
        return {
            fbo: this.Xr
        };
    }
    qc(t, e, n) {
        e = e || this.canvas.width, n = n || this.canvas.height;
        const i = this.device, r = this.hc();
        let s;
        if (!t && r) s = i.renderbuffer({
            width: e,
            height: n,
            samples: this.layer.options.multiSamples,
            format: "rgba8"
        }); else {
            const t = "uint8";
            s = i.texture({
                min: "nearest",
                mag: "nearest",
                type: t,
                width: e,
                height: n,
                sampleCount: 4
            });
        }
        return {
            width: e,
            height: n,
            colors: [ s ],
            colorFormat: r ? "rgba8" : "rgba"
        };
    }
    createFBOInfo(t, e) {
        let {width: n, height: i} = this.canvas;
        n = n || 1, i = i || 1;
        const r = this.device, s = this.qc(), o = this.hc(), a = !this.regl || r.hasExtension("WEBGL_depth_texture");
        if (o) {
            const t = e || r.renderbuffer({
                width: n,
                height: i,
                format: "depth24 stencil8",
                samples: this.layer.options.multiSamples
            });
            s.depthStencil = t;
        } else if (a) {
            const t = e || r.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "depth stencil",
                width: n,
                height: i,
                format: "depth stencil"
            });
            s.depthStencil = t;
        } else {
            const t = e || r.renderbuffer({
                width: n,
                height: i,
                format: "depth stencil"
            });
            s.depthStencil = t;
        }
        return s;
    }
    Mc() {
        if (!this.Xr) return void (this.ih = !1);
        const t = this.layer.To(), e = t && t.postProcess;
        if (!e || !e.enable) {
            if (this.isEnableWeather()) throw new Error("you must enable the post process to turn on weather");
            return;
        }
        this.layer.fire("postprocessstart");
        const n = this.layer.getMap();
        let i = e.sharpen && e.sharpen.factor;
        i || 0 === i || (i = .2);
        let r = 0, s = .2, o = .3, a = 1, c = [ 1, 1, 0 ];
        e.outline && (r = +!!e.outline.enable, s = Bh(e.outline, "highlightFactor", s), 
        o = Bh(e.outline, "outlineFactor", o), a = Bh(e.outline, "outlineWidth", a), c = Bh(e.outline, "outlineColor", c));
        const h = e.ssr && e.ssr.enable, l = e.bloom && e.bloom.enable, f = this.Jc.fc(), u = this.xc.Za(), d = this.isEnableScanEffect(), m = l || h || f || u || d;
        let v = this.nh;
        if (m) {
            if (!v) {
                const t = this.qc();
                this.hc() && (t.depthStencil = this.regl.renderbuffer({
                    width: this.canvas.width,
                    height: this.canvas.height,
                    samples: this.layer.options.multiSamples,
                    format: "depth24 stencil8"
                })), v = this.nh = this.regl.framebuffer(t);
            }
            const {width: t, height: e} = this.canvas;
            v.width === t && v.height === e || v.resize(t, e);
        } else v = null, this.nh && (this.nh.destroy(), delete this.nh);
        let g = this.Ja(this.Xr);
        if (this.Pc.fxaa(v, g, 0, +!(!e.toneMapping || !e.toneMapping.enable), +!(m || !e.sharpen || !e.sharpen.enable), n.getDevicePixelRatio(), i, r && this.zc > 0 && this.Uc(), s, o, a, c), 
        v && (g = this.Ja(v)), l && this.Rc) {
            const t = e.bloom, n = +t.threshold || 0, i = Bh(t, "factor", 1), r = Bh(t, "radius", 1);
            g = this.Pc.bloom(g, null, null, n, i, r, 0);
        }
        if (h && (this.Pc.genSsrMipmap(g, this.Hc()), this.Xc)) {
            const t = this.ih;
            this.setToRedraw(), this.ih = t, this.Xc = !1;
        }
        this.Yc && this.isEnableScanEffect() && (g = this.gh(g)), this.Jc && (g = this.fh(g)), 
        this.isEnableWeather() && (g = this.mh(g)), m && this.Pc.renderFBOToScreen(g, +!(!e.sharpen || !e.sharpen.enable), i, n.getDevicePixelRatio()), 
        this.layer.fire("postprocessend");
    }
    isEnableScanEffect() {
        const t = this.layer.To(), e = t && t.postProcess && t.postProcess.scanEffect;
        return e && e.enable && e.effects.length;
    }
}

function Uh(t) {
    return "number" == typeof t && !isNaN(t);
}

function zh(t) {
    return t._framebuffer.framebuffer;
}

function Gh(t) {
    return t.depthStencil._texture.texture;
}

function Bh(t, e, n) {
    return null == t[e] ? n : t[e];
}

class Vh extends t.worker.Actor {
    constructor(t) {
        super("@maptalks/terrain"), this.mapId = t;
    }
    checkUrl(e) {
        return e && t.Util.isString(e) ? t.Util.getAbsoluteURL(e) : e;
    }
    fetchTerrain(t, e, n) {
        t = this.checkUrl(t);
        const i = e.tileImage, r = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "fetchTerrain",
            params: {
                url: t,
                origin: location.origin,
                terrainWidth: e.terrainWidth,
                type: e.type,
                accessToken: e.accessToken,
                cesiumIonTokenURL: e.cesiumIonTokenURL,
                error: e.error,
                colors: e.colors,
                tileSize: e.tileSize,
                tileImage: i
            }
        }, s = [];
        i && s.push(i), this.send(r, s, ((t, e) => {
            t ? n(t) : n(t, e);
        }));
    }
    abortTerrain(t, e) {
        const n = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "abortTerrain",
            params: {
                url: t
            }
        };
        this.broadcast(n, null, e);
    }
    addLayer(t, e, n) {
        const i = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: t,
            command: "addLayer",
            params: {}
        };
        this.broadcast(i, null, n);
    }
    createTerrainMesh(t, e) {
        const n = {
            actorId: this.actorId,
            command: "createTerrainMesh",
            params: t
        };
        this.send(n, [ t.terrainHeights.data.buffer ], ((t, n) => {
            t ? e(t) : e(t, n);
        }));
    }
    removeLayer(t, e, n) {
        const i = {
            mapId: this.mapId,
            layerId: t,
            command: "removeLayer"
        };
        this.broadcast(i, null, n);
    }
}

class jh {
    constructor(t = 257) {
        this.gridSize = t;
        const e = t - 1;
        if (e & e - 1) throw new Error(`Expected grid size to be 2^n+1, got ${t}.`);
        this.numTriangles = e * e * 2 - 2, this.numParentTriangles = this.numTriangles - e * e, 
        this.indices = new Uint32Array(this.gridSize * this.gridSize), this.coords = new Uint16Array(4 * this.numTriangles);
        for (let t = 0; t < this.numTriangles; t++) {
            let n = t + 2, i = 0, r = 0, s = 0, o = 0, a = 0, c = 0;
            for (1 & n ? s = o = a = e : i = r = c = e; (n >>= 1) > 1; ) {
                const t = i + s >> 1, e = r + o >> 1;
                1 & n ? (s = i, o = r, i = a, r = c) : (i = s, r = o, s = a, o = c), a = t, c = e;
            }
            const h = 4 * t;
            this.coords[h + 0] = i, this.coords[h + 1] = r, this.coords[h + 2] = s, this.coords[h + 3] = o;
        }
    }
    createTile(t) {
        return new Wh(t, this);
    }
}

class Wh {
    constructor(t, e) {
        const n = e.gridSize;
        if (t.length !== n * n) throw new Error(`Expected terrain data of length ${n * n} (${n} x ${n}), got ${t.length}.`);
        this.terrain = t, this.martini = e, this.errors = new Float32Array(t.length), this.update();
    }
    update() {
        const {numTriangles: t, numParentTriangles: e, coords: n, gridSize: i} = this.martini, {terrain: r, errors: s} = this;
        for (let o = t - 1; o >= 0; o--) {
            const t = 4 * o, a = n[t + 0], c = n[t + 1], h = n[t + 2], l = n[t + 3], f = a + h >> 1, u = c + l >> 1, d = f + u - c, m = u + a - f, v = (r[c * i + a] + r[l * i + h]) / 2, g = u * i + f, p = Math.abs(v - r[g]);
            if (s[g] = Math.max(s[g], p), o < e) {
                const t = (c + m >> 1) * i + (a + d >> 1), e = (l + m >> 1) * i + (h + d >> 1);
                s[g] = Math.max(s[g], s[t], s[e]);
            }
        }
    }
    getMesh(t = 0) {
        const {gridSize: e, indices: n} = this.martini, {errors: i} = this;
        let r = 0, s = 0;
        const o = e - 1;
        function a(o, c, h, l, f, u) {
            const d = o + h >> 1, m = c + l >> 1;
            Math.abs(o - f) + Math.abs(c - u) > 1 && i[m * e + d] > t ? (a(f, u, o, c, d, m), 
            a(h, l, f, u, d, m)) : (n[c * e + o] = n[c * e + o] || ++r, n[l * e + h] = n[l * e + h] || ++r, 
            n[u * e + f] = n[u * e + f] || ++r, s++);
        }
        n.fill(0), a(0, 0, o, o, o, 0), a(o, o, 0, 0, 0, o);
        const c = new Uint16Array(2 * r), h = new Uint32Array(3 * s);
        let l = 0;
        function f(r, s, o, a, u, d) {
            const m = r + o >> 1, v = s + a >> 1;
            if (Math.abs(r - u) + Math.abs(s - d) > 1 && i[v * e + m] > t) f(u, d, r, s, m, v), 
            f(o, a, u, d, m, v); else {
                const t = n[s * e + r] - 1, i = n[a * e + o] - 1, f = n[d * e + u] - 1;
                c[2 * t] = r, c[2 * t + 1] = s, c[2 * i] = o, c[2 * i + 1] = a, c[2 * f] = u, c[2 * f + 1] = d, 
                h[l++] = t, h[l++] = i, h[l++] = f;
            }
        }
        return f(0, 0, o, o, o, 0), f(o, o, 0, 0, 0, o), {
            vertices: c,
            triangles: h
        };
    }
    getMeshWithSkirts(t = 0, e) {
        const {gridSize: n, indices: i} = this.martini, {errors: r} = this;
        let s = 0, o = 0;
        const a = n - 1;
        let c, h, l = 0;
        const f = [], u = [], d = [], m = [];
        function v(e, g, p, x, _, b) {
            const y = e + p >> 1, w = g + x >> 1;
            Math.abs(e - _) + Math.abs(g - b) > 1 && r[w * n + y] > t ? (v(_, b, e, g, y, w), 
            v(p, x, _, b, y, w)) : (c = g * n + e, h = x * n + p, l = b * n + _, 0 === i[c] && (0 === e ? f.push(s) : e === a && u.push(s), 
            0 === g ? d.push(s) : g === a && m.push(s), i[c] = ++s), 0 === i[h] && (0 === p ? f.push(s) : p === a && u.push(s), 
            0 === x ? d.push(s) : x === a && m.push(s), i[h] = ++s), 0 === i[l] && (0 === _ ? f.push(s) : _ === a && u.push(s), 
            0 === b ? d.push(s) : b === a && m.push(s), i[l] = ++s), o++);
        }
        let g;
        i.fill(0), v(0, 0, a, a, a, 0), v(a, a, 0, 0, 0, a), g = e ? 2 * (s + 3 * f.length - 2 + 3 * u.length - 2 + 3 * d.length - 2 + 3 * m.length - 2) : 2 * (s + f.length + u.length + d.length + m.length);
        const p = 3 * (o + 2 * (f.length - 1) + 2 * (u.length - 1) + 2 * (d.length - 1) + 2 * (m.length - 1)), x = new Uint16Array(g), _ = new Uint32Array(p);
        let b = 0;
        function y(e, s, o, a, c, h) {
            const l = e + o >> 1, f = s + a >> 1;
            if (Math.abs(e - c) + Math.abs(s - h) > 1 && r[f * n + l] > t) y(c, h, e, s, l, f), 
            y(o, a, c, h, l, f); else {
                const t = i[s * n + e] - 1, r = i[a * n + o] - 1, l = i[h * n + c] - 1;
                x[2 * t] = e, x[2 * t + 1] = s, x[2 * r] = o, x[2 * r + 1] = a, x[2 * l] = c, x[2 * l + 1] = h, 
                _[b++] = t, _[b++] = r, _[b++] = l;
            }
        }
        y(0, 0, a, a, a, 0), y(a, a, 0, 0, 0, a), f.sort(((t, e) => x[2 * t + 1] - x[2 * e + 1])), 
        u.sort(((t, e) => x[2 * e + 1] - x[2 * t + 1])), d.sort(((t, e) => x[2 * e] - x[2 * t])), 
        m.sort(((t, e) => x[2 * t] - x[2 * e]));
        let w, S, A, M, T = 2 * s, C = 0;
        function O(t) {
            C = t.length;
            for (let n = 0; n < C - 1; n++) w = t[n], S = t[n + 1], A = T / 2, M = (T + (e ? 6 : 2)) / 2, 
            x[T++] = 2 * w, x[T++] = 2 * w + 1, e && (x[T++] = 2 * w, x[T++] = 2 * w + 1, x[T++] = 2 * S, 
            x[T++] = 2 * S + 1), e ? (_[b++] = A + 1, _[b++] = A, _[b++] = A + 2, _[b++] = A, 
            _[b++] = M, _[b++] = A + 2) : (_[b++] = w, _[b++] = A, _[b++] = S, _[b++] = A, _[b++] = M, 
            _[b++] = S);
            x[T++] = 2 * t[C - 1], x[T++] = 2 * t[C - 1] + 1;
        }
        O(f);
        const E = T;
        O(u);
        const I = T;
        O(d);
        const P = T;
        O(m);
        return {
            vertices: x,
            triangles: _,
            numVerticesWithoutSkirts: s,
            numTrianglesWithoutSkirts: o,
            leftSkirtIndex: E,
            rightSkirtIndex: I,
            bottomSkirtIndex: P,
            topSkirtIndex: T
        };
    }
}

const qh = {};

function Xh(t, e, n) {
    let i = qh[n];
    i || (i = qh[n] = new jh(n));
    const r = i.createTile(e).getMeshWithSkirts(t, !0), {triangles: s, vertices: o, leftSkirtIndex: a, rightSkirtIndex: c, bottomSkirtIndex: h, topSkirtIndex: l} = r;
    let {numVerticesWithoutSkirts: f, numTrianglesWithoutSkirts: u} = r;
    f || (f = o.length / 2, u = s.length / 3);
    const d = o.length / 2, m = new Float32Array(3 * d), v = new Float32Array(2 * d);
    let g = 1 / 0, p = -1 / 0;
    const x = n - 1;
    for (let t = 0; t < d; t++) {
        const i = o[2 * t], r = o[2 * t + 1];
        if (t >= f) {
            const e = i / 2 * 3;
            let n, r = .001;
            (t - (t < a / 2 ? f : t < c / 2 ? a / 2 : t < h / 2 ? c / 2 : h / 2)) % 3 == 0 ? (n = Math.min(0, g), 
            r = 0) : n = m[e + 2];
            m[3 * t] = m[e], m[3 * t + 1] = m[e + 1], m[3 * t + 2] = n, v[2 * t] = m[e] / x + r, 
            v[2 * t + 1] = -m[e + 1] / x + r;
        } else {
            const s = e[r * n + i];
            m[3 * t] = 1 * i, m[3 * t + 1] = 1 * -r, m[3 * t + 2] = s, v[2 * t] = i / x, v[2 * t + 1] = r / x, 
            s < g && (g = s), s > p && (p = s);
        }
    }
    return {
        positions: m,
        texcoords: v,
        triangles: s,
        leftSkirtIndex: a,
        rightSkirtIndex: c,
        bottomSkirtIndex: h,
        topSkirtIndex: l,
        numTrianglesWithoutSkirts: u,
        numVerticesWithoutSkirts: f,
        minHeight: Math.min(0, g),
        maxHeight: p,
        terrainWidth: n
    };
}

function Kh(t, e, n, i, r, s, o, a, c) {
    const h = {};
    for (let l = 0; l < c; l++) h[l + ""] = Jh(t, e, n, i, r, s, o, a, l);
    return h;
}

const $h = [];

function Jh(t, e, n, i, r, s, o, a, c) {
    if ((i -= c) <= 0) return $h;
    const h = t.getTileSize().width, l = t._getTileOffset(i, r), f = s[0] - l[0], u = l[1] - s[1], d = t._getTileConfig(), m = t.getSpatialReference().getResolution(i), v = d.tileSystem.scale.y, g = 1e-7;
    let p = 0, x = 0, _ = a /= Math.pow(2, c), b = a;
    if (f < 0 ? _ += Math.ceil(-f / h - g) : f > 0 && (p -= Math.ceil(f / h - g)), u > 0 ? x -= Math.ceil(u / h - g) : u < 0 && (b += Math.ceil(-u / h - g)), 
    0 === p && 0 === x && _ <= 1 && b <= 1) {
        const r = Math.floor(e * a);
        let s = Math.floor(n * a);
        const c = s;
        return v !== o && (s = Qh(d, s, m)), [ {
            x: r,
            y: s,
            skinY: c,
            z: i,
            offset: l,
            tileSize: h,
            id: t._getTileId(r, s, i)
        } ];
    }
    const y = [];
    for (let r = p; r < _; r++) for (let s = x; s < b; s++) {
        const c = e * a + r;
        let f = n * a + s;
        const u = f;
        v !== o && (f = Qh(d, f, m)), y.push({
            x: c,
            y: f,
            skinY: u,
            z: i,
            offset: l,
            tileSize: h,
            id: t._getTileId(c, f, i)
        });
    }
    return y;
}

function Yh(t, e, n, i) {
    let r = t / n * i / e;
    return r < 1 ? (r = 1 / r, r = 1 / Math.round(r)) : r = Math.round(r), r;
}

function Zh(t, e, n) {
    const i = t.getResolution(e), r = e - Math.log(n / i) * Math.LOG2E;
    return {
        zoom: r,
        res: t.getResolution(r)
    };
}

function Qh(t, e, n) {
    const i = t.fullExtent, r = t.tileSize.width, s = Math.max(i.top, i.bottom), o = Math.min(i.top, i.bottom);
    return Math.ceil(s / r / n) - 1 - Math.floor(o / r / n) - e;
}

function tl(t, e) {
    const n = e * e, i = 0 !== t ? new Float32Array(n) : new Uint8Array(n);
    return i.fill(t), {
        data: i,
        width: e,
        height: e,
        max: t,
        min: t
    };
}

new t.Point(0, 0);

const el = tl(0, 5), nl = Xh(1, el.data, el.width);

function il(t, e, n) {
    const i = n && n.includes;
    if (i) for (const r in i) i[r] && (n[r].uniformDeclares && e.push(...n[r].uniformDeclares), 
    n[r].defines && cc(t, n[r].defines));
}

function rl(t, e) {
    const n = e && e.includes;
    if (n) for (const i in n) n[i] && e[i].renderUniforms && cc(t, e[i].renderUniforms);
}

nl.empty = !0;

var sl = Object.freeze({
    __proto__: null,
    fillIncludes: il,
    setIncludeUniformValues: rl
});

const ol = [], al = [];

class cl {
    constructor(t) {
        this.layer = t;
        const e = t.getRenderer();
        this.graphics = e.regl || e.device, this.renderer = new pi(this.graphics), this.ph = new Ti;
        const n = new Uint8Array(16);
        n.fill(255), this.xh = this.graphics.texture({
            width: 2,
            height: 2,
            data: n
        }), this.yo = new bi(this.xh), this._h();
    }
    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }
    getMap() {
        return this.layer.getMap();
    }
    startFrame(t) {
        t && t.states && t.states.includesChanged && (this.shader.dispose(), delete this.shader), 
        this.shader || this.initShader(t), this.ph.clear();
    }
    createTerrainMesh(t, e) {
        const {mesh: n, image: i} = e;
        let r = e.terrainMesh;
        const {positions: s, texcoords: o, triangles: a, empty: c} = n;
        if (r && r.geometry !== this.bh) r.geometry.updateData("aPosition", s), r.geometry.updateData("aTexCoord", o), 
        r.geometry.setElements(a), r.geometry.generateBuffers(this.graphics); else {
            const t = c ? this.bh : new qt({
                aPosition: s,
                aTexCoord: o
            }, a, 0);
            t !== this.bh && t.generateBuffers(this.graphics), r ? r.geometry = t : r = new mi(t, null, {
                disableVAO: !0
            });
        }
        if (!r.uniforms.skin) {
            const t = this.getEmptyTexture();
            r.setUniform("skin", t);
        }
        if (!r.uniforms.flatMask) {
            const t = this.getEmptyTexture();
            r.setUniform("flatMask", t);
        }
        return r.setUniform("heightTexture", i), this.prepareMesh(r, t, e), r;
    }
    yh(t) {
        const e = this.layer.getRenderer();
        e && e.updateMaskDefines(t);
    }
    wh(t) {
        const e = this.Sh(), n = c.identity(t);
        return c.scale(n, n, [ 1, 1, e ]), n;
    }
    Sh() {
        let t = this.layer.options.exaggeration;
        return hc(t) && (t = 1), this.Ah(100) / 100 * t;
    }
    Mh(t, e, n) {
        const i = this.getMap(), r = this.layer.getTileSize().width, s = e.res / i.getGLRes(), o = r / (n - 1), {extent2d: a, offset: l} = e;
        h.set(ol, (a.xmin - l[0]) * s, (e.extent2d.ymax - l[1]) * s, 0);
        const f = c.identity(t);
        return c.translate(f, f, ol), h.set(al, s * o, s * o, 1), c.scale(f, f, al), f;
    }
    prepareMesh(t, e, n) {
        if (!t.isValid()) return;
        const {mesh: i} = n;
        this.yh(t);
        const {triangles: r, numTrianglesWithoutSkirts: s, terrainWidth: o} = i;
        t.localTransform = this.Mh(t.localTransform || [], e, o), t.positionMatrix = this.wh(t.positionMatrix || []), 
        t.properties.skirtOffset = 3 * s, t.properties.skirtCount = r.length - 3 * s, t.properties.z = e.z, 
        t.properties.minHeight = i.minHeight, t.properties.maxHeight = i.maxHeight, t.properties.terrainWidth = o, 
        t.castShadow = !1, mc(t.uniforms, "minAltitude") || Object.defineProperty(t.uniforms, "minAltitude", {
            enumerable: !0,
            get: () => n.minAltitude || 0
        });
    }
    addTerrainImage(t, e) {
        const n = e.terrainMesh;
        n && n.geometry && e.skin && (n.setUniform("skin", e.skin.color[0]), n.setUniform("flatMask", e.mask.color[0]), 
        n.setUniform("polygonOpacity", 1), this.ph.addMesh(n));
    }
    endFrame(t) {
        this.updateIBLDefines(this.shader);
        let e = 0;
        const n = this.getUniformValues(), i = this.Th(t);
        return this.shader.filter = t && t.sceneFilter, rl(n, t), this.ph.getMeshes().forEach((t => {
            this.yh(t);
        })), e += this.renderer.render(this.shader, n, this.ph, i), e;
    }
    delete() {
        this.shader && (this.shader.dispose(), delete this.shader), this.xh && (this.xh.destroy(), 
        delete this.xh), this.bh && (this.bh.dispose(), delete this.bh);
    }
    deleteMesh(t) {
        if (!t) return;
        const e = t.geometry;
        t.dispose(), e !== this.bh && e.dispose();
    }
    initShader(t) {
        const e = [], n = [], i = {}, r = [];
        il(i, r, t), this.shader = new Br({
            name: "terrain-mesh",
            vert: "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\nuniform sampler2D flatMask;\n#include <common_pack_float>\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  vec2 c = aTexCoord;\n  c.y = 1. - c.y;\n  vec4 d = texture2D(flatMask, c);\n  float e = aPosition.z;\n  if(length(d) < 2.) {\n    float f = decodeFloat32(d);\n    e = min(aPosition.z, f);\n  }\n  vec4 h = vec4(aPosition.xy, (e + minAltitude) * heightScale, 1.);\n  h = positionMatrix * h;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(h, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * h;\n#endif\nvUv = aTexCoord;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(h);\n#endif\n}",
            frag: "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nuniform float layerOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nvoid main() {\n  vec2 c = vec2(vUv);\n  c.y = 1. - c.y;\n  vec4 d = texture2D(skin, c);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat e = shadow_computeShadow();\n  d.rgb = shadow_blend(d.rgb, e).rgb;\n#endif\ngl_FragColor = d * polygonOpacity * layerOpacity;\n#ifdef HAS_MASK_EXTENT\ngl_FragColor = setMask(gl_FragColor);\n#endif\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: r.concat([ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return c.multiply(n, e.viewMatrix, e.modelMatrix);
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, n) {
                    return c.multiply(e, n.projViewMatrix, n.modelMatrix);
                }
            } ]),
            defines: i,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const t = this.layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? t.width : 1,
                height: () => t ? t.height : 1
            },
            cull: {
                enable: !0,
                face: "back"
            },
            depth: {
                enable: !0,
                mask: () => !!this.layer.options.depthMask,
                func: this.layer.options.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: this.layer.options.blendSrc,
                    dst: this.layer.options.blendDst
                },
                equation: "add"
            }
        };
    }
    Th(t) {
        return t && t.renderTarget && t.renderTarget.fbo;
    }
    getUniformValues() {
        const t = this.getMap(), e = t.projViewMatrix, n = this.layer.getRenderer().getMaskUniforms();
        let i = this.layer.options.opacity;
        hc(i) && (i = 1);
        const r = {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: e,
            heightScale: 1,
            layerOpacity: i
        };
        return cc(r, n), r;
    }
    Ah(t) {
        const e = this.layer.getMap();
        if (!e) return null;
        return e.altitudeToPoint(t, e.getGLRes());
    }
    getEmptyTexture() {
        return this.xh;
    }
    hasIBL() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    updateIBLDefines(t) {
        const e = t.shaderDefines;
        let n = !1;
        this.hasIBL() ? e[[ "HAS_IBL_LIGHTING" ]] || (e.HAS_IBL_LIGHTING = 1, n = !0) : e[[ "HAS_IBL_LIGHTING" ]] && (delete e.HAS_IBL_LIGHTING, 
        n = !0), n && (t.shaderDefines = e);
    }
    _h() {
        const t = nl, {positions: e, texcoords: n, triangles: i} = t;
        this.bh = new qt({
            aPosition: e,
            aTexCoord: n
        }, i, 0), this.bh.generateBuffers(this.graphics);
    }
}

const {getIBLResOnCanvas: hl, getPBRUniforms: ll, loginIBLResOnCanvas: fl, logoutIBLResOnCanvas: ul} = da.PBRUtils, dl = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    emissiveFactor: [ 0, 0, 0 ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [ 0, 0, 0 ],
    contrast: 1,
    alphaTest: 0
};

class ml extends cl {
    constructor(...t) {
        super(...t), this.createIBLTextures(), this.Ch = 0;
    }
    updateMaterial(t, e) {
        this.Ch = e, this.gn = this.gn || {}, cc(this.gn, t), this.setToRedraw();
    }
    setMaterial(t, e) {
        this.Ch = e, this.gn = cc({}, dl, t), this.setToRedraw();
    }
    createIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        fl(t, this.graphics, this.getMap()), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        ul(t, this.getMap());
    }
    createTerrainMesh(t, e) {
        const {mesh: n, image: i} = e, {positions: r, texcoords: s, triangles: o, leftSkirtIndex: a, rightSkirtIndex: c, bottomSkirtIndex: h, numVerticesWithoutSkirts: l} = n, f = new Int8Array(r.length);
        for (let t = 2; t < f.length; t += 3) t < 3 * l ? f[t] = 1 : t < a / 2 * 3 ? f[t - 2] = -1 : t < c / 2 * 3 ? f[t - 2] = 1 : f[t - 1] = t < h / 2 * 3 ? -1 : 1;
        const u = new qt({
            aPosition: r,
            aTexCoord: s,
            aNormal: f
        }, o, 0);
        let d;
        u.createTangent(), delete u.data.aNormal, u.generateBuffers(this.graphics), d = i ? this.graphics.texture({
            width: i.width,
            height: i.height,
            data: i,
            min: "linear",
            mag: "linear"
        }) : this.getEmptyTexture();
        const m = this.getEmptyTexture(), v = cc({}, dl, this.layer.options.material || {});
        v.skinTexture = m, v.terrainHeightTexture = d;
        const g = new da.StandardMaterial(v), p = new mi(u, g);
        if (p.properties.matVer = this.Ch, !p.uniforms.flatMask) {
            const t = this.getEmptyTexture();
            p.setUniform("flatMask", t);
        }
        const x = p.defines;
        return x.HAS_UV_FLIP = 1, x.HAS_TERRAIN_NORMAL = 1, x.HAS_MAP = 1, x.HAS_LAYER_OPACITY = 1, 
        x.HAS_TERRAIN_FLAT_MASK = 1, p.defines = x, this.prepareMesh(p, t, e), p;
    }
    addTerrainImage(t, e) {
        const n = e.terrainMesh;
        if (n) {
            if (this.gn && n.properties.matVer !== this.Ch) {
                for (const t in this.gn) n.material.set(t, this.gn[t]);
                n.properties.matVer = this.Ch;
            }
            e.skin && n.material.set("skinTexture", e.skin.color[0]), e.mask && n.setUniform("flatMask", e.mask.color[0]), 
            n.setUniform("polygonOpacity", 1), this.ph.addMesh(n);
        }
    }
    getUniformValues() {
        const t = this.getMap(), e = t.getRenderer().canvas, {iblTexes: n, dfgLUT: i} = hl(e), r = ll(t, n, i), s = this.layer.getTileSize().width, o = this.layer.getRenderer().getMaskUniforms();
        let a = this.layer.options.opacity;
        return hc(a) && (a = 1), cc(r, {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: t.projViewMatrix,
            outSize: [ e.width, e.height ],
            polygonFill: [ 1, 1, 1, 1 ],
            terrainHeightMapResolution: [ s, s ],
            terrainResolution: [ e.width, e.height ],
            terrainUnpackFactors: [ 6553.6, 25.6, .1, 1e4 ],
            layerOpacity: a
        }), cc(r, o), r;
    }
    initShader(t) {
        const e = {}, n = [];
        il(e, n, t), this.shader = new da.StandardShader({
            uniforms: n,
            defines: e,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    delete() {
        return this.disposeIBLTextures(), super.delete();
    }
}

function vl(t, e, n, i) {
    const r = gl.call(this, n, i);
    this._projViewMatrix = e;
    const {colorExtent: s, modeExtent: o} = this._extentPass.render(r, e);
    this._maskUniforms = this._maskUniforms || {}, this._maskUniforms.mask_colorExtent = s, 
    this._maskUniforms.mask_extent = t, this._maskUniforms.mask_modeExtent = o, this._maskUniforms.mask_hasFlatOut = xl.call(this, "flat-outside"), 
    this._maskUniforms.mask_hasClipOut = xl.call(this, "clip-outside"), this._maskUniforms.mask_hasVideo = xl.call(this, "video"), 
    this._maskUniforms.mask_heightRatio = n, this._maskUniforms.mask_heightOffset = i, 
    this.setToRedraw();
}

function gl(t, e) {
    const n = [], i = this.layer.getMasks();
    for (let r = 0; r < i.length; r++) {
        const s = i[r].getMesh(this.regl, t, e);
        s && n.push(s);
    }
    return n;
}

function pl() {
    if (!this._extentPass || !this._maskUniforms) return;
    const t = this._maskUniforms.mask_heightRatio, e = this._maskUniforms.mask_heightOffset, n = gl.call(this, t, e);
    this._extentPass.render(n, this._projViewMatrix);
    const i = this.layer.getMasks();
    for (let t = 0; t < i.length; t++) i[t].m && i[t].m();
}

function xl(t) {
    const e = this.layer.getMasks();
    for (let n = 0; n < e.length; n++) if (e[n].getMode() === t) return 1;
    return 0;
}

function _l() {
    const t = this.layer.getMasks();
    if (!t) return !1;
    for (let e = 0; e < t.length; e++) if (t[e].Oh) return t[e].Oh();
    return !1;
}

function bl(t) {
    return class extends t {
        setMask(t, e, n, i) {
            this.viewport || (this.viewport = {
                x: 0,
                y: 0,
                width: () => this.canvas ? this.canvas.width : 1,
                height: () => this.canvas ? this.canvas.height : 1
            }), this._extentPass ? vl.call(this, t, e, n, i) : this.regl ? (this._extentPass = new Cs(this.regl, this.viewport), 
            vl.call(this, t, e, n, i)) : this.layer.once("contextcreate", (() => {
                this._extentPass = new Cs(this.regl, this.viewport), vl.call(this, t, e, n, i);
            }), this);
        }
        needToRedraw() {
            return !!super.needToRedraw() || !!_l.call(this);
        }
        getMaskUniforms() {
            return _l.call(this) && pl.call(this), this.layer.updateMaskExtent(), this._maskUniforms;
        }
        getMaskDefines() {
            return this._maskDefines || (this._maskDefines = {}), this._maskUniforms && this._maskUniforms.mask_colorExtent ? this._maskDefines.HAS_MASK_EXTENT = 1 : delete this._maskDefines.HAS_MASK_EXTENT, 
            this._maskDefines;
        }
        updateMaskDefines(t) {
            const e = t.getDefines();
            delete e.HAS_MASK_EXTENT;
            cc(e, this.getMaskDefines()), t.setDefines(e);
        }
        _clearMask() {
            this._deleteMaskUniforms(), this._extentPass && (this._extentPass.dispose(), delete this._extentPass), 
            this.setToRedraw();
        }
        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    };
}

class yl {
    constructor(t, e) {
        this.max = t, this.onRemove = e, this.reset();
    }
    reset() {
        if (this.data) {
            const t = this.data.values();
            for (const e of t) this.onRemove(e);
        }
        return this.data = new Map, this;
    }
    clear() {
        this.reset(), delete this.onRemove;
    }
    add(t, e) {
        return e ? (this.has(t) ? (this.data.delete(t), this.data.set(t, e)) : this.data.set(t, e), 
        this) : this;
    }
    keys() {
        const t = new Array(this.data.size);
        let e = 0;
        const n = this.data.keys();
        for (const i of n) t[e++] = i;
        return t;
    }
    has(t) {
        return this.data.has(t);
    }
    getAndRemove(t) {
        if (!this.has(t)) return null;
        const e = this.data.get(t);
        return this.data.delete(t), e;
    }
    get(t) {
        if (!this.has(t)) return null;
        return this.data.get(t);
    }
    pop() {
        if (this.data.size < this.max) return null;
        const t = this.data.keys().next();
        return this.data.get(t.value).current ? (this.max += Math.ceil(this.max / 2), null) : this.getAndRemove(t.value);
    }
    remove(t) {
        if (!this.has(t)) return this;
        const e = this.data.get(t);
        return this.data.delete(t), this.onRemove(e), this;
    }
    resetCurrent(t) {
        this.data && this.data.forEach((e => {
            e.current = t;
        }));
    }
}

const {TileLayerRendererable: wl, LayerAbstractRenderer: Sl} = t.renderer, Al = new t.Point(0, 0), Ml = new t.Point(0, 0), Tl = new t.PointExtent(0, 0, 0, 0), Cl = new t.Point(0, 0), Ol = {
    color: [ 0, 0, 0, 0 ],
    depth: 1,
    stencil: 0
}, El = {
    color: [ 1, 1, 1, 1 ],
    depth: 0,
    stencil: 0
};

class Il extends(bl(wl(Sl))){
    constructor(...t) {
        super(...t), this.init();
    }
    isDrawable() {
        return !0;
    }
    getTempTileOnLoading(t, e) {
        if (e.image && !e.image.reset) return e;
        this.Eh(t, "getTempTileOnLoading");
        const n = this.Ih(t);
        return n.temp = !0, e.image || (e.image = n), delete e.image.reset, e.current = !0, 
        e.info = t, cc(e.image, n), this.Ph(e.image, t), e;
    }
    Hh(t, e, n) {
        e.reset = !0, delete e.data, delete e.loadTime, delete e.rendered, delete e.minAltitude;
        const i = t.id + "-temp", r = e.skinImages;
        if (r) for (let t = 0; t < r.length; t++) {
            const e = r[t];
            if (e) {
                for (let t = 0; t < e.length; t++) {
                    const r = e[t];
                    r && (r.refs.delete(i), r.refs.size || n.push(r));
                }
                delete e.currentSkins, delete e.tileIds;
            }
        }
        delete e.sourceZoom, delete e.skinImages, delete e.skinStatus, delete e.skinTileIds, 
        e.debugTexture && (e.debugTexture.destroy(), delete e.debugTexture);
    }
    Ih(t, e) {
        for (e = e || this.findParentTile(t); e && e.image && (-1 === e.image.sourceZoom || e.image.originalError); ) e = this.findParentTile(e.info);
        const n = t.res, i = this.getMap().pointAtResToDistance(1, 1, n), r = e && e.image && e.image.data && this.Rh(e, t), s = r && -1 !== e.image.sourceZoom ? e.info.z : -1;
        if (!r || r.width <= 1) {
            const n = this.kh(t, e);
            return {
                data: tl(n || 0, 5),
                minAltitude: n,
                mesh: nl,
                sourceZoom: s
            };
        }
        const o = r.width;
        return {
            data: r,
            mesh: Xh(i / 2, r.data, o),
            sourceZoom: s
        };
    }
    kh(t, e) {
        if (e && e.minAltitude) return e.minAltitude;
        const {idx: n, idy: i, z: r} = t;
        for (let t = -1; t <= 1; t++) for (let e = -1; e <= 1; e++) {
            if (0 === t && 0 === e) continue;
            const s = this.layer.getTileId(n + t, i + e, r), o = this.layer.tileInfoCache, a = o && o.get(s);
            if (a && a.minAltitude) return a.minAltitude;
        }
        return 0;
    }
    consumeTile(t, e) {
        if (this.Eh(e, "consumeTile"), t.empty && !t.mesh) {
            const n = this.findParentTile(e);
            if (!n || n.image && n.image.empty) {
                t.mesh = nl;
                const n = this.kh(e);
                t.data = tl(n || 0, 5), t.minAltitude = n, t.sourceZoom = -1;
            } else t = this.Ih(e, n);
        }
        this.Ph(t, e), super.consumeTile(t, e), this.Nh(e);
    }
    Ph(t, e) {
        if (t && t.mesh) {
            t.terrainMesh = this.Dh.createTerrainMesh(e, t), e.minAltitude = t.data.min, e.maxAltitude = t.data.max, 
            delete t.mesh;
            const n = this.layer.tileInfoCache;
            if (n && e.parent && !t.empty && !t.temp) {
                const t = n.get(e.parent);
                if (t) {
                    const {minAltitude: n, maxAltitude: i} = e;
                    (void 0 === t.minAltitude || t.minAltitude > n) && (t.minAltitude = n), (void 0 === t.maxAltitude || t.maxAltitude < i) && (t.maxAltitude = i);
                }
            }
        }
    }
    Nh(t) {
        const e = this.getMap();
        if (e.updateCenterAltitude && void 0 === e.centerAltitude && t.z === this.getCurrentTileZoom()) {
            const n = e._getPrjCenter(), i = e._prjToPointAtRes(n, t.res, Cl);
            t.extent2d.contains(i) && e.updateCenterAltitude();
        }
    }
    draw(t, e) {
        this.Lh(), this.Dh.startFrame(e), super.draw(t, e), this.Fh(e);
    }
    drawTile(t, e) {
        const n = this.getMap();
        if (!t || !n || !e) return;
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) return;
        this.Eh(t, "drawTile");
        let i = this.drawingCurrentTiles ? this.getTileOpacity(e) : 1;
        i *= this.layer.options.opacity || 1, this.Dh.addTerrainImage(t, e, i);
    }
    _drawTiles(t, e, n, i, r, s, o) {
        const a = [];
        this.Uh = 0;
        const c = this.layer.getSkinCount(), h = new Set;
        if (o && o.length) {
            vc(s, o.map((t => t.info)));
            for (let t = 0; t < c; t++) this.zh(t, o, h, a);
        }
        vc(t, this.Gh(s, a)), this.Eh(t, "drawTiles");
        for (let e = 0; e < c; e++) this.zh(e, t, h, a);
        for (let e = 0; e < t.length; e++) this.Bh(t[e].info, t[e].image);
        for (let t = 0; t < a.length; t++) a[t] && a[t].texture && !a[t].refs.size && (this.Vh.delete(a[t].tile.id), 
        this.jh(a[t]));
        return this.Wh(), super._drawTiles(...arguments);
    }
    Gh(t, e) {
        const n = [];
        let i = this.qh;
        i || (i = this.qh = new yl(this.layer.options.tempTileCacheSize, (t => {
            const {info: e, image: n} = t;
            this.Xh(e, n);
        }))), i.resetCurrent(!1);
        for (let r = 0; r < t.length; r++) {
            const s = t[r];
            let o;
            this.Eh(s, "getTempTilesForMissed"), i.has(s.id) ? o = i.getAndRemove(s.id) : (o = i.pop(), 
            o ? o.image && (this.Hh(o.info, o.image, e), o.image.temp = !0) : o = {
                info: s
            }), o.current = !0, i.add(s.id, o), n.push(o);
        }
        for (let e = 0; e < t.length; e++) this.getTempTileOnLoading(t[e], n[e]);
        return n;
    }
    Wh() {
        if (!this.Vh) return;
        const t = this.getCurrentTimestamp();
        if (this.Kh && t - this.Kh < 1e3) return;
        const e = new Set;
        for (const t of this.tileCache.data.values()) this.$h(t, e);
        for (const t in this.tilesInView) {
            const n = this.tilesInView[t];
            this.$h(n, e);
        }
        if (this.qh) for (const t of this.qh.data.values()) this.$h(t, e);
        e.size && (this.Vh.forEach(((t, n) => {
            e.has(n) || (console.log("deleted:", n), this.jh(this.Vh.get(n)), this.Vh.delete(n));
        })), this.Kh = t);
    }
    $h(t, e) {
        const n = t.image && t.image.skinImages;
        if (n && n.length) for (let t = 0; t < n.length; t++) {
            const i = n[t] && n.currentSkins;
            if (i) for (const t of i) e.add(t);
        }
    }
    zh(t, e, n, i) {
        const r = this.layer.getSkinLayer(t).getRenderer();
        if (!r) return;
        const s = [];
        for (let r = 0; r < e.length; r++) {
            const {info: o, image: a} = e[r];
            this.Jh(o, a), this.Eh(o, "renderChildTerrainSkin");
            let c = !1;
            if (this.Yh(t, o, a, i)) {
                const e = a.skinImages[t];
                for (let t = 0; t < e.length; t++) {
                    const i = e[t].tile.info.id;
                    n.has(i) || (!c && e[t].layer.hasTerrainMask && (this._clearMask(a.mask), c = !0), 
                    e[t].terrainMaskFBO = a.mask, s.push(e[t]), n.add(i));
                }
            }
        }
        r.renderTerrainSkin(this.device, this.layer, s);
    }
    Jh(t, e) {
        e.mask || (e.mask = this.Zh(t, e), e.mask.id = t.id);
    }
    _clearMask(t) {
        El.framebuffer = t, this.device.clear(El);
    }
    Yh(t, e, n, i) {
        const r = this.getMap();
        if (delete n.path, !e || !r || !n) return !1;
        if (!n.terrainMesh) return !1;
        const s = this.layer.getSkinLayer(t), o = s.getRenderer();
        if (!o) return !1;
        n.skinImages || (n.skinImages = []), n.skinStatus || (n.skinStatus = []), n.skinTileIds || (n.skinTileIds = []);
        const a = o.isAnimating && o.isAnimating(), c = n.skinStatus[t], h = o.needToRefreshTerrainTileOnZooming && o.needToRefreshTerrainTileOnZooming(), l = a || h && n.renderedZoom !== r.getZoom();
        if (c && !l) return !1;
        const f = s.getSpatialReference(), {x: u, y: d, z: m, res: v, offset: g} = e;
        let p = e.nw;
        p || (p = e.nw = this.getMap().pointAtResToCoord(e.extent2d.getMin(Al), e.res));
        const x = this.layer.getTileSize().width;
        let {res: _, zoom: b} = Zh(f, m, v);
        let y = Yh(_, s.getTileSize().width, v, x), w = n.skinTileIds[t];
        if (!w) {
            const e = this.layer._getTileConfig().tileSystem.scale.y, i = s.options.maxAvailableZoom;
            !hc(i) && i >= 0 && b > i && (y *= Math.pow(2, i - b), b = i), w = n.skinTileIds[t] = Kh(s, u, d, b, p, g, e, y, 1);
        }
        const S = w[0];
        let A = !0;
        const M = [];
        for (let t = 0; t < S.length; t++) {
            const e = o.getCachedTile(S[t], !1);
            if (e) M.push(e); else {
                A = !1;
                const e = o.findParentTile(S[t]);
                e && M.push(e);
            }
        }
        const T = n.skinImages[t] || [];
        T.currentSkins = T.currentSkins || new Set;
        const C = new Set;
        let O = !1;
        for (let t = 0; t < T.length; t++) {
            if (!T[t].tile) {
                O = !0;
                continue;
            }
            const e = T[t].tile.info.id;
            C.add(e);
        }
        if (!M.length) return T.currentSkins.clear(), n.skinImages[t] = [], !1;
        const E = M.map((t => t.info.id)).join();
        if (!l && !O && T.tileIds === E) return !1;
        T.tileIds = E;
        let I = !1;
        T.currentSkins.clear(), T.length = 0;
        const P = T.currentSkins;
        let H = e.id;
        n.temp && (H += "-temp");
        for (let t = 0; t < M.length; t++) {
            const e = M[t].info.id;
            P.add(e);
            let n = this.Qh(e);
            n && ((R = n) && R.texture) || (n = {
                tile: cc({}, M[t]),
                layer: s,
                refs: new Set,
                texture: o.createTerrainTexture(this.device)
            }, this.tl(e, n)), n.refs.add(H), T.push(n), I = !0;
        }
        var R;
        return this.el(e, n, C, P, i), I && this.Uh++, n.skinImages[t] = T, s.fire("renderterrainskin", {
            tile: e,
            skinTiles: M
        }), A && (n.skinStatus[t] = 1), !0;
    }
    el(t, e, n, i, r) {
        if (!n.size) return;
        let s = t.id;
        e.temp && (s += "-temp");
        for (const t of n) if (!i || !i.has(t)) {
            const e = this.Qh(t);
            this.nl(e, s, r);
        }
    }
    Qh(t) {
        return this.Vh || (this.Vh = new Map), this.Vh.get(t);
    }
    tl(t, e) {
        this.Vh.set(t, e);
    }
    Bh(t, e) {
        const n = this.getMap();
        if (!t || !n || !e) return;
        this.Eh(t, "_renderTerrainMeshSkin");
        const i = this.il(e.renderedZoom);
        if (e.rendered && !i) return;
        e.skin ? (Ol.framebuffer = e.skin, this.device.clear(Ol)) : (e.skin = this.rl(t, e), 
        this.Jh(t, e)), this.sl();
        const r = this.layer.options.debug, s = [], o = r && [], a = this.layer.getTileSize().width, c = e.skinImages;
        if (c) for (let e = 0; e < c.length; e++) {
            const n = c[e];
            for (let e = 0; e < n.length; e++) {
                const {tile: i, texture: r, layer: o} = n[e];
                if ((i.info.offset[0] || i.info.offset[1]) && t.skinTileIds) {
                    const e = t.skinTileIds[o.getId()];
                    for (let t = 0; t < e.length; t++) if (i.info.x === e[t].x && i.info.y === e[t].y) {
                        i.info.offset = e[t].offset;
                        break;
                    }
                }
                const c = Pl(t, i, a), h = n[e].skinMesh || new mi(this.ol);
                h.setUniform("skinTexture", r);
                const l = o.getOpacity();
                h.setUniform("opacity", hc(l) ? 1 : l), h.setUniform("skinDim", c), h.setUniform("tileSize", a), 
                h.setUniform("x", t.x), h.setUniform("y", t.y), n[e].skinMesh = h, s.push(h);
            }
        }
        if (r) {
            const n = e.skinDebugMesh || new mi(this.ol);
            n.setUniform("tileSize", a);
            const i = e.debugTexture || this.al(t, a, e.temp);
            e.debugTexture = i, e.skinDebugMesh = n, n.setUniform("opacity", 1), n.setUniform("skinTexture", i), 
            n.setUniform("skinDim", [ 0, 0, 1 ]), n.setUniform("tileSize", a), o.push(n);
        }
        if (s.length) {
            this.cl.setMeshes(s);
            try {
                this.renderer.render(this.hl, null, this.cl, e.skin);
            } catch (t) {
                throw console.error(e), t;
            }
        }
        o && o.length && this.layer.options.debug && (this.cl.setMeshes(o), this.renderer.render(this.hl, null, this.cl, e.skin)), 
        e.rendered = this.ll(e), e.renderedZoom = n.getZoom();
    }
    al(t, e, n) {
        e *= 2;
        const {x: i, y: r, z: s} = t, o = `terrain:${i}/${r}/${s}` + (n ? "-temp" : ""), a = document.createElement("canvas");
        a.width = e, a.height = e;
        const c = a.getContext("2d");
        c.font = "60px monospace";
        const h = this.layer.options.debugOutline;
        return c.fillStyle = h, c.strokeStyle = h, c.fillText(o, 20, e - 40), c.beginPath(), 
        c.lineWidth = 4, c.moveTo(0, 0), c.lineTo(e, 0), c.lineTo(e, e), c.lineTo(0, e), 
        c.lineTo(0, 0), c.stroke(), this.device.texture({
            data: a,
            flipY: !0,
            mag: "linear",
            min: "linear"
        });
    }
    Zh() {
        const t = this.device, e = this.layer.getTileSize().width, n = 2 * e, i = 2 * e, r = t.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            format: "rgba",
            width: n,
            height: i
        });
        this.fl || (this.fl = t.texture({
            width: n,
            height: i,
            format: "depth stencil"
        }));
        const s = {
            width: n,
            height: i,
            colors: [ r ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0
        };
        s.depthStencil = this.fl;
        const o = t.framebuffer(s);
        return o.colorTex = r, this._clearMask(o), o;
    }
    rl(t) {
        const e = this.layer.getTileSize().width, n = 2 * e, i = 2 * e, r = this.device, s = t.colorsTexture;
        let o;
        o = s && s instanceof Uint8Array ? r.texture({
            data: s,
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: n,
            height: i,
            flipY: !0
        }) : r.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: n,
            height: i,
            flipY: !0
        });
        const a = {
            width: n,
            height: i,
            colors: [ o ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0,
            depthStencil: !1,
            depth: !1,
            stencil: !1
        }, c = r.framebuffer(a);
        return c.colorTex = o, c;
    }
    Fh(t) {
        this.Dh.endFrame(t) && !Object.keys(this.tilesLoading).length && this.layer.fire("terrainreadyandrender");
    }
    Rh(t, e) {
        const {image: n, info: i} = t, r = n.data, s = r.width, {extent2d: o, res: a} = i, {extent2d: c, res: h} = e, l = o.getWidth(), f = o.getHeight();
        let u = (c.xmin * h / a - o.xmin) / l * (s - 1), d = (o.ymax - c.ymax * h / a) / f * (s - 1);
        const m = (c.xmax * h / a - o.xmin) / l * (s - 1);
        let v = Math.round(m - u);
        const g = Math.log2(v);
        v = Math.pow(2, Math.round(g)) + 1, u = Math.floor(u), d = Math.floor(d);
        const p = new Float32Array(v * v);
        let x = 1 / 0, _ = -1 / 0;
        for (let t = 0; t < v; t++) for (let e = 0; e < v; e++) {
            let n = t + u, i = e + d;
            n > s - 1 ? n = s - 1 : n < 0 && (n = 0), i > s - 1 ? i = s - 1 : i < 0 && (i = 0);
            const o = r.data[n + i * s];
            p[t + e * v] = o, o < x && (x = o), o > _ && (_ = o);
        }
        return {
            width: v,
            height: v,
            data: p,
            min: x,
            max: _
        };
    }
    getTileOpacity(t) {
        return this.ll(t) ? super.getTileOpacity(t) : (this.resetTileLoadTime(t), 0);
    }
    ll(t) {
        const e = this.layer.getSkinCount();
        if (!e) return !0;
        if (!t.skinStatus) return !1;
        for (let n = 0; n < e; n++) if (!t.skinStatus[n]) return !1;
        return !0;
    }
    il(t) {
        const e = this.getMap().getZoom(), n = this.layer.getSkinLayers();
        for (let i = 0; i < n.length; i++) {
            const r = n[i] && n[i].getRenderer();
            if (r) {
                if (r.isAnimating && r.isAnimating()) return !0;
                if (r.needToRefreshTerrainTileOnZooming && r.needToRefreshTerrainTileOnZooming() && t !== e) return !0;
            }
        }
        return !1;
    }
    isValidCachedTile(t) {
        const e = !t.image.skinStatus;
        return t.image && !t.image.temp && (e || this.ll(t.image));
    }
    isTileComplete(t) {
        return t.image && !t.image.temp && this.ll(t.image);
    }
    ul() {
        const t = this.layer.options, e = this.layer.getTileSize().width;
        return hc(t.terrainWidth) ? e / 4 + 1 : t.terrainWidth;
    }
    dl(t, e) {
        const n = this.layer.options.maxAvailableZoom - this.layer.options.zoomOffset, i = t.z - n, r = Math.pow(2, i), s = Math.floor(t.x / r), o = Math.floor(t.y / r), a = Math.floor(t.idx / r), c = Math.floor(t.idy / r), h = Hl(s, o);
        this.ml || (this.ml = {});
        const l = !this.ml[h];
        return l && e && (this.ml[h] = new Set, this.ml[h].url = this.layer.getTileUrl(s, o, n + this.layer.options.zoomOffset)), 
        {
            x: s,
            y: o,
            idx: a,
            idy: c,
            requests: this.ml[h],
            isFirst: l,
            key: h
        };
    }
    loadTile(e) {
        const n = this.layer, i = this.ul(), r = n.getSpatialReference().getResolution(e.z);
        let s = this.getMap().pointAtResToDistance(1, 1, r);
        const o = n.options.zoomOffset || 0, a = n.options.maxAvailableZoom && n.options.maxAvailableZoom - o;
        if (a && e.z > a) {
            const t = this.Ih(e);
            if (-1 !== t.sourceZoom) return this.onTileLoad(t, e), t;
            {
                const {requests: i, isFirst: r, x: o, y: c, idx: h, idy: l} = this.dl(e, !0);
                if (i.add(e), !r) return t;
                const f = e.z - a;
                s *= Math.pow(2, f);
                const u = [ o, c, a, h, l, e.res * Math.pow(2, f), e.error * Math.pow(2, f) ];
                e = n.createTileNode ? n.createTileNode(...u) : n.vl(...u);
            }
        }
        const c = e.url, h = {}, l = n.options, f = n.getTileSize(), u = {
            terrainWidth: i,
            type: l.type,
            accessToken: l.accessToken,
            cesiumIonTokenURL: l.cesiumIonTokenURL,
            error: s,
            colors: l.colors,
            tileSize: f ? [ f.width, f.height ] : [ 256, 256 ],
            command: "loadTile"
        }, d = () => {
            this.workerConn.fetchTerrain(c, u, ((n, i) => {
                if (this.ml) {
                    const t = Hl(e.x, e.y), n = this.ml[t];
                    if (n && n.size) {
                        this.tileCache.add(e.id, {
                            info: e,
                            image: h
                        });
                        for (const t of n) this.removeTileLoading(t);
                    }
                    delete this.ml[t];
                }
                n ? m(n) : (t.Util.extend(h, i), e.colorsTexture = h.colorsTexture, this.onTileLoad(h, e));
            }));
        }, m = t => {
            t && t.canceled || (console.warn(t), this.onTileError(h, e));
        };
        return this.loadTileBitmap && fc(this.loadTileBitmap) ? this.loadTileBitmap(c, e, ((t, e) => {
            t ? m(t) : e && e instanceof ImageBitmap ? (u.tileImage = e, d()) : m(new Error("bitmap is not ImageBitmap"));
        }), u) : d(), h;
    }
    deleteTile(t) {
        if (!t || !t.image) return;
        super.deleteTile(t);
        const {info: e, image: n} = t;
        n.temp || (delete e.skinTileIds, this.Xh(t.info, n));
    }
    Xh(t, e) {
        const n = e.skin;
        n && (n.destroy(), n.colorTex.destroy(), delete n.colorTex);
        const i = e.mask;
        i && (i.destroy(), i.colorTex.destroy(), delete i.colorTex), e.debugTexture && (e.debugTexture.destroy(), 
        delete e.debugTexture, e.skinDebugMesh.dispose(), delete e.skinDebugMesh);
        const r = e.skinImages;
        if (r && r.length) {
            let n = t.id;
            e.temp && (n += "-temp");
            for (let t = 0; t < r.length; t++) {
                const e = r[t];
                if (e) {
                    for (let t = 0; t < e.length; t++) {
                        if (!e[t] || !e[t].tile) continue;
                        const i = e[t].tile.info.id, r = this.Vh && this.Vh.get(i);
                        r && this.nl(r, n);
                    }
                    e.length = 0;
                }
            }
        }
        e.terrainMesh && this.Dh.deleteMesh(e.terrainMesh), e.image && e.image.close && e.image.close(), 
        delete e.skinImages, delete e.skin, delete e.mask, delete e.skinStatus, delete e.skinTileIds, 
        delete e.terrainMesh, delete e.image, delete e.data, delete e.mesh, delete e.rendered;
    }
    nl(t, e, n) {
        t && (t.refs.delete(e), t.refs.size || (n ? n.push(t) : this.jh(t)));
    }
    jh(t) {
        if (!t || !t.tile) return;
        const e = t.tile.info.id, n = t.layer.getRenderer();
        delete t.canvas, delete t.layer, t.refs.clear(), t.texture && (n ? n.deleteTerrainTexture(t.texture) : t.texture.destroy && t.texture.destroy(), 
        delete t.texture), t.skinMesh && (t.skinMesh.dispose(), delete t.skinMesh), n && (n.removeTileCache && n.removeTileCache(e), 
        n.deleteTile && n.constructor.prototype.deleteTile.call(n, t.tile)), delete t.tile, 
        this.Vh.delete(e);
    }
    pl() {
        if (!this.Vh) return;
        const t = this.Vh.keys();
        for (const e of t) {
            const t = this.Qh(e);
            this.jh(t);
        }
        this.Vh.clear();
    }
    abortTileLoading(t, e) {
        const n = this.layer, i = n.options.maxAvailableZoom && n.options.maxAvailableZoom - n.options.zoomOffset, r = (t, e) => {
            this.loadTileBitmap && fc(this.loadTileBitmap) ? this.loadTileBitmap(t, e, (() => {}), {
                command: "abortTile"
            }) : this.workerConn && this.workerConn.abortTerrain(t);
        };
        if (e) if (i && e.z > i) {
            const {requests: t, key: n} = this.dl(e);
            t && t.size && (t.delete(e), t.size || (delete this.ml[n], r(t.url, e)));
        } else e && e.url && r(e.url, e);
        super.abortTileLoading(t, e);
    }
    onTileError(t, e) {
        super.onTileError(t, e);
    }
    xl(t) {
        const e = this.getCurrentTileZoom(), n = this.layer.getSpatialReference().getResolution(e), i = this.layer._getTileConfig().getTileIndex(t, n, this.layer.options.repeatWorld);
        return i.z = e, i;
    }
    _l(t, e, n, i, r) {
        const s = this.layer.getMinZoom(), o = this.bl(e, n.x, n.y, n.z, s);
        if (o && o.image && o.image.data) {
            const e = o.info.extent2d, s = o.info.res / r, a = i.x - e.xmin * s, c = e.ymax * s - i.y;
            let h = this.yl(o.image.data, a / (e.getWidth() * s), c / (e.getHeight() * s));
            const l = this.layer.wl();
            0 !== l && (h *= l), t[0] = h, t[1] = null === h ? 0 : +(o.info.z === n.z);
        } else t[0] = null, t[1] = 0;
        return t;
    }
    bl(t, e, n, i, r) {
        t || (t = this.layer._getTileId(e, n, i));
        const s = this.tilesInView[t] || this.tileCache.get(t);
        return !s && i - 1 >= r ? this.bl(null, Math.floor(e / 2), Math.floor(n / 2), i - 1, r) : s;
    }
    yl(t, e, n) {
        const {width: i, height: r, data: s} = t, o = Math.floor((i - 1) * e), a = Math.floor((r - 1) * n) * i + o;
        return void 0 === s[a] ? null : s[a];
    }
    Sl(t, e, n) {
        t || (t = {
            tiles: {},
            dirty: !0,
            complete: !1
        });
        const i = this.layer, r = this.getCurrentTileZoom(), s = i.getSpatialReference().getResolution(r), {xmin: o, ymin: a, xmax: c, ymax: h} = e, l = i._getTileConfig();
        Al.set(o, a).Al(n);
        const f = l._getTileNum(Al, n, !0);
        Ml.set(c, h).Al(n);
        const u = l._getTileNum(Ml, n, !0), d = Math.min(f.x, u.x), m = Math.max(f.x, u.x), v = Math.min(f.y, u.y), g = Math.max(f.y, u.y), p = n / s;
        Al.set(o, a).Al(p), Ml.set(c, h).Al(p);
        const x = Tl.set(Al.x, Al.y, Ml.x, Ml.y), _ = i.getTileSize().width + 1;
        x.Ml(x.getWidth() / _), t.array = t.array || new Float32Array(_ * _);
        const b = t.tiles;
        t.complete = !0, t.array.fill(0);
        for (let e = d; e <= m; e++) for (let n = v; n <= g; n++) {
            const i = this.layer._getTileId(e, n, r);
            if (b[i]) continue;
            const s = this.tileCache.get(i);
            s ? (this.Tl(t.array, s, x, _), t.dirty = !0, b[i] = 1) : (t.dirty = t.dirty || void 0 !== t.tiles[i], 
            t.tiles[i] && delete t.tiles[i], t.complete = !1);
        }
        return t;
    }
    Tl(t, e, n, i) {
        const r = e.info.extent2d, s = r.intersection(n), {xmin: o, ymin: a, xmax: c, ymax: h} = s, {data: l} = e.image, f = l.width, u = n.getWidth() / i, d = Math.floor((o - n.xmin) / u), m = Math.floor((a - n.ymin) / u), v = Math.floor((c - n.xmin) / u) - d, g = Math.floor((h - n.ymin) / u) - m, p = r.getWidth() / f, x = Math.floor((o - r.xmin) / p), _ = Math.floor((a - r.ymin) / p), b = Math.floor(u / p);
        for (let e = 0; e <= v; e++) for (let n = 0; n <= g; n++) {
            const r = e + d + (m + n) * i;
            let s = 0;
            for (let t = 0; t < b; t++) for (let i = 0; i < b; i++) {
                const r = (x + Math.floor(e * b)) * f + t + _ + Math.floor(n * b) + i;
                s += l.data[r];
            }
            t[r] = s / Math.max(b, 1);
        }
        return t;
    }
    clear() {
        return this.clearTempResources(), this.clearTileCaches(), super.clear();
    }
    clearTempResources() {
        this.qh && (this.qh.reset(), delete this.qh), this.Vh && this.pl();
    }
    onAdd() {
        super.onAdd(), this.prepareWorker();
    }
    onRemove() {
        this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (t => {
            if (t) throw t;
        })), this.workerConn.remove(), delete this.workerConn), this.clearTempResources(), 
        this.hl && (this.hl.dispose(), delete this.hl), this.ol && (this.ol.dispose(), delete this.ol), 
        this.fl && (this.fl.colorTex && this.fl.colorTex.destroy(), this.fl.destroy(), delete this.fl), 
        delete this.ml, super.onRemove(), this.Dh && (this.Dh.delete(), delete this.Dh);
    }
    prepareWorker() {
        const t = this.layer.getMap();
        this.workerConn || (this.workerConn = new Vh(t.id));
        const e = this.workerConn;
        if (!e.isActive()) return;
        const n = this.layer.options || {}, i = this.layer.getId();
        e.addLayer(i, n, (t => {
            if (t) throw t;
            this.layer && (this.ready = !0, this.setToRedraw(), this.layer.fire("workerready"));
        }));
    }
    initContext() {
        super.initContext();
        const {regl: t, device: e} = this.context;
        this.regl = t, this.device = e || t, this.renderer = new pi(t || e), this.layer.fire("contextcreate", {
            regl: t,
            device: e
        });
    }
    Lh() {
        const t = this.Dh;
        "lit" === this.layer.options.shader || "pbr" === this.layer.options.shader ? (t && t.constructor === cl || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.Dh = new ml(this.layer), this.layer.fire("paintercreated")) : (t && t.constructor === ml || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.Dh = new cl(this.layer), this.layer.fire("paintercreated"));
    }
    sl() {
        if (this.hl) return;
        const t = this.layer.getTileSize().width;
        this.hl = new Br({
            name: "terrain-skin",
            vert: "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n  gl_Position = vec4(aPosition, .0, 1.);\n}",
            frag: "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / 2.;\n  vec2 d = vec2(tileSize);\n  vec2 e = (c - skinDim.xy) / (d * skinDim.z);\n  if(e.x >= .0 && e.x <= 1. && e.y >= .0 && e.y <= 1.) {\n    gl_FragColor = texture2D(skinTexture, e) * opacity;\n  } else {\n    gl_FragColor = vec4(.0);\n  }\n}",
            wgslVert: "",
            wgslFrag: "",
            extraCommandProps: {
                cull: {
                    enable: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: 2 * t,
                    height: 2 * t
                },
                depth: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
        const e = new Int16Array([ -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1 ]);
        this.ol = this.ol || new qt({
            aPosition: e
        }, 0, 6, {
            positionSize: 2
        }), this.ol.generateBuffers(this.device), this.cl = this.cl || new Ti;
    }
    updateMaterial(t) {
        this.Dh && t && this.Dh.updateMaterial && (void 0 === this.Ch && (this.Ch = 1), 
        this.Dh.updateMaterial(t, this.Ch++));
    }
    setMaterial(t) {
        this.Dh && t && this.Dh.setMaterial && (void 0 === this.Ch && (this.Ch = 1), this.Dh.setMaterial(t, this.Ch++));
    }
    getAnalysisMeshes() {
        return this.Dh && this.Dh.ph ? this.Dh.ph.getMeshes() : [];
    }
    Eh(t, e, n) {
        if (this.layer.options.debugTile) {
            if (Array.isArray(t)) {
                for (let i = 0; i < t.length; i++) t[i] && this.Eh(t[i], e + " at " + i, n);
                return;
            }
            if (!t) return;
            const {x: i, y: r, z: s} = this.layer.options.debugTile, {info: o} = t;
            o && (t = o), i === t.x && r === t.y && s === t.z && console.log(`Found debug tile in TerrainLayerRenderer.${e}:`, t);
        }
    }
}

function Pl(t, e, n) {
    const {res: i, extent2d: r, offset: s} = t, {info: o} = e, a = o.res / i, c = o.offset, h = o.extent2d.xmin * a, l = o.extent2d.ymin * a, f = s[0] - c[0], u = c[1] - s[1];
    return [ h - r.xmin + f, -(r.ymin - l + u), a * o.tileSize / n ];
}

function Hl(t, e) {
    return t + "-" + e;
}

const Rl = {
    "clip-inside": .1,
    "clip-outside": .2,
    "flat-inside": .3,
    "flat-outside": .4,
    "color": .5,
    "texture": .6,
    "elevate": .7
}, kl = [], Nl = [ 1, 1, 1 ], Dl = {
    polygonFill: [ 255, 0, 0 ],
    polygonOpacity: .8
}, Ll = new e(0, 0), Fl = new e(0, 0), Ul = [], zl = new e(0, 0), Gl = new i(0, 0), Bl = new i(0, 0), Vl = new i(0, 0);

class jl extends r {
    getMode() {
        return this.Cl;
    }
    remove() {
        const t = this.getLayer();
        return t ? (t.removeMask(this), this.Ol(), super.remove(), this) : this;
    }
    getMesh(t, e, n) {
        return this.isVisible() && this.getLayer() ? (this.hs || (this.hs = this.Ph(t, e, n)), 
        this.xs(this.hs, e, n), this.hs) : null;
    }
    setCoordinates(t) {
        super.setCoordinates(t);
        const e = this.getLayer();
        if (e && (delete e._maskProjViewMatrix, delete e._maskExtentInWorld), !this.hs) return this;
        const n = this.getMode(), i = this.toGeoJSON();
        i.geometry.coordinates[0].reverse();
        const r = ct.flatten(i.geometry.coordinates), {positions: s, uvs: o, triangles: a} = "texture" === n ? this.El(r) : this.Il(r), c = this.hs.geometry;
        if (c.updateData("POSITION", s), c.updateData("TEXCOORD", o), c.setElements(a), 
        this.Pl(this.hs), this.Hl) {
            const t = this.Il(ct.flatten(i.geometry.coordinates), !0).positions;
            this.Hl.geometry.updateData("POSITION", t), this.Pl(this.Hl);
        }
    }
    So(t) {
        const e = this.getMode(), n = this.toGeoJSON();
        n.geometry.coordinates[0].reverse();
        const i = ct.flatten(n.geometry.coordinates), {positions: r, uvs: s, triangles: o} = "texture" === e ? this.El(i) : this.Il(i), a = this.Il(ct.flatten(n.geometry.coordinates), !0).positions, c = new qt({
            POSITION: r,
            TEXCOORD: s
        }, o, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        c.generateBuffers(t);
        const h = new qt({
            POSITION: a,
            TEXCOORD: s
        }, o, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        return h.generateBuffers(t), "texture" === e ? {
            geometry: c,
            copyGeometry: h
        } : c;
    }
    Il(t, e) {
        const n = this.getMap(), i = t.dimensions;
        for (let e = 0; e < t.vertices.length; e += i) {
            zl.x = t.vertices[e], zl.y = t.vertices[e + 1];
            const i = _c(n, zl);
            t.vertices[e] = i[0], t.vertices[e + 1] = i[1];
        }
        const r = _c(n, this.getCenter()), s = [], o = .01 * this.getLayer().getMasks().indexOf(this), a = "texture" === this.getMode() ? 4 : t.vertices.length / i;
        for (let c = 0; c < a; c++) s.push(t.vertices[c * i] - r[0]), s.push(t.vertices[c * i + 1] - r[1]), 
        s.push(o + e ? n.altitudeToPoint(t.vertices[c * i + 2], n.getGLRes()) : 0);
        return {
            positions: s,
            uvs: this.Rl(t.vertices, i),
            triangles: ct(s, t.holes, 3)
        };
    }
    Rl(t, e) {
        const n = [ 0, 0, 0, 1, 1, 1, 1, 0 ];
        if (this.hasHoles()) {
            const i = t.length / e * 2;
            for (let t = n.length / 2 - 1; t < i; t += 2) n[t] = n[t + 1] = 0;
        }
        return n;
    }
    El(t) {
        const e = t.dimensions, n = [], i = [], r = [], s = this.getMap();
        for (let n = 0; n < t.vertices.length; n += e) {
            zl.x = t.vertices[n], zl.y = t.vertices[n + 1];
            const e = _c(s, zl);
            t.vertices[n] = e[0], t.vertices[n + 1] = e[1];
        }
        const o = _c(this.getMap(), this.getCenter()), a = {};
        a.a = {
            x: t.vertices[0 * e] - o[0],
            y: t.vertices[0 * e + 1] - o[1]
        }, a.b = {
            x: t.vertices[1 * e] - o[0],
            y: t.vertices[1 * e + 1] - o[1]
        }, a.c = {
            x: t.vertices[2 * e] - o[0],
            y: t.vertices[2 * e + 1] - o[1]
        }, a.d = {
            x: t.vertices[3 * e] - o[0],
            y: t.vertices[3 * e + 1] - o[1]
        }, this.kl = [];
        for (let n = 0; n < 4; n++) this.kl.push(t.vertices[n * e] - o[0]), this.kl.push(t.vertices[n * e + 1] - o[1]), 
        this.kl.push(0);
        for (let t = 0; t <= 20; t++) for (let e = 0; e <= 20; e++) {
            const r = e / 20, s = t / 20, o = (1 - r) * (1 - s) * a.a.x + r * (1 - s) * a.b.x + r * s * a.c.x + (1 - r) * s * a.d.x, c = (1 - r) * (1 - s) * a.a.y + r * (1 - s) * a.b.y + r * s * a.c.y + (1 - r) * s * a.d.y;
            n.push(o, c, 0), i.push(r, 1 - s);
        }
        for (let t = 0; t < 20; t++) for (let e = 0; e < 20; e++) {
            const n = 21 * t + e, i = n + 1, s = 21 * (t + 1) + e, o = s + 1;
            r.push(n, i, o), r.push(n, o, s);
        }
        return {
            positions: n,
            uvs: i,
            triangles: r
        };
    }
    clearMesh() {
        this.Ol(), delete this.hs, this.maskGeoJSON && (this.maskGeoJSON = null);
    }
    Nl() {
        return Rl[this.Cl];
    }
    Dl() {
        const t = this.getSymbol(), {polygonFill: e, polygonOpacity: n} = t || Dl, i = pc([], e);
        return i[3] = lc(n) ? n : "texture" === this.getMode() ? 1 : Dl.polygonOpacity, 
        i;
    }
    Ll(t = 0) {
        const e = this.getMap(), n = e.getGLRes();
        return e.altitudeToPoint(t, n);
    }
    Pl(t) {
        const e = _c(this.getMap(), this.getCenter()), n = c.fromRotationTranslationScale(t.localTransform, d.identity(kl), e, Nl);
        t.localTransform = n;
    }
    Ol() {
        this.hs && (this.hs.material && this.hs.material.dispose(), this.hs.geometry && this.hs.geometry.dispose(), 
        this.Hl && this.Hl.geometry && (this.Hl.geometry.dispose(), this.Hl.dispose()), 
        this.hs.dispose(), delete this.hs, delete this.Hl);
    }
    containsPoint(t) {
        const e = this.getExtent();
        if (zl.set(t[0], t[1]), !e || !e.contains(zl)) return !1;
        const n = this.getHoles();
        for (let e = 0; e < n.length; e++) if (this.Fl(n[e], t)) return !1;
        const i = this.getShell();
        return this.Fl(i, t);
    }
    Fl(t, e) {
        const n = this.Ul(t);
        let i = 0;
        for (let n = 0; n < t.length; n++) {
            Ll.x = t[n].x, Ll.y = t[n].y;
            const r = n + 1 >= t.length ? 0 : n + 1;
            Fl.x = t[r].x, Fl.y = t[r].y, zl.x = e[0], zl.y = e[1], Ul[0] = zl, Ul[1] = Ll, 
            Ul[2] = Fl;
            i += this.Ul(Ul);
        }
        return !(Math.abs(i - n) > 1e-8);
    }
    Ul(t) {
        const e = this.getMap();
        let n = 0;
        const i = e.getGLRes(), r = e.coordToPointAtRes(t[0], i, Gl);
        for (let c = 1; c < t.length - 1; c++) {
            const h = e.coordToPointAtRes(t[c], i, Bl), l = e.coordToPointAtRes(t[c + 1], i, Vl);
            n += (s = r, a = l, (((o = h).x - s.x) * (a.y - s.y) - (o.y - s.y) * (a.x - s.x)) / 2);
        }
        var s, o, a;
        /*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/        return n;
    }
}

for (var Wl = [], ql = 0; ql < 6; ql++) Wl[ql] = [];

var Xl = [];

function Kl(t, e, n) {
    var i, r, s, o, a, c, h, l, f, u, d, m, v, g, p, x, _;
    r = (i = t)[0], s = i[1], o = i[2], a = i[3], c = i[4], h = i[5], l = i[6], f = i[7], 
    u = i[8], d = i[9], m = i[10], v = i[11], g = i[12], p = i[13], x = i[14], _ = i[15], 
    $l(Wl[0], a - r, f - c, v - u, _ - g), $l(Wl[1], a + r, f + c, v + u, _ + g), $l(Wl[2], a + s, f + h, v + d, _ + p), 
    $l(Wl[3], a - s, f - h, v - d, _ - p), $l(Wl[4], a - o, f - l, v - m, _ - x), $l(Wl[5], a + o, f + l, v + m, _ + x);
    for (var b = 0; b < 6; b++) {
        var y = Wl[b];
        if (Xl[0] = y[0] > 0 ? e[1][0] : e[0][0], Xl[1] = y[1] > 0 ? e[1][1] : e[0][1], 
        Xl[2] = y[2] > 0 ? e[1][2] : e[0][2], Jl(y, Xl) < 0) return !1;
    }
    return !0;
}

function $l(t, e, n, i, r) {
    var s = 1 / Math.sqrt(e * e + n * n + i * i);
    return t[0] = e * s, t[1] = n * s, t[2] = i * s, t[3] = r * s, t;
}

function Jl(t, e) {
    return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3];
}

const Yl = new e(0, 0), Zl = [ 0, 0, 0 ], Ql = [ 0, 0, 0 ], tf = c.identity([ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]);

function ef() {
    return this._maskList ? (this._maskList.forEach((t => {
        t.remove();
    })), this._maskList = [], this.updateMaskExtent(), this) : this;
}

function nf() {
    for (let t = 0; t < this._maskList.length; t++) if (this._maskList[t].isVisible()) return !0;
    return !1;
}

function rf(t) {
    return class extends t {
        removeMask(t) {
            if (!this._maskList) return this;
            if (!t) return ef.call(this), this;
            const e = Array.isArray(t) ? t : [ t ];
            for (let t = 0; t < e.length; t++) {
                const n = e[t], i = this._maskList.indexOf(n);
                i > -1 && this._maskList.splice(i, 1);
            }
            return this.updateMaskExtent(), this.fire("removemask", {
                masks: t
            }), this;
        }
        setMask(t) {
            return this.removeMask(null), this._maskList || (this._maskList = []), Array.isArray(t) ? t.forEach((t => {
                this._maskList.push(t);
            })) : this._maskList.push(t), this._maskList.forEach((t => {
                t._bindLayer(this), t.zl && t.zl();
            })), this.updateMaskExtent(), this.fire("setmask", {
                masks: t
            }), this;
        }
        onAdd() {
            super.onAdd(), this.updateMaskExtent();
        }
        getMasks() {
            return this._maskList || [];
        }
        onGeometryEvent(t) {
            if (!t || !t.target) return;
            "shapechange" === t.type && t.target instanceof jl && t.target.clearMesh(), t.target instanceof jl && this.updateMaskExtent(), 
            super.onGeometryEvent && super.onGeometryEvent(t);
        }
        identifyMask(t, e) {
            if (!this.getMap()) return [];
            if (!this._maskList || !this._maskList.length) return [];
            const n = cc({}, e);
            n.excludeMasks = !0;
            const i = this.identifyAtPoint(t, n), r = i.length && i[0].coordinate;
            if (r) {
                const t = this._maskList;
                if (!t) return [];
                const e = [];
                for (let n = 0; n < t.length; n++) {
                    const i = t[n].getMode();
                    !t[n].containsPoint(r) || "color" !== i && "texture" !== i || e.push(t[n]);
                }
                return e;
            }
            return [];
        }
        remove() {
            this._maskList && this._maskList.length && this._maskList.forEach((t => {
                t.remove();
            })), super.remove();
        }
        updateMask(t) {
            const e = this.getMap(), {projViewMatrix: n, mapExtent: i} = this.getProjViewMatrixInOrtho(t);
            Yl.x = i.xmin, Yl.y = i.ymin;
            const r = sf(Zl, Yl, e);
            Yl.x = i.xmax, Yl.y = i.ymax;
            const s = sf(Ql, Yl, e);
            return {
                projViewMatrix: n,
                extentInWorld: [ r[0], r[1], s[0], s[1] ]
            };
        }
        getProjViewMatrixInOrtho(t) {
            const e = this.getMap(), n = e.getView(), i = e.getFitZoom(t), r = t.getCenter();
            e.setView({
                center: r,
                zoom: i,
                pitch: 0,
                bearing: 0
            });
            const s = e.getExtent(), o = c.copy(tf, e.projViewMatrix);
            return e.setView(n), {
                mapExtent: s,
                projViewMatrix: o
            };
        }
        updateMaskExtent() {
            if (!this._maskList) return;
            if (!this.getMap()) return;
            const t = this.getRenderer();
            if (t && !this._maskList.length) return void t._clearMask();
            if (t && !nf.call(this)) return t._deleteMaskUniforms(), void t.setToRedraw();
            const e = this.getMaskExtent();
            if (!e) return;
            const {extent: n, ratio: i, minHeight: r} = e, {projViewMatrix: s, extentInWorld: o} = this.updateMask(n);
            this._maskProjViewMatrix = s, this._maskExtentInWorld = o, t ? t.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, i, r) : this.once("renderercreate", (t => {
                t.renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, i, r);
            }));
        }
        getMaskExtent() {
            let t = 1 / 0, e = 1 / 0, n = -1 / 0, i = -1 / 0, r = -1 / 0, o = 1 / 0, a = !1;
            const c = this.getMap();
            for (let s = 0; s < this._maskList.length; s++) {
                const h = this._maskList[s];
                if (!h.isVisible()) continue;
                const l = h.getExtent();
                if (l) {
                    if (h.hs && h.getBBox) {
                        const t = h.getBBox();
                        if (!Kl(c.projViewMatrix, t)) continue;
                    }
                    if (a = !0, l.xmin < t && (t = l.xmin), l.ymin < e && (e = l.ymin), l.xmax > n && (n = l.xmax), 
                    l.ymax > i && (i = l.ymax), h.Gl) {
                        const t = h.Gl();
                        t[0] < o && (o = t[0]), t[1] > r && (r = t[1]);
                    }
                }
            }
            if (!a) return null;
            const {ratio: h, minHeight: l} = function(t, e) {
                const n = t === 1 / 0 ? 0 : t, i = e === -1 / 0 ? 0 : e, r = Math.abs(i - n);
                return 0 === r ? {
                    ratio: 1,
                    minHeight: 0
                } : {
                    ratio: Math.pow(r, -1),
                    minHeight: n
                };
            }(o, r);
            return {
                extent: new s(t, e, n, i),
                ratio: h,
                minHeight: l
            };
        }
    };
}

function sf(t, n, i, r = 0) {
    if (!(i && n instanceof e)) return null;
    const s = i.coordinateToPointAtRes(n, i.getGLRes());
    return t[0] = s.x, t[1] = s.y, t[2] = r, t;
}

const of = new t.Coordinate(0, 0), af = new t.Coordinate(0, 0), cf = new t.Point(0, 0), hf = [], lf = {
    tileGrids: [],
    count: 0
}, ff = "01", uf = "1";

class df extends(rf(t.TileLayer)){
    constructor(t, e) {
        e && !e.tileSystem && ("cesium" === e.type || "cesium-ion" === e.type ? e.tileSystem = [ 1, 1, -180, -90 ] : "tianditu" === e.type && (e.tileSystem = [ 1, -1, -180, 90 ])), 
        e.tileSize || "mapbox" === e.type && (e.tileSize = 512), e.spatialReference || "mapbox" === e.type && (e.spatialReference = "preset-3857-512"), 
        super(t, e);
    }
    onAdd() {
        const t = this.options, e = this.getMap().getProjection(), n = "EPSG:4326" === e.code || "EPSG:4490" === e.code, i = "EPSG:3857" === e.code;
        512 !== t.tileSize || t.spatialReference || ("mapbox" === t.type ? n ? t.spatialReference = "preset-4326-512" : i && (t.spatialReference = "preset-3857-512") : "cesium" === t.type || "cesium-ion" === t.type ? t.spatialReference = "preset-4326-512" : "tianditu" === t.type && (t.spatialReference = {
            "projection": "EPSG:4326",
            "fullExtent": {
                "top": 90,
                "left": -180,
                "bottom": -90,
                "right": 180
            },
            "resolutions": function() {
                const t = [];
                for (let e = 0; e <= 22; e++) t[e] = 90 / (128 * Math.pow(2, e));
                return t;
            }()
        })), t.terrainWidth || "tianditu" !== t.type || (t.terrainWidth = 65);
    }
    getTileUrl(t, e, n) {
        let i = super.getTileUrl(t, e, n);
        return "mapbox" === this.options.type && this.options.requireSkuToken && (this.Bl || (this.Bl = this.Vl()), 
        i.indexOf("?") > -1 ? i += "&sku=" + this.Bl : i += "?sku=" + this.Bl), i;
    }
    getMaxAvailableZoom() {
        return this.getSpatialReference().getMaxZoom();
    }
    Vl() {
        let t = "";
        for (let e = 0; e < 10; e++) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
        return [ uf, ff, t ].join("");
    }
    wl() {
        let t = this.options.exaggeration;
        return hc(t) && (t = 1), t;
    }
    setSkinLayers(t) {
        this.jl = t;
        const e = this.getRenderer();
        e && (e.clear(), e.setToRedraw());
    }
    getSkinTiles(e) {
        const n = this.getRenderer();
        if (!n) return lf;
        const i = n.getTileGridsInCurrentFrame().tileGrids[0];
        if (!i) return lf;
        const r = e.getId(), s = this._getTileConfig().tileSystem.scale, o = e.getTileSize().width, a = i.tiles;
        if (!a.length) return lf;
        const c = this.getMap(), h = i.parents || hf, l = h.length, f = h.concat(a), u = e.getSpatialReference(), d = a[0].extent2d.getWidth(), m = s.x, v = s.y, g = [], p = [], x = new Set, _ = this._getTileConfig().tileSystem.scale.y;
        for (let n = 0; n < f.length; n++) {
            const i = f[n], {res: s} = i;
            let a = i.nw;
            a || (a = i.nw = c.pointAtResToCoord(i.extent2d.getMin(cf), i.res));
            const {res: h, zoom: b} = Zh(u, i.z, s), y = h / s, w = Yh(h, o, s, d), {extent2d: S, offset: A} = i, M = w * i.x, T = w * i.y;
            if (i.skinTileIds || (i.skinTileIds = {}), !i.skinTileIds[r]) {
                const n = new Set, s = [], c = Jh(e, i.x, i.y, b, a, A, v, w, 0);
                for (let i = 0; i < c.length; i++) {
                    const r = c[i];
                    if (n.has(r.id)) continue;
                    r.idx = r.x, r.idy = r.y, r.res = h, r.url = e.getTileUrl(r.x, r.y, r.z + e.options.zoomOffset);
                    const a = m * (r.x - M) * o, l = v * (r.skinY - T) * o, f = S.xmin * y + a, u = S.ymax * y + l, d = S.ymin * y + l;
                    r.extent2d = _ > 0 ? new t.PointExtent(f, d, f + o, d + o) : new t.PointExtent(f, u - o, f + o, u), 
                    n.add(r.id), s.push(r);
                }
                i.skinTileIds[r] = s;
            }
            const C = i.skinTileIds[r];
            for (let t = 0; t < C.length; t++) x.has(C[t].id) || (n < l ? g.push(C[t]) : p.push(C[t]), 
            x.add(C[t].id));
        }
        return {
            tileGrids: [ {
                extent: i.extent,
                tiles: p,
                parents: g,
                count: p.length
            } ],
            count: p.length
        };
    }
    getSkinLayer(t) {
        return this.getSkinLayers()[t];
    }
    getSkinLayers() {
        return this.jl || hf;
    }
    getSkinCount() {
        return this.jl && this.jl.length || 0;
    }
    queryTerrainByProjCoord(t, e) {
        e = e || [];
        const n = this.getRenderer();
        if (!n) return e[0] = null, e[1] = 0, e;
        const i = this.getMap(), r = n.xl(t);
        if (!r) return e[0] = null, e[1] = 0, e;
        const s = i._prjToPointAtRes(t, 1, cf);
        return n._l(e, r.id, r, s, 1);
    }
    queryTileTerrainByProjCoord(t, e, n, i) {
        i = i || [];
        const r = this.getRenderer();
        if (!r) return i[0] = null, i[1] = 0, i;
        const s = this.getMap()._prjToPointAtRes(t, 1, cf);
        return r._l(i, e, n, s, 1);
    }
    queryTileTerrainByPointAtRes(t, e, n, i, r) {
        r = r || [];
        const s = this.getRenderer();
        return s ? s._l(r, n, i, t, e) : (r[0] = null, r[1] = 0, r);
    }
    queryTerrain(t, e) {
        e = e || [];
        if (!this.getRenderer()) return e[0] = null, e[1] = 0, e;
        const n = this.getMap().getProjection().project(t, of);
        return this.queryTerrainByProjCoord(n, e);
    }
    queryTileMesh(t, e) {
        const n = this.getRenderer();
        n && n.Wl(t, e);
    }
    getTerrainTiles(e, n) {
        const {x: i, y: r, z: s, res: o, offset: a} = n, c = n.extent2d.getWidth(), h = this._getTileConfig(), l = e._getTileConfig(), f = this.getSpatialReference(), {res: u, zoom: d} = Zh(f, s, o), m = this.getTileSize().width, v = Yh(u, m, o, c);
        let g = n.nw;
        g || (g = n.nw = this.getMap().pointAtResToCoord(n.extent2d.getMin(cf), n.res));
        const p = Kh(this, i, r, d, g, a, l.tileSystem.scale.y, v, 1)[0];
        for (let e = 0; e < p.length; e++) {
            const {x: n, y: i} = p[e], r = h.getTilePointNW(n, i, u, cf);
            p[e].res = u, p[e].extent2d = new t.PointExtent(r.x, r.y, r.x + m, r.y - m);
        }
        return p;
    }
    isTerrainTileLoaded(t) {
        const e = this.getRenderer();
        return !!e && e.isTileCached(t);
    }
    updateMaterial(t) {
        if (!t) return;
        this.options.material || (this.options.material = {}), cc(this.options.material, t);
        const e = this.getRenderer();
        e && e.updateMaterial(t);
    }
    setMaterial(t) {
        if (!t) return;
        this.options.material = t;
        const e = this.getRenderer();
        e && e.setMaterial(t);
    }
    vl(t, e, n, i, r, s, o, a, c, h) {
        const l = this.getMap(), f = this.options.zoomOffset;
        if (!c) {
            c = this._getTileConfig().getTilePrjExtent(t, e, s).convertTo((t => l._prjToPointAtRes(t, s, af)));
        }
        const u = this._getTileOffset(n);
        return {
            parent: a,
            layer: this.getId(),
            x: t,
            y: e,
            z: n,
            idx: i,
            idy: r,
            res: s,
            extent2d: c,
            id: h || this._getTileId(t, e, n),
            url: this.getTileUrl(t, e, n + f),
            offset: u,
            error: o,
            children: []
        };
    }
}

df.mergeOptions({
    "forceRenderOnMoving": !0,
    "forceRenderOnZooming": !0,
    "forceRenderOnRotating": !0,
    "fadeAnimation": !1,
    "fadeDuration": 1e3 / 60 * 15,
    "tileLimitPerFrame": 2,
    "newTerrainTileRenderLimitPerFrameOnInteracting": 1,
    "opacity": 1,
    "renderer": "gl",
    "pyramidMode": 1,
    "tileSize": 512,
    "terrainWidth": null,
    "backZoomOffset": 0,
    "depthMask": !0,
    "blendSrc": "one",
    "blendDst": "one minus src alpha",
    "requireSkuToken": !0,
    "cesiumIonTokenURL": "https://api.cesium.com/v1/assets/1/endpoint?access_token=",
    "tileRetryCount": 0,
    "shader": "default",
    "terrainTileMode": !0,
    "tempTileCacheSize": 64,
    "tileStackStartDepth": 7,
    "tileStackDepth": 6,
    "currentTilesFirst": !1,
    "exaggeration": 1,
    "colors": []
}), df.registerJSONType("TerrainLayer"), df.registerRenderer("gl", Il);

const mf = [], vf = [], gf = [], pf = [], xf = new i(0, 0), _f = [], bf = [], yf = [], wf = [], Sf = [], Af = [], Mf = [], Tf = [], Cf = [];

class Of {
    constructor(t, e, n = !0) {
        this.ql = t, this.Xl = e, this.Kl = n;
    }
    setFromPoint(t) {
        this.ql = Array.isArray(t) ? new e(t) : t;
    }
    setToPoint(t) {
        this.Xl = Array.isArray(t) ? new e(t) : t;
    }
    test(e, n, i = {}) {
        const r = i.count || 0, s = [];
        let o = this.ql, a = this.Xl;
        this.Kl && (o = If(n, this.ql.x, this.ql.y, this.ql.z), a = If(n, this.Xl.x, this.Xl.y, this.Xl.z));
        const h = new t.math.Ray(o, a);
        for (let t = 0; t < e.length; t++) {
            const i = e[t];
            if (!this.$l(i.getBoundingBox(), h)) continue;
            const o = i.localTransform, a = i.geometry, l = a.data[a.desc.positionAttribute].array, f = a.data[a.desc.altitudeAttribute] && a.data[a.desc.altitudeAttribute].array || _f, u = a.indices;
            if (!(l && l.length && u && u.length)) continue;
            const d = c.multiply(wf, o, i.positionMatrix), m = this.Jl(i, h, n, l, f, u, a.desc.positionSize, d, r);
            if (m) {
                const t = {
                    mesh: i,
                    coordinates: m
                };
                if (s.push(t), 0 !== r && s.length >= r) break;
            }
        }
        return s;
    }
    Jl(t, e, n, i, r, s, o, a, c) {
        const l = [];
        for (let f = 0; f < s.length && !(f > t.properties.skirtOffset); f += 3) {
            const t = s[f], u = s[f + 1], d = s[f + 2], m = h.set(Sf, i[t * o], i[t * o + 1], i[t * o + 2]), v = this.Yl(vf, n, m, r[t] / 100, a), g = h.set(Af, i[u * o], i[u * o + 1], i[u * o + 2]), p = this.Yl(gf, n, g, r[u] / 100, a), x = h.set(Mf, i[d * o], i[d * o + 1], i[d * o + 2]), _ = this.Yl(pf, n, x, r[d] / 100, a), b = h.set(mf, v, p, _), y = h.sub(bf, v, p), w = h.sub(yf, v, _), S = this.Zl(Tf, b, e);
            if (S) {
                const e = n.pointAtResToAltitude(S[2], n.getGLRes());
                xf.x = S[0], xf.y = S[1];
                const i = n.pointAtResToCoordinate(xf, n.getGLRes());
                if (i.z = e, l.push({
                    coordinate: i,
                    indices: [ t, u, d ],
                    normal: h.cross([], y, w)
                }), 0 !== c && l.length >= c) break;
            }
        }
        return l.length ? l : null;
    }
    Yl(t, e, i, r, s) {
        let o;
        return n.isNumber(r) ? (o = e.altitudeToPoint(r, e.getGLRes()), l.set(t, i[0], i[1], 0, 1), 
        l.transformMat4(t, t, s), t[2] = o) : (l.set(t, i[0], i[1], i[2], 1), l.transformMat4(t, t, s)), 
        t;
    }
    Zl(t, e, n) {
        return n.intersectTriangle(e[0], e[1], e[2], !0, t);
    }
    $l(t, e) {
        return !!t && e.intersectBox(t, Cf);
    }
}

const Ef = new e(0, 0);

function If(t, e, n, i) {
    if (!t) return null;
    Ef.set(e, n);
    const r = t.coordinateToPointAtRes(Ef, t.getGLRes()), s = t.altitudeToPoint(i || 0, t.getGLRes());
    return [ r.x, r.y, s ];
}

const Pf = () => {}, Hf = new t.Coordinate(0, 0), Rf = [ 0, 0, 0 ], kf = [ 0, 0, 0 ], Nf = [ 0, 0, 0 ];

class Df extends t.Layer {
    static fromJSON(e) {
        if (!e || "GroupGLLayer" !== e.type) return null;
        const n = e.layers.map((e => t.Layer.fromJSON(e)));
        return new Df(e.id, n, e.options);
    }
    constructor(t, e, n) {
        super(t, n), this.layers = e && e.slice() || [], this.layers.forEach((t => {
            if (t.getMap()) throw new Error(`layer(${t.getId()} is already added on map`);
        })), this.Ql(), this.sortLayersByZIndex(), this.tf = {};
    }
    sortLayersByZIndex() {
        if (this.layers && this.layers.length) {
            for (let t = 0, e = this.layers.length; t < e; t++) this.layers[t].__group_gl_order = t;
            this.layers.sort(Ff);
        }
    }
    setSceneConfig(t) {
        this.options.sceneConfig = t;
        const e = this.getRenderer();
        return e && e.updateSceneConfig(), this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this.To()));
    }
    To() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        return this.To().ground;
    }
    getWeatherConfig() {
        return this.To().weather;
    }
    getScanEffectConfig() {
        const t = this.To();
        return t.postProcess && t.postProcess.scanEffect;
    }
    addLayer(t, e) {
        if (t.getMap()) throw new Error(`layer(${t.getId()}) is already added on map`);
        if ("gl" !== t.options.renderer) throw new Error(`layer(${t.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        void 0 === e ? this.layers.push(t) : this.layers.splice(e, 0, t), this.Ql(), this.sortLayersByZIndex();
        const n = this.getRenderer();
        return n ? (this.ef(t), this.nf(), n.setToRedraw(), this) : this;
    }
    removeLayer(e) {
        t.Util.isString(e) && (e = this.getChildLayer(e));
        const n = this.layers.indexOf(e);
        if (n < 0) return this;
        const i = e.getRenderer();
        i && i.setTerrainHelper && i.setTerrainHelper(null), e._doRemove(), this.rf(e), 
        delete this.tf[e.getId()], this.layers.splice(n, 1);
        const r = this.getRenderer();
        return r ? (this.nf(), r.setToRedraw(), this) : this;
    }
    clearLayers() {
        const t = this.getLayers();
        for (let e = 0; e < t.length; e++) t[e] && t[e].remove();
        return this;
    }
    wc() {
        let t = 0;
        for (let e = 0; e < this.layers.length; e++) {
            const n = this.layers[e];
            n.setPolygonOffset && n.getPolygonOffsetCount && (t += n.getPolygonOffsetCount());
        }
        let e = 0;
        for (let n = this.layers.length - 1; n >= 0; n--) {
            const i = this.layers[n];
            i.setPolygonOffset && i.getPolygonOffsetCount && (i.setPolygonOffset(e, t), e += i.getPolygonOffsetCount());
        }
        this.sf = e;
    }
    getPolygonOffsetCount() {
        return this.sf;
    }
    getLayers() {
        return this.layers.slice();
    }
    Kc() {
        return this.layers;
    }
    toJSON() {
        const t = [];
        if (this.layers) for (let e = 0; e < this.layers.length; e++) {
            const n = this.layers[e];
            n && (n && n.toJSON && t.push(n.toJSON()));
        }
        return {
            "type": this.getJSONType(),
            "id": this.getId(),
            "layers": t,
            "options": this.config()
        };
    }
    onLoadEnd() {
        this.layers.forEach((t => {
            this.ef(t);
        })), this.options.terrain && this.af(), super.onLoadEnd();
    }
    ef(t) {
        const e = this.getRenderer();
        this.tf[t.getId()] = t, t._canvas = e.canvas, t._bindMap(this), t.once("renderercreate", this.cf, this), 
        t.remove = () => (this.removeLayer(t), t.constructor.prototype.remove.call(t), delete t.remove, 
        this), t.load(), this.hf(t);
    }
    onRemove() {
        this.lf(), this.layers.forEach((t => {
            this.ff(t), t._doRemove(), this.rf(t);
        })), this.tf = {}, this.clearAnalysis(), super.onRemove();
    }
    getChildLayer(t) {
        return this.tf[t] || null;
    }
    getLayer(t) {
        return this.getChildLayer(t);
    }
    hf(t) {
        t.on("show hide", this.uf, this), t.on("idchange", this.df, this);
    }
    rf(t) {
        t.off("show hide", this.uf, this), t.off("idchange", this.df, this);
    }
    uf() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    df(t) {
        const e = t.new, n = t.old, i = this.getLayer(n);
        delete this.tf[n], this.tf[e] = i;
    }
    cf(t) {
        t.renderer.clearCanvas = Lf;
    }
    Ql() {
        const t = {};
        this.layers.forEach((e => {
            const n = e.getId();
            if (t[n]) throw new Error(`Duplicate child layer id (${n}) in the GroupGLLayer (${this.getId()})`);
            t[n] = 1;
        }));
    }
    addAnalysis(t) {
        this.lc = this.lc || [], this.lc.push(t);
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    removeAnalysis(t) {
        if (this.lc) {
            const e = this.lc.indexOf(t);
            e > -1 && (this.lc.splice(e, 1), t.remove());
        }
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    clearAnalysis() {
        this.lc && (this.lc.forEach((t => {
            t.remove();
        })), this.lc = []);
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    identify(e, n) {
        const i = this.getMap(), r = this.getRenderer();
        if (!i || !r) return [];
        const s = i.coordToContainerPoint(new t.Coordinate(e));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(t, e = {}) {
        const n = e.includeInternals, i = this.getLayers(), r = e && e.childLayers || i, s = this.getMap();
        if (!s) return [];
        const o = hc(e.count) ? 1 : e.count;
        let a = [];
        for (let s = r.length - 1; s >= 0; s--) {
            const o = r[s];
            if (i.indexOf(o) < 0 || !o.identifyAtPoint) continue;
            const c = o.options.geometryEvents;
            if (n && (void 0 === c || !1 === c || 0 === c)) continue;
            if (o.isGeometryListening && n && e.eventTypes.indexOf("mousemove") >= 0 && !o.isGeometryListening(e.eventTypes)) continue;
            const h = o.identifyAtPoint(t, e);
            if (!h || !h.length) continue;
            const l = o.getId();
            for (let t = 0; t < h.length; t++) h[t] && (h[t].layer = l);
            a.push(...h);
        }
        if (e.orderByCamera) {
            const t = s.cameraPosition;
            a.sort(((e, n) => n.point ? e.point ? h.dist(e.point, t) - h.dist(n.point, t) : 1 : -1));
        }
        return o && (a = a.slice(0, o)), a;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(t) {
        return this.options.terrain = t, this.getRenderer() ? (this.af(), this.getMap().updateCenterAltitude(), 
        this) : this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(t) {
        this.mf && t && (this.options.terrain.material ? cc(this.options.terrain.material, t) : this.options.terrain.material = t, 
        this.mf.updateMaterial(t));
    }
    af() {
        const t = this.getRenderer();
        t && t.setToRedraw();
        const e = this.options.terrain;
        if (this.mf) {
            const t = this.mf, n = t.options;
            if (e && n.urlTemplate === e.urlTemplate && n.spatialReference === e.spatialReference) {
                for (const n in e) "material" === n ? t.setMaterial(e[n]) : "urlTemplate" !== n && "spatialReference" !== n && t.config(n, e[n]);
                return this;
            }
            this.lf();
        }
        if (this.vf(), !e) return this;
        this.mf = new df("__terrain_in_group", e), this.nf();
        const n = this.mf;
        n.on("tileload", this.gf, this), this.ef(n);
        const i = e.masks;
        return i && i.length ? n.setMask(i) : n.removeMask(), this.fire("terrainlayercreated"), 
        this;
    }
    queryTerrain(t, e) {
        return this.mf ? this.mf.queryTerrain(t, e) : (e && (e[0] = null, e[1] = 0), [ null, 0 ]);
    }
    queryTerrainAtPoint(t) {
        if (!this.mf) return null;
        const e = this.mf.getRenderer().getAnalysisMeshes();
        return this.pf(t, e);
    }
    query3DTilesAtPoint(e) {
        const n = this.Kc().filter((t => t && t.isGeo3DTilesLayer));
        if (!n.length) return null;
        const i = {
            excludeMasks: !0
        };
        for (let r = 0; r < n.length; r++) {
            if (!n[r].getRenderer()) continue;
            const s = n[r].identifyAtPoint(e, i);
            if (s.length) return new t.Coordinate(s[0].coordinate);
        }
        return null;
    }
    pf(e, n) {
        const i = this.getMap(), r = i.getGLRes();
        i.getContainerPointRay(kf, Nf, e);
        const s = new Of(kf, Nf, !1).test(n, i, {
            count: 1
        }), o = [];
        s.forEach((t => {
            t.coordinates.forEach((t => {
                o.push(t.coordinate);
            }));
        }));
        const a = i.pointAtResToCoordinate(new t.Point(kf[0], kf[1]), r, Hf);
        this.xf || (this.xf = i.altitudeToPoint(1, r)), a.z = kf[2] / this.xf;
        const c = h.set(Rf, a.x, a.y, a.z);
        return o.sort(((t, e) => h.dist(t.toArray(), c) - h.dist(e.toArray(), c))), o[0];
    }
    queryTerrainByProjCoord(t, e) {
        return this.mf ? this.mf.queryTerrainByProjCoord(t, e) : (e && (e[0] = null, e[1] = 0), 
        [ null, 0 ]);
    }
    nf() {
        if (!this.mf) return;
        const t = this.layers, e = [];
        for (let n = 0; n < t.length; n++) {
            if (!t[n]) continue;
            const i = t[n], r = i.getRenderer();
            if (r.renderTerrainSkin) {
                if (r.deleteTile === Pf) {
                    e.push(t[n]);
                    continue;
                }
                i.getTiles = () => this.mf && this.mf.getSkinTiles(i), r.drawTileOnTerrain ? r.drawTile = (...t) => r.drawTileOnTerrain(...t) : r.drawTile = Pf, 
                r.deleteTile = Pf, e.push(t[n]);
            }
            r.setTerrainHelper && r.setTerrainHelper(this.mf);
        }
        this.mf.setSkinLayers(e);
    }
    ff(t) {
        if (!function(t) {
            if (!t) return !1;
            const e = t.getRenderer();
            if (!e) return !1;
            return !!e.renderTerrainSkin;
        }(t)) return;
        const e = t.getRenderer();
        e && (e.setTerrainHelper && e.setTerrainHelper(null), e.clear && e.clear(), delete e.drawTile, 
        delete e.deleteTile), delete t.getTiles;
    }
    vf() {
        const t = this.layers;
        for (let e = 0; e < t.length; e++) t[e] && this.ff(t[e]);
    }
    gf() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    lf() {
        if (this.mf) {
            const t = this.mf;
            t.off("tileload", this.gf, this), this.rf(t), this.mf._doRemove(), delete this.mf, 
            this.fire("terrainlayerremoved");
        }
    }
    getTerrainLayer() {
        return this.mf;
    }
    _bindMap(...t) {
        if (this.options.single) {
            const e = t[0].getLayers();
            for (let t = 0; t < e.length; t++) if (e[t] instanceof Df) throw new Error("Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.");
        }
        return super._bindMap(...t);
    }
    fire(...t) {
        if ("layerload" === t[0]) {
            const t = this.Kc();
            for (const e of t) {
                const t = e.getRenderer();
                t && t.isRenderComplete() && e.fire("layerload");
            }
        }
        super.fire(...t);
    }
}

function Lf() {}

function Ff(t, e) {
    const n = t.getZIndex() - e.getZIndex();
    return 0 === n ? t.__group_gl_order - e.__group_gl_order : n;
}

var Uf;

Df.mergeOptions({
    renderer: "gl",
    antialias: !0,
    extensions: [],
    single: !0,
    onlyWebGL1: !1,
    optionalExtensions: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives", "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_frag_depth", "EXT_texture_filter_anisotropic", "WEBGL_compressed_texture_astc", "WEBGL_compressed_texture_etc", "WEBGL_compressed_texture_etc1", "WEBGL_compressed_texture_pvrtc", "WEBGL_compressed_texture_s3tc", "WEBGL_compressed_texture_s3tc_srgb" ],
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    viewMoveThreshold: 100,
    geometryEvents: !0,
    multiSamples: 4,
    forceRedrawPerFrame: !1
}), Df.registerJSONType("GroupGLLayer"), Df.registerRenderer("gl", Fh), Df.registerRenderer("canvas", null), 
function(t) {
    t[t.AMBIENT = 0] = "AMBIENT", t[t.REALISTIC = 1] = "REALISTIC";
}(Uf || (Uf = {}));

class zf {
    constructor(t) {
        this.Ws = t, this.Xo = new bi;
    }
    getDirectionalLight() {
        return this.La && this.La.directional || {};
    }
    getAmbientLight() {
        return this.La && this.La.ambient || {};
    }
    getAmbientResource() {
        return this._f;
    }
    setConfig(t) {
        const e = this.La;
        this.bf = t.urlModifier, this.La = JSON.parse(JSON.stringify(t));
        let n = !1;
        if (t && t.ambient && t.ambient.resource) {
            if (!(e && e.ambient && function(t, e) {
                if (!t.resource) return !1;
                if (t.resource.url !== e.resource.url) return !1;
                return !0;
            }(e.ambient, t.ambient))) return void this.yf();
            if (this._f) {
                const i = e.ambient && e.ambient.resource, r = t.ambient.resource;
                r && r.prefilterCubeSize !== i && i.prefilterCubeSize && this.wf(), n = !0, t.ambient.resource.sh && (this._f.sh = t.ambient.resource.sh);
            }
        } else this.Sf(), n = e && e.ambient && e.ambient.resource;
        this.Ws.fire("updatelights", {
            ambientUpdate: n
        });
    }
    Af(t) {
        const e = t.getLayers();
        for (let t = 0; t < e.length; t++) {
            const n = e[t] && e[t].getRenderer();
            if (n && n.regl) return n.regl;
        }
        const n = document.createElement("canvas"), i = y({
            canvas: n,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !1
            },
            optionalExtensions: [ "OES_standard_derivatives", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear" ]
        });
        return i.Mf = !0, i;
    }
    yf() {
        const t = this.La.ambient.resource, e = t && t.url;
        if (!e) return;
        const n = [];
        let i = 0, r = 0;
        const s = () => {
            r++, r >= i && this.Tf(n);
        }, o = function() {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        }, a = this.bf;
        if (e.top || e.nx) {
            const {front: t, back: r, right: c, left: h, top: l, bottom: f} = e, {nx: u, ny: d, px: m, py: v, nz: g, pz: p} = e;
            let x;
            x = t ? [ h, c, r, t, l, f ] : [ u, m, g, p, v, d ], i = x.length;
            for (let t = 0; t < i; t++) {
                const e = new Image;
                e.onload = s, e.onerror = o, e.src = a && a(x[t]) || x[t], n[t] = e;
            }
        } else {
            const e = {
                url: t.url,
                arrayBuffer: !0,
                hdr: !0,
                flipY: !0
            };
            this.Xo.setURLModifier(a), this.Cf = new Gi(e, this.Xo), this.Cf.once("complete", (() => {
                this.wf();
            })), this.Cf.once("error", (() => {
                this.Of();
            }));
        }
    }
    dispose() {
        this.Sf();
    }
    wf() {
        this.Cf && (this._f = this.Ef(this.Cf), this.Ws.fire("updatelights", {
            "ambientUpdate": !0
        }));
    }
    Of() {
        this.Ws.fire("hdrerror");
    }
    Tf(t) {
        this._f = this.Ef(t), this.Ws.fire("updatelights", {
            "ambientUpdate": !0
        });
    }
    Ef(t) {
        const e = this.La.ambient.resource, n = e.prefilterCubeSize || 512, i = this.Af(this.Ws), r = da.PBRHelper.createIBLMaps(i, {
            envTexture: Array.isArray(t) ? t : t.getREGLTexture(i),
            ignoreSH: !!e.sh,
            envCubeSize: n,
            prefilterCubeSize: n,
            environmentExposure: this.La.ambient.exposure,
            format: "array"
        });
        if (e.sh && (r.sh = e.sh, Array.isArray(r.sh[0]))) {
            const t = r.sh, e = [];
            for (let n = 0; n < t.length; n++) e.push(...t[n]);
            r.sh = e;
        }
        return i.Mf && (delete this.Cf, i.destroy()), r;
    }
    Sf() {
        this.Cf && (this.Cf.dispose(), delete this.Cf), delete this._f;
    }
}

let Gf, Bf, Vf, jf, Wf;

o.include({
    setLights(t) {
        return this.options.lights = t, this.If(), this;
    },
    getLights() {
        return this.options.lights;
    },
    If() {
        this.Pf || (this.Pf = new zf(this)), this.Pf.setConfig(this.getLights());
    },
    getLightManager() {
        return this.Pf ? this.Pf : null;
    }
}), o.addOnLoadHook((function() {
    this.options.lights && this.If();
}));

const qf = {
    color: [ 0, 0, 0, 0 ]
}, Xf = {
    enable: !1
};

o.include({
    setPostProcessConfig(t) {
        return this.options.postProcessConfig = t, this;
    },
    getPostProcessConfig() {
        return this.options.postProcessConfig;
    }
});

const Kf = a.MapCanvasRenderer.prototype.drawLayerCanvas;

a.MapCanvasRenderer.prototype.drawLayerCanvas = function() {
    const t = Kf.apply(this, arguments);
    return t && function(t, e) {
        const n = t.map.getPostProcessConfig();
        if (!n || !n.enable) return;
        Gf || (i = e.width, r = e.height, Gf = document.createElement("canvas", i, r), Bf = y({
            canvas: Gf,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !0,
                antialias: !1,
                premultipliedAlpha: !1
            }
        }), Vf = Bf.texture({
            mag: "linear",
            min: "linear",
            mipmap: !1,
            flipY: !0,
            width: i,
            height: r
        }), jf = Bf.texture());
        var i, r;
        Gf.width === e.width && Gf.height === e.height || (Gf.width = e.width, Gf.height = e.height);
        Bf.clear(qf);
        const s = n.filmicGrain || Xf;
        void 0 === s.enable && (s.enable = !0);
        const o = n.vignette || Xf;
        void 0 === o.enable && (o.enable = !0);
        const a = n.colorLUT || Xf;
        void 0 === a.enable && (a.enable = !0);
        t.Hf || (t.Hf = {});
        const c = t.Hf;
        if (a.enable) {
            const t = a.lut;
            if (!c.lutTexture || c.lutTexture.url !== t) {
                const e = new Image;
                e.onload = function() {
                    const n = {
                        data: e,
                        min: "linear",
                        mag: "linear"
                    }, i = c.lutTexture ? c.lutTexture.texture(n) : Bf.texture(n);
                    c.lutTexture = {
                        url: t,
                        texture: i
                    };
                }, e.src = t;
            }
        }
        const h = {
            "enableGrain": +!!s.enable,
            "grainFactor": void 0 === s.factor ? .15 : s.factor,
            "timeGrain": performance.now(),
            "enableVignette": +!!o.enable,
            "lensRadius": o.lensRadius || [ .8, .25 ],
            "frameMod": 1,
            "enableLut": +!!a.enable,
            "lookupTable": c.lutTexture ? c.lutTexture.texture : jf
        };
        Wf || (Wf = new _h(Bf));
        Wf.postprocess(null, h, Vf({
            width: Gf.width,
            height: Gf.height,
            data: e,
            flipY: !0,
            mag: "linear",
            min: "linear",
            mipmap: !1
        })), t.context.drawImage(Gf, 0, 0, Gf.width, Gf.height);
    }(this, this.canvas), t;
};

const $f = a.MapCanvasRenderer.prototype.renderFrame;

a.MapCanvasRenderer.prototype.renderFrame = function() {
    const t = $f.apply(this, arguments), e = this.map.getPostProcessConfig(), n = e && e.filmicGrain;
    return !n || void 0 !== n.enable && !0 !== n.enable || this.setToRedraw(), t;
};

class Jf extends a.MapAbstractRenderer {
    clearCanvas() {
        this.regl && this.regl.clear({
            color: [ 0, 0, 0, 0 ]
        });
    }
    clearLayerCanvasContext(t) {
        if (!this.regl) return;
        const e = t.getRenderer();
        this.regl.clear({
            depth: 1,
            stencil: 0
        }), e.clearContext();
    }
    createContext() {
        const t = this.map, {preserveDrawingBuffer: e, onlyWebGL1: n, extensions: i, optionalExtensions: r} = t.options, s = t.getRenderer().canvas, {gl: o, regl: a, reglGL: c, context: h} = Eh(s, e, n, i, r);
        return this.gl = o, this.regl = a, this.reglGL = c, this.context = h, Promise.resolve();
    }
    Rf() {
        const t = this.map, e = this.gl, n = t.options.extensions;
        n && n.forEach((t => {
            e.getExtension(t);
        }));
        const i = t.options.optionalExtensions;
        i && i.forEach((t => {
            e.getExtension(t);
        }));
    }
    getContextInstance() {
        return this.gl.wrap();
    }
    isWebGPU() {
        return !1;
    }
}

o.registerRenderer("gl", Jf);

const Yf = [];

function Zf(t) {
    t.properties.showOnlyTimestamp && (delete t.properties.showOnlyTimestamp, tu(t));
}

function Qf(t, e) {
    const n = t.geometry.properties;
    n.oldElementsBeforeHighlight || (n.oldElementsBeforeHighlight = t.geometry.elements), 
    n.elements && (n.oldElementsArrBeforeHighlight || (n.oldElementsArrBeforeHighlight = n.elements), 
    n.elements = e);
}

function tu(t) {
    const e = t.geometry.properties.oldElementsBeforeHighlight;
    e && t.geometry.elements !== e && (t.geometry.deleteElements(), t.geometry.setElements(t.geometry.properties.oldElementsBeforeHighlight), 
    t.geometry.properties.oldElementsArrBeforeHighlight && (t.geometry.properties.elements = t.geometry.properties.oldElementsArrBeforeHighlight, 
    delete t.geometry.properties.oldElementsArrBeforeHighlight), delete t.geometry.properties.hasInvisible, 
    delete t.geometry.properties.oldElementsBeforeHighlight);
}

function eu(t) {
    if (!t.properties.highlightTimestamp) return;
    const e = t.defines;
    delete e.HAS_HIGHLIGHT_COLOR, delete e.HAS_HIGHLIGHT_OPACITY, t.setDefines(e), delete t.properties.highlightTimestamp, 
    tu(t), nu(t);
}

function nu(t) {
    if (!t) return;
    const {hlBloomMesh: e} = t.properties;
    if (e) {
        const n = e.geometry;
        n.elements && n.elements.destroy && n.deleteElements(), e.dispose(), delete t.properties.hlBloomMesh;
    }
}

var iu = Object.freeze({
    __proto__: null,
    clearHighlight: eu,
    clearShowOnly: Zf,
    deleteHighlightBloomMesh: nu,
    highlightMesh: function(t, e, n, i, r) {
        const {highlightTimestamp: s} = e.properties;
        if (!n) return void (s && eu(e));
        if (i === s) return;
        const o = e instanceof vi, a = o ? e.instanceCount : e.geometry.getVertexCount();
        let {aHighlightColor: h, aHighlightOpacity: f} = e.geometry.properties;
        h && h.fill(0), f && f.fill(255);
        let u = !1, d = !1;
        const m = n.keys();
        let v = null, g = null;
        for (const t of m) if (r.has(t)) {
            const i = n.get(t), {color: s, bloom: o, visible: c, nodeIndex: m} = i;
            if (!hc(m) && m !== e.properties.nodeIndex) continue;
            let p, {opacity: x} = i;
            if (s && (u || (h || (h = new Uint8Array(4 * a)), u = !0), p = xc(Yf, s)), x = hc(x) ? 1 : x, 
            x < 1 && (d || (f || (f = new Uint8Array(a), f.fill(255)), d = !0)), !1 === c && (g || (g = new Set), 
            g.add(t)), p || x < 1 || o) {
                const e = r.get(t);
                if (e) for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    p && l.set(h.subarray(4 * n, 4 * n + 4), ...p), x < 1 && (f[n] = 255 * x), o && (v || (v = []), 
                    v.push(n));
                }
            }
        }
        const p = e.geometry, x = e.defines;
        if (u ? (o ? (e.updateInstancedData("aHighlightColor", h), e.generateInstancedBuffers(t)) : (p.data.aHighlightColor ? p.updateData("aHighlightColor", h) : (p.data.aHighlightColor = h, 
        p.generateBuffers(t)), p.properties.aHighlightColor = h), x.HAS_HIGHLIGHT_COLOR = 1) : x.HAS_HIGHLIGHT_COLOR && (o ? (e.updateInstancedData("aHighlightColor", h), 
        e.generateInstancedBuffers(t)) : p.updateData("aHighlightColor", h), delete x.HAS_HIGHLIGHT_COLOR), 
        d ? (o ? (e.updateInstancedData("aHighlightOpacity", f), e.generateInstancedBuffers(t)) : (p.data.aHighlightOpacity ? p.updateData("aHighlightOpacity", f) : (p.data.aHighlightOpacity = f, 
        p.generateBuffers(t)), p.properties.aHighlightOpacity = f), x.HAS_HIGHLIGHT_OPACITY = 1) : x.HAS_HIGHLIGHT_OPACITY && (o ? (e.updateInstancedData("aHighlightOpacity", f), 
        e.generateInstancedBuffers(t)) : p.updateData("aHighlightOpacity", f), delete x.HAS_HIGHLIGHT_OPACITY), 
        g && g.size > 0) {
            let n = [];
            r.forEach(((t, e) => {
                g.has(e) || vc(n, t);
            })), p.properties.hasInvisible = !0, Qf(e, n);
            const i = {
                data: n,
                primitive: p.getPrimitive()
            };
            p.elements !== p.properties.oldElementsBeforeHighlight && p.elements.destroy && p.deleteElements(), 
            n = t.elements(i), p.setElements(n), p.generateBuffers(t);
        } else p.properties.hasInvisible && tu(e);
        e.setDefines(x), e.properties.highlightTimestamp = i;
        let _ = e.properties.hlBloomMesh;
        if (v && v.length) {
            if (_) {
                const t = c.copy(_.localTransform, e.localTransform), n = c.copy(_.positionMatrix, e.positionMatrix);
                _.setLocalTransform(t), _.setPositionMatrix(n), e.properties.hlBloomMesh.geometry.setElements(v);
            } else {
                const n = new qt(p.data, v, 0, p.desc);
                n.generateBuffers(t);
                const i = e.material;
                _ = new mi(n, i, e.config);
                const r = e.uniforms;
                for (const t in r) Object.defineProperty(_.uniforms, t, {
                    enumerable: !0,
                    get: function() {
                        return e.getUniform(t);
                    }
                });
                const s = cc({}, e.defines);
                s.HAS_BLOOM = 1;
                const o = c.copy([], e.localTransform), a = c.copy([], e.positionMatrix);
                _.setLocalTransform(o), _.setPositionMatrix(a), cc(_.properties, e.properties), 
                cc(n.properties, p.properties), _.setDefines(s), _.bloom = 1;
            }
            e.properties.hlBloomMesh = _;
        } else _ && nu(e);
    },
    showOnly: function(t, e, n, i, r) {
        const {showOnlyTimestamp: s} = e.properties;
        if (!n) return void (s && Zf(e));
        if (i === s) return;
        e.properties.showOnlyTimestamp = i;
        const o = n.keys(), a = [];
        for (const t of o) {
            if (!r.has(t)) continue;
            const e = r.get(t);
            e && vc(a, e);
        }
        Qf(e, a), e.geometry.elements !== e.geometry.properties.oldElementsBeforeHighlight && e.geometry.elements.destroy && e.geometry.deleteElements();
        const c = {
            data: a,
            primitive: e.geometry.getPrimitive()
        };
        e.geometry.setElements(t.elements(c)), e.geometry.generateBuffers(t);
    }
});

const ru = function(t) {
    return class extends t {
        constructor() {
            super(...arguments), this.kf = [];
        }
        getTexture() {
            this.kf || (this.kf = []);
            const t = this.kf;
            return t && t.length > 0 ? t.pop() : null;
        }
        saveTexture(t) {
            this.kf.push(t);
        }
        disposeTexturePool() {
            const t = this.kf;
            for (let e = 0; e < t.length; e++) t[e].dispose();
            this.kf = [];
        }
    };
}, su = new t.Point(0, 0), ou = [ 1, 1, 1, 1 ];

function au(t, e, n, i, r, s) {
    const o = n.xmax - n.xmin, a = n.ymax - n.ymin;
    i = i || [ 0, 0 ];
    const h = su.set(n.xmin - i[0], n.ymax - i[1]), l = h.x * r, f = h.y * r, u = {
        data: e,
        mag: "nearest",
        mipmap: !0
    };
    let d = this.getTexture();
    d ? d.setConfig(u) : d = new Gi(u), s = cc(s || {}, {
        opacity: 1,
        debugLine: 0,
        alphaTest: 0,
        baseColor: ou,
        baseColorTexture: d
    });
    const m = new Ie(s), v = new mi(t, m);
    v.properties.minFilter = Li;
    const g = c.identity([]);
    return c.translate(g, g, [ l || 0, f || 0, 0 ]), c.scale(g, g, [ r * o, r * a, 1 ]), 
    v.localTransform = g, v;
}

function cu(t, e, n) {
    const i = function(t) {
        const e = t.getZoom(), n = t.isMoving() && t.getRenderer().isViewChanged();
        let i;
        i = n ? Ui : t.getBearing() || t.getPitch() || !Number.isInteger(e) ? Fi : Li;
        return i;
    }(e);
    if (t.properties.minFilter !== i) {
        t.material.get("baseColorTexture").setMinFilter(i), t.properties.minFilter = i;
    }
    const r = e.getDevicePixelRatio(), s = e.getResolution() !== n;
    let o = Li;
    if ((1 !== r || s) && (o = Fi), t.properties.magFilter !== o) {
        t.material.get("baseColorTexture").setMagFilter(o), t.properties.magFilter = o;
    }
}

const {TileLayerRendererable: hu, LayerAbstractRenderer: lu} = t.renderer, fu = new Int16Array([ 0, 0, 0, -1, 1, 0, 1, -1 ]), uu = new Uint16Array([ 0, 0, 0, 1, 1, 0, 1, 1 ]), du = {
    properties: {}
}, mu = new t.Point(20, 20);

class vu extends(ru(Ih(hu(lu)))){
    constructor(t) {
        super(t), this.init();
    }
    onResize(t) {
        super.onResize(t), this.resizeCanvas();
    }
    onDrawTileStart(t, e) {
        if (!this.Nf) {
            this.es = new Jr({
                extraCommandProps: this.Df()
            }), this.Nf = new qt({
                aPosition: fu,
                aTexCoord: uu
            }, 4, 0, {
                positionSize: 2,
                primitive: "triangle strip"
            });
            const {regl: t, device: e} = this.context;
            this.Nf.generateBuffers(t || e), this.Lf = [], this.Ff = new Ti(this.Lf), this.zi = new pi(t || e);
        }
        this.Lf.length = 0, this.clearStencil(e);
    }
    clearStencil(t) {
        let e;
        t && t.renderTarget && (e = t.renderTarget.fbo);
        const {regl: n, device: i} = this.context;
        (n || i).clear({
            stencil: 255,
            fbo: e
        });
    }
    onDrawTileEnd(t, e) {
        const n = this.ta();
        let i;
        e && e.renderTarget && (i = e.renderTarget.fbo), this.Ff.setMeshes(this.Lf), this.zi.render(this.es, n, this.Ff, i);
    }
    ta() {
        return {
            "projViewMatrix": this.getMap().projViewMatrix
        };
    }
    consumeTile(t, e) {
        let n = t.mesh;
        return n || (n = this.Uf(e, t), t.mesh = n), super.consumeTile(t, e);
    }
    drawTile(t, e, n) {
        if (n && n.sceneFilter && !n.sceneFilter(du)) return;
        const i = this.getMap();
        if (!t || !i || !e) return;
        let r = e.mesh;
        r || (r = this.Uf(t, e), e.mesh = r);
        const s = r.getDefines();
        if (this.layer.options.debug) {
            let n = r.material.get("debugTexture");
            n || (n = this.al(t, e.width, e.height), r.material.set("debugTexture", n), e.debugTexture = n), 
            s.HAS_DEBUG || r.setDefines({
                "HAS_DEBUG": 1
            });
        } else s.HAS_DEBUG && r.setDefines({});
        cu(r, i, t.res);
        let o = this.getTileOpacity(e, t), a = this.layer.options.opacity;
        hc(a) && (a = 1), o *= a, r.material.set("opacity", o), r.setUniform("isCurrentTiles", +!!this.drawingCurrentTiles), 
        this.Lf.push(r), this.getTileFadingOpacity(e) < 1 && this.setToRedraw();
    }
    al(t, e, n) {
        const i = this.getDebugInfo(t.id), r = this.getMap().getDevicePixelRatio() > 1 ? 2 : 1, s = this.zf = document.createElement("canvas");
        s.width = e * r, s.height = n * r;
        const o = s.getContext("2d");
        o.font = "20px monospace", o.scale(r, r);
        const a = this.layer.options.debugOutline;
        o.fillStyle = a, o.strokeStyle = a, o.lineWidth = 3, o.fillText(i, 20, n - 12), 
        o.beginPath(), o.moveTo(0, 0), o.lineTo(e, 0), o.lineTo(e, n), o.lineTo(0, n), o.lineTo(0, 0), 
        o.stroke();
        const c = {
            data: s,
            width: s.width,
            height: s.height
        };
        let h = this.getTexture();
        h ? h.setConfig(c) : h = new Gi(c);
        const {device: l, regl: f} = this.context;
        return h.getREGLTexture(l || f), h;
    }
    Uf(t, e) {
        const n = this.getMap(), i = t.res / n.getGLRes(), r = {
            zoom: t.z
        }, s = au.call(this, this.Nf, e, t.extent2d, t.offset, i, r), o = s.material.get("baseColorTexture");
        return e.texture = o, s;
    }
    loadTileImage(t, e) {
        const n = this.layer.options.crossOrigin;
        t.crossOrigin = null !== n ? n : "", t.src = e;
    }
    deleteTile(t) {
        if (!t || !t.image) return super.deleteTile(t);
        const e = t.image;
        e.texture && this.saveTexture(e.texture), e.debugTexture && this.saveTexture(e.debugTexture), 
        delete e.texture, delete e.debugTexture;
        const n = e.mesh;
        return n && (n.material.set("baseColorTexture", null, !1), n.material.set("debugTexture", null, !1), 
        n.material.dispose(), n.dispose(), delete e.mesh), super.deleteTile(t);
    }
    onRemove() {
        this.Nf && (this.es.dispose(), this.Nf.dispose(), delete this.es, delete this.Nf, 
        delete this.zi, delete this.Ff, delete this.Lf), this.disposeTexturePool(), super.onRemove();
    }
    Df() {
        const t = this.getMap().getRenderer().canvas, e = {
            units: 0,
            factor: 0
        };
        return {
            stencil: {
                enable: !0,
                func: {
                    cmp: "<=",
                    ref: (t, e) => Math.abs(this.getCurrentTileZoom() - e.zoom)
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                func: "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? t.width : 1,
                height: () => t ? t.height : 1
            },
            polygonOffset: {
                enable: !0,
                offset: (t, n) => {
                    let i = this.layer.getPolygonOffset();
                    return i = n.isCurrentTiles ? i : i + 1, e.factor = i, e.units = i, e;
                }
            }
        };
    }
    renderTerrainSkin(t, e, n) {
        const i = this.layer.getTileSize().width, r = e.options.debug;
        for (let t = 0; t < n.length; t++) {
            const {tile: e, texture: s} = n[t];
            if (!e.image) continue;
            const o = document.createElement("canvas");
            n[t].canvas = o, o.width = i, o.height = i;
            const a = o.getContext("2d");
            if (a.drawImage(e.image, 0, 0), r) {
                const {x: t, y: n, z: r} = e.info;
                gu(a, `${t}/${n}/${r}`, "yellow", 1, 0, 0, i, i, -18);
            }
            const c = {
                data: o,
                width: i,
                height: i,
                flipY: !0,
                min: "linear mipmap linear",
                mag: "linear"
            };
            s.update ? s.update(c) : s(c);
        }
    }
    createTerrainTexture(t) {
        const e = this.layer.getTileSize().width, n = {
            width: e,
            height: e,
            flipY: !0,
            min: "linear mipmap linear",
            mag: "linear",
            depthStencil: !1,
            depth: !1,
            stencil: !1
        };
        return t.texture(n);
    }
    deleteTerrainTexture(t) {
        t.destroy();
    }
    clear() {
        this.clearTileCaches(), super.clear();
    }
}

function gu(t, e, n, i, r, s, o, a, c = 0) {
    t.font = "20px monospace", t.fillStyle = n, mu.y = a - 30, t.globalAlpha = 1, t.fillText(e, mu.x + r, mu.y + s + c), 
    t.globalAlpha = .6, t.strokeStyle = n, t.lineWidth = i, t.beginPath(), t.moveTo(r, s), 
    t.lineTo(r + o, s), t.lineTo(r + o, s + a), t.lineTo(r, s + a), t.lineTo(r, s), 
    t.stroke(), t.globalAlpha = 1;
}

t.TileLayer.registerRenderer("gl", vu);

const {LayerAbstractRenderer: pu, ImageLayerRenderable: xu} = t.renderer, _u = new Int16Array([ 0, 0, 0, -1, 1, 0, 1, -1 ]), bu = new Uint16Array([ 0, 0, 0, 1, 1, 0, 1, 1 ]);

class yu extends(ru(Ih(xu(pu)))){
    constructor() {
        super(...arguments), this.Gf = [];
    }
    isDrawable() {
        return !0;
    }
    drawImage(t, e, n) {
        let i = t.mesh;
        i || (i = this.Bf(t, e), t.mesh = i);
        const r = this.getMap();
        if (cu(i, r, r.getGLRes()), r.getRenderer().canvas === this.canvas) {
            let t = this.layer.options.opacity;
            hc(t) && (t = 1), n *= t;
        }
        i.material.set("opacity", n), this.Gf.push(i);
    }
    Bf(t, e) {
        const n = au.call(this, this.Vf, t, e, null, 1), i = n.material.get("baseColorTexture");
        return t.texture = i, n;
    }
    drawImages(t, e) {
        this.Gf.length = 0, super.drawImages(t, e);
        const n = this.ta();
        let i;
        e && e.renderTarget && (i = e.renderTarget.fbo), this.jf.setMeshes(this.Gf), this.zi.render(this.es, n, this.jf, i);
    }
    ta() {
        return {
            "projViewMatrix": this.getMap().projViewMatrix
        };
    }
    retireImage(t) {
        const e = t.texture;
        if (e && (this.saveTexture(e), delete t.texture), t.mesh) {
            const e = t.mesh;
            e.material.set("baseColorTexture", null, !1), e.material.dispose(), t.mesh.dispose();
        }
        return delete t.mesh, super.retireImage(t);
    }
    initContext() {
        this.es = new Jr({
            extraCommandProps: this.Df()
        }), this.Vf = new qt({
            aPosition: _u,
            aTexCoord: bu
        }, 4, 0, {
            positionSize: 2,
            primitive: "triangle strip"
        });
        const {regl: t, device: e} = this.context;
        this.Vf.generateBuffers(t || e), this.Gf = [], this.jf = new Ti(this.Gf), this.zi = new pi(t || e);
    }
    Df() {
        const t = this.getMap().getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? t.width : 1,
                height: () => t ? t.height : 1
            },
            depth: {
                enable: !0,
                func: this.layer.options.depthFunc,
                mask: !!this.layer.options.depthMask
            },
            blend: {
                enable: !0,
                func: {
                    src: 1,
                    dst: "one minus src alpha"
                },
                equation: "add"
            }
        };
    }
    onRemove() {
        return this.disposeTexturePool(), super.onRemove();
    }
}

function wu(t, e, n, i) {
    return new (n || (n = Promise))((function(r, s) {
        function o(t) {
            try {
                c(i.next(t));
            } catch (t) {
                s(t);
            }
        }
        function a(t) {
            try {
                c(i.throw(t));
            } catch (t) {
                s(t);
            }
        }
        function c(t) {
            var e;
            t.done ? r(t.value) : (e = t.value, e instanceof n ? e : new n((function(t) {
                t(e);
            }))).then(o, a);
        }
        c((i = i.apply(t, e || [])).next());
    }));
}

let Su, Au;

function Mu() {
    return wu(this, void 0, void 0, (function*() {
        var t;
        return Au || (Su = yield null === (t = navigator.gpu) || void 0 === t ? void 0 : t.requestAdapter(), 
        Au = yield null == Su ? void 0 : Su.requestDevice({}), {
            gpuDevice: Au,
            gpuAdapter: Su
        });
    }));
}

t.ImageLayer.registerRenderer("gl", yu), "function" == typeof SuppressedError && SuppressedError;

class Tu extends a.MapAbstractRenderer {
    drawLayers(t, e) {
        const n = super.drawLayers(t, e);
        return n && this.device.submit(), n;
    }
    clearCanvas() {
        this.device && this.device.clear({
            color: [ 0, 0, 0, 0 ]
        });
    }
    clearLayerCanvasContext(t) {
        if (!this.device) return;
        const e = t.getRenderer();
        this.device.clear({
            depth: 1,
            stencil: 0
        }), e.clearContext();
    }
    isWebGPU() {
        return !0;
    }
    createContext() {
        return wu(this, void 0, void 0, (function*() {
            const {gpuDevice: t, gpuAdapter: e} = yield Mu(), n = this.canvas.getContext("webgpu");
            this.device = new fa(t, n, e), this.context = {
                context: n,
                device: this.device,
                getImageData: (t, e, n, i) => {
                    const r = new Uint8Array(n * i * 4), s = this.canvas;
                    return this.device.read({
                        x: t,
                        y: s.height - e,
                        width: n,
                        height: i,
                        data: r
                    }), new ImageData(new Uint8ClampedArray(r.buffer), n, i);
                }
            };
        }));
    }
}

o.registerRenderer("gpu", Tu);

const Cu = [ 0, 0, 0, 0 ];

class Ou {
    constructor(t, e, n, i, r, s) {
        this.renderer = new pi(t), this.sceneConfig = e, this.Zr = n, this.Wf = i, this.qf = r, 
        this.sf = s || {
            factor: 0,
            units: 0
        }, this.ts(), this.Xf = [];
    }
    render(t, e, n) {
        this.Et();
        const i = this.Zr.getMap();
        this.renderer.device.clear({
            color: Cu,
            depth: 1,
            stencil: 255,
            framebuffer: this.Kf
        }), this.renderer.render(this.$f, e, t, this.Kf);
        const r = this.Zr.getRenderer().canvas;
        this.Xf[0] = r.width, this.Xf[1] = r.height;
        const s = cc({
            colorRamp: this.Jf,
            inputTexture: this.Kf,
            projViewMatrix: i.projViewMatrix,
            textureOutputSize: this.Xf
        }, e);
        return this.Po(), this.renderer.render(this.Yf, s, this.qo, n);
    }
    dispose() {
        this.$f && (this.$f.dispose(), delete this.$f), this.Yf && (this.Yf.dispose(), delete this.Yf), 
        this.No && (this.No.geometry.dispose(), this.No.dispose(), delete this.No, delete this.qo), 
        this.Kf && (this.Kf.destroy(), delete this.Kf);
    }
    Zf() {
        const t = this.Wf;
        let e = this.Qf, n = this.tu;
        n ? n.clearRect(0, 0, 256, 1) : (e = this.Qf = document.createElement("canvas"), 
        e.width = 256, e.height = 1, n = this.tu = e.getContext("2d"));
        const i = n.createLinearGradient(0, 0, 256, 1);
        for (let e = 0; e < t.length; e++) i.addColorStop(t[e][0], t[e][1]);
        n.fillStyle = i, n.fillRect(0, 0, 256, 1), this.Jf && this.Jf.destroy();
        const r = this.renderer.device;
        this.Jf = r.texture({
            width: 256,
            height: 1,
            data: e,
            min: "linear",
            mag: "linear",
            premultiplyAlpha: !0
        });
    }
    Et() {
        const t = this.Zr.getRenderer().canvas, e = Math.ceil(t.width / 4), n = Math.ceil(t.height / 4), i = this.Kf;
        i.width === e && i.height === n || i.resize(e, n);
    }
    ts() {
        this.Zf(), this.eu(), this.nu(), this.Io();
    }
    Io() {
        const t = new Bi;
        t.generateBuffers(this.renderer.device), this.No = new mi(t), this.qo = new Ti([ this.No ]);
    }
    Po() {
        const t = this.Zr.getMap(), e = Bc.getGroundTransform(this.No.localTransform, t);
        this.No.setLocalTransform(e);
    }
    nu() {
        const t = this.Zr.getRenderer().canvas, e = this.renderer.device, n = e.hasExtension("OES_texture_half_float") ? "half float" : "float", i = Math.ceil(t.width / 4), r = Math.ceil(t.height / 4), s = e.texture({
            width: i,
            height: r,
            type: n,
            min: "linear",
            mag: "linear",
            format: "rgba"
        });
        this.Kf = e.framebuffer({
            width: i,
            height: r,
            color: [ s ]
        });
    }
    eu() {
        const t = this.Zr.getRenderer().canvas, e = this.sceneConfig.depthRange, n = {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? Math.ceil(t.width / 4) : 1,
                height: () => t ? Math.ceil(t.height / 4) : 1
            },
            depth: {
                enable: !0,
                func: "always"
            }
        };
        this.qf && (n.stencil = this.qf), this.$f = new os({
            extraCommandProps: n
        }), this.Yf = new ls({
            x: 0,
            y: 0,
            width: () => t ? t.width : 1,
            height: () => t ? t.height : 1
        }, {
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: e || [ 0, 1 ],
                    func: "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.sf
                }
            }
        });
    }
}

class Eu extends jl {
    constructor(t, e) {
        super(t, e);
    }
    Ph(t) {
        const e = this.So(t), n = new mi(e);
        return this.iu(n), this.Pl(n), n;
    }
    xs(t, e, n) {
        const i = this.Nl();
        t.setUniform("maskMode", i);
        const r = this.Dl();
        if (t.setUniform("maskColor", r), lc(e)) {
            const i = this.Gl();
            i[0] = (i[0] - n) * e, i[1] = (i[1] - n) * e, t.setUniform("heightRange", i);
        }
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    getHeightRange() {
        return this.options.heightRange;
    }
    Gl() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Ll(this.options.heightRange[0]), 
        t[1] = this.Ll(this.options.heightRange[1])), t;
    }
    iu(t) {
        const e = t.getDefines();
        e.HAS_MASK_COLOR = 1, t.setDefines(e);
    }
}

class Iu extends Eu {
    constructor(t, e) {
        super(t, e), this.Cl = "clip-inside";
    }
}

class Pu extends Eu {
    constructor(t, e) {
        super(t, e), this.Cl = "clip-outside";
    }
}

class Hu extends jl {
    constructor(t, e) {
        super(t, e);
    }
    setFlatheight(t) {
        this.options.flatHeight = t, this._fireEvent("flatheightchange");
    }
    Ph(t) {
        const e = this.So(t), n = new mi(e);
        return this.iu(n), this.Pl(n), n;
    }
    xs(t) {
        const e = this.Nl();
        t.setUniform("maskMode", e);
        const n = this.Dl();
        t.setUniform("maskColor", n);
        const i = this.Ll(this.options.flatHeight || 0);
        t.setUniform("flatHeight", i);
    }
    iu(t) {
        const e = t.getDefines();
        e.HAS_MASK_FLAT = 1, t.setDefines(e);
    }
    Gl() {
        const t = [ 0, this.options.flatHeight ];
        return t[1] = this.Ll(t[1]), t;
    }
}

let Ru = class extends Hu {
    constructor(t, e) {
        super(t, e), this.Cl = "flat-inside";
    }
};

class ku extends Hu {
    constructor(t, e) {
        super(t, e), this.Cl = "flat-outside";
    }
}

class Nu extends jl {
    constructor(t, e) {
        super(t, e), this.Cl = "color";
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    Ph(t) {
        const e = this.So(t), n = new mi(e);
        return this.iu(n), this.Pl(n), n;
    }
    xs(t, e, n) {
        const i = this.Nl();
        t.setUniform("maskMode", i);
        const r = this.Dl();
        if (t.setUniform("maskColor", r), lc(e)) {
            const i = this.Gl();
            i[0] = (i[0] - n) * e, i[1] = (i[1] - n) * e, t.setUniform("heightRange", i);
        }
    }
    iu(t) {
        const e = t.getDefines();
        e.HAS_MASK_COLOR = 1, t.setDefines(e);
    }
    Gl() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Ll(this.options.heightRange[0]), 
        t[1] = this.Ll(this.options.heightRange[1])), t;
    }
}

class Du extends jl {
    constructor(t, e) {
        super(t, e), this.Cl = "texture";
    }
    play() {
        this.ru && this.ru.play();
    }
    pause() {
        this.ru && this.ru.pause();
    }
    setAudio(t) {
        this.ru && (this.video.muted = t);
    }
    setUrl(t) {
        this.options.url = t, this.su(t);
    }
    getState() {
        return this.ou;
    }
    Ph(t) {
        const {geometry: e, copyGeometry: n} = this.So(t), i = new mi(e), r = this.au(t);
        return i.material = new Ie({
            maskTexture: r
        }), this.iu(i), this.Pl(i), this.Hl = new mi(n), this.Pl(this.Hl), i;
    }
    xs(t) {
        const e = this.Nl();
        if (t.setUniform("maskMode", e), this.kl && this.kl.length) for (let e = 0; e < 4; e++) t.setUniform("mask_position" + e, this.kl.slice(3 * e, 3 * e + 3));
        const n = this.Dl();
        t.setUniform("maskColor", n);
    }
    iu(t) {
        const e = t.getDefines();
        e.HAS_TEXTURE = 1, t.setDefines(e);
    }
    au(t) {
        this.su();
        return t.texture();
    }
    su() {
        this.ou = "stop";
        const t = this.options.url, e = this.options.elementId;
        let n = document.getElementById(e);
        if (t && (n = document.createElement("video"), n.src = t), !n) throw new Error("there is no element or url setting for video mask");
        n.autoplay = this.options.autoplay || !0, n.loop = this.options.loop || !0, n.muted = this.options.muted || !0, 
        n.play(), n.addEventListener("playing", (() => {
            this.ou = "playing";
        })), n.addEventListener("pause", (() => {
            this.ou = "pause";
        })), this.ru = n;
    }
    m() {
        const t = this.hs;
        if (t && t.material) {
            const e = t.material.get("maskTexture");
            e && this.ru && this.Oh() && e(this.ru);
        }
    }
    Oh() {
        return "playing" === this.ou;
    }
}

class Lu extends jl {
    constructor(t, e) {
        super(t, e), this.Cl = "texture";
    }
    setUrl(t) {
        this.options.url = t;
        const e = this.hs;
        if (e && e.material) {
            const t = e.material.get("maskTexture");
            if (t) {
                this.cu(t);
                const e = this.getLayer();
                e && e.getRenderer().setToRedraw();
            }
        }
    }
    Ph(t) {
        const {geometry: e, copyGeometry: n} = this.So(t), i = new mi(e), r = t.texture();
        return this.cu(r), i.material = new Ie({
            maskTexture: r
        }), this.iu(i), this.Pl(i), this.Hl = new mi(n), this.Pl(this.Hl), i;
    }
    xs(t) {
        const e = this.Nl();
        t.setUniform("maskMode", e);
        const n = this.Dl();
        if (t.setUniform("maskColor", n), this.kl && this.kl.length) for (let e = 0; e < 4; e++) t.setUniform("mask_position" + e, this.kl.slice(3 * e, 3 * e + 3));
    }
    iu(t) {
        const e = t.getDefines();
        e.HAS_TEXTURE = 1, t.setDefines(e);
    }
    cu(t) {
        const e = new Image;
        e.src = this.options.url, e.crossOrigin = "anonymous", e.onload = function() {
            t(e);
        }, e.onerror = function() {
            console.warn("Image load error");
        };
    }
    getBBox() {
        return this.Hl.getBoundingBox();
    }
}

class Fu extends Hu {
    constructor(t, e) {
        super(t, e), this.setElevation(e.elevation), this.Cl = "elevate";
    }
    setElevation(t) {
        this.options.elevation = t, this.setFlatheight(this.options.elevation);
    }
}

const Uu = new i(0, 0), zu = new i(0, 0), Gu = new i(0, 0), Bu = new i(0, 0);

class Vu extends Eu {
    constructor(t, e) {
        super([], e), this.hu = t;
    }
    setPosition(t) {
        this.hu = t, this.zl();
    }
    getPosition() {
        return this.hu;
    }
    setWidth(t) {
        this.options.width = t, this.zl();
    }
    setLength(t) {
        this.options.length = t, this.zl();
    }
    setHeight(t) {
        this.options.height = t, this.zl();
    }
    setRotation(t) {
        this.options.rotation = t, this.zl();
    }
    zl() {
        const t = this.getLayer();
        if (!t) return;
        const e = t.getMap();
        if (e) {
            const {length: t, width: n, height: i} = this.options, r = this.hu, s = this.options.rotation || 0, {coordinates: o, heightRange: a} = this.lu(e, r, t, n, i, s);
            this.setCoordinates(o), this.setHeightRange(a);
        }
    }
    lu(t, e, n, i, r, s) {
        const o = t.getGLRes(), a = t.distanceToPointAtRes(i / 2, 0, o, Uu), c = t.distanceToPointAtRes(0, n / 2, o, zu), h = t.coordinateToPointAtRes(e, o, Gu), l = h.x - a.x, f = h.x + a.x, u = h.y + c.y, d = h.y - c.y, m = this.fu([ [ l, u ], [ f, u ], [ f, d ], [ l, d ] ], h, s);
        Bu.set(m[0][0], m[0][1]);
        const v = t.pointAtResToCoordinate(Bu, o);
        Bu.set(m[1][0], m[1][1]);
        const g = t.pointAtResToCoordinate(Bu, o);
        Bu.set(m[2][0], m[2][1]);
        const p = t.pointAtResToCoordinate(Bu, o);
        Bu.set(m[3][0], m[3][1]);
        const x = t.pointAtResToCoordinate(Bu, o), _ = e.z - r / 2, b = [ _, e.z + r / 2 ];
        return {
            coordinates: [ [ v.x, v.y, _ ], [ g.x, g.y, _ ], [ p.x, p.y, _ ], [ x.x, x.y, _ ], [ v.x, v.y, _ ] ],
            heightRange: b
        };
    }
    fu(t, e, n) {
        for (let i = 0; i < t.length; i++) u.rotate(t[i], t[i], [ e.x, e.y ], n * Math.PI / 180);
        return t;
    }
}

class ju extends Vu {
    constructor(t, e) {
        super(t, e), this.Cl = "clip-inside";
    }
}

class Wu extends Vu {
    constructor(t, e) {
        super(t, e), this.Cl = "clip-outside";
    }
}

class qu extends t.DrawTool {
    constructor(t) {
        super(t), this.on("enable", this.uu, this), this.on("disable", this.du, this), this.mu = [];
    }
    addTo(t) {
        return t && (super.addTo(t), this.Ws = t, this.vu()), this;
    }
    vu() {
        const e = t.INTERNAL_LAYER_PREFIX + "drawtool";
        this.Ws.getLayer(e).hide();
    }
    uu() {
        this.on("drawstart", this.gu, this).on("drawvertex", this.pu, this).on("mousemove", this.xu, this).on("drawend", this._u, this);
    }
    du() {
        this.off("drawstart", this.gu, this).off("drawvertex", this.pu, this).off("mousemove", this.xu, this).off("drawend", this._u, this);
    }
    bu(e) {
        const {coordinate: n, containerPoint: i} = e, r = this.Ws.getLayers((t => t.queryTerrainAtPoint))[0];
        if (!r) return n.z = n.z || 0, n;
        const s = r.identify(n, {
            includeInternals: !1
        })[0];
        let o = null;
        if (s && s.coordinate ? o = new t.Coordinate(s.coordinate) : (n.z = n.z || 0, o = n), 
        r.getTerrainLayer()) {
            const t = r.queryTerrainAtPoint(i);
            return t && t.z > o.z ? t : o;
        }
        return o;
    }
    gu(t) {
        const e = this.bu(t);
        e && (this.yu = !0, this.mu.push(e), this.wu(e));
    }
    pu(t) {
        const e = this.bu(t);
        e && (this.yu = !0, this.mu[this.mu.length - 1] = e, this.Su());
    }
    xu(t) {
        const e = this.bu(t);
        e && (this.yu ? this.mu.push(e) : this.mu[this.mu.length - 1] = e, this.Su(), this.yu = !1);
    }
    _u(t) {
        const e = this.bu(t);
        e && (this.mu.push(e), this.Au());
    }
    Au() {
        this.Su(), this.mu = [], this.Mu = null, this.Tu = null;
    }
    remove() {
        this.Cu && this.Cu.remove(), this.Ou && this.Ou.remove();
    }
    clear() {
        this.Cu && this.Cu.clear(), this.Ou && this.Ou.clear();
    }
}

qu.mergeOptions({
    "mode": "LineString",
    "language": "zh-CN",
    "metric": !0,
    "imperial": !1,
    "once": !0,
    "symbol": {
        "lineColor": "#e8542b",
        "lineWidth": 2,
        "polygonFill": "#eee",
        "polygonOpacity": .5
    },
    "vertexSymbol": {
        "markerType": "ellipse",
        "markerFill": "#e8542b",
        "markerLineColor": "#fff",
        "markerLineWidth": 2,
        "markerWidth": 10,
        "markerHeight": 10,
        "markerDy": 0
    },
    "labelSymbol": {
        "boxStyle": {
            "padding": [ 15, 6 ],
            "verticalAlignment": "top",
            "horizontalAlignment": "left",
            "minWidth": 150,
            "minHeight": 30,
            "symbol": {
                "markerType": "square",
                "markerFill": "rgb(60, 60, 60)",
                "markerFillOpacity": .8,
                "markerLineColor": "#fff",
                "markerLineWidth": 2,
                "textDx": -110
            }
        },
        "textSymbol": {
            "textFill": "#fff",
            "textSize": 16,
            "textVerticalAlignment": "top"
        }
    }
});

class Xu extends qu {
    vu() {
        super.vu(), this.Cu = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool").addTo(this.Ws), 
        this.Ou = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool_marker").addTo(this.Ws);
    }
    Su() {
        this.Mu.setCoordinates(this.mu);
        const e = this.Ou.getGeometries(), n = this.Cu.getGeometries().length;
        for (let t = 0; t < e.length; t++) {
            const i = e[t].getId();
            i !== "label" + n && i.indexOf(`${n}_`) > -1 && e[t].remove();
        }
        for (let e = 0; e < this.mu.length; e++) new t.Marker(this.mu[e], {
            id: n + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Ou);
        this.Eu();
    }
    Eu() {
        const e = this.getMeasureResult(), n = (("zh-CN" === this.options.language ? 0 : 1) ? "distance: " : "距离: ") + this.Iu(e), i = this.mu[this.mu.length - 1], r = this.Cu.getGeometries().length, s = t.Util.extend({
            id: "label" + r
        }, this.options.labelSymbol);
        this.Tu ? (this.Tu.setContent(n), this.Tu.setCoordinates(i)) : this.Tu = new t.Label(n, i, s).addTo(this.Ou);
    }
    Iu(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let n = "";
        return this.options.metric && (this.Pu = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Hu = t < 1e3 ? e[0] : e[1]), this.options.imperial && (t *= 3.2808399, n.length > 0 && (n += "\n"), 
        this.Pu = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Hu = t < 5280 ? e[2] : e[3]), 
        n += this.Pu + this.Hu, n;
    }
    wu(e) {
        this.Mu || (this.Mu = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Cu)), this.Su(), this.yu = !0;
    }
    getMeasureResult() {
        return this.Mu.getLength();
    }
}

class Ku extends qu {
    vu() {
        super.vu(), this.Cu = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool").addTo(this.Ws), 
        this.Ou = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool_marker").addTo(this.Ws);
    }
    Su() {
        const e = this.Ru(this.mu);
        this.Mu.setCoordinates(e), this.ku.setCoordinates(e);
        const n = this.Ou.getGeometries(), i = this.Cu.getGeometries().length;
        for (let t = 0; t < n.length; t++) {
            const e = n[t].getId();
            e !== "label" + i && e.indexOf(`${i}_`) > -1 && n[t].remove();
        }
        for (let e = 0; e < this.mu.length; e++) new t.Marker(this.mu[e], {
            id: i + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Ou);
        this.Eu();
    }
    Ru(t) {
        const e = t.map((t => t));
        return t.length > 2 && e.push(t[0]), e;
    }
    Eu() {
        const e = this.getMeasureResult(), n = (("zh-CN" === this.options.language ? 0 : 1) ? "area: " : "面积: ") + this.Iu(e), i = this.mu[this.mu.length - 1], r = this.Cu.getGeometries().length, s = t.Util.extend({
            id: "label" + r
        }, this.options.labelSymbol);
        this.Tu ? (this.Tu.setContent(n), this.Tu.setCoordinates(i)) : this.Tu = new t.Label(n, i, s).addTo(this.Ou);
    }
    Iu(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 平方米", " 平方公里", " 平方英尺", " 平方英里" ] : [ " sq.m", " sq.km", " sq.ft", " sq.mi" ];
        let n = "";
        if (this.options.metric && (this.Pu = t < 1e6 ? t.toFixed(2) : (t / 1e6).toFixed(2), 
        this.Hu = t < 1e6 ? e[0] : e[1]), this.options.imperial) {
            t *= 3.2808399, n.length > 0 && (n += "\n");
            const i = 27878400;
            this.Pu = t < i ? t.toFixed(2) : (t / i).toFixed(2), this.Hu = t < i ? e[2] : e[3];
        }
        return n += this.Pu + this.Hu, n;
    }
    wu(e) {
        this.Mu || (this.Mu = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Cu), this.ku = new t.Polygon([ e ])), this.Su(), this.yu = !0;
    }
    getMeasureResult() {
        return this.ku.getArea();
    }
}

const $u = [ [ "直线距离", "垂直高度", "水平距离" ], [ "spatial distance", "vertical height", "horizontal distance" ] ];

class Ju extends qu {
    vu() {
        super.vu(), this.Cu = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool").addTo(this.Ws), 
        this.Ou = new t.DrawToolLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool_marker").addTo(this.Ws);
    }
    pu(t) {
        super.pu(t), this.mu.length > 1 && (this.Au(), this.disable());
    }
    Su() {
        const e = this.Ou.getGeometries(), n = this.Cu.getGeometries().length;
        for (let t = 0; t < e.length; t++) {
            const i = e[t].getId();
            i !== "label" + n + "_" + t && 0 === i.indexOf(`${n}_`) && e[t].remove();
        }
        for (let e = 0; e < this.mu.length; e++) new t.Marker(this.mu[e], {
            id: n + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Ou);
        const i = this.mu.length;
        if (i > 1) {
            const e = this.mu[i - 1].x, r = this.mu[i - 1].y, s = this.mu[i - 2].z, o = new t.Coordinate([ e, r, s ]);
            new t.Marker(o, {
                id: n + "_2",
                symbol: this.options.vertexSymbol
            }).addTo(this.Ou);
            const a = [].concat(this.mu);
            a.push(o), a.push(this.mu[0]);
            const c = a.map((t => t.z));
            this.Mu.setCoordinates(a), this.Mu.setProperties({
                altitude: c
            });
            const h = this.Ws.getProjection().measureLenBetween(a[0], a[2]), l = a[1].z - a[2].z, f = Math.sqrt(Math.pow(h, 2) + Math.pow(l, 2));
            this.Eu(a, [ f, l, h ]);
        }
    }
    Eu(e, n) {
        for (let i = 0; i < e.length - 1; i++) {
            const r = e[i], s = e[i + 1], o = n[i], a = "zh-CN" === this.options.language ? 0 : 1, c = this.Iu(o), h = $u[a][i] + ":" + c, l = "label" + this.Cu.getGeometries().length + "_" + i, f = JSON.parse(JSON.stringify(this.options.labelSymbol));
            f.id = l, i < 2 && (f.boxStyle.symbol.textDx *= -1);
            const u = 1 === i ? r : new t.Coordinate((r.x + s.x) / 2, (r.y + s.y) / 2, (r.z + s.z) / 2), d = this.Ou.getGeometryById(l), m = `${l}_marker`, v = this.Ou.getGeometryById(m);
            d ? (d.setContent(h), d.setCoordinates(u), v.setCoordinates(u)) : (new t.Label(h, u, f).addTo(this.Ou), 
            new t.Marker(u, {
                id: m,
                symbol: this.options.vertexSymbol
            }).addTo(this.Ou));
        }
    }
    Iu(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let n = "";
        return this.options.metric && (this.Pu = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Hu = t < 1e3 ? e[0] : e[1]), this.options.imperial && (t *= 3.2808399, n.length > 0 && (n += "\n"), 
        this.Pu = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Hu = t < 5280 ? e[2] : e[3]), 
        n += this.Pu + this.Hu, n;
    }
    wu(e) {
        this.Mu || (this.Mu = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Cu)), this.Su(), this.yu = !0;
    }
    getMeasureResult() {
        return this.Mu.getLength();
    }
}

export { Ku as Area3DTool, ju as BoxInsideClipMask, Wu as BoxOutsideClipMask, Ih as CanvasCompatible, Iu as ClipInsideMask, Pu as ClipOutsideMask, Nu as ColorMask, sl as ContextUtil, Xu as Distance3DTool, Fu as ElevateMask, Ru as FlatInsideMask, ku as FlatOutsideMask, Bc as GroundPainter, Df as GroupGLLayer, Ou as HeatmapProcess, Ju as Height3DTool, iu as HighlightUtil, Lu as ImageMask, rf as MaskLayerMixin, bl as MaskRendererMixin, qu as Measure3DTool, Of as RayCaster, Du as VideoMask, sc as color, ct as earcut, va as reshader };
//# sourceMappingURL=gl.es.js.map
